import {Buffer as $fkrEL$Buffer} from "buffer";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2_jzyv5"];
var parcelRegister = parcelRequire.register;
parcelRegister("jTOzh", function(module, exports) {

$parcel$export(module.exports, "DoppioWrapper", function () { return $7c7148d2e0acc08c$export$3e6cf7ea7caddd61; });

var $bsvQL = parcelRequire("bsvQL");

var $iRn4y = parcelRequire("iRn4y");

var $hJ7nZ = parcelRequire("hJ7nZ");

var $4gxuw = parcelRequire("4gxuw");

var $giOKx = parcelRequire("giOKx");
const $7c7148d2e0acc08c$var$mapDoppioPlaybackStateToMMPPlaybackState = {
    [(0, $iRn4y.EPlaybackState).IDLE]: (0, $hJ7nZ.EPlaybackState).IDLE,
    [(0, $iRn4y.EPlaybackState).LOADING]: (0, $hJ7nZ.EPlaybackState).LOADING,
    [(0, $iRn4y.EPlaybackState).PAUSED]: (0, $hJ7nZ.EPlaybackState).PAUSED,
    [(0, $iRn4y.EPlaybackState).PLAYING]: (0, $hJ7nZ.EPlaybackState).PLAYING,
    [(0, $iRn4y.EPlaybackState).ERROR]: (0, $hJ7nZ.EPlaybackState).ERROR
};
class $7c7148d2e0acc08c$export$3e6cf7ea7caddd61 extends (0, $4gxuw.AbstractWrapper) {
    constructor(eventBusInstance){
        super(eventBusInstance), this._logLevels = [];
    }
    setStreamConfig(config) {
        if (!config || !config.HLSStreamUrl) {
            this._lastKnownStreamConfig = null;
            this._playerInstance?.setUrl('');
            return this;
        }
        this._lastKnownStreamConfig = {
            hlsStreamUrl: config.HLSStreamUrl
        };
        this._playerInstance?.setUrl(config.HLSStreamUrl);
        return this;
    }
    setAbrResolutions() {
        return this;
    }
    enableAbr() {
        this._isAbrEnabled = true;
        this._playerInstance?.enableABR();
        return this;
    }
    setResolutionByName(resolutionName) {
        this._playerInstance?.setResolutionByName(resolutionName);
        return this;
    }
    setResolutionByBitrate(bitrate) {
        this._playerInstance?.setResolutionByBitrate(bitrate);
        return this;
    }
    setLoggerLevel(levels) {
        this._playerInstance?.setLoggerLevel(levels);
        this._logLevels = levels;
    }
    disableAbr() {
        this._isAbrEnabled = false;
        this._playerInstance?.disableABR();
        return this;
    }
    get version() {
        return this._playerInstance?.version;
    }
    _attachEventListeners() {
        if (!this._playerInstance) return;
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).DEBUGGER_CONNECTED, this._onDebuggerConnected);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).PLAYBACK_STATE_CHANGED, this._onPlaybackStateChanged);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).ERROR, this._onDoppioError);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).VARIANTS_DETECTED, this._onResolutionsAvailable);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).METRICS_AVAILABLE, this._onMetricsReported);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).FRAG_LOADED, this._onPlaylistLoaded);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).LEVEL_LOADED, this._onFragLoaded);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).LIFECYCLE_EVENT, this._onLifecycleEventReported);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).LIFECYCLE_ERROR, this._onLifecycleErrorReported);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).LEVEL_SWITCHED_AUTO, this._onRenditionSwitchAuto);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).RESOLUTION_CHANGED, this._onResolutionChanged);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).RESOLUTION_NOT_FOUND, this._onResolutionNotFound);
        this._playerInstance.addEventListener((0, $iRn4y.EEvent).FRAGMENT_FILTERED_OUT, this._onFragmentFilteredOut);
    }
    _detachEventListeners() {
        if (!this._playerInstance) return;
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).DEBUGGER_CONNECTED, this._onDebuggerConnected);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).PLAYBACK_STATE_CHANGED, this._onPlaybackStateChanged);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).ERROR, this._onDoppioError);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).VARIANTS_DETECTED, this._onResolutionsAvailable);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).METRICS_AVAILABLE, this._onMetricsReported);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).FRAG_LOADED, this._onPlaylistLoaded);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).LEVEL_LOADED, this._onFragLoaded);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).LIFECYCLE_EVENT, this._onLifecycleEventReported);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).LIFECYCLE_ERROR, this._onLifecycleErrorReported);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).RESOLUTION_CHANGED, this._onRenditionSwitchAuto);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).RESOLUTION_CHANGED, this._onResolutionChanged);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).RESOLUTION_NOT_FOUND, this._onResolutionNotFound);
        this._playerInstance.removeEventListener((0, $iRn4y.EEvent).FRAGMENT_FILTERED_OUT, this._onFragmentFilteredOut);
    }
    _createPlayerInstance() {
        this._destroyPlayerInstance();
        this._playerInstance = new (0, $iRn4y.DoppioPlayer)();
        if (this._lastKnownConfig) this._playerInstance.setConfig(this._lastKnownConfig);
        if (this._lastKnownStreamConfig) this._playerInstance.setUrl(this._lastKnownStreamConfig.hlsStreamUrl);
        if (this._videoElement) this._playerInstance.setVideoElement(this._videoElement);
        if (this._isAbrEnabled) this._playerInstance.enableABR();
        else this._playerInstance.disableABR();
        this._attachEventListeners();
        this._playerInstance?.setLoggerLevel(this._logLevels);
    }
    _onDebuggerConnected({ detail: { panelUrl: panelUrl } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).DEBUGGER_CONNECTED, {
            debuggerUrl: panelUrl
        });
    }
    _onPlaybackStateChanged({ detail: { prevState: prevState, nextState: nextState } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).PLAYBACK_STATE_CHANGED, {
            nextState: $7c7148d2e0acc08c$var$mapDoppioPlaybackStateToMMPPlaybackState[nextState],
            prevState: $7c7148d2e0acc08c$var$mapDoppioPlaybackStateToMMPPlaybackState[prevState]
        });
    }
    _onDoppioError({ detail: { error: error } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).ERROR, {
            error: error,
            playerType: (0, $hJ7nZ.EPlayerType).HLS
        });
    }
    _onResolutionsAvailable({ detail: detail }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).RESOLUTIONS_AVAILABLE, {
            resolutions: detail
        });
    }
    _onMetricsReported({ detail: detail }) {
        this._metricsCollector?.registerMetrics({
            targetBuffer: detail.targetBuffer
        });
    }
    _onFragLoaded(e) {
        this._metricsCollector?.registerMetrics({
            chunkLoadDuration: e.detail.netStats.downloadDuration,
            chunkLoadTTFB: e.detail.netStats.ttfb
        });
    }
    _onPlaylistLoaded(e) {
        this._metricsCollector?.registerMetrics({
            playlistLoadTTFB: e.detail.netStats.ttfb,
            playlistLoadDuration: e.detail.netStats.downloadDuration
        });
    }
    _onLifecycleEventReported({ detail: { eventType: eventType } }) {
        this._metricsCollector?.registerEvent(eventType, {});
    }
    _onRenditionSwitchAuto({ detail: { nextResolution: nextResolution, prevResolution: prevResolution } }) {
        this._metricsCollector?.registerEvent('RenditionSwitchedAuto', {
            prevResolution: prevResolution,
            nextResolution: nextResolution
        });
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).AUTO_RESOLUTION_SWITCHED, {
            name: nextResolution
        });
    }
    _onResolutionChanged({ detail: { name: name } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).RESOLUTION_SWITCHED, {
            name: name
        });
    }
    _onLifecycleErrorReported({ detail: { errorType: errorType, nativeError: nativeError } }) {
        this._metricsCollector?.registerEvent(errorType, {
            errorMessage: nativeError?.message || ''
        });
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).STREAM_LOAD_ERROR, {
            reason: 'HTTP_ERROR',
            httpStatusCode: nativeError?.statusCode
        });
    }
    _onResolutionNotFound() {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).RESOLUTION_NOT_FOUND, {});
    }
    _onFragmentFilteredOut({ detail: { reason: reason, fragment: fragment } }) {
        this._metricsCollector?.registerEvent('FragmentFilteredOut', {
            reason: reason,
            fragmentName: fragment
        });
    }
}
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onDebuggerConnected", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onPlaybackStateChanged", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onDoppioError", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onResolutionsAvailable", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onMetricsReported", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onFragLoaded", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onPlaylistLoaded", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onLifecycleEventReported", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onRenditionSwitchAuto", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onResolutionChanged", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onLifecycleErrorReported", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onResolutionNotFound", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $7c7148d2e0acc08c$export$3e6cf7ea7caddd61.prototype, "_onFragmentFilteredOut", null);

});
parcelRegister("iRn4y", function(module, exports) {

$parcel$export(module.exports, "EEvent", function () { return $dbaf12f73216aff4$export$99d210b57a8acd4e; });
$parcel$export(module.exports, "EPlaybackState", function () { return $dbaf12f73216aff4$export$af29ccb356acd9fc; });
$parcel$export(module.exports, "DoppioPlayer", function () { return $dbaf12f73216aff4$export$af89f16da513df38; });

function $dbaf12f73216aff4$var$t(e, t, r, n) {
    Object.defineProperty(e, t, {
        get: r,
        set: n,
        enumerable: !0,
        configurable: !0
    });
}
var $dbaf12f73216aff4$var$r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : {};
function $dbaf12f73216aff4$var$n(e) {
    return e && e.__esModule ? e.default : e;
}
var $dbaf12f73216aff4$var$i = {}, $dbaf12f73216aff4$var$s = {}, $dbaf12f73216aff4$var$a = $dbaf12f73216aff4$var$r.parcelRequire5d5f_mn5mlk;

null == $dbaf12f73216aff4$var$a && (($dbaf12f73216aff4$var$a = function(e) {
    if (e in $dbaf12f73216aff4$var$i) return $dbaf12f73216aff4$var$i[e].exports;
    if (e in $dbaf12f73216aff4$var$s) {
        var t = $dbaf12f73216aff4$var$s[e];
        delete $dbaf12f73216aff4$var$s[e];
        var r = {
            id: e,
            exports: {}
        };
        return $dbaf12f73216aff4$var$i[e] = r, t.call(r.exports, r, r.exports), r.exports;
    }
    var n = new Error("Cannot find module '" + e + "'");
    throw n.code = "MODULE_NOT_FOUND", n;
}).register = function(e, t) {
    $dbaf12f73216aff4$var$s[e] = t;
}, $dbaf12f73216aff4$var$r.parcelRequire5d5f_mn5mlk = $dbaf12f73216aff4$var$a), $dbaf12f73216aff4$var$a.register("8NFq9", function(e, r) {
    $dbaf12f73216aff4$var$t(e.exports, "default", function() {
        return $dbaf12f73216aff4$var$a("a8VW4").__decorate;
    });
    $dbaf12f73216aff4$var$a("a8VW4");
}), $dbaf12f73216aff4$var$a.register("a8VW4", function(e, r) {
    $dbaf12f73216aff4$var$t(e.exports, "__decorate", function() {
        return n;
    });
    function n(e, t, r, n) {
        var i, s = arguments.length, a = s < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);
        else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (a = (s < 3 ? i(a) : s > 3 ? i(t, r, a) : i(t, r)) || a);
        return s > 3 && a && Object.defineProperty(t, r, a), a;
    }
    Object.create;
    Object.create;
    "function" == typeof SuppressedError && SuppressedError;
}), $dbaf12f73216aff4$var$a.register("eQOGK", function(e, r) {
    $dbaf12f73216aff4$var$t(e.exports, "default", function() {
        return n;
    });
    var n = function(e, t, r) {
        if (!r || "function" != typeof r.value) throw new TypeError(`Only methods can be decorated with @bind. <${t}> is not a method!`);
        return {
            configurable: !0,
            get () {
                const e = r.value?.bind(this);
                return Object.defineProperty(this, t, {
                    value: e,
                    configurable: !0,
                    writable: !0
                }), e;
            }
        };
    };
}), $dbaf12f73216aff4$var$a.register("3mtZ4", function(e, t) {
    (function() {
        var n, i = "Expected a function", s = "__lodash_hash_undefined__", a = "__lodash_placeholder__", o = 16, l = 32, u = 64, d = 128, c = 256, h = 1 / 0, f = 9007199254740991, _ = NaN, g = 4294967295, p = [
            [
                "ary",
                d
            ],
            [
                "bind",
                1
            ],
            [
                "bindKey",
                2
            ],
            [
                "curry",
                8
            ],
            [
                "curryRight",
                o
            ],
            [
                "flip",
                512
            ],
            [
                "partial",
                l
            ],
            [
                "partialRight",
                u
            ],
            [
                "rearg",
                c
            ]
        ], m = "[object Arguments]", b = "[object Array]", v = "[object Boolean]", y = "[object Date]", E = "[object Error]", S = "[object Function]", R = "[object GeneratorFunction]", T = "[object Map]", A = "[object Number]", L = "[object Object]", $ = "[object Promise]", B = "[object RegExp]", P = "[object Set]", C = "[object String]", w = "[object Symbol]", O = "[object WeakMap]", D = "[object ArrayBuffer]", M = "[object DataView]", I = "[object Float32Array]", F = "[object Float64Array]", x = "[object Int8Array]", k = "[object Int16Array]", N = "[object Int32Array]", V = "[object Uint8Array]", U = "[object Uint8ClampedArray]", q = "[object Uint16Array]", G = "[object Uint32Array]", W = /\b__p \+= '';/g, j = /\b(__p \+=) '' \+/g, H = /(__e\(.*?\)|\b__t\)) \+\n'';/g, K = /&(?:amp|lt|gt|quot|#39);/g, Y = /[&<>"']/g, Q = RegExp(K.source), z = RegExp(Y.source), X = /<%-([\s\S]+?)%>/g, Z = /<%([\s\S]+?)%>/g, J = /<%=([\s\S]+?)%>/g, ee = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, te = /^\w*$/, re = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ne = /[\\^$.*+?()[\]{}|]/g, ie = RegExp(ne.source), se = /^\s+/, ae = /\s/, oe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, le = /\{\n\/\* \[wrapped with (.+)\] \*/, ue = /,? & /, de = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ce = /[()=,{}\[\]\/\s]/, he = /\\(\\)?/g, fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, _e = /\w*$/, ge = /^[-+]0x[0-9a-f]+$/i, pe = /^0b[01]+$/i, me = /^\[object .+?Constructor\]$/, be = /^0o[0-7]+$/i, ve = /^(?:0|[1-9]\d*)$/, ye = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ee = /($^)/, Se = /['\n\r\u2028\u2029\\]/g, Re = "\ud800-\udfff", Te = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff", Ae = "\\u2700-\\u27bf", Le = "a-z\\xdf-\\xf6\\xf8-\\xff", $e = "A-Z\\xc0-\\xd6\\xd8-\\xde", Be = "\\ufe0e\\ufe0f", Pe = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ce = "['\u2019]", we = "[\ud800-\udfff]", Oe = "[" + Pe + "]", De = "[" + Te + "]", Me = "\\d+", Ie = "[" + Ae + "]", Fe = "[" + Le + "]", xe = "[^" + Re + Pe + Me + Ae + Le + $e + "]", ke = "\ud83c[\udffb-\udfff]", Ne = "[^\ud800-\udfff]", Ve = "(?:\ud83c[\udde6-\uddff]){2}", Ue = "[\ud800-\udbff][\udc00-\udfff]", qe = "[" + $e + "]", Ge = "\\u200d", We = "(?:" + Fe + "|" + xe + ")", je = "(?:" + qe + "|" + xe + ")", He = "(?:['\u2019](?:d|ll|m|re|s|t|ve))?", Ke = "(?:['\u2019](?:D|LL|M|RE|S|T|VE))?", Ye = "(?:" + De + "|" + ke + ")" + "?", Qe = "[" + Be + "]?", ze = Qe + Ye + ("(?:" + Ge + "(?:" + [
            Ne,
            Ve,
            Ue
        ].join("|") + ")" + Qe + Ye + ")*"), Xe = "(?:" + [
            Ie,
            Ve,
            Ue
        ].join("|") + ")" + ze, Ze = "(?:" + [
            Ne + De + "?",
            De,
            Ve,
            Ue,
            we
        ].join("|") + ")", Je = RegExp(Ce, "g"), et = RegExp(De, "g"), tt = RegExp(ke + "(?=" + ke + ")|" + Ze + ze, "g"), rt = RegExp([
            qe + "?" + Fe + "+" + He + "(?=" + [
                Oe,
                qe,
                "$"
            ].join("|") + ")",
            je + "+" + Ke + "(?=" + [
                Oe,
                qe + We,
                "$"
            ].join("|") + ")",
            qe + "?" + We + "+" + He,
            qe + "+" + Ke,
            "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
            "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
            Me,
            Xe
        ].join("|"), "g"), nt = RegExp("[" + Ge + Re + Te + Be + "]"), it = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, st = [
            "Array",
            "Buffer",
            "DataView",
            "Date",
            "Error",
            "Float32Array",
            "Float64Array",
            "Function",
            "Int8Array",
            "Int16Array",
            "Int32Array",
            "Map",
            "Math",
            "Object",
            "Promise",
            "RegExp",
            "Set",
            "String",
            "Symbol",
            "TypeError",
            "Uint8Array",
            "Uint8ClampedArray",
            "Uint16Array",
            "Uint32Array",
            "WeakMap",
            "_",
            "clearTimeout",
            "isFinite",
            "parseInt",
            "setTimeout"
        ], at = -1, ot = {};
        ot[I] = ot[F] = ot[x] = ot[k] = ot[N] = ot[V] = ot[U] = ot[q] = ot[G] = !0, ot[m] = ot[b] = ot[D] = ot[v] = ot[M] = ot[y] = ot[E] = ot[S] = ot[T] = ot[A] = ot[L] = ot[B] = ot[P] = ot[C] = ot[O] = !1;
        var lt = {};
        lt[m] = lt[b] = lt[D] = lt[M] = lt[v] = lt[y] = lt[I] = lt[F] = lt[x] = lt[k] = lt[N] = lt[T] = lt[A] = lt[L] = lt[B] = lt[P] = lt[C] = lt[w] = lt[V] = lt[U] = lt[q] = lt[G] = !0, lt[E] = lt[S] = lt[O] = !1;
        var ut = {
            "\\": "\\",
            "'": "'",
            "\n": "n",
            "\r": "r",
            "\u2028": "u2028",
            "\u2029": "u2029"
        }, dt = parseFloat, ct = parseInt, ht = "object" == typeof $dbaf12f73216aff4$var$r && $dbaf12f73216aff4$var$r && $dbaf12f73216aff4$var$r.Object === Object && $dbaf12f73216aff4$var$r, ft = "object" == typeof self && self && self.Object === Object && self, _t = ht || ft || Function("return this")(), gt = t && !t.nodeType && t, pt = gt && e && !e.nodeType && e, mt = pt && pt.exports === gt, bt = mt && ht.process, vt = function() {
            try {
                var e = pt && pt.require && pt.require("util").types;
                return e || bt && bt.binding && bt.binding("util");
            } catch (e) {}
        }(), yt = vt && vt.isArrayBuffer, Et = vt && vt.isDate, St = vt && vt.isMap, Rt = vt && vt.isRegExp, Tt = vt && vt.isSet, At = vt && vt.isTypedArray;
        function Lt(e, t, r) {
            switch(r.length){
                case 0:
                    return e.call(t);
                case 1:
                    return e.call(t, r[0]);
                case 2:
                    return e.call(t, r[0], r[1]);
                case 3:
                    return e.call(t, r[0], r[1], r[2]);
            }
            return e.apply(t, r);
        }
        function $t(e, t, r, n) {
            for(var i = -1, s = null == e ? 0 : e.length; ++i < s;){
                var a = e[i];
                t(n, a, r(a), e);
            }
            return n;
        }
        function Bt(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e););
            return e;
        }
        function Pt(e, t) {
            for(var r = null == e ? 0 : e.length; r-- && !1 !== t(e[r], r, e););
            return e;
        }
        function Ct(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (!t(e[r], r, e)) return !1;
            return !0;
        }
        function wt(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length, i = 0, s = []; ++r < n;){
                var a = e[r];
                t(a, r, e) && (s[i++] = a);
            }
            return s;
        }
        function Ot(e, t) {
            return !!(null == e ? 0 : e.length) && qt(e, t, 0) > -1;
        }
        function Dt(e, t, r) {
            for(var n = -1, i = null == e ? 0 : e.length; ++n < i;)if (r(t, e[n])) return !0;
            return !1;
        }
        function Mt(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length, i = Array(n); ++r < n;)i[r] = t(e[r], r, e);
            return i;
        }
        function It(e, t) {
            for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
            return e;
        }
        function Ft(e, t, r, n) {
            var i = -1, s = null == e ? 0 : e.length;
            for(n && s && (r = e[++i]); ++i < s;)r = t(r, e[i], i, e);
            return r;
        }
        function xt(e, t, r, n) {
            var i = null == e ? 0 : e.length;
            for(n && i && (r = e[--i]); i--;)r = t(r, e[i], i, e);
            return r;
        }
        function kt(e, t) {
            for(var r = -1, n = null == e ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
            return !1;
        }
        var Nt = Ht("length");
        function Vt(e, t, r) {
            var n;
            return r(e, function(e, r, i) {
                if (t(e, r, i)) return n = r, !1;
            }), n;
        }
        function Ut(e, t, r, n) {
            for(var i = e.length, s = r + (n ? 1 : -1); n ? s-- : ++s < i;)if (t(e[s], s, e)) return s;
            return -1;
        }
        function qt(e, t, r) {
            return t == t ? function(e, t, r) {
                var n = r - 1, i = e.length;
                for(; ++n < i;)if (e[n] === t) return n;
                return -1;
            }(e, t, r) : Ut(e, Wt, r);
        }
        function Gt(e, t, r, n) {
            for(var i = r - 1, s = e.length; ++i < s;)if (n(e[i], t)) return i;
            return -1;
        }
        function Wt(e) {
            return e != e;
        }
        function jt(e, t) {
            var r = null == e ? 0 : e.length;
            return r ? Qt(e, t) / r : _;
        }
        function Ht(e) {
            return function(t) {
                return null == t ? n : t[e];
            };
        }
        function Kt(e) {
            return function(t) {
                return null == e ? n : e[t];
            };
        }
        function Yt(e, t, r, n, i) {
            return i(e, function(e, i, s) {
                r = n ? (n = !1, e) : t(r, e, i, s);
            }), r;
        }
        function Qt(e, t) {
            for(var r, i = -1, s = e.length; ++i < s;){
                var a = t(e[i]);
                a !== n && (r = r === n ? a : r + a);
            }
            return r;
        }
        function zt(e, t) {
            for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
            return n;
        }
        function Xt(e) {
            return e ? e.slice(0, _r(e) + 1).replace(se, "") : e;
        }
        function Zt(e) {
            return function(t) {
                return e(t);
            };
        }
        function Jt(e, t) {
            return Mt(t, function(t) {
                return e[t];
            });
        }
        function er(e, t) {
            return e.has(t);
        }
        function tr(e, t) {
            for(var r = -1, n = e.length; ++r < n && qt(t, e[r], 0) > -1;);
            return r;
        }
        function rr(e, t) {
            for(var r = e.length; r-- && qt(t, e[r], 0) > -1;);
            return r;
        }
        var nr = Kt({
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            "\u0100": "A",
            "\u0102": "A",
            "\u0104": "A",
            "\u0101": "a",
            "\u0103": "a",
            "\u0105": "a",
            "\u0106": "C",
            "\u0108": "C",
            "\u010A": "C",
            "\u010C": "C",
            "\u0107": "c",
            "\u0109": "c",
            "\u010B": "c",
            "\u010D": "c",
            "\u010E": "D",
            "\u0110": "D",
            "\u010F": "d",
            "\u0111": "d",
            "\u0112": "E",
            "\u0114": "E",
            "\u0116": "E",
            "\u0118": "E",
            "\u011A": "E",
            "\u0113": "e",
            "\u0115": "e",
            "\u0117": "e",
            "\u0119": "e",
            "\u011B": "e",
            "\u011C": "G",
            "\u011E": "G",
            "\u0120": "G",
            "\u0122": "G",
            "\u011D": "g",
            "\u011F": "g",
            "\u0121": "g",
            "\u0123": "g",
            "\u0124": "H",
            "\u0126": "H",
            "\u0125": "h",
            "\u0127": "h",
            "\u0128": "I",
            "\u012A": "I",
            "\u012C": "I",
            "\u012E": "I",
            "\u0130": "I",
            "\u0129": "i",
            "\u012B": "i",
            "\u012D": "i",
            "\u012F": "i",
            "\u0131": "i",
            "\u0134": "J",
            "\u0135": "j",
            "\u0136": "K",
            "\u0137": "k",
            "\u0138": "k",
            "\u0139": "L",
            "\u013B": "L",
            "\u013D": "L",
            "\u013F": "L",
            "\u0141": "L",
            "\u013A": "l",
            "\u013C": "l",
            "\u013E": "l",
            "\u0140": "l",
            "\u0142": "l",
            "\u0143": "N",
            "\u0145": "N",
            "\u0147": "N",
            "\u014A": "N",
            "\u0144": "n",
            "\u0146": "n",
            "\u0148": "n",
            "\u014B": "n",
            "\u014C": "O",
            "\u014E": "O",
            "\u0150": "O",
            "\u014D": "o",
            "\u014F": "o",
            "\u0151": "o",
            "\u0154": "R",
            "\u0156": "R",
            "\u0158": "R",
            "\u0155": "r",
            "\u0157": "r",
            "\u0159": "r",
            "\u015A": "S",
            "\u015C": "S",
            "\u015E": "S",
            "\u0160": "S",
            "\u015B": "s",
            "\u015D": "s",
            "\u015F": "s",
            "\u0161": "s",
            "\u0162": "T",
            "\u0164": "T",
            "\u0166": "T",
            "\u0163": "t",
            "\u0165": "t",
            "\u0167": "t",
            "\u0168": "U",
            "\u016A": "U",
            "\u016C": "U",
            "\u016E": "U",
            "\u0170": "U",
            "\u0172": "U",
            "\u0169": "u",
            "\u016B": "u",
            "\u016D": "u",
            "\u016F": "u",
            "\u0171": "u",
            "\u0173": "u",
            "\u0174": "W",
            "\u0175": "w",
            "\u0176": "Y",
            "\u0177": "y",
            "\u0178": "Y",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u017D": "Z",
            "\u017A": "z",
            "\u017C": "z",
            "\u017E": "z",
            "\u0132": "IJ",
            "\u0133": "ij",
            "\u0152": "Oe",
            "\u0153": "oe",
            "\u0149": "'n",
            "\u017F": "s"
        }), ir = Kt({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;"
        });
        function sr(e) {
            return "\\" + ut[e];
        }
        function ar(e) {
            return nt.test(e);
        }
        function or(e) {
            var t = -1, r = Array(e.size);
            return e.forEach(function(e, n) {
                r[++t] = [
                    n,
                    e
                ];
            }), r;
        }
        function lr(e, t) {
            return function(r) {
                return e(t(r));
            };
        }
        function ur(e, t) {
            for(var r = -1, n = e.length, i = 0, s = []; ++r < n;){
                var o = e[r];
                o !== t && o !== a || (e[r] = a, s[i++] = r);
            }
            return s;
        }
        function dr(e) {
            var t = -1, r = Array(e.size);
            return e.forEach(function(e) {
                r[++t] = e;
            }), r;
        }
        function cr(e) {
            var t = -1, r = Array(e.size);
            return e.forEach(function(e) {
                r[++t] = [
                    e,
                    e
                ];
            }), r;
        }
        function hr(e) {
            return ar(e) ? function(e) {
                var t = tt.lastIndex = 0;
                for(; tt.test(e);)++t;
                return t;
            }(e) : Nt(e);
        }
        function fr(e) {
            return ar(e) ? function(e) {
                return e.match(tt) || [];
            }(e) : function(e) {
                return e.split("");
            }(e);
        }
        function _r(e) {
            for(var t = e.length; t-- && ae.test(e.charAt(t)););
            return t;
        }
        var gr = Kt({
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
        });
        var pr = function e(t) {
            var r, ae = (t = null == t ? _t : pr.defaults(_t.Object(), t, pr.pick(_t, st))).Array, Re = t.Date, Te = t.Error, Ae = t.Function, Le = t.Math, $e = t.Object, Be = t.RegExp, Pe = t.String, Ce = t.TypeError, we = ae.prototype, Oe = Ae.prototype, De = $e.prototype, Me = t["__core-js_shared__"], Ie = Oe.toString, Fe = De.hasOwnProperty, xe = 0, ke = (r = /[^.]+$/.exec(Me && Me.keys && Me.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "", Ne = De.toString, Ve = Ie.call($e), Ue = _t._, qe = Be("^" + Ie.call(Fe).replace(ne, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ge = mt ? t.Buffer : n, We = t.Symbol, je = t.Uint8Array, He = Ge ? Ge.allocUnsafe : n, Ke = lr($e.getPrototypeOf, $e), Ye = $e.create, Qe = De.propertyIsEnumerable, ze = we.splice, Xe = We ? We.isConcatSpreadable : n, Ze = We ? We.iterator : n, tt = We ? We.toStringTag : n, nt = function() {
                try {
                    var e = hs($e, "defineProperty");
                    return e({}, "", {}), e;
                } catch (e) {}
            }(), ut = t.clearTimeout !== _t.clearTimeout && t.clearTimeout, ht = Re && Re.now !== _t.Date.now && Re.now, ft = t.setTimeout !== _t.setTimeout && t.setTimeout, gt = Le.ceil, pt = Le.floor, bt = $e.getOwnPropertySymbols, vt = Ge ? Ge.isBuffer : n, Nt = t.isFinite, Kt = we.join, mr = lr($e.keys, $e), br = Le.max, vr = Le.min, yr = Re.now, Er = t.parseInt, Sr = Le.random, Rr = we.reverse, Tr = hs(t, "DataView"), Ar = hs(t, "Map"), Lr = hs(t, "Promise"), $r = hs(t, "Set"), Br = hs(t, "WeakMap"), Pr = hs($e, "create"), Cr = Br && new Br, wr = {}, Or = Us(Tr), Dr = Us(Ar), Mr = Us(Lr), Ir = Us($r), Fr = Us(Br), xr = We ? We.prototype : n, kr = xr ? xr.valueOf : n, Nr = xr ? xr.toString : n;
            function Vr(e) {
                if (io(e) && !Ka(e) && !(e instanceof Wr)) {
                    if (e instanceof Gr) return e;
                    if (Fe.call(e, "__wrapped__")) return qs(e);
                }
                return new Gr(e);
            }
            var Ur = function() {
                function e() {}
                return function(t) {
                    if (!no(t)) return {};
                    if (Ye) return Ye(t);
                    e.prototype = t;
                    var r = new e;
                    return e.prototype = n, r;
                };
            }();
            function qr() {}
            function Gr(e, t) {
                this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = n;
            }
            function Wr(e) {
                this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = g, this.__views__ = [];
            }
            function jr(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function Hr(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function Kr(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.clear(); ++t < r;){
                    var n = e[t];
                    this.set(n[0], n[1]);
                }
            }
            function Yr(e) {
                var t = -1, r = null == e ? 0 : e.length;
                for(this.__data__ = new Kr; ++t < r;)this.add(e[t]);
            }
            function Qr(e) {
                var t = this.__data__ = new Hr(e);
                this.size = t.size;
            }
            function zr(e, t) {
                var r = Ka(e), n = !r && Ha(e), i = !r && !n && Xa(e), s = !r && !n && !i && fo(e), a = r || n || i || s, o = a ? zt(e.length, Pe) : [], l = o.length;
                for(var u in e)!t && !Fe.call(e, u) || a && ("length" == u || i && ("offset" == u || "parent" == u) || s && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || vs(u, l)) || o.push(u);
                return o;
            }
            function Xr(e) {
                var t = e.length;
                return t ? e[Qn(0, t - 1)] : n;
            }
            function Zr(e, t) {
                return Is(Ci(e), ln(t, 0, e.length));
            }
            function Jr(e) {
                return Is(Ci(e));
            }
            function en(e, t, r) {
                (r !== n && !Ga(e[t], r) || r === n && !(t in e)) && an(e, t, r);
            }
            function tn(e, t, r) {
                var i = e[t];
                Fe.call(e, t) && Ga(i, r) && (r !== n || t in e) || an(e, t, r);
            }
            function rn(e, t) {
                for(var r = e.length; r--;)if (Ga(e[r][0], t)) return r;
                return -1;
            }
            function nn(e, t, r, n) {
                return fn(e, function(e, i, s) {
                    t(n, e, r(e), s);
                }), n;
            }
            function sn(e, t) {
                return e && wi(t, Io(t), e);
            }
            function an(e, t, r) {
                "__proto__" == t && nt ? nt(e, t, {
                    configurable: !0,
                    enumerable: !0,
                    value: r,
                    writable: !0
                }) : e[t] = r;
            }
            function on(e, t) {
                for(var r = -1, i = t.length, s = ae(i), a = null == e; ++r < i;)s[r] = a ? n : Co(e, t[r]);
                return s;
            }
            function ln(e, t, r) {
                return e == e && (r !== n && (e = e <= r ? e : r), t !== n && (e = e >= t ? e : t)), e;
            }
            function un(e, t, r, i, s, a) {
                var o, l = 1 & t, u = 2 & t, d = 4 & t;
                if (r && (o = s ? r(e, i, s, a) : r(e)), o !== n) return o;
                if (!no(e)) return e;
                var c = Ka(e);
                if (c) {
                    if (o = function(e) {
                        var t = e.length, r = new e.constructor(t);
                        t && "string" == typeof e[0] && Fe.call(e, "index") && (r.index = e.index, r.input = e.input);
                        return r;
                    }(e), !l) return Ci(e, o);
                } else {
                    var h = gs(e), f = h == S || h == R;
                    if (Xa(e)) return Ti(e, l);
                    if (h == L || h == m || f && !s) {
                        if (o = u || f ? {} : ms(e), !l) return u ? function(e, t) {
                            return wi(e, _s(e), t);
                        }(e, function(e, t) {
                            return e && wi(t, Fo(t), e);
                        }(o, e)) : function(e, t) {
                            return wi(e, fs(e), t);
                        }(e, sn(o, e));
                    } else {
                        if (!lt[h]) return s ? e : {};
                        o = function(e, t, r) {
                            var n = e.constructor;
                            switch(t){
                                case D:
                                    return Ai(e);
                                case v:
                                case y:
                                    return new n(+e);
                                case M:
                                    return function(e, t) {
                                        var r = t ? Ai(e.buffer) : e.buffer;
                                        return new e.constructor(r, e.byteOffset, e.byteLength);
                                    }(e, r);
                                case I:
                                case F:
                                case x:
                                case k:
                                case N:
                                case V:
                                case U:
                                case q:
                                case G:
                                    return Li(e, r);
                                case T:
                                    return new n;
                                case A:
                                case C:
                                    return new n(e);
                                case B:
                                    return function(e) {
                                        var t = new e.constructor(e.source, _e.exec(e));
                                        return t.lastIndex = e.lastIndex, t;
                                    }(e);
                                case P:
                                    return new n;
                                case w:
                                    return i = e, kr ? $e(kr.call(i)) : {};
                            }
                            var i;
                        }(e, h, l);
                    }
                }
                a || (a = new Qr);
                var _ = a.get(e);
                if (_) return _;
                a.set(e, o), uo(e) ? e.forEach(function(n) {
                    o.add(un(n, t, r, n, e, a));
                }) : so(e) && e.forEach(function(n, i) {
                    o.set(i, un(n, t, r, i, e, a));
                });
                var g = c ? n : (d ? u ? ss : is : u ? Fo : Io)(e);
                return Bt(g || e, function(n, i) {
                    g && (n = e[i = n]), tn(o, i, un(n, t, r, i, e, a));
                }), o;
            }
            function dn(e, t, r) {
                var i = r.length;
                if (null == e) return !i;
                for(e = $e(e); i--;){
                    var s = r[i], a = t[s], o = e[s];
                    if (o === n && !(s in e) || !a(o)) return !1;
                }
                return !0;
            }
            function cn(e, t, r) {
                if ("function" != typeof e) throw new Ce(i);
                return ws(function() {
                    e.apply(n, r);
                }, t);
            }
            function hn(e, t, r, n) {
                var i = -1, s = Ot, a = !0, o = e.length, l = [], u = t.length;
                if (!o) return l;
                r && (t = Mt(t, Zt(r))), n ? (s = Dt, a = !1) : t.length >= 200 && (s = er, a = !1, t = new Yr(t));
                e: for(; ++i < o;){
                    var d = e[i], c = null == r ? d : r(d);
                    if (d = n || 0 !== d ? d : 0, a && c == c) {
                        for(var h = u; h--;)if (t[h] === c) continue e;
                        l.push(d);
                    } else s(t, c, n) || l.push(d);
                }
                return l;
            }
            Vr.templateSettings = {
                escape: X,
                evaluate: Z,
                interpolate: J,
                variable: "",
                imports: {
                    _: Vr
                }
            }, Vr.prototype = qr.prototype, Vr.prototype.constructor = Vr, Gr.prototype = Ur(qr.prototype), Gr.prototype.constructor = Gr, Wr.prototype = Ur(qr.prototype), Wr.prototype.constructor = Wr, jr.prototype.clear = function() {
                this.__data__ = Pr ? Pr(null) : {}, this.size = 0;
            }, jr.prototype.delete = function(e) {
                var t = this.has(e) && delete this.__data__[e];
                return this.size -= t ? 1 : 0, t;
            }, jr.prototype.get = function(e) {
                var t = this.__data__;
                if (Pr) {
                    var r = t[e];
                    return r === s ? n : r;
                }
                return Fe.call(t, e) ? t[e] : n;
            }, jr.prototype.has = function(e) {
                var t = this.__data__;
                return Pr ? t[e] !== n : Fe.call(t, e);
            }, jr.prototype.set = function(e, t) {
                var r = this.__data__;
                return this.size += this.has(e) ? 0 : 1, r[e] = Pr && t === n ? s : t, this;
            }, Hr.prototype.clear = function() {
                this.__data__ = [], this.size = 0;
            }, Hr.prototype.delete = function(e) {
                var t = this.__data__, r = rn(t, e);
                return !(r < 0) && (r == t.length - 1 ? t.pop() : ze.call(t, r, 1), --this.size, !0);
            }, Hr.prototype.get = function(e) {
                var t = this.__data__, r = rn(t, e);
                return r < 0 ? n : t[r][1];
            }, Hr.prototype.has = function(e) {
                return rn(this.__data__, e) > -1;
            }, Hr.prototype.set = function(e, t) {
                var r = this.__data__, n = rn(r, e);
                return n < 0 ? (++this.size, r.push([
                    e,
                    t
                ])) : r[n][1] = t, this;
            }, Kr.prototype.clear = function() {
                this.size = 0, this.__data__ = {
                    hash: new jr,
                    map: new (Ar || Hr),
                    string: new jr
                };
            }, Kr.prototype.delete = function(e) {
                var t = ds(this, e).delete(e);
                return this.size -= t ? 1 : 0, t;
            }, Kr.prototype.get = function(e) {
                return ds(this, e).get(e);
            }, Kr.prototype.has = function(e) {
                return ds(this, e).has(e);
            }, Kr.prototype.set = function(e, t) {
                var r = ds(this, e), n = r.size;
                return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
            }, Yr.prototype.add = Yr.prototype.push = function(e) {
                return this.__data__.set(e, s), this;
            }, Yr.prototype.has = function(e) {
                return this.__data__.has(e);
            }, Qr.prototype.clear = function() {
                this.__data__ = new Hr, this.size = 0;
            }, Qr.prototype.delete = function(e) {
                var t = this.__data__, r = t.delete(e);
                return this.size = t.size, r;
            }, Qr.prototype.get = function(e) {
                return this.__data__.get(e);
            }, Qr.prototype.has = function(e) {
                return this.__data__.has(e);
            }, Qr.prototype.set = function(e, t) {
                var r = this.__data__;
                if (r instanceof Hr) {
                    var n = r.__data__;
                    if (!Ar || n.length < 199) return n.push([
                        e,
                        t
                    ]), this.size = ++r.size, this;
                    r = this.__data__ = new Kr(n);
                }
                return r.set(e, t), this.size = r.size, this;
            };
            var fn = Mi(En), _n = Mi(Sn, !0);
            function gn(e, t) {
                var r = !0;
                return fn(e, function(e, n, i) {
                    return r = !!t(e, n, i);
                }), r;
            }
            function pn(e, t, r) {
                for(var i = -1, s = e.length; ++i < s;){
                    var a = e[i], o = t(a);
                    if (null != o && (l === n ? o == o && !ho(o) : r(o, l))) var l = o, u = a;
                }
                return u;
            }
            function mn(e, t) {
                var r = [];
                return fn(e, function(e, n, i) {
                    t(e, n, i) && r.push(e);
                }), r;
            }
            function bn(e, t, r, n, i) {
                var s = -1, a = e.length;
                for(r || (r = bs), i || (i = []); ++s < a;){
                    var o = e[s];
                    t > 0 && r(o) ? t > 1 ? bn(o, t - 1, r, n, i) : It(i, o) : n || (i[i.length] = o);
                }
                return i;
            }
            var vn = Ii(), yn = Ii(!0);
            function En(e, t) {
                return e && vn(e, t, Io);
            }
            function Sn(e, t) {
                return e && yn(e, t, Io);
            }
            function Rn(e, t) {
                return wt(t, function(t) {
                    return eo(e[t]);
                });
            }
            function Tn(e, t) {
                for(var r = 0, i = (t = yi(t, e)).length; null != e && r < i;)e = e[Vs(t[r++])];
                return r && r == i ? e : n;
            }
            function An(e, t, r) {
                var n = t(e);
                return Ka(e) ? n : It(n, r(e));
            }
            function Ln(e) {
                return null == e ? e === n ? "[object Undefined]" : "[object Null]" : tt && tt in $e(e) ? function(e) {
                    var t = Fe.call(e, tt), r = e[tt];
                    try {
                        e[tt] = n;
                        var i = !0;
                    } catch (e) {}
                    var s = Ne.call(e);
                    i && (t ? e[tt] = r : delete e[tt]);
                    return s;
                }(e) : function(e) {
                    return Ne.call(e);
                }(e);
            }
            function $n(e, t) {
                return e > t;
            }
            function Bn(e, t) {
                return null != e && Fe.call(e, t);
            }
            function Pn(e, t) {
                return null != e && t in $e(e);
            }
            function Cn(e, t, r) {
                for(var i = r ? Dt : Ot, s = e[0].length, a = e.length, o = a, l = ae(a), u = 1 / 0, d = []; o--;){
                    var c = e[o];
                    o && t && (c = Mt(c, Zt(t))), u = vr(c.length, u), l[o] = !r && (t || s >= 120 && c.length >= 120) ? new Yr(o && c) : n;
                }
                c = e[0];
                var h = -1, f = l[0];
                e: for(; ++h < s && d.length < u;){
                    var _ = c[h], g = t ? t(_) : _;
                    if (_ = r || 0 !== _ ? _ : 0, !(f ? er(f, g) : i(d, g, r))) {
                        for(o = a; --o;){
                            var p = l[o];
                            if (!(p ? er(p, g) : i(e[o], g, r))) continue e;
                        }
                        f && f.push(g), d.push(_);
                    }
                }
                return d;
            }
            function wn(e, t, r) {
                var i = null == (e = Bs(e, t = yi(t, e))) ? e : e[Vs(Js(t))];
                return null == i ? n : Lt(i, e, r);
            }
            function On(e) {
                return io(e) && Ln(e) == m;
            }
            function Dn(e, t, r, i, s) {
                return e === t || (null == e || null == t || !io(e) && !io(t) ? e != e && t != t : function(e, t, r, i, s, a) {
                    var o = Ka(e), l = Ka(t), u = o ? b : gs(e), d = l ? b : gs(t), c = (u = u == m ? L : u) == L, h = (d = d == m ? L : d) == L, f = u == d;
                    if (f && Xa(e)) {
                        if (!Xa(t)) return !1;
                        o = !0, c = !1;
                    }
                    if (f && !c) return a || (a = new Qr), o || fo(e) ? rs(e, t, r, i, s, a) : function(e, t, r, n, i, s, a) {
                        switch(r){
                            case M:
                                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                                e = e.buffer, t = t.buffer;
                            case D:
                                return !(e.byteLength != t.byteLength || !s(new je(e), new je(t)));
                            case v:
                            case y:
                            case A:
                                return Ga(+e, +t);
                            case E:
                                return e.name == t.name && e.message == t.message;
                            case B:
                            case C:
                                return e == t + "";
                            case T:
                                var o = or;
                            case P:
                                var l = 1 & n;
                                if (o || (o = dr), e.size != t.size && !l) return !1;
                                var u = a.get(e);
                                if (u) return u == t;
                                n |= 2, a.set(e, t);
                                var d = rs(o(e), o(t), n, i, s, a);
                                return a.delete(e), d;
                            case w:
                                if (kr) return kr.call(e) == kr.call(t);
                        }
                        return !1;
                    }(e, t, u, r, i, s, a);
                    if (!(1 & r)) {
                        var _ = c && Fe.call(e, "__wrapped__"), g = h && Fe.call(t, "__wrapped__");
                        if (_ || g) {
                            var p = _ ? e.value() : e, S = g ? t.value() : t;
                            return a || (a = new Qr), s(p, S, r, i, a);
                        }
                    }
                    return !!f && (a || (a = new Qr), function(e, t, r, i, s, a) {
                        var o = 1 & r, l = is(e), u = l.length, d = is(t), c = d.length;
                        if (u != c && !o) return !1;
                        var h = u;
                        for(; h--;){
                            var f = l[h];
                            if (!(o ? f in t : Fe.call(t, f))) return !1;
                        }
                        var _ = a.get(e), g = a.get(t);
                        if (_ && g) return _ == t && g == e;
                        var p = !0;
                        a.set(e, t), a.set(t, e);
                        var m = o;
                        for(; ++h < u;){
                            var b = e[f = l[h]], v = t[f];
                            if (i) var y = o ? i(v, b, f, t, e, a) : i(b, v, f, e, t, a);
                            if (!(y === n ? b === v || s(b, v, r, i, a) : y)) {
                                p = !1;
                                break;
                            }
                            m || (m = "constructor" == f);
                        }
                        if (p && !m) {
                            var E = e.constructor, S = t.constructor;
                            E == S || !("constructor" in e) || !("constructor" in t) || "function" == typeof E && E instanceof E && "function" == typeof S && S instanceof S || (p = !1);
                        }
                        return a.delete(e), a.delete(t), p;
                    }(e, t, r, i, s, a));
                }(e, t, r, i, Dn, s));
            }
            function Mn(e, t, r, i) {
                var s = r.length, a = s, o = !i;
                if (null == e) return !a;
                for(e = $e(e); s--;){
                    var l = r[s];
                    if (o && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
                }
                for(; ++s < a;){
                    var u = (l = r[s])[0], d = e[u], c = l[1];
                    if (o && l[2]) {
                        if (d === n && !(u in e)) return !1;
                    } else {
                        var h = new Qr;
                        if (i) var f = i(d, c, u, e, t, h);
                        if (!(f === n ? Dn(c, d, 3, i, h) : f)) return !1;
                    }
                }
                return !0;
            }
            function In(e) {
                var t;
                return !(!no(e) || (t = e, ke && ke in t)) && (eo(e) ? qe : me).test(Us(e));
            }
            function Fn(e) {
                return "function" == typeof e ? e : null == e ? ol : "object" == typeof e ? Ka(e) ? qn(e[0], e[1]) : Un(e) : pl(e);
            }
            function xn(e) {
                if (!Ts(e)) return mr(e);
                var t = [];
                for(var r in $e(e))Fe.call(e, r) && "constructor" != r && t.push(r);
                return t;
            }
            function kn(e) {
                if (!no(e)) return function(e) {
                    var t = [];
                    if (null != e) for(var r in $e(e))t.push(r);
                    return t;
                }(e);
                var t = Ts(e), r = [];
                for(var n in e)("constructor" != n || !t && Fe.call(e, n)) && r.push(n);
                return r;
            }
            function Nn(e, t) {
                return e < t;
            }
            function Vn(e, t) {
                var r = -1, n = Qa(e) ? ae(e.length) : [];
                return fn(e, function(e, i, s) {
                    n[++r] = t(e, i, s);
                }), n;
            }
            function Un(e) {
                var t = cs(e);
                return 1 == t.length && t[0][2] ? Ls(t[0][0], t[0][1]) : function(r) {
                    return r === e || Mn(r, e, t);
                };
            }
            function qn(e, t) {
                return Es(e) && As(t) ? Ls(Vs(e), t) : function(r) {
                    var i = Co(r, e);
                    return i === n && i === t ? wo(r, e) : Dn(t, i, 3);
                };
            }
            function Gn(e, t, r, i, s) {
                e !== t && vn(t, function(a, o) {
                    if (s || (s = new Qr), no(a)) !function(e, t, r, i, s, a, o) {
                        var l = Ps(e, r), u = Ps(t, r), d = o.get(u);
                        if (d) return void en(e, r, d);
                        var c = a ? a(l, u, r + "", e, t, o) : n, h = c === n;
                        if (h) {
                            var f = Ka(u), _ = !f && Xa(u), g = !f && !_ && fo(u);
                            c = u, f || _ || g ? Ka(l) ? c = l : za(l) ? c = Ci(l) : _ ? (h = !1, c = Ti(u, !0)) : g ? (h = !1, c = Li(u, !0)) : c = [] : oo(u) || Ha(u) ? (c = l, Ha(l) ? c = Eo(l) : no(l) && !eo(l) || (c = ms(u))) : h = !1;
                        }
                        h && (o.set(u, c), s(c, u, i, a, o), o.delete(u));
                        en(e, r, c);
                    }(e, t, o, r, Gn, i, s);
                    else {
                        var l = i ? i(Ps(e, o), a, o + "", e, t, s) : n;
                        l === n && (l = a), en(e, o, l);
                    }
                }, Fo);
            }
            function Wn(e, t) {
                var r = e.length;
                if (r) return vs(t += t < 0 ? r : 0, r) ? e[t] : n;
            }
            function jn(e, t, r) {
                t = t.length ? Mt(t, function(e) {
                    return Ka(e) ? function(t) {
                        return Tn(t, 1 === e.length ? e[0] : e);
                    } : e;
                }) : [
                    ol
                ];
                var n = -1;
                return t = Mt(t, Zt(us())), function(e, t) {
                    var r = e.length;
                    for(e.sort(t); r--;)e[r] = e[r].value;
                    return e;
                }(Vn(e, function(e, r, i) {
                    return {
                        criteria: Mt(t, function(t) {
                            return t(e);
                        }),
                        index: ++n,
                        value: e
                    };
                }), function(e, t) {
                    return function(e, t, r) {
                        var n = -1, i = e.criteria, s = t.criteria, a = i.length, o = r.length;
                        for(; ++n < a;){
                            var l = $i(i[n], s[n]);
                            if (l) return n >= o ? l : l * ("desc" == r[n] ? -1 : 1);
                        }
                        return e.index - t.index;
                    }(e, t, r);
                });
            }
            function Hn(e, t, r) {
                for(var n = -1, i = t.length, s = {}; ++n < i;){
                    var a = t[n], o = Tn(e, a);
                    r(o, a) && ei(s, yi(a, e), o);
                }
                return s;
            }
            function Kn(e, t, r, n) {
                var i = n ? Gt : qt, s = -1, a = t.length, o = e;
                for(e === t && (t = Ci(t)), r && (o = Mt(e, Zt(r))); ++s < a;)for(var l = 0, u = t[s], d = r ? r(u) : u; (l = i(o, d, l, n)) > -1;)o !== e && ze.call(o, l, 1), ze.call(e, l, 1);
                return e;
            }
            function Yn(e, t) {
                for(var r = e ? t.length : 0, n = r - 1; r--;){
                    var i = t[r];
                    if (r == n || i !== s) {
                        var s = i;
                        vs(i) ? ze.call(e, i, 1) : hi(e, i);
                    }
                }
                return e;
            }
            function Qn(e, t) {
                return e + pt(Sr() * (t - e + 1));
            }
            function zn(e, t) {
                var r = "";
                if (!e || t < 1 || t > f) return r;
                do t % 2 && (r += e), (t = pt(t / 2)) && (e += e);
                while (t);
                return r;
            }
            function Xn(e, t) {
                return Os($s(e, t, ol), e + "");
            }
            function Zn(e) {
                return Xr(Wo(e));
            }
            function Jn(e, t) {
                var r = Wo(e);
                return Is(r, ln(t, 0, r.length));
            }
            function ei(e, t, r, i) {
                if (!no(e)) return e;
                for(var s = -1, a = (t = yi(t, e)).length, o = a - 1, l = e; null != l && ++s < a;){
                    var u = Vs(t[s]), d = r;
                    if ("__proto__" === u || "constructor" === u || "prototype" === u) return e;
                    if (s != o) {
                        var c = l[u];
                        (d = i ? i(c, u, l) : n) === n && (d = no(c) ? c : vs(t[s + 1]) ? [] : {});
                    }
                    tn(l, u, d), l = l[u];
                }
                return e;
            }
            var ti = Cr ? function(e, t) {
                return Cr.set(e, t), e;
            } : ol, ri = nt ? function(e, t) {
                return nt(e, "toString", {
                    configurable: !0,
                    enumerable: !1,
                    value: il(t),
                    writable: !0
                });
            } : ol;
            function ni(e) {
                return Is(Wo(e));
            }
            function ii(e, t, r) {
                var n = -1, i = e.length;
                t < 0 && (t = -t > i ? 0 : i + t), (r = r > i ? i : r) < 0 && (r += i), i = t > r ? 0 : r - t >>> 0, t >>>= 0;
                for(var s = ae(i); ++n < i;)s[n] = e[n + t];
                return s;
            }
            function si(e, t) {
                var r;
                return fn(e, function(e, n, i) {
                    return !(r = t(e, n, i));
                }), !!r;
            }
            function ai(e, t, r) {
                var n = 0, i = null == e ? n : e.length;
                if ("number" == typeof t && t == t && i <= 2147483647) {
                    for(; n < i;){
                        var s = n + i >>> 1, a = e[s];
                        null !== a && !ho(a) && (r ? a <= t : a < t) ? n = s + 1 : i = s;
                    }
                    return i;
                }
                return oi(e, t, ol, r);
            }
            function oi(e, t, r, i) {
                var s = 0, a = null == e ? 0 : e.length;
                if (0 === a) return 0;
                for(var o = (t = r(t)) != t, l = null === t, u = ho(t), d = t === n; s < a;){
                    var c = pt((s + a) / 2), h = r(e[c]), f = h !== n, _ = null === h, g = h == h, p = ho(h);
                    if (o) var m = i || g;
                    else m = d ? g && (i || f) : l ? g && f && (i || !_) : u ? g && f && !_ && (i || !p) : !_ && !p && (i ? h <= t : h < t);
                    m ? s = c + 1 : a = c;
                }
                return vr(a, 4294967294);
            }
            function li(e, t) {
                for(var r = -1, n = e.length, i = 0, s = []; ++r < n;){
                    var a = e[r], o = t ? t(a) : a;
                    if (!r || !Ga(o, l)) {
                        var l = o;
                        s[i++] = 0 === a ? 0 : a;
                    }
                }
                return s;
            }
            function ui(e) {
                return "number" == typeof e ? e : ho(e) ? _ : +e;
            }
            function di(e) {
                if ("string" == typeof e) return e;
                if (Ka(e)) return Mt(e, di) + "";
                if (ho(e)) return Nr ? Nr.call(e) : "";
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function ci(e, t, r) {
                var n = -1, i = Ot, s = e.length, a = !0, o = [], l = o;
                if (r) a = !1, i = Dt;
                else if (s >= 200) {
                    var u = t ? null : zi(e);
                    if (u) return dr(u);
                    a = !1, i = er, l = new Yr;
                } else l = t ? [] : o;
                e: for(; ++n < s;){
                    var d = e[n], c = t ? t(d) : d;
                    if (d = r || 0 !== d ? d : 0, a && c == c) {
                        for(var h = l.length; h--;)if (l[h] === c) continue e;
                        t && l.push(c), o.push(d);
                    } else i(l, c, r) || (l !== o && l.push(c), o.push(d));
                }
                return o;
            }
            function hi(e, t) {
                return null == (e = Bs(e, t = yi(t, e))) || delete e[Vs(Js(t))];
            }
            function fi(e, t, r, n) {
                return ei(e, t, r(Tn(e, t)), n);
            }
            function _i(e, t, r, n) {
                for(var i = e.length, s = n ? i : -1; (n ? s-- : ++s < i) && t(e[s], s, e););
                return r ? ii(e, n ? 0 : s, n ? s + 1 : i) : ii(e, n ? s + 1 : 0, n ? i : s);
            }
            function gi(e, t) {
                var r = e;
                return r instanceof Wr && (r = r.value()), Ft(t, function(e, t) {
                    return t.func.apply(t.thisArg, It([
                        e
                    ], t.args));
                }, r);
            }
            function pi(e, t, r) {
                var n = e.length;
                if (n < 2) return n ? ci(e[0]) : [];
                for(var i = -1, s = ae(n); ++i < n;)for(var a = e[i], o = -1; ++o < n;)o != i && (s[i] = hn(s[i] || a, e[o], t, r));
                return ci(bn(s, 1), t, r);
            }
            function mi(e, t, r) {
                for(var i = -1, s = e.length, a = t.length, o = {}; ++i < s;){
                    var l = i < a ? t[i] : n;
                    r(o, e[i], l);
                }
                return o;
            }
            function bi(e) {
                return za(e) ? e : [];
            }
            function vi(e) {
                return "function" == typeof e ? e : ol;
            }
            function yi(e, t) {
                return Ka(e) ? e : Es(e, t) ? [
                    e
                ] : Ns(So(e));
            }
            var Ei = Xn;
            function Si(e, t, r) {
                var i = e.length;
                return r = r === n ? i : r, !t && r >= i ? e : ii(e, t, r);
            }
            var Ri = ut || function(e) {
                return _t.clearTimeout(e);
            };
            function Ti(e, t) {
                if (t) return e.slice();
                var r = e.length, n = He ? He(r) : new e.constructor(r);
                return e.copy(n), n;
            }
            function Ai(e) {
                var t = new e.constructor(e.byteLength);
                return new je(t).set(new je(e)), t;
            }
            function Li(e, t) {
                var r = t ? Ai(e.buffer) : e.buffer;
                return new e.constructor(r, e.byteOffset, e.length);
            }
            function $i(e, t) {
                if (e !== t) {
                    var r = e !== n, i = null === e, s = e == e, a = ho(e), o = t !== n, l = null === t, u = t == t, d = ho(t);
                    if (!l && !d && !a && e > t || a && o && u && !l && !d || i && o && u || !r && u || !s) return 1;
                    if (!i && !a && !d && e < t || d && r && s && !i && !a || l && r && s || !o && s || !u) return -1;
                }
                return 0;
            }
            function Bi(e, t, r, n) {
                for(var i = -1, s = e.length, a = r.length, o = -1, l = t.length, u = br(s - a, 0), d = ae(l + u), c = !n; ++o < l;)d[o] = t[o];
                for(; ++i < a;)(c || i < s) && (d[r[i]] = e[i]);
                for(; u--;)d[o++] = e[i++];
                return d;
            }
            function Pi(e, t, r, n) {
                for(var i = -1, s = e.length, a = -1, o = r.length, l = -1, u = t.length, d = br(s - o, 0), c = ae(d + u), h = !n; ++i < d;)c[i] = e[i];
                for(var f = i; ++l < u;)c[f + l] = t[l];
                for(; ++a < o;)(h || i < s) && (c[f + r[a]] = e[i++]);
                return c;
            }
            function Ci(e, t) {
                var r = -1, n = e.length;
                for(t || (t = ae(n)); ++r < n;)t[r] = e[r];
                return t;
            }
            function wi(e, t, r, i) {
                var s = !r;
                r || (r = {});
                for(var a = -1, o = t.length; ++a < o;){
                    var l = t[a], u = i ? i(r[l], e[l], l, r, e) : n;
                    u === n && (u = e[l]), s ? an(r, l, u) : tn(r, l, u);
                }
                return r;
            }
            function Oi(e, t) {
                return function(r, n) {
                    var i = Ka(r) ? $t : nn, s = t ? t() : {};
                    return i(r, e, us(n, 2), s);
                };
            }
            function Di(e) {
                return Xn(function(t, r) {
                    var i = -1, s = r.length, a = s > 1 ? r[s - 1] : n, o = s > 2 ? r[2] : n;
                    for(a = e.length > 3 && "function" == typeof a ? (s--, a) : n, o && ys(r[0], r[1], o) && (a = s < 3 ? n : a, s = 1), t = $e(t); ++i < s;){
                        var l = r[i];
                        l && e(t, l, i, a);
                    }
                    return t;
                });
            }
            function Mi(e, t) {
                return function(r, n) {
                    if (null == r) return r;
                    if (!Qa(r)) return e(r, n);
                    for(var i = r.length, s = t ? i : -1, a = $e(r); (t ? s-- : ++s < i) && !1 !== n(a[s], s, a););
                    return r;
                };
            }
            function Ii(e) {
                return function(t, r, n) {
                    for(var i = -1, s = $e(t), a = n(t), o = a.length; o--;){
                        var l = a[e ? o : ++i];
                        if (!1 === r(s[l], l, s)) break;
                    }
                    return t;
                };
            }
            function Fi(e) {
                return function(t) {
                    var r = ar(t = So(t)) ? fr(t) : n, i = r ? r[0] : t.charAt(0), s = r ? Si(r, 1).join("") : t.slice(1);
                    return i[e]() + s;
                };
            }
            function xi(e) {
                return function(t) {
                    return Ft(tl(Ko(t).replace(Je, "")), e, "");
                };
            }
            function ki(e) {
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return new e;
                        case 1:
                            return new e(t[0]);
                        case 2:
                            return new e(t[0], t[1]);
                        case 3:
                            return new e(t[0], t[1], t[2]);
                        case 4:
                            return new e(t[0], t[1], t[2], t[3]);
                        case 5:
                            return new e(t[0], t[1], t[2], t[3], t[4]);
                        case 6:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                        case 7:
                            return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                    }
                    var r = Ur(e.prototype), n = e.apply(r, t);
                    return no(n) ? n : r;
                };
            }
            function Ni(e) {
                return function(t, r, i) {
                    var s = $e(t);
                    if (!Qa(t)) {
                        var a = us(r, 3);
                        t = Io(t), r = function(e) {
                            return a(s[e], e, s);
                        };
                    }
                    var o = e(t, r, i);
                    return o > -1 ? s[a ? t[o] : o] : n;
                };
            }
            function Vi(e) {
                return ns(function(t) {
                    var r = t.length, s = r, a = Gr.prototype.thru;
                    for(e && t.reverse(); s--;){
                        var o = t[s];
                        if ("function" != typeof o) throw new Ce(i);
                        if (a && !l && "wrapper" == os(o)) var l = new Gr([], !0);
                    }
                    for(s = l ? s : r; ++s < r;){
                        var u = os(o = t[s]), d = "wrapper" == u ? as(o) : n;
                        l = d && Ss(d[0]) && 424 == d[1] && !d[4].length && 1 == d[9] ? l[os(d[0])].apply(l, d[3]) : 1 == o.length && Ss(o) ? l[u]() : l.thru(o);
                    }
                    return function() {
                        var e = arguments, n = e[0];
                        if (l && 1 == e.length && Ka(n)) return l.plant(n).value();
                        for(var i = 0, s = r ? t[i].apply(this, e) : n; ++i < r;)s = t[i].call(this, s);
                        return s;
                    };
                });
            }
            function Ui(e, t, r, i, s, a, o, l, u, c) {
                var h = t & d, f = 1 & t, _ = 2 & t, g = 24 & t, p = 512 & t, m = _ ? n : ki(e);
                return function d() {
                    for(var b = arguments.length, v = ae(b), y = b; y--;)v[y] = arguments[y];
                    if (g) var E = ls(d), S = function(e, t) {
                        for(var r = e.length, n = 0; r--;)e[r] === t && ++n;
                        return n;
                    }(v, E);
                    if (i && (v = Bi(v, i, s, g)), a && (v = Pi(v, a, o, g)), b -= S, g && b < c) {
                        var R = ur(v, E);
                        return Yi(e, t, Ui, d.placeholder, r, v, R, l, u, c - b);
                    }
                    var T = f ? r : this, A = _ ? T[e] : e;
                    return b = v.length, l ? v = function(e, t) {
                        var r = e.length, i = vr(t.length, r), s = Ci(e);
                        for(; i--;){
                            var a = t[i];
                            e[i] = vs(a, r) ? s[a] : n;
                        }
                        return e;
                    }(v, l) : p && b > 1 && v.reverse(), h && u < b && (v.length = u), this && this !== _t && this instanceof d && (A = m || ki(A)), A.apply(T, v);
                };
            }
            function qi(e, t) {
                return function(r, n) {
                    return function(e, t, r, n) {
                        return En(e, function(e, i, s) {
                            t(n, r(e), i, s);
                        }), n;
                    }(r, e, t(n), {});
                };
            }
            function Gi(e, t) {
                return function(r, i) {
                    var s;
                    if (r === n && i === n) return t;
                    if (r !== n && (s = r), i !== n) {
                        if (s === n) return i;
                        "string" == typeof r || "string" == typeof i ? (r = di(r), i = di(i)) : (r = ui(r), i = ui(i)), s = e(r, i);
                    }
                    return s;
                };
            }
            function Wi(e) {
                return ns(function(t) {
                    return t = Mt(t, Zt(us())), Xn(function(r) {
                        var n = this;
                        return e(t, function(e) {
                            return Lt(e, n, r);
                        });
                    });
                });
            }
            function ji(e, t) {
                var r = (t = t === n ? " " : di(t)).length;
                if (r < 2) return r ? zn(t, e) : t;
                var i = zn(t, gt(e / hr(t)));
                return ar(t) ? Si(fr(i), 0, e).join("") : i.slice(0, e);
            }
            function Hi(e) {
                return function(t, r, i) {
                    return i && "number" != typeof i && ys(t, r, i) && (r = i = n), t = mo(t), r === n ? (r = t, t = 0) : r = mo(r), function(e, t, r, n) {
                        for(var i = -1, s = br(gt((t - e) / (r || 1)), 0), a = ae(s); s--;)a[n ? s : ++i] = e, e += r;
                        return a;
                    }(t, r, i = i === n ? t < r ? 1 : -1 : mo(i), e);
                };
            }
            function Ki(e) {
                return function(t, r) {
                    return "string" == typeof t && "string" == typeof r || (t = yo(t), r = yo(r)), e(t, r);
                };
            }
            function Yi(e, t, r, i, s, a, o, d, c, h) {
                var f = 8 & t;
                t |= f ? l : u, 4 & (t &= ~(f ? u : l)) || (t &= -4);
                var _ = [
                    e,
                    t,
                    s,
                    f ? a : n,
                    f ? o : n,
                    f ? n : a,
                    f ? n : o,
                    d,
                    c,
                    h
                ], g = r.apply(n, _);
                return Ss(e) && Cs(g, _), g.placeholder = i, Ds(g, e, t);
            }
            function Qi(e) {
                var t = Le[e];
                return function(e, r) {
                    if (e = yo(e), (r = null == r ? 0 : vr(bo(r), 292)) && Nt(e)) {
                        var n = (So(e) + "e").split("e");
                        return +((n = (So(t(n[0] + "e" + (+n[1] + r))) + "e").split("e"))[0] + "e" + (+n[1] - r));
                    }
                    return t(e);
                };
            }
            var zi = $r && 1 / dr(new $r([
                ,
                -0
            ]))[1] == h ? function(e) {
                return new $r(e);
            } : hl;
            function Xi(e) {
                return function(t) {
                    var r = gs(t);
                    return r == T ? or(t) : r == P ? cr(t) : function(e, t) {
                        return Mt(t, function(t) {
                            return [
                                t,
                                e[t]
                            ];
                        });
                    }(t, e(t));
                };
            }
            function Zi(e, t, r, s, h, f, _, g) {
                var p = 2 & t;
                if (!p && "function" != typeof e) throw new Ce(i);
                var m = s ? s.length : 0;
                if (m || (t &= -97, s = h = n), _ = _ === n ? _ : br(bo(_), 0), g = g === n ? g : bo(g), m -= h ? h.length : 0, t & u) {
                    var b = s, v = h;
                    s = h = n;
                }
                var y = p ? n : as(e), E = [
                    e,
                    t,
                    r,
                    s,
                    h,
                    b,
                    v,
                    f,
                    _,
                    g
                ];
                if (y && function(e, t) {
                    var r = e[1], n = t[1], i = r | n, s = i < 131, o = n == d && 8 == r || n == d && r == c && e[7].length <= t[8] || 384 == n && t[7].length <= t[8] && 8 == r;
                    if (!s && !o) return e;
                    1 & n && (e[2] = t[2], i |= 1 & r ? 0 : 4);
                    var l = t[3];
                    if (l) {
                        var u = e[3];
                        e[3] = u ? Bi(u, l, t[4]) : l, e[4] = u ? ur(e[3], a) : t[4];
                    }
                    (l = t[5]) && (u = e[5], e[5] = u ? Pi(u, l, t[6]) : l, e[6] = u ? ur(e[5], a) : t[6]);
                    (l = t[7]) && (e[7] = l);
                    n & d && (e[8] = null == e[8] ? t[8] : vr(e[8], t[8]));
                    null == e[9] && (e[9] = t[9]);
                    e[0] = t[0], e[1] = i;
                }(E, y), e = E[0], t = E[1], r = E[2], s = E[3], h = E[4], !(g = E[9] = E[9] === n ? p ? 0 : e.length : br(E[9] - m, 0)) && 24 & t && (t &= -25), t && 1 != t) S = 8 == t || t == o ? function(e, t, r) {
                    var i = ki(e);
                    return function s() {
                        for(var a = arguments.length, o = ae(a), l = a, u = ls(s); l--;)o[l] = arguments[l];
                        var d = a < 3 && o[0] !== u && o[a - 1] !== u ? [] : ur(o, u);
                        return (a -= d.length) < r ? Yi(e, t, Ui, s.placeholder, n, o, d, n, n, r - a) : Lt(this && this !== _t && this instanceof s ? i : e, this, o);
                    };
                }(e, t, g) : t != l && 33 != t || h.length ? Ui.apply(n, E) : function(e, t, r, n) {
                    var i = 1 & t, s = ki(e);
                    return function t() {
                        for(var a = -1, o = arguments.length, l = -1, u = n.length, d = ae(u + o), c = this && this !== _t && this instanceof t ? s : e; ++l < u;)d[l] = n[l];
                        for(; o--;)d[l++] = arguments[++a];
                        return Lt(c, i ? r : this, d);
                    };
                }(e, t, r, s);
                else var S = function(e, t, r) {
                    var n = 1 & t, i = ki(e);
                    return function t() {
                        return (this && this !== _t && this instanceof t ? i : e).apply(n ? r : this, arguments);
                    };
                }(e, t, r);
                return Ds((y ? ti : Cs)(S, E), e, t);
            }
            function Ji(e, t, r, i) {
                return e === n || Ga(e, De[r]) && !Fe.call(i, r) ? t : e;
            }
            function es(e, t, r, i, s, a) {
                return no(e) && no(t) && (a.set(t, e), Gn(e, t, n, es, a), a.delete(t)), e;
            }
            function ts(e) {
                return oo(e) ? n : e;
            }
            function rs(e, t, r, i, s, a) {
                var o = 1 & r, l = e.length, u = t.length;
                if (l != u && !(o && u > l)) return !1;
                var d = a.get(e), c = a.get(t);
                if (d && c) return d == t && c == e;
                var h = -1, f = !0, _ = 2 & r ? new Yr : n;
                for(a.set(e, t), a.set(t, e); ++h < l;){
                    var g = e[h], p = t[h];
                    if (i) var m = o ? i(p, g, h, t, e, a) : i(g, p, h, e, t, a);
                    if (m !== n) {
                        if (m) continue;
                        f = !1;
                        break;
                    }
                    if (_) {
                        if (!kt(t, function(e, t) {
                            if (!er(_, t) && (g === e || s(g, e, r, i, a))) return _.push(t);
                        })) {
                            f = !1;
                            break;
                        }
                    } else if (g !== p && !s(g, p, r, i, a)) {
                        f = !1;
                        break;
                    }
                }
                return a.delete(e), a.delete(t), f;
            }
            function ns(e) {
                return Os($s(e, n, Ys), e + "");
            }
            function is(e) {
                return An(e, Io, fs);
            }
            function ss(e) {
                return An(e, Fo, _s);
            }
            var as = Cr ? function(e) {
                return Cr.get(e);
            } : hl;
            function os(e) {
                for(var t = e.name + "", r = wr[t], n = Fe.call(wr, t) ? r.length : 0; n--;){
                    var i = r[n], s = i.func;
                    if (null == s || s == e) return i.name;
                }
                return t;
            }
            function ls(e) {
                return (Fe.call(Vr, "placeholder") ? Vr : e).placeholder;
            }
            function us() {
                var e = Vr.iteratee || ll;
                return e = e === ll ? Fn : e, arguments.length ? e(arguments[0], arguments[1]) : e;
            }
            function ds(e, t) {
                var r, n, i = e.__data__;
                return ("string" == (n = typeof (r = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== r : null === r) ? i["string" == typeof t ? "string" : "hash"] : i.map;
            }
            function cs(e) {
                for(var t = Io(e), r = t.length; r--;){
                    var n = t[r], i = e[n];
                    t[r] = [
                        n,
                        i,
                        As(i)
                    ];
                }
                return t;
            }
            function hs(e, t) {
                var r = function(e, t) {
                    return null == e ? n : e[t];
                }(e, t);
                return In(r) ? r : n;
            }
            var fs = bt ? function(e) {
                return null == e ? [] : (e = $e(e), wt(bt(e), function(t) {
                    return Qe.call(e, t);
                }));
            } : vl, _s = bt ? function(e) {
                for(var t = []; e;)It(t, fs(e)), e = Ke(e);
                return t;
            } : vl, gs = Ln;
            function ps(e, t, r) {
                for(var n = -1, i = (t = yi(t, e)).length, s = !1; ++n < i;){
                    var a = Vs(t[n]);
                    if (!(s = null != e && r(e, a))) break;
                    e = e[a];
                }
                return s || ++n != i ? s : !!(i = null == e ? 0 : e.length) && ro(i) && vs(a, i) && (Ka(e) || Ha(e));
            }
            function ms(e) {
                return "function" != typeof e.constructor || Ts(e) ? {} : Ur(Ke(e));
            }
            function bs(e) {
                return Ka(e) || Ha(e) || !!(Xe && e && e[Xe]);
            }
            function vs(e, t) {
                var r = typeof e;
                return !!(t = null == t ? f : t) && ("number" == r || "symbol" != r && ve.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function ys(e, t, r) {
                if (!no(r)) return !1;
                var n = typeof t;
                return !!("number" == n ? Qa(r) && vs(t, r.length) : "string" == n && t in r) && Ga(r[t], e);
            }
            function Es(e, t) {
                if (Ka(e)) return !1;
                var r = typeof e;
                return !("number" != r && "symbol" != r && "boolean" != r && null != e && !ho(e)) || te.test(e) || !ee.test(e) || null != t && e in $e(t);
            }
            function Ss(e) {
                var t = os(e), r = Vr[t];
                if ("function" != typeof r || !(t in Wr.prototype)) return !1;
                if (e === r) return !0;
                var n = as(r);
                return !!n && e === n[0];
            }
            (Tr && gs(new Tr(new ArrayBuffer(1))) != M || Ar && gs(new Ar) != T || Lr && gs(Lr.resolve()) != $ || $r && gs(new $r) != P || Br && gs(new Br) != O) && (gs = function(e) {
                var t = Ln(e), r = t == L ? e.constructor : n, i = r ? Us(r) : "";
                if (i) switch(i){
                    case Or:
                        return M;
                    case Dr:
                        return T;
                    case Mr:
                        return $;
                    case Ir:
                        return P;
                    case Fr:
                        return O;
                }
                return t;
            });
            var Rs = Me ? eo : yl;
            function Ts(e) {
                var t = e && e.constructor;
                return e === ("function" == typeof t && t.prototype || De);
            }
            function As(e) {
                return e == e && !no(e);
            }
            function Ls(e, t) {
                return function(r) {
                    return null != r && r[e] === t && (t !== n || e in $e(r));
                };
            }
            function $s(e, t, r) {
                return t = br(t === n ? e.length - 1 : t, 0), function() {
                    for(var n = arguments, i = -1, s = br(n.length - t, 0), a = ae(s); ++i < s;)a[i] = n[t + i];
                    i = -1;
                    for(var o = ae(t + 1); ++i < t;)o[i] = n[i];
                    return o[t] = r(a), Lt(e, this, o);
                };
            }
            function Bs(e, t) {
                return t.length < 2 ? e : Tn(e, ii(t, 0, -1));
            }
            function Ps(e, t) {
                if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
            }
            var Cs = Ms(ti), ws = ft || function(e, t) {
                return _t.setTimeout(e, t);
            }, Os = Ms(ri);
            function Ds(e, t, r) {
                var n = t + "";
                return Os(e, function(e, t) {
                    var r = t.length;
                    if (!r) return e;
                    var n = r - 1;
                    return t[n] = (r > 1 ? "& " : "") + t[n], t = t.join(r > 2 ? ", " : " "), e.replace(oe, "{\n/* [wrapped with " + t + "] */\n");
                }(n, function(e, t) {
                    return Bt(p, function(r) {
                        var n = "_." + r[0];
                        t & r[1] && !Ot(e, n) && e.push(n);
                    }), e.sort();
                }(function(e) {
                    var t = e.match(le);
                    return t ? t[1].split(ue) : [];
                }(n), r)));
            }
            function Ms(e) {
                var t = 0, r = 0;
                return function() {
                    var i = yr(), s = 16 - (i - r);
                    if (r = i, s > 0) {
                        if (++t >= 800) return arguments[0];
                    } else t = 0;
                    return e.apply(n, arguments);
                };
            }
            function Is(e, t) {
                var r = -1, i = e.length, s = i - 1;
                for(t = t === n ? i : t; ++r < t;){
                    var a = Qn(r, s), o = e[a];
                    e[a] = e[r], e[r] = o;
                }
                return e.length = t, e;
            }
            var Fs, xs, ks, Ns = (Fs = function(e) {
                var t = [];
                return 46 === e.charCodeAt(0) && t.push(""), e.replace(re, function(e, r, n, i) {
                    t.push(n ? i.replace(he, "$1") : r || e);
                }), t;
            }, xs = xa(Fs, function(e) {
                return 500 === ks.size && ks.clear(), e;
            }), ks = xs.cache, xs);
            function Vs(e) {
                if ("string" == typeof e || ho(e)) return e;
                var t = e + "";
                return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Us(e) {
                if (null != e) {
                    try {
                        return Ie.call(e);
                    } catch (e) {}
                    try {
                        return e + "";
                    } catch (e) {}
                }
                return "";
            }
            function qs(e) {
                if (e instanceof Wr) return e.clone();
                var t = new Gr(e.__wrapped__, e.__chain__);
                return t.__actions__ = Ci(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
            }
            var Gs = Xn(function(e, t) {
                return za(e) ? hn(e, bn(t, 1, za, !0)) : [];
            }), Ws = Xn(function(e, t) {
                var r = Js(t);
                return za(r) && (r = n), za(e) ? hn(e, bn(t, 1, za, !0), us(r, 2)) : [];
            }), js = Xn(function(e, t) {
                var r = Js(t);
                return za(r) && (r = n), za(e) ? hn(e, bn(t, 1, za, !0), n, r) : [];
            });
            function Hs(e, t, r) {
                var n = null == e ? 0 : e.length;
                if (!n) return -1;
                var i = null == r ? 0 : bo(r);
                return i < 0 && (i = br(n + i, 0)), Ut(e, us(t, 3), i);
            }
            function Ks(e, t, r) {
                var i = null == e ? 0 : e.length;
                if (!i) return -1;
                var s = i - 1;
                return r !== n && (s = bo(r), s = r < 0 ? br(i + s, 0) : vr(s, i - 1)), Ut(e, us(t, 3), s, !0);
            }
            function Ys(e) {
                return (null == e ? 0 : e.length) ? bn(e, 1) : [];
            }
            function Qs(e) {
                return e && e.length ? e[0] : n;
            }
            var zs = Xn(function(e) {
                var t = Mt(e, bi);
                return t.length && t[0] === e[0] ? Cn(t) : [];
            }), Xs = Xn(function(e) {
                var t = Js(e), r = Mt(e, bi);
                return t === Js(r) ? t = n : r.pop(), r.length && r[0] === e[0] ? Cn(r, us(t, 2)) : [];
            }), Zs = Xn(function(e) {
                var t = Js(e), r = Mt(e, bi);
                return (t = "function" == typeof t ? t : n) && r.pop(), r.length && r[0] === e[0] ? Cn(r, n, t) : [];
            });
            function Js(e) {
                var t = null == e ? 0 : e.length;
                return t ? e[t - 1] : n;
            }
            var ea = Xn(ta);
            function ta(e, t) {
                return e && e.length && t && t.length ? Kn(e, t) : e;
            }
            var ra = ns(function(e, t) {
                var r = null == e ? 0 : e.length, n = on(e, t);
                return Yn(e, Mt(t, function(e) {
                    return vs(e, r) ? +e : e;
                }).sort($i)), n;
            });
            function na(e) {
                return null == e ? e : Rr.call(e);
            }
            var ia = Xn(function(e) {
                return ci(bn(e, 1, za, !0));
            }), sa = Xn(function(e) {
                var t = Js(e);
                return za(t) && (t = n), ci(bn(e, 1, za, !0), us(t, 2));
            }), aa = Xn(function(e) {
                var t = Js(e);
                return t = "function" == typeof t ? t : n, ci(bn(e, 1, za, !0), n, t);
            });
            function oa(e) {
                if (!e || !e.length) return [];
                var t = 0;
                return e = wt(e, function(e) {
                    if (za(e)) return t = br(e.length, t), !0;
                }), zt(t, function(t) {
                    return Mt(e, Ht(t));
                });
            }
            function la(e, t) {
                if (!e || !e.length) return [];
                var r = oa(e);
                return null == t ? r : Mt(r, function(e) {
                    return Lt(t, n, e);
                });
            }
            var ua = Xn(function(e, t) {
                return za(e) ? hn(e, t) : [];
            }), da = Xn(function(e) {
                return pi(wt(e, za));
            }), ca = Xn(function(e) {
                var t = Js(e);
                return za(t) && (t = n), pi(wt(e, za), us(t, 2));
            }), ha = Xn(function(e) {
                var t = Js(e);
                return t = "function" == typeof t ? t : n, pi(wt(e, za), n, t);
            }), fa = Xn(oa);
            var _a = Xn(function(e) {
                var t = e.length, r = t > 1 ? e[t - 1] : n;
                return r = "function" == typeof r ? (e.pop(), r) : n, la(e, r);
            });
            function ga(e) {
                var t = Vr(e);
                return t.__chain__ = !0, t;
            }
            function pa(e, t) {
                return t(e);
            }
            var ma = ns(function(e) {
                var t = e.length, r = t ? e[0] : 0, i = this.__wrapped__, s = function(t) {
                    return on(t, e);
                };
                return !(t > 1 || this.__actions__.length) && i instanceof Wr && vs(r) ? ((i = i.slice(r, +r + (t ? 1 : 0))).__actions__.push({
                    func: pa,
                    args: [
                        s
                    ],
                    thisArg: n
                }), new Gr(i, this.__chain__).thru(function(e) {
                    return t && !e.length && e.push(n), e;
                })) : this.thru(s);
            });
            var ba = Oi(function(e, t, r) {
                Fe.call(e, r) ? ++e[r] : an(e, r, 1);
            });
            var va = Ni(Hs), ya = Ni(Ks);
            function Ea(e, t) {
                return (Ka(e) ? Bt : fn)(e, us(t, 3));
            }
            function Sa(e, t) {
                return (Ka(e) ? Pt : _n)(e, us(t, 3));
            }
            var Ra = Oi(function(e, t, r) {
                Fe.call(e, r) ? e[r].push(t) : an(e, r, [
                    t
                ]);
            });
            var Ta = Xn(function(e, t, r) {
                var n = -1, i = "function" == typeof t, s = Qa(e) ? ae(e.length) : [];
                return fn(e, function(e) {
                    s[++n] = i ? Lt(t, e, r) : wn(e, t, r);
                }), s;
            }), Aa = Oi(function(e, t, r) {
                an(e, r, t);
            });
            function La(e, t) {
                return (Ka(e) ? Mt : Vn)(e, us(t, 3));
            }
            var $a = Oi(function(e, t, r) {
                e[r ? 0 : 1].push(t);
            }, function() {
                return [
                    [],
                    []
                ];
            });
            var Ba = Xn(function(e, t) {
                if (null == e) return [];
                var r = t.length;
                return r > 1 && ys(e, t[0], t[1]) ? t = [] : r > 2 && ys(t[0], t[1], t[2]) && (t = [
                    t[0]
                ]), jn(e, bn(t, 1), []);
            }), Pa = ht || function() {
                return _t.Date.now();
            };
            function Ca(e, t, r) {
                return t = r ? n : t, t = e && null == t ? e.length : t, Zi(e, d, n, n, n, n, t);
            }
            function wa(e, t) {
                var r;
                if ("function" != typeof t) throw new Ce(i);
                return e = bo(e), function() {
                    return --e > 0 && (r = t.apply(this, arguments)), e <= 1 && (t = n), r;
                };
            }
            var Oa = Xn(function(e, t, r) {
                var n = 1;
                if (r.length) {
                    var i = ur(r, ls(Oa));
                    n |= l;
                }
                return Zi(e, n, t, r, i);
            }), Da = Xn(function(e, t, r) {
                var n = 3;
                if (r.length) {
                    var i = ur(r, ls(Da));
                    n |= l;
                }
                return Zi(t, n, e, r, i);
            });
            function Ma(e, t, r) {
                var s, a, o, l, u, d, c = 0, h = !1, f = !1, _ = !0;
                if ("function" != typeof e) throw new Ce(i);
                function g(t) {
                    var r = s, i = a;
                    return s = a = n, c = t, l = e.apply(i, r);
                }
                function p(e) {
                    var r = e - d;
                    return d === n || r >= t || r < 0 || f && e - c >= o;
                }
                function m() {
                    var e = Pa();
                    if (p(e)) return b(e);
                    u = ws(m, function(e) {
                        var r = t - (e - d);
                        return f ? vr(r, o - (e - c)) : r;
                    }(e));
                }
                function b(e) {
                    return u = n, _ && s ? g(e) : (s = a = n, l);
                }
                function v() {
                    var e = Pa(), r = p(e);
                    if (s = arguments, a = this, d = e, r) {
                        if (u === n) return function(e) {
                            return c = e, u = ws(m, t), h ? g(e) : l;
                        }(d);
                        if (f) return Ri(u), u = ws(m, t), g(d);
                    }
                    return u === n && (u = ws(m, t)), l;
                }
                return t = yo(t) || 0, no(r) && (h = !!r.leading, o = (f = "maxWait" in r) ? br(yo(r.maxWait) || 0, t) : o, _ = "trailing" in r ? !!r.trailing : _), v.cancel = function() {
                    u !== n && Ri(u), c = 0, s = d = a = u = n;
                }, v.flush = function() {
                    return u === n ? l : b(Pa());
                }, v;
            }
            var Ia = Xn(function(e, t) {
                return cn(e, 1, t);
            }), Fa = Xn(function(e, t, r) {
                return cn(e, yo(t) || 0, r);
            });
            function xa(e, t) {
                if ("function" != typeof e || null != t && "function" != typeof t) throw new Ce(i);
                var r = function() {
                    var n = arguments, i = t ? t.apply(this, n) : n[0], s = r.cache;
                    if (s.has(i)) return s.get(i);
                    var a = e.apply(this, n);
                    return r.cache = s.set(i, a) || s, a;
                };
                return r.cache = new (xa.Cache || Kr), r;
            }
            function ka(e) {
                if ("function" != typeof e) throw new Ce(i);
                return function() {
                    var t = arguments;
                    switch(t.length){
                        case 0:
                            return !e.call(this);
                        case 1:
                            return !e.call(this, t[0]);
                        case 2:
                            return !e.call(this, t[0], t[1]);
                        case 3:
                            return !e.call(this, t[0], t[1], t[2]);
                    }
                    return !e.apply(this, t);
                };
            }
            xa.Cache = Kr;
            var Na = Ei(function(e, t) {
                var r = (t = 1 == t.length && Ka(t[0]) ? Mt(t[0], Zt(us())) : Mt(bn(t, 1), Zt(us()))).length;
                return Xn(function(n) {
                    for(var i = -1, s = vr(n.length, r); ++i < s;)n[i] = t[i].call(this, n[i]);
                    return Lt(e, this, n);
                });
            }), Va = Xn(function(e, t) {
                var r = ur(t, ls(Va));
                return Zi(e, l, n, t, r);
            }), Ua = Xn(function(e, t) {
                var r = ur(t, ls(Ua));
                return Zi(e, u, n, t, r);
            }), qa = ns(function(e, t) {
                return Zi(e, c, n, n, n, t);
            });
            function Ga(e, t) {
                return e === t || e != e && t != t;
            }
            var Wa = Ki($n), ja = Ki(function(e, t) {
                return e >= t;
            }), Ha = On(function() {
                return arguments;
            }()) ? On : function(e) {
                return io(e) && Fe.call(e, "callee") && !Qe.call(e, "callee");
            }, Ka = ae.isArray, Ya = yt ? Zt(yt) : function(e) {
                return io(e) && Ln(e) == D;
            };
            function Qa(e) {
                return null != e && ro(e.length) && !eo(e);
            }
            function za(e) {
                return io(e) && Qa(e);
            }
            var Xa = vt || yl, Za = Et ? Zt(Et) : function(e) {
                return io(e) && Ln(e) == y;
            };
            function Ja(e) {
                if (!io(e)) return !1;
                var t = Ln(e);
                return t == E || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !oo(e);
            }
            function eo(e) {
                if (!no(e)) return !1;
                var t = Ln(e);
                return t == S || t == R || "[object AsyncFunction]" == t || "[object Proxy]" == t;
            }
            function to(e) {
                return "number" == typeof e && e == bo(e);
            }
            function ro(e) {
                return "number" == typeof e && e > -1 && e % 1 == 0 && e <= f;
            }
            function no(e) {
                var t = typeof e;
                return null != e && ("object" == t || "function" == t);
            }
            function io(e) {
                return null != e && "object" == typeof e;
            }
            var so = St ? Zt(St) : function(e) {
                return io(e) && gs(e) == T;
            };
            function ao(e) {
                return "number" == typeof e || io(e) && Ln(e) == A;
            }
            function oo(e) {
                if (!io(e) || Ln(e) != L) return !1;
                var t = Ke(e);
                if (null === t) return !0;
                var r = Fe.call(t, "constructor") && t.constructor;
                return "function" == typeof r && r instanceof r && Ie.call(r) == Ve;
            }
            var lo = Rt ? Zt(Rt) : function(e) {
                return io(e) && Ln(e) == B;
            };
            var uo = Tt ? Zt(Tt) : function(e) {
                return io(e) && gs(e) == P;
            };
            function co(e) {
                return "string" == typeof e || !Ka(e) && io(e) && Ln(e) == C;
            }
            function ho(e) {
                return "symbol" == typeof e || io(e) && Ln(e) == w;
            }
            var fo = At ? Zt(At) : function(e) {
                return io(e) && ro(e.length) && !!ot[Ln(e)];
            };
            var _o = Ki(Nn), go = Ki(function(e, t) {
                return e <= t;
            });
            function po(e) {
                if (!e) return [];
                if (Qa(e)) return co(e) ? fr(e) : Ci(e);
                if (Ze && e[Ze]) return function(e) {
                    for(var t, r = []; !(t = e.next()).done;)r.push(t.value);
                    return r;
                }(e[Ze]());
                var t = gs(e);
                return (t == T ? or : t == P ? dr : Wo)(e);
            }
            function mo(e) {
                return e ? (e = yo(e)) === h || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            function bo(e) {
                var t = mo(e), r = t % 1;
                return t == t ? r ? t - r : t : 0;
            }
            function vo(e) {
                return e ? ln(bo(e), 0, g) : 0;
            }
            function yo(e) {
                if ("number" == typeof e) return e;
                if (ho(e)) return _;
                if (no(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = no(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = Xt(e);
                var r = pe.test(e);
                return r || be.test(e) ? ct(e.slice(2), r ? 2 : 8) : ge.test(e) ? _ : +e;
            }
            function Eo(e) {
                return wi(e, Fo(e));
            }
            function So(e) {
                return null == e ? "" : di(e);
            }
            var Ro = Di(function(e, t) {
                if (Ts(t) || Qa(t)) wi(t, Io(t), e);
                else for(var r in t)Fe.call(t, r) && tn(e, r, t[r]);
            }), To = Di(function(e, t) {
                wi(t, Fo(t), e);
            }), Ao = Di(function(e, t, r, n) {
                wi(t, Fo(t), e, n);
            }), Lo = Di(function(e, t, r, n) {
                wi(t, Io(t), e, n);
            }), $o = ns(on);
            var Bo = Xn(function(e, t) {
                e = $e(e);
                var r = -1, i = t.length, s = i > 2 ? t[2] : n;
                for(s && ys(t[0], t[1], s) && (i = 1); ++r < i;)for(var a = t[r], o = Fo(a), l = -1, u = o.length; ++l < u;){
                    var d = o[l], c = e[d];
                    (c === n || Ga(c, De[d]) && !Fe.call(e, d)) && (e[d] = a[d]);
                }
                return e;
            }), Po = Xn(function(e) {
                return e.push(n, es), Lt(ko, n, e);
            });
            function Co(e, t, r) {
                var i = null == e ? n : Tn(e, t);
                return i === n ? r : i;
            }
            function wo(e, t) {
                return null != e && ps(e, t, Pn);
            }
            var Oo = qi(function(e, t, r) {
                null != t && "function" != typeof t.toString && (t = Ne.call(t)), e[t] = r;
            }, il(ol)), Do = qi(function(e, t, r) {
                null != t && "function" != typeof t.toString && (t = Ne.call(t)), Fe.call(e, t) ? e[t].push(r) : e[t] = [
                    r
                ];
            }, us), Mo = Xn(wn);
            function Io(e) {
                return Qa(e) ? zr(e) : xn(e);
            }
            function Fo(e) {
                return Qa(e) ? zr(e, !0) : kn(e);
            }
            var xo = Di(function(e, t, r) {
                Gn(e, t, r);
            }), ko = Di(function(e, t, r, n) {
                Gn(e, t, r, n);
            }), No = ns(function(e, t) {
                var r = {};
                if (null == e) return r;
                var n = !1;
                t = Mt(t, function(t) {
                    return t = yi(t, e), n || (n = t.length > 1), t;
                }), wi(e, ss(e), r), n && (r = un(r, 7, ts));
                for(var i = t.length; i--;)hi(r, t[i]);
                return r;
            });
            var Vo = ns(function(e, t) {
                return null == e ? {} : function(e, t) {
                    return Hn(e, t, function(t, r) {
                        return wo(e, r);
                    });
                }(e, t);
            });
            function Uo(e, t) {
                if (null == e) return {};
                var r = Mt(ss(e), function(e) {
                    return [
                        e
                    ];
                });
                return t = us(t), Hn(e, r, function(e, r) {
                    return t(e, r[0]);
                });
            }
            var qo = Xi(Io), Go = Xi(Fo);
            function Wo(e) {
                return null == e ? [] : Jt(e, Io(e));
            }
            var jo = xi(function(e, t, r) {
                return t = t.toLowerCase(), e + (r ? Ho(t) : t);
            });
            function Ho(e) {
                return el(So(e).toLowerCase());
            }
            function Ko(e) {
                return (e = So(e)) && e.replace(ye, nr).replace(et, "");
            }
            var Yo = xi(function(e, t, r) {
                return e + (r ? "-" : "") + t.toLowerCase();
            }), Qo = xi(function(e, t, r) {
                return e + (r ? " " : "") + t.toLowerCase();
            }), zo = Fi("toLowerCase");
            var Xo = xi(function(e, t, r) {
                return e + (r ? "_" : "") + t.toLowerCase();
            });
            var Zo = xi(function(e, t, r) {
                return e + (r ? " " : "") + el(t);
            });
            var Jo = xi(function(e, t, r) {
                return e + (r ? " " : "") + t.toUpperCase();
            }), el = Fi("toUpperCase");
            function tl(e, t, r) {
                return e = So(e), (t = r ? n : t) === n ? function(e) {
                    return it.test(e);
                }(e) ? function(e) {
                    return e.match(rt) || [];
                }(e) : function(e) {
                    return e.match(de) || [];
                }(e) : e.match(t) || [];
            }
            var rl = Xn(function(e, t) {
                try {
                    return Lt(e, n, t);
                } catch (e) {
                    return Ja(e) ? e : new Te(e);
                }
            }), nl = ns(function(e, t) {
                return Bt(t, function(t) {
                    t = Vs(t), an(e, t, Oa(e[t], e));
                }), e;
            });
            function il(e) {
                return function() {
                    return e;
                };
            }
            var sl = Vi(), al = Vi(!0);
            function ol(e) {
                return e;
            }
            function ll(e) {
                return Fn("function" == typeof e ? e : un(e, 1));
            }
            var ul = Xn(function(e, t) {
                return function(r) {
                    return wn(r, e, t);
                };
            }), dl = Xn(function(e, t) {
                return function(r) {
                    return wn(e, r, t);
                };
            });
            function cl(e, t, r) {
                var n = Io(t), i = Rn(t, n);
                null != r || no(t) && (i.length || !n.length) || (r = t, t = e, e = this, i = Rn(t, Io(t)));
                var s = !(no(r) && "chain" in r && !r.chain), a = eo(e);
                return Bt(i, function(r) {
                    var n = t[r];
                    e[r] = n, a && (e.prototype[r] = function() {
                        var t = this.__chain__;
                        if (s || t) {
                            var r = e(this.__wrapped__);
                            return (r.__actions__ = Ci(this.__actions__)).push({
                                func: n,
                                args: arguments,
                                thisArg: e
                            }), r.__chain__ = t, r;
                        }
                        return n.apply(e, It([
                            this.value()
                        ], arguments));
                    });
                }), e;
            }
            function hl() {}
            var fl = Wi(Mt), _l = Wi(Ct), gl = Wi(kt);
            function pl(e) {
                return Es(e) ? Ht(Vs(e)) : function(e) {
                    return function(t) {
                        return Tn(t, e);
                    };
                }(e);
            }
            var ml = Hi(), bl = Hi(!0);
            function vl() {
                return [];
            }
            function yl() {
                return !1;
            }
            var El = Gi(function(e, t) {
                return e + t;
            }, 0), Sl = Qi("ceil"), Rl = Gi(function(e, t) {
                return e / t;
            }, 1), Tl = Qi("floor");
            var Al, Ll = Gi(function(e, t) {
                return e * t;
            }, 1), $l = Qi("round"), Bl = Gi(function(e, t) {
                return e - t;
            }, 0);
            return Vr.after = function(e, t) {
                if ("function" != typeof t) throw new Ce(i);
                return e = bo(e), function() {
                    if (--e < 1) return t.apply(this, arguments);
                };
            }, Vr.ary = Ca, Vr.assign = Ro, Vr.assignIn = To, Vr.assignInWith = Ao, Vr.assignWith = Lo, Vr.at = $o, Vr.before = wa, Vr.bind = Oa, Vr.bindAll = nl, Vr.bindKey = Da, Vr.castArray = function() {
                if (!arguments.length) return [];
                var e = arguments[0];
                return Ka(e) ? e : [
                    e
                ];
            }, Vr.chain = ga, Vr.chunk = function(e, t, r) {
                t = (r ? ys(e, t, r) : t === n) ? 1 : br(bo(t), 0);
                var i = null == e ? 0 : e.length;
                if (!i || t < 1) return [];
                for(var s = 0, a = 0, o = ae(gt(i / t)); s < i;)o[a++] = ii(e, s, s += t);
                return o;
            }, Vr.compact = function(e) {
                for(var t = -1, r = null == e ? 0 : e.length, n = 0, i = []; ++t < r;){
                    var s = e[t];
                    s && (i[n++] = s);
                }
                return i;
            }, Vr.concat = function() {
                var e = arguments.length;
                if (!e) return [];
                for(var t = ae(e - 1), r = arguments[0], n = e; n--;)t[n - 1] = arguments[n];
                return It(Ka(r) ? Ci(r) : [
                    r
                ], bn(t, 1));
            }, Vr.cond = function(e) {
                var t = null == e ? 0 : e.length, r = us();
                return e = t ? Mt(e, function(e) {
                    if ("function" != typeof e[1]) throw new Ce(i);
                    return [
                        r(e[0]),
                        e[1]
                    ];
                }) : [], Xn(function(r) {
                    for(var n = -1; ++n < t;){
                        var i = e[n];
                        if (Lt(i[0], this, r)) return Lt(i[1], this, r);
                    }
                });
            }, Vr.conforms = function(e) {
                return function(e) {
                    var t = Io(e);
                    return function(r) {
                        return dn(r, e, t);
                    };
                }(un(e, 1));
            }, Vr.constant = il, Vr.countBy = ba, Vr.create = function(e, t) {
                var r = Ur(e);
                return null == t ? r : sn(r, t);
            }, Vr.curry = function e(t, r, i) {
                var s = Zi(t, 8, n, n, n, n, n, r = i ? n : r);
                return s.placeholder = e.placeholder, s;
            }, Vr.curryRight = function e(t, r, i) {
                var s = Zi(t, o, n, n, n, n, n, r = i ? n : r);
                return s.placeholder = e.placeholder, s;
            }, Vr.debounce = Ma, Vr.defaults = Bo, Vr.defaultsDeep = Po, Vr.defer = Ia, Vr.delay = Fa, Vr.difference = Gs, Vr.differenceBy = Ws, Vr.differenceWith = js, Vr.drop = function(e, t, r) {
                var i = null == e ? 0 : e.length;
                return i ? ii(e, (t = r || t === n ? 1 : bo(t)) < 0 ? 0 : t, i) : [];
            }, Vr.dropRight = function(e, t, r) {
                var i = null == e ? 0 : e.length;
                return i ? ii(e, 0, (t = i - (t = r || t === n ? 1 : bo(t))) < 0 ? 0 : t) : [];
            }, Vr.dropRightWhile = function(e, t) {
                return e && e.length ? _i(e, us(t, 3), !0, !0) : [];
            }, Vr.dropWhile = function(e, t) {
                return e && e.length ? _i(e, us(t, 3), !0) : [];
            }, Vr.fill = function(e, t, r, i) {
                var s = null == e ? 0 : e.length;
                return s ? (r && "number" != typeof r && ys(e, t, r) && (r = 0, i = s), function(e, t, r, i) {
                    var s = e.length;
                    for((r = bo(r)) < 0 && (r = -r > s ? 0 : s + r), (i = i === n || i > s ? s : bo(i)) < 0 && (i += s), i = r > i ? 0 : vo(i); r < i;)e[r++] = t;
                    return e;
                }(e, t, r, i)) : [];
            }, Vr.filter = function(e, t) {
                return (Ka(e) ? wt : mn)(e, us(t, 3));
            }, Vr.flatMap = function(e, t) {
                return bn(La(e, t), 1);
            }, Vr.flatMapDeep = function(e, t) {
                return bn(La(e, t), h);
            }, Vr.flatMapDepth = function(e, t, r) {
                return r = r === n ? 1 : bo(r), bn(La(e, t), r);
            }, Vr.flatten = Ys, Vr.flattenDeep = function(e) {
                return (null == e ? 0 : e.length) ? bn(e, h) : [];
            }, Vr.flattenDepth = function(e, t) {
                return (null == e ? 0 : e.length) ? bn(e, t = t === n ? 1 : bo(t)) : [];
            }, Vr.flip = function(e) {
                return Zi(e, 512);
            }, Vr.flow = sl, Vr.flowRight = al, Vr.fromPairs = function(e) {
                for(var t = -1, r = null == e ? 0 : e.length, n = {}; ++t < r;){
                    var i = e[t];
                    n[i[0]] = i[1];
                }
                return n;
            }, Vr.functions = function(e) {
                return null == e ? [] : Rn(e, Io(e));
            }, Vr.functionsIn = function(e) {
                return null == e ? [] : Rn(e, Fo(e));
            }, Vr.groupBy = Ra, Vr.initial = function(e) {
                return (null == e ? 0 : e.length) ? ii(e, 0, -1) : [];
            }, Vr.intersection = zs, Vr.intersectionBy = Xs, Vr.intersectionWith = Zs, Vr.invert = Oo, Vr.invertBy = Do, Vr.invokeMap = Ta, Vr.iteratee = ll, Vr.keyBy = Aa, Vr.keys = Io, Vr.keysIn = Fo, Vr.map = La, Vr.mapKeys = function(e, t) {
                var r = {};
                return t = us(t, 3), En(e, function(e, n, i) {
                    an(r, t(e, n, i), e);
                }), r;
            }, Vr.mapValues = function(e, t) {
                var r = {};
                return t = us(t, 3), En(e, function(e, n, i) {
                    an(r, n, t(e, n, i));
                }), r;
            }, Vr.matches = function(e) {
                return Un(un(e, 1));
            }, Vr.matchesProperty = function(e, t) {
                return qn(e, un(t, 1));
            }, Vr.memoize = xa, Vr.merge = xo, Vr.mergeWith = ko, Vr.method = ul, Vr.methodOf = dl, Vr.mixin = cl, Vr.negate = ka, Vr.nthArg = function(e) {
                return e = bo(e), Xn(function(t) {
                    return Wn(t, e);
                });
            }, Vr.omit = No, Vr.omitBy = function(e, t) {
                return Uo(e, ka(us(t)));
            }, Vr.once = function(e) {
                return wa(2, e);
            }, Vr.orderBy = function(e, t, r, i) {
                return null == e ? [] : (Ka(t) || (t = null == t ? [] : [
                    t
                ]), Ka(r = i ? n : r) || (r = null == r ? [] : [
                    r
                ]), jn(e, t, r));
            }, Vr.over = fl, Vr.overArgs = Na, Vr.overEvery = _l, Vr.overSome = gl, Vr.partial = Va, Vr.partialRight = Ua, Vr.partition = $a, Vr.pick = Vo, Vr.pickBy = Uo, Vr.property = pl, Vr.propertyOf = function(e) {
                return function(t) {
                    return null == e ? n : Tn(e, t);
                };
            }, Vr.pull = ea, Vr.pullAll = ta, Vr.pullAllBy = function(e, t, r) {
                return e && e.length && t && t.length ? Kn(e, t, us(r, 2)) : e;
            }, Vr.pullAllWith = function(e, t, r) {
                return e && e.length && t && t.length ? Kn(e, t, n, r) : e;
            }, Vr.pullAt = ra, Vr.range = ml, Vr.rangeRight = bl, Vr.rearg = qa, Vr.reject = function(e, t) {
                return (Ka(e) ? wt : mn)(e, ka(us(t, 3)));
            }, Vr.remove = function(e, t) {
                var r = [];
                if (!e || !e.length) return r;
                var n = -1, i = [], s = e.length;
                for(t = us(t, 3); ++n < s;){
                    var a = e[n];
                    t(a, n, e) && (r.push(a), i.push(n));
                }
                return Yn(e, i), r;
            }, Vr.rest = function(e, t) {
                if ("function" != typeof e) throw new Ce(i);
                return Xn(e, t = t === n ? t : bo(t));
            }, Vr.reverse = na, Vr.sampleSize = function(e, t, r) {
                return t = (r ? ys(e, t, r) : t === n) ? 1 : bo(t), (Ka(e) ? Zr : Jn)(e, t);
            }, Vr.set = function(e, t, r) {
                return null == e ? e : ei(e, t, r);
            }, Vr.setWith = function(e, t, r, i) {
                return i = "function" == typeof i ? i : n, null == e ? e : ei(e, t, r, i);
            }, Vr.shuffle = function(e) {
                return (Ka(e) ? Jr : ni)(e);
            }, Vr.slice = function(e, t, r) {
                var i = null == e ? 0 : e.length;
                return i ? (r && "number" != typeof r && ys(e, t, r) ? (t = 0, r = i) : (t = null == t ? 0 : bo(t), r = r === n ? i : bo(r)), ii(e, t, r)) : [];
            }, Vr.sortBy = Ba, Vr.sortedUniq = function(e) {
                return e && e.length ? li(e) : [];
            }, Vr.sortedUniqBy = function(e, t) {
                return e && e.length ? li(e, us(t, 2)) : [];
            }, Vr.split = function(e, t, r) {
                return r && "number" != typeof r && ys(e, t, r) && (t = r = n), (r = r === n ? g : r >>> 0) ? (e = So(e)) && ("string" == typeof t || null != t && !lo(t)) && !(t = di(t)) && ar(e) ? Si(fr(e), 0, r) : e.split(t, r) : [];
            }, Vr.spread = function(e, t) {
                if ("function" != typeof e) throw new Ce(i);
                return t = null == t ? 0 : br(bo(t), 0), Xn(function(r) {
                    var n = r[t], i = Si(r, 0, t);
                    return n && It(i, n), Lt(e, this, i);
                });
            }, Vr.tail = function(e) {
                var t = null == e ? 0 : e.length;
                return t ? ii(e, 1, t) : [];
            }, Vr.take = function(e, t, r) {
                return e && e.length ? ii(e, 0, (t = r || t === n ? 1 : bo(t)) < 0 ? 0 : t) : [];
            }, Vr.takeRight = function(e, t, r) {
                var i = null == e ? 0 : e.length;
                return i ? ii(e, (t = i - (t = r || t === n ? 1 : bo(t))) < 0 ? 0 : t, i) : [];
            }, Vr.takeRightWhile = function(e, t) {
                return e && e.length ? _i(e, us(t, 3), !1, !0) : [];
            }, Vr.takeWhile = function(e, t) {
                return e && e.length ? _i(e, us(t, 3)) : [];
            }, Vr.tap = function(e, t) {
                return t(e), e;
            }, Vr.throttle = function(e, t, r) {
                var n = !0, s = !0;
                if ("function" != typeof e) throw new Ce(i);
                return no(r) && (n = "leading" in r ? !!r.leading : n, s = "trailing" in r ? !!r.trailing : s), Ma(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: s
                });
            }, Vr.thru = pa, Vr.toArray = po, Vr.toPairs = qo, Vr.toPairsIn = Go, Vr.toPath = function(e) {
                return Ka(e) ? Mt(e, Vs) : ho(e) ? [
                    e
                ] : Ci(Ns(So(e)));
            }, Vr.toPlainObject = Eo, Vr.transform = function(e, t, r) {
                var n = Ka(e), i = n || Xa(e) || fo(e);
                if (t = us(t, 4), null == r) {
                    var s = e && e.constructor;
                    r = i ? n ? new s : [] : no(e) && eo(s) ? Ur(Ke(e)) : {};
                }
                return (i ? Bt : En)(e, function(e, n, i) {
                    return t(r, e, n, i);
                }), r;
            }, Vr.unary = function(e) {
                return Ca(e, 1);
            }, Vr.union = ia, Vr.unionBy = sa, Vr.unionWith = aa, Vr.uniq = function(e) {
                return e && e.length ? ci(e) : [];
            }, Vr.uniqBy = function(e, t) {
                return e && e.length ? ci(e, us(t, 2)) : [];
            }, Vr.uniqWith = function(e, t) {
                return t = "function" == typeof t ? t : n, e && e.length ? ci(e, n, t) : [];
            }, Vr.unset = function(e, t) {
                return null == e || hi(e, t);
            }, Vr.unzip = oa, Vr.unzipWith = la, Vr.update = function(e, t, r) {
                return null == e ? e : fi(e, t, vi(r));
            }, Vr.updateWith = function(e, t, r, i) {
                return i = "function" == typeof i ? i : n, null == e ? e : fi(e, t, vi(r), i);
            }, Vr.values = Wo, Vr.valuesIn = function(e) {
                return null == e ? [] : Jt(e, Fo(e));
            }, Vr.without = ua, Vr.words = tl, Vr.wrap = function(e, t) {
                return Va(vi(t), e);
            }, Vr.xor = da, Vr.xorBy = ca, Vr.xorWith = ha, Vr.zip = fa, Vr.zipObject = function(e, t) {
                return mi(e || [], t || [], tn);
            }, Vr.zipObjectDeep = function(e, t) {
                return mi(e || [], t || [], ei);
            }, Vr.zipWith = _a, Vr.entries = qo, Vr.entriesIn = Go, Vr.extend = To, Vr.extendWith = Ao, cl(Vr, Vr), Vr.add = El, Vr.attempt = rl, Vr.camelCase = jo, Vr.capitalize = Ho, Vr.ceil = Sl, Vr.clamp = function(e, t, r) {
                return r === n && (r = t, t = n), r !== n && (r = (r = yo(r)) == r ? r : 0), t !== n && (t = (t = yo(t)) == t ? t : 0), ln(yo(e), t, r);
            }, Vr.clone = function(e) {
                return un(e, 4);
            }, Vr.cloneDeep = function(e) {
                return un(e, 5);
            }, Vr.cloneDeepWith = function(e, t) {
                return un(e, 5, t = "function" == typeof t ? t : n);
            }, Vr.cloneWith = function(e, t) {
                return un(e, 4, t = "function" == typeof t ? t : n);
            }, Vr.conformsTo = function(e, t) {
                return null == t || dn(e, t, Io(t));
            }, Vr.deburr = Ko, Vr.defaultTo = function(e, t) {
                return null == e || e != e ? t : e;
            }, Vr.divide = Rl, Vr.endsWith = function(e, t, r) {
                e = So(e), t = di(t);
                var i = e.length, s = r = r === n ? i : ln(bo(r), 0, i);
                return (r -= t.length) >= 0 && e.slice(r, s) == t;
            }, Vr.eq = Ga, Vr.escape = function(e) {
                return (e = So(e)) && z.test(e) ? e.replace(Y, ir) : e;
            }, Vr.escapeRegExp = function(e) {
                return (e = So(e)) && ie.test(e) ? e.replace(ne, "\\$&") : e;
            }, Vr.every = function(e, t, r) {
                var i = Ka(e) ? Ct : gn;
                return r && ys(e, t, r) && (t = n), i(e, us(t, 3));
            }, Vr.find = va, Vr.findIndex = Hs, Vr.findKey = function(e, t) {
                return Vt(e, us(t, 3), En);
            }, Vr.findLast = ya, Vr.findLastIndex = Ks, Vr.findLastKey = function(e, t) {
                return Vt(e, us(t, 3), Sn);
            }, Vr.floor = Tl, Vr.forEach = Ea, Vr.forEachRight = Sa, Vr.forIn = function(e, t) {
                return null == e ? e : vn(e, us(t, 3), Fo);
            }, Vr.forInRight = function(e, t) {
                return null == e ? e : yn(e, us(t, 3), Fo);
            }, Vr.forOwn = function(e, t) {
                return e && En(e, us(t, 3));
            }, Vr.forOwnRight = function(e, t) {
                return e && Sn(e, us(t, 3));
            }, Vr.get = Co, Vr.gt = Wa, Vr.gte = ja, Vr.has = function(e, t) {
                return null != e && ps(e, t, Bn);
            }, Vr.hasIn = wo, Vr.head = Qs, Vr.identity = ol, Vr.includes = function(e, t, r, n) {
                e = Qa(e) ? e : Wo(e), r = r && !n ? bo(r) : 0;
                var i = e.length;
                return r < 0 && (r = br(i + r, 0)), co(e) ? r <= i && e.indexOf(t, r) > -1 : !!i && qt(e, t, r) > -1;
            }, Vr.indexOf = function(e, t, r) {
                var n = null == e ? 0 : e.length;
                if (!n) return -1;
                var i = null == r ? 0 : bo(r);
                return i < 0 && (i = br(n + i, 0)), qt(e, t, i);
            }, Vr.inRange = function(e, t, r) {
                return t = mo(t), r === n ? (r = t, t = 0) : r = mo(r), function(e, t, r) {
                    return e >= vr(t, r) && e < br(t, r);
                }(e = yo(e), t, r);
            }, Vr.invoke = Mo, Vr.isArguments = Ha, Vr.isArray = Ka, Vr.isArrayBuffer = Ya, Vr.isArrayLike = Qa, Vr.isArrayLikeObject = za, Vr.isBoolean = function(e) {
                return !0 === e || !1 === e || io(e) && Ln(e) == v;
            }, Vr.isBuffer = Xa, Vr.isDate = Za, Vr.isElement = function(e) {
                return io(e) && 1 === e.nodeType && !oo(e);
            }, Vr.isEmpty = function(e) {
                if (null == e) return !0;
                if (Qa(e) && (Ka(e) || "string" == typeof e || "function" == typeof e.splice || Xa(e) || fo(e) || Ha(e))) return !e.length;
                var t = gs(e);
                if (t == T || t == P) return !e.size;
                if (Ts(e)) return !xn(e).length;
                for(var r in e)if (Fe.call(e, r)) return !1;
                return !0;
            }, Vr.isEqual = function(e, t) {
                return Dn(e, t);
            }, Vr.isEqualWith = function(e, t, r) {
                var i = (r = "function" == typeof r ? r : n) ? r(e, t) : n;
                return i === n ? Dn(e, t, n, r) : !!i;
            }, Vr.isError = Ja, Vr.isFinite = function(e) {
                return "number" == typeof e && Nt(e);
            }, Vr.isFunction = eo, Vr.isInteger = to, Vr.isLength = ro, Vr.isMap = so, Vr.isMatch = function(e, t) {
                return e === t || Mn(e, t, cs(t));
            }, Vr.isMatchWith = function(e, t, r) {
                return r = "function" == typeof r ? r : n, Mn(e, t, cs(t), r);
            }, Vr.isNaN = function(e) {
                return ao(e) && e != +e;
            }, Vr.isNative = function(e) {
                if (Rs(e)) throw new Te("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
                return In(e);
            }, Vr.isNil = function(e) {
                return null == e;
            }, Vr.isNull = function(e) {
                return null === e;
            }, Vr.isNumber = ao, Vr.isObject = no, Vr.isObjectLike = io, Vr.isPlainObject = oo, Vr.isRegExp = lo, Vr.isSafeInteger = function(e) {
                return to(e) && e >= -9007199254740991 && e <= f;
            }, Vr.isSet = uo, Vr.isString = co, Vr.isSymbol = ho, Vr.isTypedArray = fo, Vr.isUndefined = function(e) {
                return e === n;
            }, Vr.isWeakMap = function(e) {
                return io(e) && gs(e) == O;
            }, Vr.isWeakSet = function(e) {
                return io(e) && "[object WeakSet]" == Ln(e);
            }, Vr.join = function(e, t) {
                return null == e ? "" : Kt.call(e, t);
            }, Vr.kebabCase = Yo, Vr.last = Js, Vr.lastIndexOf = function(e, t, r) {
                var i = null == e ? 0 : e.length;
                if (!i) return -1;
                var s = i;
                return r !== n && (s = (s = bo(r)) < 0 ? br(i + s, 0) : vr(s, i - 1)), t == t ? function(e, t, r) {
                    for(var n = r + 1; n--;)if (e[n] === t) return n;
                    return n;
                }(e, t, s) : Ut(e, Wt, s, !0);
            }, Vr.lowerCase = Qo, Vr.lowerFirst = zo, Vr.lt = _o, Vr.lte = go, Vr.max = function(e) {
                return e && e.length ? pn(e, ol, $n) : n;
            }, Vr.maxBy = function(e, t) {
                return e && e.length ? pn(e, us(t, 2), $n) : n;
            }, Vr.mean = function(e) {
                return jt(e, ol);
            }, Vr.meanBy = function(e, t) {
                return jt(e, us(t, 2));
            }, Vr.min = function(e) {
                return e && e.length ? pn(e, ol, Nn) : n;
            }, Vr.minBy = function(e, t) {
                return e && e.length ? pn(e, us(t, 2), Nn) : n;
            }, Vr.stubArray = vl, Vr.stubFalse = yl, Vr.stubObject = function() {
                return {};
            }, Vr.stubString = function() {
                return "";
            }, Vr.stubTrue = function() {
                return !0;
            }, Vr.multiply = Ll, Vr.nth = function(e, t) {
                return e && e.length ? Wn(e, bo(t)) : n;
            }, Vr.noConflict = function() {
                return _t._ === this && (_t._ = Ue), this;
            }, Vr.noop = hl, Vr.now = Pa, Vr.pad = function(e, t, r) {
                e = So(e);
                var n = (t = bo(t)) ? hr(e) : 0;
                if (!t || n >= t) return e;
                var i = (t - n) / 2;
                return ji(pt(i), r) + e + ji(gt(i), r);
            }, Vr.padEnd = function(e, t, r) {
                e = So(e);
                var n = (t = bo(t)) ? hr(e) : 0;
                return t && n < t ? e + ji(t - n, r) : e;
            }, Vr.padStart = function(e, t, r) {
                e = So(e);
                var n = (t = bo(t)) ? hr(e) : 0;
                return t && n < t ? ji(t - n, r) + e : e;
            }, Vr.parseInt = function(e, t, r) {
                return r || null == t ? t = 0 : t && (t = +t), Er(So(e).replace(se, ""), t || 0);
            }, Vr.random = function(e, t, r) {
                if (r && "boolean" != typeof r && ys(e, t, r) && (t = r = n), r === n && ("boolean" == typeof t ? (r = t, t = n) : "boolean" == typeof e && (r = e, e = n)), e === n && t === n ? (e = 0, t = 1) : (e = mo(e), t === n ? (t = e, e = 0) : t = mo(t)), e > t) {
                    var i = e;
                    e = t, t = i;
                }
                if (r || e % 1 || t % 1) {
                    var s = Sr();
                    return vr(e + s * (t - e + dt("1e-" + ((s + "").length - 1))), t);
                }
                return Qn(e, t);
            }, Vr.reduce = function(e, t, r) {
                var n = Ka(e) ? Ft : Yt, i = arguments.length < 3;
                return n(e, us(t, 4), r, i, fn);
            }, Vr.reduceRight = function(e, t, r) {
                var n = Ka(e) ? xt : Yt, i = arguments.length < 3;
                return n(e, us(t, 4), r, i, _n);
            }, Vr.repeat = function(e, t, r) {
                return t = (r ? ys(e, t, r) : t === n) ? 1 : bo(t), zn(So(e), t);
            }, Vr.replace = function() {
                var e = arguments, t = So(e[0]);
                return e.length < 3 ? t : t.replace(e[1], e[2]);
            }, Vr.result = function(e, t, r) {
                var i = -1, s = (t = yi(t, e)).length;
                for(s || (s = 1, e = n); ++i < s;){
                    var a = null == e ? n : e[Vs(t[i])];
                    a === n && (i = s, a = r), e = eo(a) ? a.call(e) : a;
                }
                return e;
            }, Vr.round = $l, Vr.runInContext = e, Vr.sample = function(e) {
                return (Ka(e) ? Xr : Zn)(e);
            }, Vr.size = function(e) {
                if (null == e) return 0;
                if (Qa(e)) return co(e) ? hr(e) : e.length;
                var t = gs(e);
                return t == T || t == P ? e.size : xn(e).length;
            }, Vr.snakeCase = Xo, Vr.some = function(e, t, r) {
                var i = Ka(e) ? kt : si;
                return r && ys(e, t, r) && (t = n), i(e, us(t, 3));
            }, Vr.sortedIndex = function(e, t) {
                return ai(e, t);
            }, Vr.sortedIndexBy = function(e, t, r) {
                return oi(e, t, us(r, 2));
            }, Vr.sortedIndexOf = function(e, t) {
                var r = null == e ? 0 : e.length;
                if (r) {
                    var n = ai(e, t);
                    if (n < r && Ga(e[n], t)) return n;
                }
                return -1;
            }, Vr.sortedLastIndex = function(e, t) {
                return ai(e, t, !0);
            }, Vr.sortedLastIndexBy = function(e, t, r) {
                return oi(e, t, us(r, 2), !0);
            }, Vr.sortedLastIndexOf = function(e, t) {
                if (null == e ? 0 : e.length) {
                    var r = ai(e, t, !0) - 1;
                    if (Ga(e[r], t)) return r;
                }
                return -1;
            }, Vr.startCase = Zo, Vr.startsWith = function(e, t, r) {
                return e = So(e), r = null == r ? 0 : ln(bo(r), 0, e.length), t = di(t), e.slice(r, r + t.length) == t;
            }, Vr.subtract = Bl, Vr.sum = function(e) {
                return e && e.length ? Qt(e, ol) : 0;
            }, Vr.sumBy = function(e, t) {
                return e && e.length ? Qt(e, us(t, 2)) : 0;
            }, Vr.template = function(e, t, r) {
                var i = Vr.templateSettings;
                r && ys(e, t, r) && (t = n), e = So(e), t = Ao({}, t, i, Ji);
                var s, a, o = Ao({}, t.imports, i.imports, Ji), l = Io(o), u = Jt(o, l), d = 0, c = t.interpolate || Ee, h = "__p += '", f = Be((t.escape || Ee).source + "|" + c.source + "|" + (c === J ? fe : Ee).source + "|" + (t.evaluate || Ee).source + "|$", "g"), _ = "//# sourceURL=" + (Fe.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++at + "]") + "\n";
                e.replace(f, function(t, r, n, i, o, l) {
                    return n || (n = i), h += e.slice(d, l).replace(Se, sr), r && (s = !0, h += "' +\n__e(" + r + ") +\n'"), o && (a = !0, h += "';\n" + o + ";\n__p += '"), n && (h += "' +\n((__t = (" + n + ")) == null ? '' : __t) +\n'"), d = l + t.length, t;
                }), h += "';\n";
                var g = Fe.call(t, "variable") && t.variable;
                if (g) {
                    if (ce.test(g)) throw new Te("Invalid `variable` option passed into `_.template`");
                } else h = "with (obj) {\n" + h + "\n}\n";
                h = (a ? h.replace(W, "") : h).replace(j, "$1").replace(H, "$1;"), h = "function(" + (g || "obj") + ") {\n" + (g ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (s ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + h + "return __p\n}";
                var p = rl(function() {
                    return Ae(l, _ + "return " + h).apply(n, u);
                });
                if (p.source = h, Ja(p)) throw p;
                return p;
            }, Vr.times = function(e, t) {
                if ((e = bo(e)) < 1 || e > f) return [];
                var r = g, n = vr(e, g);
                t = us(t), e -= g;
                for(var i = zt(n, t); ++r < e;)t(r);
                return i;
            }, Vr.toFinite = mo, Vr.toInteger = bo, Vr.toLength = vo, Vr.toLower = function(e) {
                return So(e).toLowerCase();
            }, Vr.toNumber = yo, Vr.toSafeInteger = function(e) {
                return e ? ln(bo(e), -9007199254740991, f) : 0 === e ? e : 0;
            }, Vr.toString = So, Vr.toUpper = function(e) {
                return So(e).toUpperCase();
            }, Vr.trim = function(e, t, r) {
                if ((e = So(e)) && (r || t === n)) return Xt(e);
                if (!e || !(t = di(t))) return e;
                var i = fr(e), s = fr(t);
                return Si(i, tr(i, s), rr(i, s) + 1).join("");
            }, Vr.trimEnd = function(e, t, r) {
                if ((e = So(e)) && (r || t === n)) return e.slice(0, _r(e) + 1);
                if (!e || !(t = di(t))) return e;
                var i = fr(e);
                return Si(i, 0, rr(i, fr(t)) + 1).join("");
            }, Vr.trimStart = function(e, t, r) {
                if ((e = So(e)) && (r || t === n)) return e.replace(se, "");
                if (!e || !(t = di(t))) return e;
                var i = fr(e);
                return Si(i, tr(i, fr(t))).join("");
            }, Vr.truncate = function(e, t) {
                var r = 30, i = "...";
                if (no(t)) {
                    var s = "separator" in t ? t.separator : s;
                    r = "length" in t ? bo(t.length) : r, i = "omission" in t ? di(t.omission) : i;
                }
                var a = (e = So(e)).length;
                if (ar(e)) {
                    var o = fr(e);
                    a = o.length;
                }
                if (r >= a) return e;
                var l = r - hr(i);
                if (l < 1) return i;
                var u = o ? Si(o, 0, l).join("") : e.slice(0, l);
                if (s === n) return u + i;
                if (o && (l += u.length - l), lo(s)) {
                    if (e.slice(l).search(s)) {
                        var d, c = u;
                        for(s.global || (s = Be(s.source, So(_e.exec(s)) + "g")), s.lastIndex = 0; d = s.exec(c);)var h = d.index;
                        u = u.slice(0, h === n ? l : h);
                    }
                } else if (e.indexOf(di(s), l) != l) {
                    var f = u.lastIndexOf(s);
                    f > -1 && (u = u.slice(0, f));
                }
                return u + i;
            }, Vr.unescape = function(e) {
                return (e = So(e)) && Q.test(e) ? e.replace(K, gr) : e;
            }, Vr.uniqueId = function(e) {
                var t = ++xe;
                return So(e) + t;
            }, Vr.upperCase = Jo, Vr.upperFirst = el, Vr.each = Ea, Vr.eachRight = Sa, Vr.first = Qs, cl(Vr, (Al = {}, En(Vr, function(e, t) {
                Fe.call(Vr.prototype, t) || (Al[t] = e);
            }), Al), {
                chain: !1
            }), Vr.VERSION = "4.17.21", Bt([
                "bind",
                "bindKey",
                "curry",
                "curryRight",
                "partial",
                "partialRight"
            ], function(e) {
                Vr[e].placeholder = Vr;
            }), Bt([
                "drop",
                "take"
            ], function(e, t) {
                Wr.prototype[e] = function(r) {
                    r = r === n ? 1 : br(bo(r), 0);
                    var i = this.__filtered__ && !t ? new Wr(this) : this.clone();
                    return i.__filtered__ ? i.__takeCount__ = vr(r, i.__takeCount__) : i.__views__.push({
                        size: vr(r, g),
                        type: e + (i.__dir__ < 0 ? "Right" : "")
                    }), i;
                }, Wr.prototype[e + "Right"] = function(t) {
                    return this.reverse()[e](t).reverse();
                };
            }), Bt([
                "filter",
                "map",
                "takeWhile"
            ], function(e, t) {
                var r = t + 1, n = 1 == r || 3 == r;
                Wr.prototype[e] = function(e) {
                    var t = this.clone();
                    return t.__iteratees__.push({
                        iteratee: us(e, 3),
                        type: r
                    }), t.__filtered__ = t.__filtered__ || n, t;
                };
            }), Bt([
                "head",
                "last"
            ], function(e, t) {
                var r = "take" + (t ? "Right" : "");
                Wr.prototype[e] = function() {
                    return this[r](1).value()[0];
                };
            }), Bt([
                "initial",
                "tail"
            ], function(e, t) {
                var r = "drop" + (t ? "" : "Right");
                Wr.prototype[e] = function() {
                    return this.__filtered__ ? new Wr(this) : this[r](1);
                };
            }), Wr.prototype.compact = function() {
                return this.filter(ol);
            }, Wr.prototype.find = function(e) {
                return this.filter(e).head();
            }, Wr.prototype.findLast = function(e) {
                return this.reverse().find(e);
            }, Wr.prototype.invokeMap = Xn(function(e, t) {
                return "function" == typeof e ? new Wr(this) : this.map(function(r) {
                    return wn(r, e, t);
                });
            }), Wr.prototype.reject = function(e) {
                return this.filter(ka(us(e)));
            }, Wr.prototype.slice = function(e, t) {
                e = bo(e);
                var r = this;
                return r.__filtered__ && (e > 0 || t < 0) ? new Wr(r) : (e < 0 ? r = r.takeRight(-e) : e && (r = r.drop(e)), t !== n && (r = (t = bo(t)) < 0 ? r.dropRight(-t) : r.take(t - e)), r);
            }, Wr.prototype.takeRightWhile = function(e) {
                return this.reverse().takeWhile(e).reverse();
            }, Wr.prototype.toArray = function() {
                return this.take(g);
            }, En(Wr.prototype, function(e, t) {
                var r = /^(?:filter|find|map|reject)|While$/.test(t), i = /^(?:head|last)$/.test(t), s = Vr[i ? "take" + ("last" == t ? "Right" : "") : t], a = i || /^find/.test(t);
                s && (Vr.prototype[t] = function() {
                    var t = this.__wrapped__, o = i ? [
                        1
                    ] : arguments, l = t instanceof Wr, u = o[0], d = l || Ka(t), c = function(e) {
                        var t = s.apply(Vr, It([
                            e
                        ], o));
                        return i && h ? t[0] : t;
                    };
                    d && r && "function" == typeof u && 1 != u.length && (l = d = !1);
                    var h = this.__chain__, f = !!this.__actions__.length, _ = a && !h, g = l && !f;
                    if (!a && d) {
                        t = g ? t : new Wr(this);
                        var p = e.apply(t, o);
                        return p.__actions__.push({
                            func: pa,
                            args: [
                                c
                            ],
                            thisArg: n
                        }), new Gr(p, h);
                    }
                    return _ && g ? e.apply(this, o) : (p = this.thru(c), _ ? i ? p.value()[0] : p.value() : p);
                });
            }), Bt([
                "pop",
                "push",
                "shift",
                "sort",
                "splice",
                "unshift"
            ], function(e) {
                var t = we[e], r = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", n = /^(?:pop|shift)$/.test(e);
                Vr.prototype[e] = function() {
                    var e = arguments;
                    if (n && !this.__chain__) {
                        var i = this.value();
                        return t.apply(Ka(i) ? i : [], e);
                    }
                    return this[r](function(r) {
                        return t.apply(Ka(r) ? r : [], e);
                    });
                };
            }), En(Wr.prototype, function(e, t) {
                var r = Vr[t];
                if (r) {
                    var n = r.name + "";
                    Fe.call(wr, n) || (wr[n] = []), wr[n].push({
                        name: t,
                        func: r
                    });
                }
            }), wr[Ui(n, 2).name] = [
                {
                    name: "wrapper",
                    func: n
                }
            ], Wr.prototype.clone = function() {
                var e = new Wr(this.__wrapped__);
                return e.__actions__ = Ci(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Ci(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Ci(this.__views__), e;
            }, Wr.prototype.reverse = function() {
                if (this.__filtered__) {
                    var e = new Wr(this);
                    e.__dir__ = -1, e.__filtered__ = !0;
                } else (e = this.clone()).__dir__ *= -1;
                return e;
            }, Wr.prototype.value = function() {
                var e = this.__wrapped__.value(), t = this.__dir__, r = Ka(e), n = t < 0, i = r ? e.length : 0, s = function(e, t, r) {
                    var n = -1, i = r.length;
                    for(; ++n < i;){
                        var s = r[n], a = s.size;
                        switch(s.type){
                            case "drop":
                                e += a;
                                break;
                            case "dropRight":
                                t -= a;
                                break;
                            case "take":
                                t = vr(t, e + a);
                                break;
                            case "takeRight":
                                e = br(e, t - a);
                        }
                    }
                    return {
                        start: e,
                        end: t
                    };
                }(0, i, this.__views__), a = s.start, o = s.end, l = o - a, u = n ? o : a - 1, d = this.__iteratees__, c = d.length, h = 0, f = vr(l, this.__takeCount__);
                if (!r || !n && i == l && f == l) return gi(e, this.__actions__);
                var _ = [];
                e: for(; l-- && h < f;){
                    for(var g = -1, p = e[u += t]; ++g < c;){
                        var m = d[g], b = m.iteratee, v = m.type, y = b(p);
                        if (2 == v) p = y;
                        else if (!y) {
                            if (1 == v) continue e;
                            break e;
                        }
                    }
                    _[h++] = p;
                }
                return _;
            }, Vr.prototype.at = ma, Vr.prototype.chain = function() {
                return ga(this);
            }, Vr.prototype.commit = function() {
                return new Gr(this.value(), this.__chain__);
            }, Vr.prototype.next = function() {
                this.__values__ === n && (this.__values__ = po(this.value()));
                var e = this.__index__ >= this.__values__.length;
                return {
                    done: e,
                    value: e ? n : this.__values__[this.__index__++]
                };
            }, Vr.prototype.plant = function(_e1) {
                for(var t, r = this; r instanceof qr;){
                    var i = qs(r);
                    i.__index__ = 0, i.__values__ = n, t ? s.__wrapped__ = i : t = i;
                    var s = i;
                    r = r.__wrapped__;
                }
                return s.__wrapped__ = _e1, t;
            }, Vr.prototype.reverse = function() {
                var e = this.__wrapped__;
                if (e instanceof Wr) {
                    var t = e;
                    return this.__actions__.length && (t = new Wr(this)), (t = t.reverse()).__actions__.push({
                        func: pa,
                        args: [
                            na
                        ],
                        thisArg: n
                    }), new Gr(t, this.__chain__);
                }
                return this.thru(na);
            }, Vr.prototype.toJSON = Vr.prototype.valueOf = Vr.prototype.value = function() {
                return gi(this.__wrapped__, this.__actions__);
            }, Vr.prototype.first = Vr.prototype.head, Ze && (Vr.prototype[Ze] = function() {
                return this;
            }), Vr;
        }();
        "function" == typeof define && "object" == typeof define.amd && define.amd ? (_t._ = pr, define(function() {
            return pr;
        })) : pt ? ((pt.exports = pr)._ = pr, gt._ = pr) : _t._ = pr;
    }).call(this);
}), $dbaf12f73216aff4$var$a.register("3264a", function(e, r) {
    let n;
    var i;
    $dbaf12f73216aff4$var$t(e.exports, "ECommand", function() {
        return n;
    }), (i = n || (n = {})).CONNECT_TO_ROOM = "connectToRoom", i.MODULES_INFO_AVAILABLE = "modulesInfoAvailable", i.MODULE_LIFECYCLE_EVENT_AVAILABLE = "moduleLifecycleEventAvailable", i.CLIENT_CONNECTED = "clientConnected", i.CLIENT_INFO_AVAILABLE = "clientInfoAvailable", i.CLIENT_DISCONNECTED = "clientDisconnected";
}), $dbaf12f73216aff4$var$a.register("iVqGx", function(e, t) {
    e.exports = (parcelRequire("jecYn")).then(()=>$dbaf12f73216aff4$var$a("8GHQT"));
}), $dbaf12f73216aff4$var$a("8NFq9");
var $dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
function $dbaf12f73216aff4$var$l() {
    return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== $dbaf12f73216aff4$var$r ? $dbaf12f73216aff4$var$r : void 0;
}
"undefined" == typeof globalThis && (globalThis = $dbaf12f73216aff4$var$l());
const $dbaf12f73216aff4$var$u = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== $dbaf12f73216aff4$var$r && $dbaf12f73216aff4$var$r;
function $dbaf12f73216aff4$var$d(e) {
    try {
        new e("");
    } catch (e) {
        return !1;
    }
    return !0;
}
"function" == typeof $dbaf12f73216aff4$var$u.Event && $dbaf12f73216aff4$var$d($dbaf12f73216aff4$var$u.Event) || ($dbaf12f73216aff4$var$u.Event = function(e, t) {
    this.bubbles = !!t && !!t.bubbles, this.cancelable = !!t && !!t.cancelable, this.composed = !!t && !!t.composed, this.type = e;
}), void 0 !== $dbaf12f73216aff4$var$u.EventTarget && $dbaf12f73216aff4$var$d($dbaf12f73216aff4$var$u.EventTarget) || ($dbaf12f73216aff4$var$u.EventTarget = function() {
    function e() {
        this.__listeners = new Map;
    }
    return e.prototype = Object.create(Object.prototype), e.prototype.addEventListener = function(e, t, r) {
        if (arguments.length < 2) throw new TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        const n = this.__listeners, i = e.toString();
        n.has(i) || n.set(i, new Map);
        const s = n.get(i);
        s.has(t) || s.set(t, r);
    }, e.prototype.removeEventListener = function(e, t, r) {
        if (arguments.length < 2) throw new TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        const n = this.__listeners, i = e.toString();
        if (n.has(i)) {
            const e = n.get(i);
            e.has(t) && e.delete(t);
        }
    }, e.prototype.dispatchEvent = function(e) {
        if (!(e instanceof Event)) throw new TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
        const t = e.type, r = this.__listeners.get(t);
        if (r) for (const [t, n] of r.entries()){
            try {
                "function" == typeof t ? t.call(this, e) : t && "function" == typeof t.handleEvent && t.handleEvent(e);
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            }
            n && n.once && r.delete(t);
        }
        return !0;
    }, e;
}());

class $dbaf12f73216aff4$var$$69ed7a9a1170b81a$var$Emitter {
    constructor(){
        Object.defineProperty(this, "listeners", {
            value: {},
            writable: !0,
            configurable: !0
        });
    }
    addEventListener(e, t, r) {
        e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
            callback: t,
            options: r
        });
    }
    removeEventListener(e, t) {
        if (!(e in this.listeners)) return;
        const r = this.listeners[e];
        for(let e = 0, n = r.length; e < n; e++)if (r[e].callback === t) return void r.splice(e, 1);
    }
    dispatchEvent(e) {
        if (!(e.type in this.listeners)) return;
        const t = this.listeners[e.type].slice();
        for(let r = 0, n = t.length; r < n; r++){
            const n = t[r];
            try {
                n.callback.call(this, e);
            } catch (e) {
                Promise.resolve().then(function() {
                    return (parcelRequire("jecYn"));
                }).then((res)=>{
                    throw e;
                });
            }
            n.options && n.options.once && this.removeEventListener(e.type, n.callback);
        }
        return !e.defaultPrevented;
    }
}
class $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$e42c54032314dc1d extends $dbaf12f73216aff4$var$$69ed7a9a1170b81a$var$Emitter {
    constructor(){
        super(), this.listeners || $dbaf12f73216aff4$var$$69ed7a9a1170b81a$var$Emitter.call(this), Object.defineProperty(this, "aborted", {
            value: !1,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "onabort", {
            value: null,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "reason", {
            value: void 0,
            writable: !0,
            configurable: !0
        });
    }
    toString() {
        return "[object AbortSignal]";
    }
    dispatchEvent(e) {
        "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), super.dispatchEvent(e);
    }
}
class $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$48f7e099c149af88 {
    constructor(){
        Object.defineProperty(this, "signal", {
            value: new $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$e42c54032314dc1d,
            writable: !0,
            configurable: !0
        });
    }
    abort(e) {
        const t = new Event("abort");
        let r = e;
        void 0 === r && (r = new Error("This operation was aborted"), r.name = "AbortError"), this.signal.reason = r, this.signal.dispatchEvent(t);
    }
    toString() {
        return "[object AbortController]";
    }
}
!function(e) {
    (function(e) {
        return "function" == typeof e.Request && !Object.prototype.hasOwnProperty.call(e.Request.prototype, "signal") || !e.AbortController;
    })(e) && ("undefined" != typeof Symbol && Symbol.toStringTag && ($dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$48f7e099c149af88.prototype[Symbol.toStringTag] = "AbortController", $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$e42c54032314dc1d.prototype[Symbol.toStringTag] = "AbortSignal"), e.AbortController = $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$48f7e099c149af88, e.AbortSignal = $dbaf12f73216aff4$var$$69ed7a9a1170b81a$export$e42c54032314dc1d);
}("undefined" != typeof self ? self : $dbaf12f73216aff4$var$r);
const $dbaf12f73216aff4$var$c = $dbaf12f73216aff4$var$l();
"function" != typeof $dbaf12f73216aff4$var$c.queueMicrotask && ($dbaf12f73216aff4$var$c.queueMicrotask = function(e) {
    Promise.resolve().then(e).catch((e)=>setTimeout(()=>{
            throw e;
        }));
}), Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", {
    configurable: !0,
    value: function e(...t) {
        const r = isNaN(t[0]) ? 1 : Number(t[0]);
        return r ? Array.prototype.reduce.call(this, function(t, n) {
            return Array.isArray(n) ? t.push(...e.call(n, r - 1)) : t.push(n), t;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: !0
}), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", {
    configurable: !0,
    value: function(...e) {
        return this.map(...e).flat();
    },
    writable: !0
}), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
var $dbaf12f73216aff4$var$h, $dbaf12f73216aff4$var$f, $dbaf12f73216aff4$var$_, $dbaf12f73216aff4$var$g, $dbaf12f73216aff4$var$p, $dbaf12f73216aff4$var$m, $dbaf12f73216aff4$var$b, $dbaf12f73216aff4$export$559043f40a876a16, $dbaf12f73216aff4$var$y, $dbaf12f73216aff4$var$E, $dbaf12f73216aff4$var$S, $dbaf12f73216aff4$var$R, $dbaf12f73216aff4$var$T = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== $dbaf12f73216aff4$var$r ? $dbaf12f73216aff4$var$r : {};
function $dbaf12f73216aff4$var$A() {
    return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== $dbaf12f73216aff4$var$T ? $dbaf12f73216aff4$var$T : void 0;
}
"undefined" == typeof globalThis && (globalThis = $dbaf12f73216aff4$var$A());
let $dbaf12f73216aff4$var$L = "undefined" != typeof globalThis && globalThis || "undefined" != typeof self && self || void 0 !== $dbaf12f73216aff4$var$T && $dbaf12f73216aff4$var$T;
function $dbaf12f73216aff4$var$$(e) {
    try {
        new e("");
    } catch (e) {
        return !1;
    }
    return !0;
}
"function" == typeof $dbaf12f73216aff4$var$L.Event && $dbaf12f73216aff4$var$$($dbaf12f73216aff4$var$L.Event) || ($dbaf12f73216aff4$var$L.Event = function(e, t) {
    this.bubbles = !!t && !!t.bubbles, this.cancelable = !!t && !!t.cancelable, this.composed = !!t && !!t.composed, this.type = e;
}), void 0 !== $dbaf12f73216aff4$var$L.EventTarget && $dbaf12f73216aff4$var$$($dbaf12f73216aff4$var$L.EventTarget) || ($dbaf12f73216aff4$var$L.EventTarget = function() {
    function e() {
        this.__listeners = new Map;
    }
    return e.prototype = Object.create(Object.prototype), e.prototype.addEventListener = function(e, t, r) {
        if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        let n = this.__listeners, i = e.toString();
        n.has(i) || n.set(i, new Map);
        let s = n.get(i);
        s.has(t) || s.set(t, r);
    }, e.prototype.removeEventListener = function(e, t, r) {
        if (arguments.length < 2) throw TypeError(`TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ${arguments.length} present.`);
        let n = this.__listeners, i = e.toString();
        if (n.has(i)) {
            let e = n.get(i);
            e.has(t) && e.delete(t);
        }
    }, e.prototype.dispatchEvent = function(e) {
        if (!(e instanceof Event)) throw TypeError("Failed to execute 'dispatchEvent' on 'EventTarget': parameter 1 is not of type 'Event'.");
        let t = e.type, r = this.__listeners.get(t);
        if (r) for (let [t, n] of r.entries()){
            try {
                "function" == typeof t ? t.call(this, e) : t && "function" == typeof t.handleEvent && t.handleEvent(e);
            } catch (e) {
                setTimeout(()=>{
                    throw e;
                });
            }
            n && n.once && r.delete(t);
        }
        return !0;
    }, e;
}());
let $dbaf12f73216aff4$var$B = class $3cfe36083fdf784d$var$Emitter {
    constructor(){
        Object.defineProperty(this, "listeners", {
            value: {},
            writable: !0,
            configurable: !0
        });
    }
    addEventListener(e, t, r) {
        e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
            callback: t,
            options: r
        });
    }
    removeEventListener(e, t) {
        if (!(e in this.listeners)) return;
        let r = this.listeners[e];
        for(let e = 0, n = r.length; e < n; e++)if (r[e].callback === t) return void r.splice(e, 1);
    }
    dispatchEvent(e) {
        if (!(e.type in this.listeners)) return;
        let t = this.listeners[e.type].slice();
        for(let r = 0, n = t.length; r < n; r++){
            let n = t[r];
            try {
                n.callback.call(this, e);
            } catch (e) {
                Promise.resolve().then(()=>{
                    throw e;
                });
            }
            n.options && n.options.once && this.removeEventListener(e.type, n.callback);
        }
        return !e.defaultPrevented;
    }
}, $dbaf12f73216aff4$var$P = class $3cfe36083fdf784d$export$e42c54032314dc1d extends $dbaf12f73216aff4$var$B {
    constructor(){
        super(), this.listeners || $dbaf12f73216aff4$var$B.call(this), Object.defineProperty(this, "aborted", {
            value: !1,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "onabort", {
            value: null,
            writable: !0,
            configurable: !0
        }), Object.defineProperty(this, "reason", {
            value: void 0,
            writable: !0,
            configurable: !0
        });
    }
    toString() {
        return "[object AbortSignal]";
    }
    dispatchEvent(e) {
        "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), super.dispatchEvent(e);
    }
}, $dbaf12f73216aff4$var$C = class $3cfe36083fdf784d$export$48f7e099c149af88 {
    constructor(){
        Object.defineProperty(this, "signal", {
            value: new $dbaf12f73216aff4$var$P,
            writable: !0,
            configurable: !0
        });
    }
    abort(e) {
        let t;
        t = new Event("abort");
        let r = e;
        void 0 === r && ((r = Error("This operation was aborted")).name = "AbortError"), this.signal.reason = r, this.signal.dispatchEvent(t);
    }
    toString() {
        return "[object AbortController]";
    }
};
var $dbaf12f73216aff4$var$w;
("function" != typeof ($dbaf12f73216aff4$var$w = "undefined" != typeof self ? self : $dbaf12f73216aff4$var$T).Request || $dbaf12f73216aff4$var$w.Request.prototype.hasOwnProperty("signal")) && $dbaf12f73216aff4$var$w.AbortController || ("undefined" != typeof Symbol && Symbol.toStringTag && ($dbaf12f73216aff4$var$C.prototype[Symbol.toStringTag] = "AbortController", $dbaf12f73216aff4$var$P.prototype[Symbol.toStringTag] = "AbortSignal"), $dbaf12f73216aff4$var$w.AbortController = $dbaf12f73216aff4$var$C, $dbaf12f73216aff4$var$w.AbortSignal = $dbaf12f73216aff4$var$P);
let $dbaf12f73216aff4$var$O = $dbaf12f73216aff4$var$A();
var $dbaf12f73216aff4$var$D;
"function" != typeof $dbaf12f73216aff4$var$O.queueMicrotask && ($dbaf12f73216aff4$var$O.queueMicrotask = function(e) {
    Promise.resolve().then(e).catch((e)=>setTimeout(()=>{
            throw e;
        }));
}), Array.prototype.flat || Object.defineProperty(Array.prototype, "flat", {
    configurable: !0,
    value: function e() {
        let t = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
        return t ? Array.prototype.reduce.call(this, function(r, n) {
            return Array.isArray(n) ? r.push.apply(r, e.call(n, t - 1)) : r.push(n), r;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: !0
}), Array.prototype.flatMap || Object.defineProperty(Array.prototype, "flatMap", {
    configurable: !0,
    value: function(e) {
        return Array.prototype.map.apply(this, arguments).flat();
    },
    writable: !0
}), ($dbaf12f73216aff4$var$D = $dbaf12f73216aff4$var$h || ($dbaf12f73216aff4$var$h = {})).CLICK = "videoElement.click", $dbaf12f73216aff4$var$D.PLAYING = "videoElement.playing", $dbaf12f73216aff4$var$D.LOADING = "videoElement.loading", $dbaf12f73216aff4$var$D.PAUSE = "videoElement.pause", $dbaf12f73216aff4$var$D.VIDEO_PLAYBACK_STATE_CHANGE = "videoElement.videoPlaybackStateChange", $dbaf12f73216aff4$var$D.NATIVE_EVENT = "videoElement.nativeEvent", $dbaf12f73216aff4$var$D.UPDATE_PLAYER_RESOLUTION = "videoElement.updatePlayerResolution", $dbaf12f73216aff4$var$D.TIME_UPDATE = "videoElement.timeUpdate";
let $dbaf12f73216aff4$var$M = class $ae21521d6337de01$export$5087227eb54526 {
    constructor(e = !0){
        this.appId = null, this._lastUid = -1, this._messages = {}, this._immediateExceptions = !1, this._allSubscribingMsg = "*", this._immediateExceptions = e;
    }
    setAppId(e) {
        this.appId = e;
    }
    getAppId() {
        return this.appId;
    }
    publish(e, t) {
        return this._publish(e, t, !1, this._immediateExceptions);
    }
    publishSync(e, t) {
        return this._publish(e, t, !0, this._immediateExceptions);
    }
    subscribe(e, t) {
        if ("function" != typeof t) return "";
        let r = "uid_" + String(++this._lastUid);
        return this._messages[e] || (this._messages[e] = {}), (this._messages[e] || {})[r] = t, r;
    }
    toggleSubscriptionBulk(e) {
        "subscribe" === e.action ? Object.entries(e.callbacks).forEach(([e, t])=>{
            this.subscribe.call(this, e, t);
        }) : Object.entries(e.callbacks).forEach(([e, t])=>{
            this.unsubscribe.call(this, t);
        });
    }
    subscribeAll(e) {
        return this.subscribe(this._allSubscribingMsg, e);
    }
    subscribeOnce(e, t) {
        let r = this.subscribe(e, (...e)=>{
            this.unsubscribe(r), t.apply(this, e);
        });
        return this;
    }
    clearAllSubscriptions() {
        this._messages = {};
    }
    clearSubscriptions(e) {
        for(let t in this._messages)Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e) && delete this._messages[t];
    }
    unsubscribe(e) {
        let t = "string" == typeof e && (Object.prototype.hasOwnProperty.call(this._messages, e) || this._descendantTopicExists(e)), r = !t && "string" == typeof e, n = "function" == typeof e, i = !1;
        if (!t) {
            for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t)) {
                let s = this._messages[t] || {};
                if (r && s[e]) {
                    delete s[e], i = e;
                    break;
                }
                if (n) for(let t in s)Object.prototype.hasOwnProperty.call(s, t) && s[t] === e && (delete s[t], i = !0);
            }
            return i;
        }
        this.clearSubscriptions(e);
    }
    _hasKeys(e) {
        for(let t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !0;
        return !1;
    }
    _throwException(e) {
        return ()=>{
            throw e;
        };
    }
    _callSubscriberWithDelayedExceptions(e, t) {
        try {
            e(t);
        } catch (e) {
            setTimeout(this._throwException(e), 0);
        }
    }
    _callSubscriberWithImmediateExceptions(e, t) {
        e(t);
    }
    _deliverMessage(e, t, r, n) {
        let i = this._messages[t] || {}, s = n ? this._callSubscriberWithImmediateExceptions : this._callSubscriberWithDelayedExceptions;
        if (Object.prototype.hasOwnProperty.call(this._messages, t)) for(let e in i)Object.prototype.hasOwnProperty.call(i, e) && s(i[e], r);
    }
    _createDeliveryFunction(e, t, r) {
        return ()=>{
            let n = String(e), i = n.lastIndexOf(".");
            for(this._deliverMessage(e, e, t, r); i > -1;)i = (n = n.substr(0, i)).lastIndexOf("."), this._deliverMessage(e, n, t, r);
            this._deliverMessage(e, this._allSubscribingMsg, t, r);
        };
    }
    _hasDirectSubscribersFor(e) {
        let t = String(e);
        return !(!Object.prototype.hasOwnProperty.call(this._messages, t) || !this._hasKeys(this._messages[t] || {}));
    }
    _messageHasSubscribers(e) {
        let t = String(e), r = this._hasDirectSubscribersFor(t) || this._hasDirectSubscribersFor(this._allSubscribingMsg), n = t.lastIndexOf(".");
        for(; !r && -1 !== n;)n = (t = t.substr(0, n)).lastIndexOf("."), r = this._hasDirectSubscribersFor(t);
        return r;
    }
    _publish(e, t, r, n) {
        let i = "symbol" == typeof e ? e.toString() : e, s = this._createDeliveryFunction(i, t, n);
        return !!this._messageHasSubscribers(i) && (r ? s() : setTimeout(s, 0), !0);
    }
    _descendantTopicExists(e) {
        for(let t in this._messages)if (Object.prototype.hasOwnProperty.call(this._messages, t) && 0 === t.indexOf(e)) return !0;
        return !1;
    }
};
new $dbaf12f73216aff4$var$M, new $dbaf12f73216aff4$var$M;
let $dbaf12f73216aff4$var$I = "configProvider.configUpdated", $dbaf12f73216aff4$var$F = (e)=>`${$dbaf12f73216aff4$var$I}.${e}`, $dbaf12f73216aff4$var$x = (e)=>{
    let t = {};
    return {
        configConsumerConstructor: class ConfigConsumer {
            constructor(r, n){
                this._onConfigUpdatedWithContext = this._onConfigUpdated.bind(this), this._configKey = r, this._eventBus = n || e;
                let i = $dbaf12f73216aff4$var$F(r);
                this._onConfigUpdatedListener = this._eventBus.subscribe(i, this._onConfigUpdatedWithContext), this.config = t[r];
            }
            destroy() {
                this._eventBus.unsubscribe(this._onConfigUpdatedListener);
            }
            _handleConfigUpdated(e, t) {}
            _onConfigUpdated(e) {
                t = e.newConfig;
                let r = e.newConfig[this._configKey];
                this.config = r, this._handleConfigUpdated(e.updatedValues, r);
            }
        },
        setConsumerConfig: (e)=>{
            t = e;
        }
    };
}, $dbaf12f73216aff4$var$k = (e)=>e instanceof Date, $dbaf12f73216aff4$var$N = (e)=>e instanceof Element || e instanceof Document, $dbaf12f73216aff4$var$V = (e)=>null != e && "object" == typeof e, $dbaf12f73216aff4$var$U = (e, ...t)=>Object.prototype.hasOwnProperty.call(e, ...t), $dbaf12f73216aff4$var$q = (e)=>{
    var t;
    return $dbaf12f73216aff4$var$V(e) && (t = e, 0 === Object.keys(t).length);
}, $dbaf12f73216aff4$var$G = (e)=>(t)=>new Promise((r, n)=>{
            e(t, (e)=>{
                r(e);
            }, (e)=>{
                n(e);
            });
        }), $dbaf12f73216aff4$var$W = (e, t)=>{
    if (e === t) return {};
    if (!$dbaf12f73216aff4$var$V(e) || !$dbaf12f73216aff4$var$V(t) || $dbaf12f73216aff4$var$N(e) || $dbaf12f73216aff4$var$N(t)) return t;
    let r = Object.keys(e).reduce((e, r)=>($dbaf12f73216aff4$var$U(t, r) || (e[r] = void 0), e), {});
    return $dbaf12f73216aff4$var$k(e) || $dbaf12f73216aff4$var$k(t) ? e.valueOf() == t.valueOf() ? {} : t : Object.keys(t).reduce((r, n)=>{
        if (!$dbaf12f73216aff4$var$U(e, n)) return r[n] = t[n], r;
        let i = $dbaf12f73216aff4$var$W(e[n], t[n]);
        return $dbaf12f73216aff4$var$q(i) && !$dbaf12f73216aff4$var$k(i) && ($dbaf12f73216aff4$var$q(e[n]) || !$dbaf12f73216aff4$var$q(t[n])) || (r[n] = i), r;
    }, r);
}, $dbaf12f73216aff4$var$j = (e)=>{
    let t = {
        ...e
    }, r = new $dbaf12f73216aff4$var$M, { configConsumerConstructor: n, setConsumerConfig: i } = $dbaf12f73216aff4$var$x(r);
    return i(e), {
        getConfigField: (e)=>t[e],
        setConfig: (e, r, n = !1)=>{
            let s = Object.entries(e).reduce((e, [t, r])=>(e[t] = {
                    ...e[t],
                    ...r
                }, e), {
                ...t
            }), a = $dbaf12f73216aff4$var$W(t, s);
            t = s, Object.entries(a).forEach(([e, t])=>{
                let i = $dbaf12f73216aff4$var$F(e);
                n ? r.publishSync(i, {
                    updatedValues: t,
                    newConfig: s
                }) : r.publish(i, {
                    updatedValues: t,
                    newConfig: s
                });
            }), i(t);
        },
        getConfig: ()=>t,
        resetConfig: ()=>{
            t = {
                ...e
            };
        },
        ConfigConsumer: n
    };
};
function $dbaf12f73216aff4$var$H(e, t, r) {
    if (!r || "function" != typeof r.value) throw TypeError(`Only methods can be decorated with @bind. <${t}> is not a method!`);
    return {
        configurable: !0,
        get () {
            let e = r.value?.bind(this);
            return Object.defineProperty(this, t, {
                value: e,
                configurable: !0,
                writable: !0
            }), e;
        }
    };
}
var $dbaf12f73216aff4$var$K, $dbaf12f73216aff4$var$Y, $dbaf12f73216aff4$var$Q, $dbaf12f73216aff4$var$z;
function $dbaf12f73216aff4$var$X(e, t, r, n) {
    var i, s = arguments.length, a = s < 3 ? t : null === n ? n = Object.getOwnPropertyDescriptor(t, r) : n;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, r, n);
    else for(var o = e.length - 1; o >= 0; o--)(i = e[o]) && (a = (s < 3 ? i(a) : s > 3 ? i(t, r, a) : i(t, r)) || a);
    return s > 3 && a && Object.defineProperty(t, r, a), a;
}
($dbaf12f73216aff4$var$z = $dbaf12f73216aff4$var$f || ($dbaf12f73216aff4$var$f = {})).HLS = "hls", $dbaf12f73216aff4$var$z.WEBRTC = "webrtc", $dbaf12f73216aff4$var$z.NATIVE = "native", $dbaf12f73216aff4$var$z.BROADCAST = "broadcast", ($dbaf12f73216aff4$var$Q = $dbaf12f73216aff4$var$_ || ($dbaf12f73216aff4$var$_ = {})).IDLE = "idle", $dbaf12f73216aff4$var$Q.LOADING = "loading", $dbaf12f73216aff4$var$Q.PAUSED = "paused", $dbaf12f73216aff4$var$Q.PLAYING = "playing", $dbaf12f73216aff4$var$Q.ERROR = "error", ($dbaf12f73216aff4$var$Y = $dbaf12f73216aff4$var$g || ($dbaf12f73216aff4$var$g = {})).WAITING = "waiting", $dbaf12f73216aff4$var$Y.AUTO = "auto", $dbaf12f73216aff4$var$Y.MANUAL = "manual", ($dbaf12f73216aff4$var$K = $dbaf12f73216aff4$var$p || ($dbaf12f73216aff4$var$p = {})).BROADCAST_STATE_CHANGED = "commonEvents.broadcastStateChanged", $dbaf12f73216aff4$var$K.BROADCAST_REMOTE_STATS_AVAILABLE = "commonEvents.broadcastRemoteStatsAvailable", $dbaf12f73216aff4$var$K.PLAYING_STATE_CHANGED = "commonEvents.playingStateChanged", $dbaf12f73216aff4$var$K.COMMON_ERROR = "commonEvents.commonError", new $dbaf12f73216aff4$var$M, ($dbaf12f73216aff4$var$m || ($dbaf12f73216aff4$var$m = {})).LOG = "logger.log";
let $dbaf12f73216aff4$var$Z = (e, t, r)=>(n, i)=>{
        e.publish($dbaf12f73216aff4$var$m.LOG, {
            domain: t,
            timestamp: performance.now(),
            level: r,
            message: n,
            payload: i
        });
    }, $dbaf12f73216aff4$var$J = (e, t)=>{
    let r = `${t}{${(Math.random() + 1).toString(36).substring(2, 6)}}`;
    return {
        debug: $dbaf12f73216aff4$var$Z(e, r, "debug"),
        verbose: $dbaf12f73216aff4$var$Z(e, r, "verbose"),
        info: $dbaf12f73216aff4$var$Z(e, r, "info"),
        warn: $dbaf12f73216aff4$var$Z(e, r, "warn"),
        error: $dbaf12f73216aff4$var$Z(e, r, "error"),
        fatal: $dbaf12f73216aff4$var$Z(e, r, "fatal")
    };
}, $dbaf12f73216aff4$var$ee = (...e)=>console.log(...e.filter((e)=>void 0 !== e)), $dbaf12f73216aff4$var$te = {
    debug: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "color: rgb(102, 102, 102)", t),
    verbose: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "color: rgb(36, 114, 200)", t),
    info: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "color: rgb(13, 188, 121)", t),
    warn: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "color: rgb(229, 229, 16)", t),
    error: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "color: rgb(241, 76, 76)", t),
    fatal: (e, t)=>$dbaf12f73216aff4$var$ee(`%c${e}`, "background: rgb(241, 76, 76); color: #fff", t)
}, $dbaf12f73216aff4$var$re = [], $dbaf12f73216aff4$var$ne = class $6b88f92c0e0219d7$export$8734a8c908553955 {
    constructor(e, t = $dbaf12f73216aff4$var$re, r = [], n = [], i = !0){
        this._levels = t, this._eventBus = e, this._enableErrorAutoLog = i, this._onLogMessageReceivedToken = this._eventBus.subscribe($dbaf12f73216aff4$var$m.LOG, this._onMessageReceived), this._onErrorReceivedToken = this._eventBus.subscribe($dbaf12f73216aff4$var$p.COMMON_ERROR, this._onErrorReceived), this._ignoreDomains = n, this._additionalScopeSubscriptions = r.map((e)=>this._eventBus.subscribe(e, (t)=>{
                this._onAdditionalScopeMessageReceived(e, t);
            })), this._appId = `${(Math.random() + 1).toString(36).substring(2, 6)}`;
    }
    destroy() {
        this._eventBus.unsubscribe(this._onLogMessageReceivedToken), this._eventBus.unsubscribe(this._onErrorReceivedToken), this._additionalScopeSubscriptions.forEach(this._eventBus.unsubscribe);
    }
    _onMessageReceived(e) {
        let { domain: t, timestamp: r, level: n, message: i, payload: s } = e;
        this._levels.includes(n) && !this._ignoreDomains.includes(t) && ($dbaf12f73216aff4$var$te[n] || $dbaf12f73216aff4$var$te.info)(`(${this._appId}) :: [${t}] ${n.toUpperCase()}:\n${i}@${r}`, s);
    }
    _onAdditionalScopeMessageReceived(e, t) {
        (0, $dbaf12f73216aff4$var$te.verbose)(`[${e}] Event receiver with payload ${t} @ ${performance.now()}`);
    }
    _onErrorReceived({ error: e }) {
        this._enableErrorAutoLog && $dbaf12f73216aff4$var$J(this._eventBus, "COMMON ERROR").error(`Error in ${e.domain}: ${e.message} ${e.info && " (" + e.info + ")"}`);
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ne.prototype, "_onMessageReceived", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ne.prototype, "_onAdditionalScopeMessageReceived", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ne.prototype, "_onErrorReceived", null);
let $dbaf12f73216aff4$var$ie = {
    videoElementControllerConfig: {
        limitCheckingAutoplay: 5,
        minimalPossibleVideoDimension: 50,
        timeoutUpdateStatusPlaying: 2e3,
        timeoutUpdateVideoDuration: 500
    }
}, { ConfigConsumer: $dbaf12f73216aff4$var$se, setConfig: $dbaf12f73216aff4$var$ae, resetConfig: $dbaf12f73216aff4$var$oe } = $dbaf12f73216aff4$var$j($dbaf12f73216aff4$var$ie);
var $dbaf12f73216aff4$var$le;
($dbaf12f73216aff4$var$le = $dbaf12f73216aff4$var$b || ($dbaf12f73216aff4$var$b = {})).NATIVE_EVENT = "videoElementController.nativeEvent", $dbaf12f73216aff4$var$le.CLICK = "videoElementController.click", $dbaf12f73216aff4$var$le.FORCE_PLAY_AFTER_PAUSE = "videoElementController.forcePlayAfterPause", $dbaf12f73216aff4$var$le.VIDEO_START = "videoElementController.videoStart", $dbaf12f73216aff4$var$le.VIDEO_PAUSE = "videoElementController.videoPause", $dbaf12f73216aff4$var$le.VIDEO_RESET = "videoElementController.videoReset", $dbaf12f73216aff4$var$le.PAUSED = "videoElementController.paused", $dbaf12f73216aff4$var$le.PLAYING = "videoElementController.playing", $dbaf12f73216aff4$var$le.LOADING = "videoElementController.loading", $dbaf12f73216aff4$var$le.LOADED = "videoElementController.loaded", $dbaf12f73216aff4$var$le.UPDATED = "videoElementController.updated", $dbaf12f73216aff4$var$le.DESTROY = "videoElementController.destroy", $dbaf12f73216aff4$var$le.STREAM_RESET = "videoElementController.streamReset", $dbaf12f73216aff4$var$le.CAN_PLAY = "videoElementController.canPlay", $dbaf12f73216aff4$var$le.REMOVE_MEDIA_STREAM = "videoElementController.removeMediaStream", $dbaf12f73216aff4$var$le.ERROR = "videoElementController.error", $dbaf12f73216aff4$var$le.ABORT = "videoElementController.abort", $dbaf12f73216aff4$var$le.STALLED = "videoElementController.stalled", $dbaf12f73216aff4$var$le.WAITING = "videoElementController.waiting", $dbaf12f73216aff4$var$le.UPDATE_PLAYER_RESOLUTION = "videoElementController.updatePlayerResolution", $dbaf12f73216aff4$var$le.RESET_CHECKING_AUTOPLAY_COUNT = "videoElementController.resetCheckingAutoplayCount", $dbaf12f73216aff4$var$le.CANCEL_RESET_STREAM = "videoElementController.cancelResetStream", $dbaf12f73216aff4$var$le.RESTART = "videoElementController.restart", $dbaf12f73216aff4$var$le.TIME_UPDATE_NATIVE = "videoElementController.native", $dbaf12f73216aff4$var$le.UPDATE_MEDIA_STREAM = "videoElementController.updateMediaStream", $dbaf12f73216aff4$var$le.VIDEO_ELEMENT_RECREATED = "videoElementController.videoElementRecreated", $dbaf12f73216aff4$var$le.VIDEO_PLAYBACK_STATE_CHANGED = "videoElementController.videoPlaybackStateChanged", $dbaf12f73216aff4$var$le.SET_VOLUME = "videoElementController.setVolume";
let $dbaf12f73216aff4$var$ue = 0, $dbaf12f73216aff4$var$de = class $13e0e8c55e207599$export$a9a0b55bc0093be5 {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$dbaf12f73216aff4$var$b.CAN_PLAY]: this._checkAutoplayEnabled,
            [$dbaf12f73216aff4$var$b.DESTROY]: this.destroy,
            [$dbaf12f73216aff4$var$b.FORCE_PLAY_AFTER_PAUSE]: this._forcePlayAfterPause,
            [$dbaf12f73216aff4$var$b.RESET_CHECKING_AUTOPLAY_COUNT]: this._resetCheckingAutoplayCount
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - AutoplayController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handleConfigUpdated() {}
    _forcePlayAfterPause(e) {
        if (void 0 !== this._config.autoplay && !this._config.autoplay) return void this._logger.verbose("Autoplay is disabled.");
        this._logger.verbose(`Trying to force video to play.\n    Reason: ${e.reason}`);
        let t = this._state.getState();
        !t.startedPlaying || t.isPlaying || this._config.canBePaused ? this._logger.verbose("Currently unable to autoplay the video") : this._checkAutoplayEnabled();
    }
    _checkAutoplayEnabled() {
        if (this._logger.debug("Checking if autoplay is possible"), this._state.getState().canPlay) {
            if (void 0 === this._config.autoplay || this._config.autoplay) return $dbaf12f73216aff4$var$ue > this._config.limitCheckingAutoplay ? (this._logger.verbose(`Unable to autoplay the video. The limit of autoplay checking (${this._config.limitCheckingAutoplay}) is exceeded`), void this._eventBus.publish($dbaf12f73216aff4$var$b.PAUSED, {})) : ($dbaf12f73216aff4$var$ue += 1, this._logger.verbose("Autoplay is used to play the video"), void this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_START, {}));
            this._logger.verbose("Autoplay is disabled.");
        } else this._logger.verbose("No canPlay event caught, skipping check");
    }
    _resetCheckingAutoplayCount() {
        $dbaf12f73216aff4$var$ue = 0;
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$de.prototype, "destroy", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$de.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$de.prototype, "_forcePlayAfterPause", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$de.prototype, "_checkAutoplayEnabled", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$de.prototype, "_resetCheckingAutoplayCount", null);
let $dbaf12f73216aff4$var$ce = class $2698823e1558ee6a$export$493b9b82400bc18 extends EventTarget {
    constructor(){
        super();
    }
    emitEvent(e, t) {
        this.dispatchEvent(new CustomEvent(e, {
            detail: t
        }));
    }
}, $dbaf12f73216aff4$var$he = class $b8fa44c52cf48ebe$export$17bfd6b0f11e369b extends $dbaf12f73216aff4$var$ce {
    constructor(e){
        super(), this._eventsMap = {
            [$dbaf12f73216aff4$var$b.PLAYING]: this._handlePlaying,
            [$dbaf12f73216aff4$var$b.LOADING]: this._handleLoading,
            [$dbaf12f73216aff4$var$b.VIDEO_PAUSE]: this._handlePause,
            [$dbaf12f73216aff4$var$b.CLICK]: this._handleClick,
            [$dbaf12f73216aff4$var$b.DESTROY]: this.destroy,
            [$dbaf12f73216aff4$var$b.NATIVE_EVENT]: this._handleNativeEvent,
            [$dbaf12f73216aff4$var$b.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [$dbaf12f73216aff4$var$b.VIDEO_PLAYBACK_STATE_CHANGED]: this._handleVideoPlaybackStateChange,
            [$dbaf12f73216aff4$var$b.TIME_UPDATE_NATIVE]: this._handleTimeUpdate
        }, this._eventBus = e.eventBus, this.init();
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _handlePlaying(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.PLAYING, e);
    }
    _handleLoading() {
        this.emitEvent($dbaf12f73216aff4$var$h.LOADING, {});
    }
    _handlePause() {
        this.emitEvent($dbaf12f73216aff4$var$h.PAUSE, {});
    }
    _handleClick(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.CLICK, {
            originalEvent: e.originalEvent
        });
    }
    _handleNativeEvent(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.NATIVE_EVENT, e);
    }
    _handleUpdatePlayerResolution(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.UPDATE_PLAYER_RESOLUTION, e);
    }
    _handleTimeUpdate(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.TIME_UPDATE, e);
    }
    _handleVideoPlaybackStateChange(e) {
        this.emitEvent($dbaf12f73216aff4$var$h.VIDEO_PLAYBACK_STATE_CHANGE, {
            prevState: e.prevState,
            nextState: e.nextState
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "destroy", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handlePlaying", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleLoading", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handlePause", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleClick", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleNativeEvent", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleUpdatePlayerResolution", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleTimeUpdate", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$he.prototype, "_handleVideoPlaybackStateChange", null);
var $dbaf12f73216aff4$var$fe;
$dbaf12f73216aff4$var$fe = function(e) {
    var t = {};
    function r(n) {
        if (t[n]) return t[n].exports;
        var i = t[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }
    return r.m = e, r.c = t, r.d = function(e, t, n) {
        r.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
        });
    }, r.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, r.t = function(e, t) {
        if (1 & t && (e = r(e)), 8 & t || 4 & t && "object" == typeof e && e && e.__esModule) return e;
        var n = Object.create(null);
        if (r.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
            return e[t];
        }).bind(null, i));
        return n;
    }, r.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return r.d(t, "a", t), t;
    }, r.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 90);
}({
    17: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n = r(18), i = function() {
            function e() {}
            return e.getFirstMatch = function(e, t) {
                var r = t.match(e);
                return r && r.length > 0 && r[1] || "";
            }, e.getSecondMatch = function(e, t) {
                var r = t.match(e);
                return r && r.length > 1 && r[2] || "";
            }, e.matchAndReturnConst = function(e, t, r) {
                if (e.test(t)) return r;
            }, e.getWindowsVersionName = function(e) {
                switch(e){
                    case "NT":
                        return "NT";
                    case "XP":
                    case "NT 5.1":
                        return "XP";
                    case "NT 5.0":
                        return "2000";
                    case "NT 5.2":
                        return "2003";
                    case "NT 6.0":
                        return "Vista";
                    case "NT 6.1":
                        return "7";
                    case "NT 6.2":
                        return "8";
                    case "NT 6.3":
                        return "8.1";
                    case "NT 10.0":
                        return "10";
                    default:
                        return;
                }
            }, e.getMacOSVersionName = function(e) {
                var t = e.split(".").splice(0, 2).map(function(e) {
                    return parseInt(e, 10) || 0;
                });
                if (t.push(0), 10 === t[0]) switch(t[1]){
                    case 5:
                        return "Leopard";
                    case 6:
                        return "Snow Leopard";
                    case 7:
                        return "Lion";
                    case 8:
                        return "Mountain Lion";
                    case 9:
                        return "Mavericks";
                    case 10:
                        return "Yosemite";
                    case 11:
                        return "El Capitan";
                    case 12:
                        return "Sierra";
                    case 13:
                        return "High Sierra";
                    case 14:
                        return "Mojave";
                    case 15:
                        return "Catalina";
                    default:
                        return;
                }
            }, e.getAndroidVersionName = function(e) {
                var t = e.split(".").splice(0, 2).map(function(e) {
                    return parseInt(e, 10) || 0;
                });
                if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
            }, e.getVersionPrecision = function(e) {
                return e.split(".").length;
            }, e.compareVersions = function(t, r, n) {
                void 0 === n && (n = !1);
                var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, l = e.map([
                    t,
                    r
                ], function(t) {
                    var r = a - e.getVersionPrecision(t), n = t + Array(r + 1).join(".0");
                    return e.map(n.split("."), function(e) {
                        return Array(20 - e.length).join("0") + e;
                    }).reverse();
                });
                for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                    if (l[0][a] > l[1][a]) return 1;
                    if (l[0][a] === l[1][a]) {
                        if (a === o) return 0;
                        a -= 1;
                    } else if (l[0][a] < l[1][a]) return -1;
                }
            }, e.map = function(e, t) {
                var r, n = [];
                if (Array.prototype.map) return Array.prototype.map.call(e, t);
                for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                return n;
            }, e.find = function(e, t) {
                var r, n;
                if (Array.prototype.find) return Array.prototype.find.call(e, t);
                for(r = 0, n = e.length; r < n; r += 1){
                    var i = e[r];
                    if (t(i, r)) return i;
                }
            }, e.assign = function(e) {
                for(var t, r, n = arguments.length, i = Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)i[s - 1] = arguments[s];
                if (Object.assign) return Object.assign.apply(Object, [
                    e
                ].concat(i));
                for(t = 0, r = i.length; t < r; t += 1)!function() {
                    var r = i[t];
                    "object" == typeof r && null !== r && Object.keys(r).forEach(function(t) {
                        e[t] = r[t];
                    });
                }();
                return e;
            }, e.getBrowserAlias = function(e) {
                return n.BROWSER_ALIASES_MAP[e];
            }, e.getBrowserTypeByAlias = function(e) {
                return n.BROWSER_MAP[e] || "";
            }, e;
        }();
        t.default = i, e.exports = t.default;
    },
    18: function(e, t, r) {
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
        }, t.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
            tablet: "tablet",
            mobile: "mobile",
            desktop: "desktop",
            tv: "tv"
        }, t.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
        }, t.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
        };
    },
    90: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n, i = (n = r(91)) && n.__esModule ? n : {
            default: n
        }, s = r(18), a = function() {
            function e() {}
            return e.getParser = function(e, t) {
                if (void 0 === t && (t = !1), "string" != typeof e) throw Error("UserAgent should be a string");
                return new i.default(e, t);
            }, e.parse = function(e) {
                return new i.default(e).getResult();
            }, function(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }(e, [
                {
                    key: "BROWSER_MAP",
                    get: function() {
                        return s.BROWSER_MAP;
                    }
                },
                {
                    key: "ENGINE_MAP",
                    get: function() {
                        return s.ENGINE_MAP;
                    }
                },
                {
                    key: "OS_MAP",
                    get: function() {
                        return s.OS_MAP;
                    }
                },
                {
                    key: "PLATFORMS_MAP",
                    get: function() {
                        return s.PLATFORMS_MAP;
                    }
                }
            ]), e;
        }();
        t.default = a, e.exports = t.default;
    },
    91: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n = l(r(92)), i = l(r(93)), s = l(r(94)), a = l(r(95)), o = l(r(17));
        function l(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        var u = function() {
            function e(e, t) {
                if (void 0 === t && (t = !1), null == e || "" === e) throw Error("UserAgent parameter can't be empty");
                this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
            }
            var t = e.prototype;
            return t.getUA = function() {
                return this._ua;
            }, t.test = function(e) {
                return e.test(this._ua);
            }, t.parseBrowser = function() {
                var e = this;
                this.parsedResult.browser = {};
                var t = o.default.find(n.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
            }, t.getBrowser = function() {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
            }, t.getBrowserName = function(e) {
                return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
            }, t.getBrowserVersion = function() {
                return this.getBrowser().version;
            }, t.getOS = function() {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
            }, t.parseOS = function() {
                var e = this;
                this.parsedResult.os = {};
                var t = o.default.find(i.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
            }, t.getOSName = function(e) {
                var t = this.getOS().name;
                return e ? String(t).toLowerCase() || "" : t || "";
            }, t.getOSVersion = function() {
                return this.getOS().version;
            }, t.getPlatform = function() {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
            }, t.getPlatformType = function(e) {
                void 0 === e && (e = !1);
                var t = this.getPlatform().type;
                return e ? String(t).toLowerCase() || "" : t || "";
            }, t.parsePlatform = function() {
                var e = this;
                this.parsedResult.platform = {};
                var t = o.default.find(s.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
            }, t.getEngine = function() {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
            }, t.getEngineName = function(e) {
                return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
            }, t.parseEngine = function() {
                var e = this;
                this.parsedResult.engine = {};
                var t = o.default.find(a.default, function(t) {
                    if ("function" == typeof t.test) return t.test(e);
                    if (t.test instanceof Array) return t.test.some(function(t) {
                        return e.test(t);
                    });
                    throw Error("Browser's test function is not valid");
                });
                return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
            }, t.parse = function() {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
            }, t.getResult = function() {
                return o.default.assign({}, this.parsedResult);
            }, t.satisfies = function(e) {
                var t = this, r = {}, n = 0, i = {}, s = 0;
                if (Object.keys(e).forEach(function(t) {
                    var a = e[t];
                    "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                }), n > 0) {
                    var a = Object.keys(r), l = o.default.find(a, function(e) {
                        return t.isOS(e);
                    });
                    if (l) {
                        var u = this.satisfies(r[l]);
                        if (void 0 !== u) return u;
                    }
                    var d = o.default.find(a, function(e) {
                        return t.isPlatform(e);
                    });
                    if (d) {
                        var c = this.satisfies(r[d]);
                        if (void 0 !== c) return c;
                    }
                }
                if (s > 0) {
                    var h = Object.keys(i), f = o.default.find(h, function(e) {
                        return t.isBrowser(e, !0);
                    });
                    if (void 0 !== f) return this.compareVersion(i[f]);
                }
            }, t.isBrowser = function(e, t) {
                void 0 === t && (t = !1);
                var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                return t && i && (n = i.toLowerCase()), n === r;
            }, t.compareVersion = function(e) {
                var t = [
                    0
                ], r = e, n = !1, i = this.getBrowserVersion();
                if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
            }, t.isOS = function(e) {
                return this.getOSName(!0) === String(e).toLowerCase();
            }, t.isPlatform = function(e) {
                return this.getPlatformType(!0) === String(e).toLowerCase();
            }, t.isEngine = function(e) {
                return this.getEngineName(!0) === String(e).toLowerCase();
            }, t.is = function(e, t) {
                return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
            }, t.some = function(e) {
                var t = this;
                return void 0 === e && (e = []), e.some(function(e) {
                    return t.is(e);
                });
            }, e;
        }();
        t.default = u, e.exports = t.default;
    },
    92: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : {
            default: n
        }, s = /version\/(\d+(\.?_?\d+)+)/i, a = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Googlebot"
                    }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /opera/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /opr\/|opios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera"
                    }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /SamsungBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Samsung Internet for Android"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /Whale/i
                ],
                describe: function(e) {
                    var t = {
                        name: "NAVER Whale Browser"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /MZBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "MZ Browser"
                    }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /focus/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Focus"
                    }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /swing/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Swing"
                    }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /coast/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera Coast"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /opt\/\d+(?:.?_?\d+)+/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Opera Touch"
                    }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /yabrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Yandex Browser"
                    }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /ucbrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "UC Browser"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /Maxthon|mxios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Maxthon"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /epiphany/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Epiphany"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /puffin/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Puffin"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /sleipnir/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Sleipnir"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /k-meleon/i
                ],
                describe: function(e) {
                    var t = {
                        name: "K-Meleon"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /micromessenger/i
                ],
                describe: function(e) {
                    var t = {
                        name: "WeChat"
                    }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /qqbrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                    }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /msie|trident/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Internet Explorer"
                    }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /\sedg\//i
                ],
                describe: function(e) {
                    var t = {
                        name: "Microsoft Edge"
                    }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /edg([ea]|ios)/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Microsoft Edge"
                    }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /vivaldi/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Vivaldi"
                    }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /seamonkey/i
                ],
                describe: function(e) {
                    var t = {
                        name: "SeaMonkey"
                    }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /sailfish/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Sailfish"
                    }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Amazon Silk"
                    }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /phantom/i
                ],
                describe: function(e) {
                    var t = {
                        name: "PhantomJS"
                    }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /slimerjs/i
                ],
                describe: function(e) {
                    var t = {
                        name: "SlimerJS"
                    }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(e) {
                    var t = {
                        name: "BlackBerry"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(e) {
                    var t = {
                        name: "WebOS Browser"
                    }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Bada"
                    }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Tizen"
                    }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /qupzilla/i
                ],
                describe: function(e) {
                    var t = {
                        name: "QupZilla"
                    }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /firefox|iceweasel|fxios/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Firefox"
                    }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /electron/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Electron"
                    }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /MiuiBrowser/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Miui"
                    }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /chromium/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Chromium"
                    }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /chrome|crios|crmo/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Chrome"
                    }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /GSA/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Google Search"
                    }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: function(e) {
                    var t = !e.test(/like android/i), r = e.test(/android/i);
                    return t && r;
                },
                describe: function(e) {
                    var t = {
                        name: "Android Browser"
                    }, r = i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /playstation 4/i
                ],
                describe: function(e) {
                    var t = {
                        name: "PlayStation 4"
                    }, r = i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /safari|applewebkit/i
                ],
                describe: function(e) {
                    var t = {
                        name: "Safari"
                    }, r = i.default.getFirstMatch(s, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /.*/i
                ],
                describe: function(e) {
                    var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                    return {
                        name: i.default.getFirstMatch(t, e),
                        version: i.default.getSecondMatch(t, e)
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    93: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : {
            default: n
        }, s = r(18), a = [
            {
                test: [
                    /Roku\/DVP/
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                    return {
                        name: s.OS_MAP.Roku,
                        version: t
                    };
                }
            },
            {
                test: [
                    /windows phone/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.WindowsPhone,
                        version: t
                    };
                }
            },
            {
                test: [
                    /windows /i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                    return {
                        name: s.OS_MAP.Windows,
                        version: t,
                        versionName: r
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function(e) {
                    var t = {
                        name: s.OS_MAP.iOS
                    }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /macintosh/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                        name: s.OS_MAP.MacOS,
                        version: t
                    };
                    return r && (n.versionName = r), n;
                }
            },
            {
                test: [
                    /(ipod|iphone|ipad)/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                    return {
                        name: s.OS_MAP.iOS,
                        version: t
                    };
                }
            },
            {
                test: function(e) {
                    var t = !e.test(/like android/i), r = e.test(/android/i);
                    return t && r;
                },
                describe: function(e) {
                    var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                        name: s.OS_MAP.Android,
                        version: t
                    };
                    return r && (n.versionName = r), n;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                        name: s.OS_MAP.WebOS
                    };
                    return t && t.length && (r.version = t), r;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                    return {
                        name: s.OS_MAP.BlackBerry,
                        version: t
                    };
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.Bada,
                        version: t
                    };
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.Tizen,
                        version: t
                    };
                }
            },
            {
                test: [
                    /linux/i
                ],
                describe: function() {
                    return {
                        name: s.OS_MAP.Linux
                    };
                }
            },
            {
                test: [
                    /CrOS/
                ],
                describe: function() {
                    return {
                        name: s.OS_MAP.ChromeOS
                    };
                }
            },
            {
                test: [
                    /PlayStation 4/
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                    return {
                        name: s.OS_MAP.PlayStation4,
                        version: t
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    94: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : {
            default: n
        }, s = r(18), a = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function() {
                    return {
                        type: "bot",
                        vendor: "Google"
                    };
                }
            },
            {
                test: [
                    /huawei/i
                ],
                describe: function(e) {
                    var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Huawei"
                    };
                    return t && (r.model = t), r;
                }
            },
            {
                test: [
                    /nexus\s*(?:7|8|9|10).*/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /ipad/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /kftt build/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Amazon",
                        model: "Kindle Fire HD 7"
                    };
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet,
                        vendor: "Amazon"
                    };
                }
            },
            {
                test: [
                    /tablet(?! pc)/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(e) {
                    var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                    return t && !r;
                },
                describe: function(e) {
                    var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Apple",
                        model: t
                    };
                }
            },
            {
                test: [
                    /nexus\s*[0-6].*/i,
                    /galaxy nexus/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /[^-]mobi/i
                ],
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "blackberry" === e.getBrowserName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "BlackBerry"
                    };
                }
            },
            {
                test: function(e) {
                    return "bada" === e.getBrowserName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "windows phone" === e.getBrowserName();
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile,
                        vendor: "Microsoft"
                    };
                }
            },
            {
                test: function(e) {
                    var t = Number(String(e.getOSVersion()).split(".")[0]);
                    return "android" === e.getOSName(!0) && t >= 3;
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(e) {
                    return "android" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(e) {
                    return "macos" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop,
                        vendor: "Apple"
                    };
                }
            },
            {
                test: function(e) {
                    return "windows" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(e) {
                    return "linux" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(e) {
                    return "playstation 4" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tv
                    };
                }
            },
            {
                test: function(e) {
                    return "roku" === e.getOSName(!0);
                },
                describe: function() {
                    return {
                        type: s.PLATFORMS_MAP.tv
                    };
                }
            }
        ];
        t.default = a, e.exports = t.default;
    },
    95: function(e, t, r) {
        t.__esModule = !0, t.default = void 0;
        var n, i = (n = r(17)) && n.__esModule ? n : {
            default: n
        }, s = r(18), a = [
            {
                test: function(e) {
                    return "microsoft edge" === e.getBrowserName(!0);
                },
                describe: function(e) {
                    if (/\sedg\//i.test(e)) return {
                        name: s.ENGINE_MAP.Blink
                    };
                    var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                    return {
                        name: s.ENGINE_MAP.EdgeHTML,
                        version: t
                    };
                }
            },
            {
                test: [
                    /trident/i
                ],
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Trident
                    }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: function(e) {
                    return e.test(/presto/i);
                },
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Presto
                    }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: function(e) {
                    var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                    return t && !r;
                },
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.Gecko
                    }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            },
            {
                test: [
                    /(apple)?webkit\/537\.36/i
                ],
                describe: function() {
                    return {
                        name: s.ENGINE_MAP.Blink
                    };
                }
            },
            {
                test: [
                    /(apple)?webkit/i
                ],
                describe: function(e) {
                    var t = {
                        name: s.ENGINE_MAP.WebKit
                    }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                    return r && (t.version = r), t;
                }
            }
        ];
        t.default = a, e.exports = t.default;
    }
});
let $dbaf12f73216aff4$var$_e = globalThis?.navigator?.userAgent ? ($dbaf12f73216aff4$var$$e = $dbaf12f73216aff4$var$fe, $dbaf12f73216aff4$var$$e && $dbaf12f73216aff4$var$$e.__esModule ? $dbaf12f73216aff4$var$$e.default : $dbaf12f73216aff4$var$$e).getParser(globalThis.navigator.userAgent) : null, $dbaf12f73216aff4$var$ge = (e)=>!!$dbaf12f73216aff4$var$_e && ($dbaf12f73216aff4$var$_e.satisfies(e) || !1), $dbaf12f73216aff4$var$pe = $dbaf12f73216aff4$var$ge({
    safari: ">=15"
}), $dbaf12f73216aff4$var$me = $dbaf12f73216aff4$var$ge({
    firefox: ">0"
}), $dbaf12f73216aff4$var$be = $dbaf12f73216aff4$var$ge({
    safari: ">0"
}), $dbaf12f73216aff4$var$ve = $dbaf12f73216aff4$var$ge({
    chrome: ">0"
}), $dbaf12f73216aff4$var$ye = $dbaf12f73216aff4$var$ge({
    edge: ">0"
}), $dbaf12f73216aff4$var$Ee = new WeakMap, $dbaf12f73216aff4$var$Se = 1, $dbaf12f73216aff4$var$Re = 2, $dbaf12f73216aff4$var$Te = 0, $dbaf12f73216aff4$var$Ae = (e, t)=>e instanceof HTMLMediaElement ? (((e, t)=>{
        let r = e.readyState === $dbaf12f73216aff4$var$Te, n = e.networkState !== $dbaf12f73216aff4$var$Re && e.networkState !== $dbaf12f73216aff4$var$Se;
        if ($dbaf12f73216aff4$var$me && "play" === t && r && n) throw Error("Can not play audio");
    })(e, t), "function" == typeof t ? t(e) : e[t]()) : null, $dbaf12f73216aff4$var$Le = (e, t)=>{
    let r = ($dbaf12f73216aff4$var$Ee.get(e) || Promise.resolve()).then(()=>{
        let r = $dbaf12f73216aff4$var$Ae(e, t);
        return r?.then ? Promise.resolve(r) : new Promise((e)=>{
            setTimeout(()=>{
                e(r);
            }, 150);
        });
    }).then(()=>{
        $dbaf12f73216aff4$var$Ee.delete(e);
    }).catch((t)=>{
        throw $dbaf12f73216aff4$var$Ee.delete(e), t;
    });
    return $dbaf12f73216aff4$var$Ee.set(e, r), r;
};
var $dbaf12f73216aff4$var$$e;
let $dbaf12f73216aff4$var$Be = class $0e423be0c289d786$export$900e53962f1f4ab1 {
    constructor(e){
        this._eventsMap = {
            [$dbaf12f73216aff4$var$b.VIDEO_START]: this._startVideo,
            [$dbaf12f73216aff4$var$b.VIDEO_PAUSE]: this._pauseVideo,
            [$dbaf12f73216aff4$var$b.VIDEO_RESET]: this._resetVideo,
            [$dbaf12f73216aff4$var$b.RESTART]: this._restart,
            [$dbaf12f73216aff4$var$b.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - PlaybackController"), this._logger.info("Created"), this._logger.debug("Initial state", this._state), this.init();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _startVideo() {
        let e = this._state.getState().videoElement;
        if (this._logger.verbose("Starting the video"), e) return e.playbackRate || (e.playbackRate = 1), this._logger.debug("Play call is added to the promises queue"), $dbaf12f73216aff4$var$Le(e, "play").then(()=>{
            this._logger.debug("Play call resolved"), this._state.getState().canPlay && this._eventBus.publish($dbaf12f73216aff4$var$b.PLAYING, {});
        }).catch((e)=>{
            this._state.setState({
                isAutoplayError: !0
            }), this._logger.error("An error occured when trying to play the video.", {
                error: e
            }), this._state.getState().canPlay && this._eventBus.publish($dbaf12f73216aff4$var$b.PAUSED, {});
        });
    }
    _pauseVideo() {
        this._logger.debug("Pausing the video");
        let e = this._state.getState().videoElement;
        if (e) return this._logger.debug("Pause call is added to the promises queue"), $dbaf12f73216aff4$var$Le(e, "pause").then(()=>{
            this._logger.debug("Pause call resolved");
        }).catch((e)=>{
            this._logger.warn("Could not pause video", e);
        });
    }
    _loadVideo() {
        this._logger.verbose("Loading the video");
        let e = this._state.getState().videoElement;
        if (!e?.src || !e.src.startsWith("blob")) return e ? (this._logger.debug("Load call is added to the promises queue"), $dbaf12f73216aff4$var$Le(e, "load").then(()=>{
            this._logger.debug("Load call resolved");
        }).catch((e)=>{
            this._logger.warn("Could not load video", e);
        })) : void 0;
        this._logger.debug("Stream seems to be blob. Skipping load");
    }
    _resetVideo() {
        this._logger.verbose("Resetting the video"), this._state.getState().videoElement && (this._eventBus.publish($dbaf12f73216aff4$var$b.LOADING, {}), this._loadVideo());
    }
    async _restart() {
        this._logger.verbose("Restarting the video"), await this._pauseVideo(), this._startVideo();
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_startVideo", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_pauseVideo", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_loadVideo", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_resetVideo", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_restart", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Be.prototype, "_destroy", null);
let $dbaf12f73216aff4$var$Pe = (e)=>{
    e && e.parentNode && e.parentNode.removeChild(e);
}, $dbaf12f73216aff4$var$Ce = "\n  width: 100%;\n", $dbaf12f73216aff4$var$we = class $c148f595ba898186$export$ff45b5d0a0c535a9 {
    constructor(e){
        this._knownVideoElementStyles = "", this._eventsMap = {
            [$dbaf12f73216aff4$var$b.PLAYING]: this.startAnimationFrame,
            [$dbaf12f73216aff4$var$b.LOADING]: this.cancelAnimationFrame,
            [$dbaf12f73216aff4$var$b.REMOVE_MEDIA_STREAM]: this.cancelAnimationFrame
        }, this._applyStyles = ()=>{
            this._logger.debug("Apply styles for canvas and video elements");
            let { canvasElement: e, videoElement: t } = this._getElements();
            e && t && (this._knownVideoElementStyles = t.style.cssText, e.style.cssText = $dbaf12f73216aff4$var$Ce, t.style.cssText = `\n      ${$dbaf12f73216aff4$var$Ce}\n      opacity: 0;\n      position: absolute;\n      left: 0;\n      top: 0;\n    `);
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - CanvasVideoRenderer");
        let t = document.createElement("canvas");
        this._canvasContext = t.getContext("2d"), e.className && (t.className = e.className), this.init(), this._state.setState({
            canvasElement: t
        }), this._applyStyles(), this._logger.verbose("Canvas renderer has been created");
    }
    startAnimationFrame() {
        let { canvasElement: e, videoElement: t } = this._getElements();
        if (this.cancelAnimationFrame(), !e || !t) return;
        let { width: r, height: n } = e.getBoundingClientRect(), { videoWidth: i, videoHeight: s } = t;
        if (r / n < 1 && i / s > 1) {
            let a = Math.max(r, i), o = s * (r / i), l = r > a ? (r - a) / 2 : 0, u = (n - o) / 2;
            if (this._canvasContext) {
                let t = devicePixelRatio;
                e.width = a * t, e.height = n * t, this._canvasContext.scale(t, t);
            }
            this._canvasContext?.drawImage(t, l, u, a, o);
        } else {
            let a = Math.max(n, s), o = i * (n / s), l = n > a ? (n - a) / 2 : 0, u = (r - o) / 2;
            if (this._canvasContext) {
                let t = devicePixelRatio;
                e.width = r * t, e.height = a * t, this._canvasContext.scale(t, t);
            }
            this._canvasContext?.drawImage(t, u, l, o, a);
        }
        this._state.getState().isLoading || (this._canvasAnimationFrameId = requestAnimationFrame(this.startAnimationFrame));
    }
    getCanvasElement() {
        return this._getElements().canvasElement;
    }
    destroy() {
        this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
        let { canvasElement: e, videoElement: t } = this._getElements();
        e && e.parentNode && e.parentNode.removeChild(e), t && (t.style.cssText = this._knownVideoElementStyles, this._knownVideoElementStyles = ""), this._state.setState({
            canvasElement: null
        }), this._logger.verbose("Canvas renderer was destroyed");
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    cancelAnimationFrame() {
        this._canvasAnimationFrameId && (cancelAnimationFrame(this._canvasAnimationFrameId), this._canvasAnimationFrameId = null);
    }
    _getElements() {
        let { videoElement: e, canvasElement: t } = this._state.getState();
        return {
            videoElement: e,
            canvasElement: t
        };
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$we.prototype, "startAnimationFrame", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$we.prototype, "destroy", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$we.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$we.prototype, "cancelAnimationFrame", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$we.prototype, "_getElements", null);
let $dbaf12f73216aff4$var$Oe = class $bdd9a250938bedd7$export$61525c45d39f05de {
    constructor(e){
        this._canvasVideoRenderer = null, this._config = {}, this._isLocalVideo = !1, this._eventsMap = {
            [$dbaf12f73216aff4$var$b.SET_VOLUME]: this._setVolume,
            [$dbaf12f73216aff4$var$b.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - RenderController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._logger.debug("Initial state", this._state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e, this.applyConfigToVideoElement();
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    getElements() {
        let { videoElement: e, canvasElement: t, ownContainer: r } = this._state.getState();
        return {
            videoElement: e,
            canvasElement: t,
            ownContainer: r
        };
    }
    getVideoElement() {
        return this.getElements().videoElement;
    }
    getCanvasElement() {
        return this.getElements().canvasElement;
    }
    renderVideoInto(e) {
        let { ownContainer: t, videoElement: r } = this.getElements();
        this._logger.debug("renderVideoInto method was called");
        let n = !1;
        if (e && r) {
            let i = t || e;
            r.parentElement !== i && (n = !0, i.appendChild(r));
            let s = this._canvasVideoRenderer?.getCanvasElement();
            this._canvasVideoRenderer && s?.parentElement !== i && (n = !0, i.appendChild(s), this._logger.info("Canvas element has been rendered to DOM")), i === t && t.parentElement !== e && (n = !0, e.appendChild(t)), n ? this._logger.info("Video element has been rendered to DOM") : this._logger.verbose("Skipping video element render: video element is already mounted to the DOM.");
        }
    }
    setVideoElement(e, t) {
        this._logger.debug("Video element updated", {
            videoElement: e
        }), e !== this.getVideoElement() ? (this._isLocalVideo && (this._logger.verbose("Removing video element and container from document"), $dbaf12f73216aff4$var$Pe(this.getElements().videoElement), $dbaf12f73216aff4$var$Pe(this.getElements().ownContainer)), this._state.setState({
            videoElement: e,
            ownContainer: t
        }), this.applyConfigToVideoElement()) : this._logger.verbose("Received video element is equal to the previous one. Skipping");
    }
    applyConfigToVideoElement() {
        if (this._logger.debug("Applying config to the video element"), !this.getVideoElement()) return void this._logger.verbose("No video element known, could not apply config");
        let e = this.getVideoElement();
        if (!e) return;
        let { isNonAnonymous: t, isMuted: r, nativeControls: n, videoElementClassName: i, canvasElementClassName: s, shouldUseCanvas: a, rootElement: o, autoplay: l } = this._config;
        this._logger.verbose("Applied config", this._config), l && (e.autoplay = !0), e.playsInline = !0, void 0 !== n && (e.controls = !!n), void 0 !== r && (e.muted = !!r), void 0 !== t && (t ? e.removeAttribute("crossOrigin") : e.crossOrigin = "anonymous"), i && (e.className = i);
        let u = [
            this._state.getState().volume,
            this._config.volume
        ].find((e)=>void 0 !== e);
        if (void 0 !== u && this._setVolume({
            volume: u
        }), a && !this._canvasVideoRenderer && (this._logger.verbose("Adding canvas as requested"), this._addCanvasVideoRenderer(), this._state.getState().isPlaying && this._canvasVideoRenderer.startAnimationFrame()), !a && this._canvasVideoRenderer) {
            let e = this._state.getState().stream;
            this._logger.verbose("Removing canvas renderer"), e && this._eventBus.publish($dbaf12f73216aff4$var$b.UPDATE_MEDIA_STREAM, e), this._destroyCanvasRenderer();
        }
        let d = this.getCanvasElement();
        d && (e.className = "", s && (d.className = s)), o && this.renderVideoInto(o);
    }
    destroy() {
        if (this._logger.info("Destroying"), this._destroyCanvasRenderer(), this._isLocalVideo) {
            this._logger.debug("Removing video element and container from document in destroy");
            let { videoElement: e, ownContainer: t } = this.getElements();
            $dbaf12f73216aff4$var$Pe(e), $dbaf12f73216aff4$var$Pe(t);
        }
    }
    createVideoElement() {
        let e, t;
        this._logger.info("Creating video element"), this._config.videoElement ? (this._logger.debug("External video element passed from config - using existing one", this._config.videoElement), this._isLocalVideo = !1, e = this._config.videoElement) : (this._isLocalVideo = !0, e = document.createElement("video"), t = document.createElement("div"), this._logger.debug("No external video element provided in config - created the new one", {
            videoElement: e,
            ownContainer: t
        }), t.style.position = "relative"), this.setVideoElement(e, t), this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_ELEMENT_RECREATED, {
            videoElement: this.getVideoElement()
        });
    }
    _addCanvasVideoRenderer() {
        this._logger.debug("Adding canvas renderer"), this._canvasVideoRenderer || (this._canvasVideoRenderer = new $dbaf12f73216aff4$var$we({
            videoElement: this.getVideoElement(),
            className: this._config.videoElementClassName,
            state: this._state,
            eventBus: this._eventBus
        }));
    }
    _destroyCanvasRenderer() {
        this._logger.debug("Destroying canvas renderer"), this._canvasVideoRenderer && (this._canvasVideoRenderer.destroy(), this._canvasVideoRenderer = null);
    }
    _setVolume({ volume: e }) {
        let t = this.getVideoElement();
        t && (((e, t)=>{
            if (!t || t < 0) e.muted = !0, e.volume = 0;
            else {
                let r = Math.min(t, 1);
                isNaN(r) || (e.muted = !1, e.volume = r);
            }
        })(t, e), this._logger.verbose(`Video volume level has been set to ${e}`));
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "getElements", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "getVideoElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "getCanvasElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "renderVideoInto", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "setVideoElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "applyConfigToVideoElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "createVideoElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "_addCanvasVideoRenderer", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "_destroyCanvasRenderer", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "_setVolume", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Oe.prototype, "_destroy", null);
let $dbaf12f73216aff4$var$De = class $04304713e5d9da2c$export$9456d357203666ac {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$dbaf12f73216aff4$var$b.PLAYING]: this._handlePlaying,
            [$dbaf12f73216aff4$var$b.LOADING]: this._handleLoading,
            [$dbaf12f73216aff4$var$b.VIDEO_PAUSE]: this._handlePause,
            [$dbaf12f73216aff4$var$b.CAN_PLAY]: this._handleCanPlay,
            [$dbaf12f73216aff4$var$b.PAUSED]: this._handlePaused,
            [$dbaf12f73216aff4$var$b.RESTART]: this._handleRestart,
            [$dbaf12f73216aff4$var$b.UPDATED]: this._handleUpdate,
            [$dbaf12f73216aff4$var$b.STALLED]: this._handleStalled,
            [$dbaf12f73216aff4$var$b.WAITING]: this._handleWaiting,
            [$dbaf12f73216aff4$var$b.UPDATE_PLAYER_RESOLUTION]: this._handleUpdatePlayerResolution,
            [$dbaf12f73216aff4$var$b.ERROR]: this._handleError,
            [$dbaf12f73216aff4$var$b.SET_VOLUME]: this._handleSetVolume,
            [$dbaf12f73216aff4$var$b.DESTROY]: this.destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - StateController"), this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    destroy() {
        this._logger.info("Destroy"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this._state.resetState(), this._state.setState({
            isDestroyed: !0
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _updateState(e) {
        let t = this._state.getState().videoPlaybackState, r = t;
        e.isPlaying ? r = $dbaf12f73216aff4$var$_.PLAYING : e.isLoading ? r = $dbaf12f73216aff4$var$_.LOADING : e.isPaused ? r = $dbaf12f73216aff4$var$_.PAUSED : e.isError && (r = $dbaf12f73216aff4$var$_.ERROR), this._logger.debug(`State updated: ${t} -> ${r}`), this._state.setState({
            ...e,
            videoPlaybackState: r
        }), t !== r && this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_PLAYBACK_STATE_CHANGED, {
            prevState: t,
            nextState: r
        });
    }
    _handlePlaying() {
        this._logger.debug("Playing event received"), this._updateState({
            isPlaying: !0,
            startedPlaying: !0,
            isLoading: !1,
            isStalled: !1,
            isWaiting: !1,
            isPaused: !1,
            isError: !1
        });
    }
    _handleLoading() {
        this._logger.debug("Loading event received"), this._updateState({
            isLoading: !0,
            isPlaying: !1
        });
    }
    _handlePause() {
        this._logger.debug("Pause event received"), this._updateState({
            isPlaying: !1,
            isPaused: !0
        });
    }
    _handlePaused() {
        this._logger.debug("Paused event received"), this._updateState({
            isPlaying: !1,
            isLoading: !1,
            isPaused: !0
        });
    }
    _handleCanPlay() {
        this._logger.debug("CanPlay event received"), this._updateState({
            canPlay: !0,
            isDestroyed: !1
        });
    }
    _handleRestart() {
        this._logger.debug("Restart event received"), this._updateState({
            isRestarted: !0
        });
    }
    _handleStalled() {
        this._logger.debug("Stalled event received"), this._updateState({
            isStalled: !0
        });
    }
    _handleWaiting() {
        this._logger.debug("Waiting event received"), this._updateState({
            isWaiting: !0
        });
    }
    _handleError() {
        this._logger.debug("Error event received"), this._updateState({
            isError: !0
        });
    }
    _handleSetVolume({ volume: e }) {
        this._logger.debug("Volume event received", {
            volume: e
        }), this._updateState({
            volume: e
        });
    }
    _handleUpdatePlayerResolution(e) {
        this._logger.debug("Player resolution event received", {
            height: e.height,
            width: e.width
        }), this._updateState({
            videoElementResolution: {
                height: e.height,
                width: e.width
            }
        });
    }
    _handleUpdate() {
        this._logger.debug("Update event received"), this._updateState({
            canPlay: !1,
            isLoading: !0,
            isPlaying: !1,
            isRestarted: !1,
            isPaused: !1,
            isError: !1
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "destroy", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_updateState", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handlePlaying", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleLoading", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handlePause", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handlePaused", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleCanPlay", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleRestart", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleStalled", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleWaiting", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleError", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleSetVolume", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleUpdatePlayerResolution", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$De.prototype, "_handleUpdate", null);
let $dbaf12f73216aff4$var$Me = class $fa81a3aa7a22efa4$export$450c54b9e8861ae8 {
    constructor(e){
        this._config = {}, this._eventsMap = {
            [$dbaf12f73216aff4$var$b.PLAYING]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.LOADING]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.LOADED]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.PAUSED]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.UPDATED]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.CANCEL_RESET_STREAM]: this._cancelResetStream,
            [$dbaf12f73216aff4$var$b.STREAM_RESET]: this._resetStream,
            [$dbaf12f73216aff4$var$b.UPDATE_MEDIA_STREAM]: this.updateMediaStream,
            [$dbaf12f73216aff4$var$b.DESTROY]: this.destroy
        }, this._getIsSrcObjectAvailable = ()=>void 0 !== this._props.getVideoElement()?.srcObject, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - StreamController"), this._props = e, this._logger.info("Created"), this._logger.verbose("Initial state", e.state), this.init();
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e), this._config = e;
    }
    updateMediaStream(e) {
        this._logger.info("Updating media stream", {
            stream: e
        }), this._props.getVideoElement() ? (this._attachStream(e), this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_START, {})) : this._logger.debug("No video element known. Skipping media stream update");
    }
    removeMediaStream() {
        this._logger.info("Removing media stream");
        let e = this._props.getVideoElement();
        e ? (this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_PAUSE, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.REMOVE_MEDIA_STREAM, {}), this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting srcObject to null"), e.srcObject = null) : (this._logger.debug("Revoking object url", {
            url: e.src
        }), window.URL.revokeObjectURL(e.src)), e.src && (this._logger.debug("Removing src attribute from video"), e.removeAttribute("src"))) : this._logger.debug("No video element known. Skipping media stream remove");
    }
    destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    _attachStream(e) {
        this._logger.info("Attaching media stream", {
            stream: e
        });
        let t = this._props.getVideoElement();
        t && e ? t.src !== e ? "string" == typeof e ? (this._logger.debug("Setting video element src attribute"), t.src = e) : this._getIsSrcObjectAvailable() ? (this._logger.debug("Setting video element srcObject attribute"), t.srcObject = e) : (t.src = window.URL.createObjectURL(e), this._logger.debug(`Got MediaStream as stream, but srcObject is not available. Created new object URL: ${t.src}`)) : this._logger.debug("Current video element src attribute value is equal to the new stream. Skipping stream set") : this._logger.debug("No video element or stream defined. Skipping stream set");
    }
    _cancelResetStream() {
        this._logger.debug("Stream reset action cancel required"), this._streamResetDelayId && (clearTimeout(this._streamResetDelayId), this._logger.debug("Stream reset action cancelled"));
    }
    _resetStream({ timeout: e }) {
        this._logger.debug("Reset stream required"), e ? (this._cancelResetStream(), this._streamResetDelayId = setTimeout(()=>{
            this._logger.debug("Resetting stream timeout fired");
            let e = !1;
            this._config.onResetStream && (e = this._config.onResetStream());
            let t = this._state.getState().stream;
            if (t && !e) {
                if ("string" == typeof t && t.startsWith("blob")) return void this._logger.debug("Streams seems to be object url. Skipping reset");
                this._logger.debug("Resetting stream"), this.removeMediaStream(), this.updateMediaStream(t);
            }
        }, e)) : this._logger.verbose("No timeout set, skipping stream reset", {
            timeout: e
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "updateMediaStream", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "removeMediaStream", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "destroy", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "_attachStream", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "_cancelResetStream", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$Me.prototype, "_resetStream", null);
var $dbaf12f73216aff4$var$Ie = function(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
}, $dbaf12f73216aff4$var$Fe = "object" == typeof $dbaf12f73216aff4$var$T && $dbaf12f73216aff4$var$T && $dbaf12f73216aff4$var$T.Object === Object && $dbaf12f73216aff4$var$T, $dbaf12f73216aff4$var$xe = "object" == typeof self && self && self.Object === Object && self, $dbaf12f73216aff4$var$ke = $dbaf12f73216aff4$var$Fe || $dbaf12f73216aff4$var$xe || Function("return this")(), $dbaf12f73216aff4$var$Ne = function() {
    return $dbaf12f73216aff4$var$ke.Date.now();
}, $dbaf12f73216aff4$var$Ve = /\s/, $dbaf12f73216aff4$var$Ue = /^\s+/, $dbaf12f73216aff4$var$qe = $dbaf12f73216aff4$var$ke.Symbol, $dbaf12f73216aff4$var$Ge = Object.prototype, $dbaf12f73216aff4$var$We = $dbaf12f73216aff4$var$Ge.hasOwnProperty, $dbaf12f73216aff4$var$je = $dbaf12f73216aff4$var$Ge.toString, $dbaf12f73216aff4$var$He = $dbaf12f73216aff4$var$qe ? $dbaf12f73216aff4$var$qe.toStringTag : void 0, $dbaf12f73216aff4$var$Ke = Object.prototype.toString, $dbaf12f73216aff4$var$Ye = $dbaf12f73216aff4$var$qe ? $dbaf12f73216aff4$var$qe.toStringTag : void 0, $dbaf12f73216aff4$var$Qe = function(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : $dbaf12f73216aff4$var$Ye && $dbaf12f73216aff4$var$Ye in Object(e) ? function(e) {
        var t = $dbaf12f73216aff4$var$We.call(e, $dbaf12f73216aff4$var$He), r = e[$dbaf12f73216aff4$var$He];
        try {
            e[$dbaf12f73216aff4$var$He] = void 0;
            var n = !0;
        } catch (e) {}
        var i = $dbaf12f73216aff4$var$je.call(e);
        return n && (t ? e[$dbaf12f73216aff4$var$He] = r : delete e[$dbaf12f73216aff4$var$He]), i;
    }(e) : $dbaf12f73216aff4$var$Ke.call(e);
}, $dbaf12f73216aff4$var$ze = /^[-+]0x[0-9a-f]+$/i, $dbaf12f73216aff4$var$Xe = /^0b[01]+$/i, $dbaf12f73216aff4$var$Ze = /^0o[0-7]+$/i, $dbaf12f73216aff4$var$Je = parseInt, $dbaf12f73216aff4$var$et = function(e) {
    if ("number" == typeof e) return e;
    if ("symbol" == typeof (t = e) || null != t && "object" == typeof t && "[object Symbol]" == $dbaf12f73216aff4$var$Qe(t)) return NaN;
    var t;
    if ($dbaf12f73216aff4$var$Ie(e)) {
        var r, n = "function" == typeof e.valueOf ? e.valueOf() : e;
        e = $dbaf12f73216aff4$var$Ie(n) ? n + "" : n;
    }
    if ("string" != typeof e) return 0 === e ? e : +e;
    e = (r = e) ? r.slice(0, function(e) {
        for(var t = e.length; t-- && $dbaf12f73216aff4$var$Ve.test(e.charAt(t)););
        return t;
    }(r) + 1).replace($dbaf12f73216aff4$var$Ue, "") : r;
    var i = $dbaf12f73216aff4$var$Xe.test(e);
    return i || $dbaf12f73216aff4$var$Ze.test(e) ? $dbaf12f73216aff4$var$Je(e.slice(2), i ? 2 : 8) : $dbaf12f73216aff4$var$ze.test(e) ? NaN : +e;
}, $dbaf12f73216aff4$var$tt = Math.max, $dbaf12f73216aff4$var$rt = Math.min, $dbaf12f73216aff4$var$nt = function(e, t, r) {
    var n = !0, i = !0;
    if ("function" != typeof e) throw TypeError("Expected a function");
    return $dbaf12f73216aff4$var$Ie(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
        var n, i, s, a, o, l, u = 0, d = !1, c = !1, h = !0;
        if ("function" != typeof e) throw TypeError("Expected a function");
        function f(t) {
            var r = n, s = i;
            return n = i = void 0, u = t, a = e.apply(s, r);
        }
        function _(e) {
            var r = e - l;
            return void 0 === l || r >= t || r < 0 || c && e - u >= s;
        }
        function g() {
            var e, r = $dbaf12f73216aff4$var$Ne();
            if (_(r)) return p(r);
            o = setTimeout(g, (e = t - (r - l), c ? $dbaf12f73216aff4$var$rt(e, s - (r - u)) : e));
        }
        function p(e) {
            return o = void 0, h && n ? f(e) : (n = i = void 0, a);
        }
        function m() {
            var e, r = $dbaf12f73216aff4$var$Ne(), s = _(r);
            if (n = arguments, i = this, l = r, s) {
                if (void 0 === o) return u = e = l, o = setTimeout(g, t), d ? f(e) : a;
                if (c) return clearTimeout(o), o = setTimeout(g, t), f(l);
            }
            return void 0 === o && (o = setTimeout(g, t)), a;
        }
        return t = $dbaf12f73216aff4$var$et(t) || 0, $dbaf12f73216aff4$var$Ie(r) && (d = !!r.leading, s = (c = "maxWait" in r) ? $dbaf12f73216aff4$var$tt($dbaf12f73216aff4$var$et(r.maxWait) || 0, t) : s, h = "trailing" in r ? !!r.trailing : h), m.cancel = function() {
            void 0 !== o && clearTimeout(o), u = 0, n = l = i = o = void 0;
        }, m.flush = function() {
            return void 0 === o ? a : p($dbaf12f73216aff4$var$Ne());
        }, m;
    }(e, t, {
        leading: n,
        maxWait: t,
        trailing: i
    });
};
let $dbaf12f73216aff4$var$it = "ristrettoWasRestarted", $dbaf12f73216aff4$var$st = 0, $dbaf12f73216aff4$var$at = 0, $dbaf12f73216aff4$var$ot = class $0b302ff0925c3ef2$export$25e21b090bbc69f9 {
    constructor(e){
        this._shouldSetNextUpdateVideoDurationId = !0, this._config = {}, this._onNativeTimeUpdateHandlerThrottled = $dbaf12f73216aff4$var$nt(this._onNativeTimeUpdateHandler, 2e3, {
            trailing: !1
        }), this._eventsMap = {
            [$dbaf12f73216aff4$var$b.TIME_UPDATE_NATIVE]: this._onNativeTimeUpdateHandlerThrottled,
            [$dbaf12f73216aff4$var$b.DESTROY]: this._destroy
        }, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - TimeUpdateController"), this._props = e, this._logger.info("Created"), this._logger.debug("Initial state", e.state), this._logger.debug("Initial props", e);
    }
    setConfig(e) {
        this._logger.debug("Config update received, the new one:", e);
        let t = e.timeoutUpdateStatusPlaying !== this._config.timeoutUpdateStatusPlaying;
        this._config = e, t && (this._eventsMap[$dbaf12f73216aff4$var$b.TIME_UPDATE_NATIVE] = $dbaf12f73216aff4$var$nt(this._onNativeTimeUpdateHandler, e.timeoutUpdateStatusPlaying, {
            trailing: !1
        }), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this.init());
    }
    init() {
        this._logger.info("Initialization requested, attaching eventBus listeners"), this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    startTimeUpdate() {
        this._stopTimeUpdate(), this._shouldSetNextUpdateVideoDurationId && this._config ? (this._updateVideoDurationId = setTimeout(this._onTimeUpdate, this._config.timeoutUpdateVideoDuration), this._publishUpdatePlayerResolutionIfNeeded()) : this._shouldSetNextUpdateVideoDurationId = !0;
    }
    _onNativeTimeUpdateHandler(e) {
        if (this._logger.debug("Native video timeUpdate caught"), e?.originalEvent?.defaultPrevented) return;
        let t = this._props.getVideoElement(), { canPlay: r, isPlaying: n, isLoading: i, isRestarted: s } = this._state.getState();
        if (this._publishUpdatePlayerResolutionIfNeeded(), !r) return void this._logger.verbose("CanPlay shared state is false. Skipping");
        this._eventBus.publish($dbaf12f73216aff4$var$b.RESET_CHECKING_AUTOPLAY_COUNT, {});
        let a = $dbaf12f73216aff4$var$st !== t?.currentTime;
        this._logger.verbose(`Video current time is ${a ? "" : "not"} changed`), a ? (this._eventBus.publish($dbaf12f73216aff4$var$b.CANCEL_RESET_STREAM, {}), !$dbaf12f73216aff4$var$pe || s || localStorage?.getItem($dbaf12f73216aff4$var$it) || (localStorage.setItem($dbaf12f73216aff4$var$it, "1"), this._eventBus.publish($dbaf12f73216aff4$var$b.RESTART, {})), t && ($dbaf12f73216aff4$var$st = t.currentTime), (!n || i) && this._eventBus.publish($dbaf12f73216aff4$var$b.PLAYING, {})) : i ? this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_RESET, {}) : this._eventBus.publish($dbaf12f73216aff4$var$b.LOADING, {});
    }
    _stopTimeUpdate() {
        clearTimeout(this._updateVideoDurationId);
    }
    _onTimeUpdate() {
        if (!this._state.getState().canPlay) return void this.startTimeUpdate();
        let e = this._props.getVideoElement();
        e && $dbaf12f73216aff4$var$at !== e.currentTime && ($dbaf12f73216aff4$var$at = e.currentTime), this.startTimeUpdate();
    }
    _publishUpdatePlayerResolutionIfNeeded() {
        let e = this._props.getVideoElement();
        if (e) {
            let { videoWidth: t, videoHeight: r } = e, { videoElementResolution: n } = this._state.getState();
            (!n || n.height !== r || n.width !== t) && this._config.minimalPossibleVideoDimension && Math.min(r, t) > this._config.minimalPossibleVideoDimension && (this._logger.verbose(`Stored resolution is ${n?.width}x${n?.height}, current is ${t}x${r}`), this._eventBus.publish($dbaf12f73216aff4$var$b.UPDATE_PLAYER_RESOLUTION, {
                width: t,
                height: r
            }));
        }
    }
    _destroy() {
        this._logger.info("Destroying"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        }), this._shouldSetNextUpdateVideoDurationId = !1, this._stopTimeUpdate();
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "startTimeUpdate", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "_onNativeTimeUpdateHandler", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "_stopTimeUpdate", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "_onTimeUpdate", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "_publishUpdatePlayerResolutionIfNeeded", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ot.prototype, "_destroy", null);
let $dbaf12f73216aff4$var$lt = class $12f7c2f2c1b55bfc$export$3a521cb24f143cc8 {
    constructor(e){
        this._config = {}, this._timeUpdateEventWasLogged = !1, this._eventsMap = {
            [$dbaf12f73216aff4$var$b.VIDEO_ELEMENT_RECREATED]: this._handleVideoElementRecreated,
            [$dbaf12f73216aff4$var$b.DESTROY]: this._handleDestroy
        }, this._onVideoClick = (e)=>{
            this._logger.verbose('"click" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.CLICK, {
                originalEvent: e
            });
        }, this._onSeeked = (e)=>{
            this._logger.verbose('"seeked" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.FORCE_PLAY_AFTER_PAUSE, {
                reason: "seeked video native event"
            });
        }, this._onRateChange = (e)=>{
            this._logger.verbose('"ratechange" video native event fired'), this._handleNativeEvent(e), e.target && !e.target.playbackRate && this._eventBus.publish($dbaf12f73216aff4$var$b.FORCE_PLAY_AFTER_PAUSE, {
                reason: "video playbackRate is 0"
            });
        }, this._onCanPlayThrough = (e)=>{
            this._logger.verbose('"canplaythrough" video native event fired');
            let t = this._state.getState();
            this._handleNativeEvent(e), (t.isStalled || t.isWaiting) && this._eventBus.publish($dbaf12f73216aff4$var$b.FORCE_PLAY_AFTER_PAUSE, {
                reason: "canplaythrough video native event fired, and video is in the state of either stalled or waiting"
            });
        }, this._onPlayingHandler = (e)=>{
            this._logger.verbose('"playing" video native event fired'), this._logger.info("Video has started playing"), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.PLAYING, {
                isAutoplay: !this._state.getState().isAutoplayError
            });
        }, this._onAbortHandler = (e)=>{
            this._logger.verbose('"abort" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || this._eventBus.publish($dbaf12f73216aff4$var$b.LOADING, {});
        }, this._onPauseHandler = (e)=>{
            this._logger.verbose('"pause" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_PAUSE, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.FORCE_PLAY_AFTER_PAUSE, {
                reason: "pause video event fired (most likely user paused the video manually)"
            });
        }, this._onCanPlayHandler = (e)=>{
            this._logger.verbose('"canplay" video native event fired'), this._handleNativeEvent(e), e.defaultPrevented || (this._state.setState({
                canPlay: !0
            }), this._eventBus.publish($dbaf12f73216aff4$var$b.CAN_PLAY, {}));
        }, this._onErrorHandler = (e)=>{
            if (this._logger.error('"error" video native event fired', {
                error: e
            }), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.ERROR, {
                originalEvent: e
            }), !e.defaultPrevented) {
                let { MEDIA_ERR_SRC_NOT_SUPPORTED: e } = MediaError, t = this._props.getVideoElement()?.error, r = t?.code;
                r !== e && (this._logger.verbose("Video element error is not of MEDIA_ERR_SRC_NOT_SUPPORTED kind. Requesting reset"), this._eventBus.publish($dbaf12f73216aff4$var$b.VIDEO_RESET, {}));
            }
        }, this._onTimeUpdateHandler = (e)=>{
            this._handleNativeEvent(e), this._timeUpdateEventWasLogged || (this._logger.verbose('"timeupdate" video native event fired for the first time'), this._timeUpdateEventWasLogged = !0), this._eventBus.publishSync($dbaf12f73216aff4$var$b.TIME_UPDATE_NATIVE, {
                originalEvent: e
            });
        }, this._onLoadStartHandler = (e)=>{
            this._handleNativeEvent(e), this._logger.verbose('"loadstart" video native event fired');
            let { timeoutUpdateStream: t } = this._config;
            this._eventBus.publish($dbaf12f73216aff4$var$b.LOADING, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.STREAM_RESET, {
                reason: "onLoadStartHandler",
                timeout: t
            });
        }, this._onLoadedDataHandler = (e)=>{
            this._logger.verbose('"loadeddata" video native event fired'), this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.LOADED, {});
        }, this._onWaiting = (e)=>{
            this._logger.verbose('"waiting" video native event fired');
            let { timeoutWaitingStream: t } = this._config;
            this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.WAITING, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.LOADING, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.STREAM_RESET, {
                reason: "onWaiting",
                timeout: t
            });
        }, this._onStalled = (e)=>{
            this._logger.verbose('"stalled" video native event fired');
            let { timeoutWaitingStream: t } = this._config;
            this._handleNativeEvent(e), this._eventBus.publish($dbaf12f73216aff4$var$b.STALLED, {}), this._eventBus.publish($dbaf12f73216aff4$var$b.STREAM_RESET, {
                reason: "onStalled",
                timeout: t
            });
        }, this._onEndFullscreenHandler = (e)=>{
            this._handleNativeEvent(e);
        }, this._props = e, this._state = e.state, this._eventBus = e.eventBus, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoElementController - VideoEventsHandler"), this.init();
    }
    setConfig(e) {
        this._config = e;
    }
    init() {
        this._eventBus.toggleSubscriptionBulk({
            action: "subscribe",
            callbacks: this._eventsMap
        });
    }
    toggleEvents(e, t) {
        let r = t || this._props.getVideoElement();
        if (!r) return;
        let n = "attach" === e ? "addEventListener" : "removeEventListener";
        r[n]("click", this._onVideoClick), r[n]("playing", this._onPlayingHandler), r[n]("abort", this._onAbortHandler), r[n]("pause", this._onPauseHandler), r[n]("canplay", this._onCanPlayHandler), r[n]("error", this._onErrorHandler), r[n]("timeupdate", this._onTimeUpdateHandler), r[n]("loadstart", this._onLoadStartHandler), r[n]("loadeddata", this._onLoadedDataHandler), r[n]("waiting", this._onWaiting), r[n]("stalled", this._onStalled), r[n]("canplaythrough", this._onCanPlayThrough), r[n]("seeked", this._onSeeked), r[n]("ratechange", this._onRateChange), r[n]("webkitendfullscreen", this._onEndFullscreenHandler), "addEventListener" === n ? this._logger.verbose("event listeners are ATTACHED to the video element") : this._logger.verbose("event listeners are DETACHED from the video element");
    }
    _handleVideoElementRecreated() {
        this.toggleEvents("attach");
    }
    _handleDestroy() {
        this.toggleEvents("detach"), this._eventBus.toggleSubscriptionBulk({
            action: "unsubscribe",
            callbacks: this._eventsMap
        });
    }
    _handleNativeEvent(e) {
        this._eventBus.publishSync($dbaf12f73216aff4$var$b.NATIVE_EVENT, {
            eventName: e.type,
            event: e
        });
    }
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$lt.prototype, "init", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$lt.prototype, "_handleVideoElementRecreated", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$lt.prototype, "_handleDestroy", null);
let $dbaf12f73216aff4$var$ut = {
    canPlay: !1,
    isLoading: !0,
    isError: !1,
    isAutoplayError: !1,
    isPaused: !1,
    isPlaying: !1,
    isRestarted: !1,
    isStalled: !1,
    isWaiting: !1,
    isDestroyed: !1,
    videoPlaybackState: $dbaf12f73216aff4$var$_.IDLE,
    startedPlaying: !1
}, $dbaf12f73216aff4$var$dt = class $442b7bba03edb347$export$4d5c8163a511d38a {
    constructor(e){
        this._initState = {
            ...e
        }, this._state = {
            ...e
        };
    }
    setState(e, t) {
        Object.assign(this._state, e), t && t(this._state);
    }
    getState() {
        return this._state;
    }
    resetState() {
        this.setState(this._initState);
    }
}, $dbaf12f73216aff4$var$ct = class $4ec065df5e9ead04$export$6dab3502ba426410 {
    constructor(){
        this._config = {
            ...$dbaf12f73216aff4$var$ie.videoElementControllerConfig
        }, this.attachVideoElementEvents = ()=>{
            this._logger.debug("Attach event listeners"), this._eventsHandler.toggleEvents("attach"), this._timeUpdateController.startTimeUpdate();
        }, this.detachVideoElementEvents = (e)=>{
            this._logger.debug("Detach event listeners"), this._eventsHandler.toggleEvents("detach", e);
        }, this._updated = ()=>{
            this._eventBus.publish($dbaf12f73216aff4$var$b.UPDATED, {});
        }, this._eventBus = new $dbaf12f73216aff4$var$M, this._loggerTransport = new $dbaf12f73216aff4$var$ne(this._eventBus), this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "VideoController"), this._logger.info("Created"), this._logger.debug("Initial config", this._config), this._createControllers();
    }
    addEventListener(e, t) {
        this._logger.verbose(`Attaching ${e} event listener`), this._customEventsEmitter.addEventListener(e, t);
    }
    removeEventListener(e, t) {
        this._logger.verbose(`Detaching ${e} event listener`), this._customEventsEmitter.removeEventListener(e, t);
    }
    getIsPlaying() {
        return this._state.getState().isPlaying;
    }
    getVideoElement() {
        return this._state.getState().videoElement;
    }
    getCanvasElement() {
        return this._state.getState().canvasElement;
    }
    updateConfig(e) {
        this._config = {
            ...this._config,
            ...e
        }, this._logger.debug("Config update received, the new one: ", this._config), e.isRemote && this.attachVideoElementEvents(), this._syncConfig();
    }
    setVideoElement(e) {
        let t = this._state.getState().videoElement;
        e !== t && (t && this.detachVideoElementEvents(t), this._logger.info("Video element set", {
            videoElement: e
        }), this._renderController.setVideoElement(e), this.attachVideoElementEvents());
    }
    createVideoElement() {
        return this._logger.info("Creating video element"), this._renderController.createVideoElement(), this.getVideoElement();
    }
    setStream(e) {
        if (this._logger.info("Setting media stream"), this._state.getState().stream !== e) return e ? this._streamController.updateMediaStream(e) : this._streamController.removeMediaStream(), this._updated(), this._state.setState({
            stream: e
        }), this;
        this._logger.verbose("Previous stream is equal to the new one. Skipping.");
    }
    renderVideoInto(e) {
        this._logger.info("Rendering video element into container", e), this._renderController.renderVideoInto(e);
    }
    setVolume(e) {
        this._logger.info("Setting volume of the video element", {
            volume: e
        }), this._eventBus.publish($dbaf12f73216aff4$var$b.SET_VOLUME, {
            volume: e
        });
    }
    getState() {
        return this._state.getState();
    }
    destroy() {
        this._logger.info("Destroying"), this._config = {
            ...$dbaf12f73216aff4$var$ie.videoElementControllerConfig
        }, this.detachVideoElementEvents(), this._streamController.removeMediaStream(), this._renderController.destroy(), this._eventBus.publishSync($dbaf12f73216aff4$var$b.DESTROY, {}), this._logger.info("VideoElementController was destroyed"), this._loggerTransport?.destroy();
    }
    reinit() {
        this._logger.info("Reinit requested"), [
            this._autoplayController,
            this._customEventsEmitter,
            this._playbackController,
            this._streamController,
            this._stateController,
            this._timeUpdateController,
            this._renderController,
            this._eventsHandler
        ].forEach((e)=>{
            e && e.init();
        }), this.attachVideoElementEvents(), this._logger.info("VideoElementController was reinited");
    }
    setLoggerLevels(e, t = [], r = []) {
        this._logger.info("Setting new log level", {
            levels: e
        }), this._loggerTransport && (this._loggerTransport.destroy(), this._loggerTransport = null), e.length && (this._loggerTransport = new $dbaf12f73216aff4$var$ne(this._eventBus, e, t, r));
    }
    _syncConfig() {
        this._logger.verbose("Sycronizing configs across all controllers"), this._autoplayController?.setConfig(this._config), this._eventsHandler.setConfig(this._config), this._streamController.setConfig(this._config), this._timeUpdateController.setConfig(this._config), this._renderController.setConfig(this._config), this._stateController.setConfig(this._config);
    }
    _createControllers() {
        this._logger.verbose("Creating all controllers"), this._state = new $dbaf12f73216aff4$var$dt($dbaf12f73216aff4$var$ut);
        let e = {
            getVideoElement: this.getVideoElement,
            state: this._state,
            eventBus: this._eventBus
        };
        this._autoplayController = new $dbaf12f73216aff4$var$de(e), this._customEventsEmitter = new $dbaf12f73216aff4$var$he(e), this._eventsHandler = new $dbaf12f73216aff4$var$lt(e), this._playbackController = new $dbaf12f73216aff4$var$Be(e), this._streamController = new $dbaf12f73216aff4$var$Me(e), this._stateController = new $dbaf12f73216aff4$var$De(e), this._timeUpdateController = new $dbaf12f73216aff4$var$ot(e), this._renderController = new $dbaf12f73216aff4$var$Oe(e), this._logger.verbose("Controllers created");
    }
};
var $dbaf12f73216aff4$var$ht;
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ct.prototype, "addEventListener", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ct.prototype, "removeEventListener", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ct.prototype, "getIsPlaying", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ct.prototype, "getVideoElement", null), $dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], $dbaf12f73216aff4$var$ct.prototype, "getCanvasElement", null), ($dbaf12f73216aff4$var$ht = $dbaf12f73216aff4$export$559043f40a876a16 || ($dbaf12f73216aff4$export$559043f40a876a16 = {}))[$dbaf12f73216aff4$var$ht.FATAL = 0] = "FATAL", $dbaf12f73216aff4$var$ht[$dbaf12f73216aff4$var$ht.ERROR = 1] = "ERROR", $dbaf12f73216aff4$var$ht[$dbaf12f73216aff4$var$ht.WARN = 2] = "WARN", $dbaf12f73216aff4$var$ht[$dbaf12f73216aff4$var$ht.INFO = 3] = "INFO", $dbaf12f73216aff4$var$ht[$dbaf12f73216aff4$var$ht.DEBUG = 4] = "DEBUG", $dbaf12f73216aff4$var$ht[$dbaf12f73216aff4$var$ht.VERBOSE = 5] = "VERBOSE";
$dbaf12f73216aff4$export$559043f40a876a16.FATAL, $dbaf12f73216aff4$export$559043f40a876a16.ERROR, $dbaf12f73216aff4$export$559043f40a876a16.WARN, $dbaf12f73216aff4$export$559043f40a876a16.INFO, $dbaf12f73216aff4$export$559043f40a876a16.DEBUG, $dbaf12f73216aff4$export$559043f40a876a16.VERBOSE;
let $dbaf12f73216aff4$export$2fd275ff363b1e1d = {
    [$dbaf12f73216aff4$export$559043f40a876a16.FATAL]: "Fatal",
    [$dbaf12f73216aff4$export$559043f40a876a16.WARN]: "Warning",
    [$dbaf12f73216aff4$export$559043f40a876a16.ERROR]: "Error",
    [$dbaf12f73216aff4$export$559043f40a876a16.INFO]: "Info",
    [$dbaf12f73216aff4$export$559043f40a876a16.DEBUG]: "Debug",
    [$dbaf12f73216aff4$export$559043f40a876a16.VERBOSE]: "Verbose"
};
var $dbaf12f73216aff4$var$_t;
($dbaf12f73216aff4$var$_t = $dbaf12f73216aff4$var$y || ($dbaf12f73216aff4$var$y = {}))[$dbaf12f73216aff4$var$_t.MEDIA_DEVICES_UPDATED = 0] = "MEDIA_DEVICES_UPDATED";
let $dbaf12f73216aff4$var$gt = ()=>{
    let e = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices) || navigator.getUserMedia && $dbaf12f73216aff4$var$G(navigator.getUserMedia.bind(navigator)) || navigator.webkitGetUserMedia && $dbaf12f73216aff4$var$G(navigator.webkitGetUserMedia.bind(navigator)) || navigator.mozGetUserMedia && $dbaf12f73216aff4$var$G(navigator.mozGetUserMedia.bind(navigator));
    return (t)=>e.call(navigator, t);
};
var $dbaf12f73216aff4$var$pt;
($dbaf12f73216aff4$var$pt = $dbaf12f73216aff4$var$E || ($dbaf12f73216aff4$var$E = {})).VIDEO_INPUT = "videoinput", $dbaf12f73216aff4$var$pt.AUDIO_INPUT = "audioinput", $dbaf12f73216aff4$var$pt.AUDIO_OUTPUT = "audiooutput";
let $dbaf12f73216aff4$var$mt = (e, t)=>e.filter((e)=>e.kind === t);
var $dbaf12f73216aff4$var$bt;
($dbaf12f73216aff4$var$bt = $dbaf12f73216aff4$var$S || ($dbaf12f73216aff4$var$S = {})).SYSTEM_PERMISSION_DENIED = "SystemPermissionDenied", $dbaf12f73216aff4$var$bt.USER_PERMISSION_DENIED = "UserPermissionDenied", $dbaf12f73216aff4$var$bt.COULD_NOT_START_VIDEO_SOURCE = "CouldNotStartVideoSource", $dbaf12f73216aff4$var$bt.GENERIC = "Generic";
let $dbaf12f73216aff4$var$vt = async (e)=>new Promise((t, r)=>{
        navigator.mediaDevices.getUserMedia(e ?? {
            audio: !0,
            video: !0
        }).then((e)=>{
            e.getTracks().forEach((e)=>{
                e.stop();
            }), t(!0);
        }).catch((e)=>{
            let t = e.name, n = e.message, i = $dbaf12f73216aff4$var$S.GENERIC;
            $dbaf12f73216aff4$var$ve ? "NotAllowedError" === t ? "Permission denied by system" === n ? i = $dbaf12f73216aff4$var$S.SYSTEM_PERMISSION_DENIED : "Permission denied" === n && (i = $dbaf12f73216aff4$var$S.USER_PERMISSION_DENIED) : "NotReadableError" === t && (i = $dbaf12f73216aff4$var$S.COULD_NOT_START_VIDEO_SOURCE) : $dbaf12f73216aff4$var$be ? "NotAllowedError" === t && (i = $dbaf12f73216aff4$var$S.USER_PERMISSION_DENIED) : $dbaf12f73216aff4$var$ye ? "NotAllowedError" === t ? i = $dbaf12f73216aff4$var$S.USER_PERMISSION_DENIED : "NotReadableError" === t && (i = $dbaf12f73216aff4$var$S.COULD_NOT_START_VIDEO_SOURCE) : $dbaf12f73216aff4$var$me && ("NotFoundError" === t || "NotReadableError" === t ? i = $dbaf12f73216aff4$var$S.SYSTEM_PERMISSION_DENIED : "NotAllowedError" === t ? i = $dbaf12f73216aff4$var$S.USER_PERMISSION_DENIED : "AbortError" === t && (i = $dbaf12f73216aff4$var$S.COULD_NOT_START_VIDEO_SOURCE)), r({
                type: i,
                name: e.name,
                message: e.message
            });
        });
    });
var $dbaf12f73216aff4$var$yt;
($dbaf12f73216aff4$var$yt = $dbaf12f73216aff4$var$R || ($dbaf12f73216aff4$var$R = {})).LIVE = "live", $dbaf12f73216aff4$var$yt.ENDED = "ended";
let $dbaf12f73216aff4$var$Et = (e)=>{
    if (!e) return !0;
    let { muted: t, enabled: r, readyState: n } = e;
    return t || !r || n === $dbaf12f73216aff4$var$R.ENDED;
};
$dbaf12f73216aff4$var$X([
    $dbaf12f73216aff4$var$H
], (class $bf3f4aeafb4efc61$export$187d60d76727d102 extends $dbaf12f73216aff4$var$ce {
    constructor(){
        super(), this._currentMediaStream = null, this._mediaCheckCache = null, this._mediaDevices = null, this._eventBus = new $dbaf12f73216aff4$var$M, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "UserMedia"), this._loggerTransport = new $dbaf12f73216aff4$var$ne(this._eventBus), this._logger.info("Created"), navigator.mediaDevices.addEventListener("devicechange", this._onDevicesChanged);
    }
    destroy() {
        navigator.mediaDevices.removeEventListener("devicechange", this._onDevicesChanged), this._logger.info("Destroyed"), this._stopCurrentStream();
    }
    async requestPermissions() {
        if (this._logger.info("Requesting permissions"), this._mediaCheckCache) return this._logger.debug("Has previous check results cached. Returning it"), this._logger.info("Check results", {
            ...this._mediaCheckCache
        }), this._mediaCheckCache;
        try {
            return this._logger.verbose("Request both video and audio permissions"), await $dbaf12f73216aff4$var$vt({
                video: !0,
                audio: !0
            }), this._logger.debug("No exceptions thrown while checking permissions. Saving both as available in cache"), this._mediaCheckCache = {
                video: {
                    isAvailable: !0,
                    error: null
                },
                audio: {
                    isAvailable: !0,
                    error: null
                }
            }, this._logger.info("Check results", {
                ...this._mediaCheckCache
            }), this._mediaCheckCache;
        } catch (e) {
            this._logger.debug("Got an exception while checking both audio and video permissions. Checking them individually", {
                exception: e.toString()
            });
            let t = {
                video: {
                    isAvailable: !1,
                    error: null
                },
                audio: {
                    isAvailable: !1,
                    error: null
                }
            };
            return t.video = await this._checkKindPermissions({
                video: !0,
                audio: !1
            }), this._logger.verbose(`Video permissions result: ${t.video.isAvailable}`), t.audio = await this._checkKindPermissions({
                video: !1,
                audio: !0
            }), this._logger.verbose(`Audio permissions result: ${t.audio.isAvailable}`), this._mediaCheckCache = t, this._logger.debug("Got individual check results", {
                ...t
            }), this._logger.info("Check results", {
                ...this._mediaCheckCache
            }), this._mediaCheckCache;
        }
    }
    async getVideoDevices() {
        this._logger.info("Getting video devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got video devices", e), e.videoInputs;
    }
    async getAudioInputDevices() {
        this._logger.info("Getting audio input devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got audio input devices", e), e.audioInputs;
    }
    async getAudioOutputDevices() {
        this._logger.info("Getting audio output devices list");
        let e = await this._getMediaDevices();
        return this._logger.info("Got audio output devices", e), e.audioOutputs;
    }
    async getMediaStream(e, t) {
        this._logger.info("Getting media stream", {
            constraints: e,
            defaults: t
        });
        let r = {};
        if (e.audio && (this._logger.debug("Audio constraints are specified in requested constraints. Mapping it"), r.audio = ((e)=>{
            if (!e) return !1;
            if ("boolean" == typeof e) return e;
            if (e.deviceId) return {
                deviceId: $dbaf12f73216aff4$var$be ? e.deviceId : {
                    exact: e.deviceId
                },
                channelCount: 2
            };
            return !1;
        })(e.audio), this._logger.debug("Audio constraints mapped", {
            constraints: r.audio
        })), e.video && (this._logger.debug("Video constraints are specified in requested constraints. Mapping it"), r.video = ((e, t)=>{
            if (!e) return !1;
            if ("boolean" == typeof e) return !0;
            let r = e.width && e.height ? Number(e.width) / Number(e.height) : t.baseAspectRatio, n = {};
            e.frameRate && (n.frameRate = {
                ideal: e.frameRate,
                min: 15
            }), e.facingMode && navigator.mediaDevices.getSupportedConstraints().facingMode && (n.facingMode = {
                exact: e.facingMode
            });
            return e.width && (n.width = {
                ideal: e.width
            }), e.height && (n.height = {
                ideal: e.height
            }), e.width && e.height && r && (n.aspectRatio = r), e.deviceId && (n.deviceId = $dbaf12f73216aff4$var$be ? e.deviceId : {
                exact: e.deviceId
            }), e.width && e.height && !n.facingMode && (n.advanced = [
                {
                    width: {
                        min: e.width - t.sizeThreshold,
                        max: e.width + t.sizeThreshold
                    },
                    height: {
                        min: e.height - t.sizeThreshold,
                        max: e.height + t.sizeThreshold
                    }
                },
                {
                    aspectRatio: r
                }
            ]), 0 !== Object.keys(n).length && n;
        })(e.video, t), this._logger.debug("Video constraints mapped", {
            constraints: r.video
        })), this._logger.info("Final constraints for media stream", {
            mappedConstraints: r
        }), !this._currentMediaStream) {
            this._logger.debug("No current media stream known. Creating new stream");
            let e = await this._createNewStream(r);
            return this._logger.info("Media stream is ready", {
                mediaStream: e
            }), e;
        }
        let n = !(!(i = this._currentMediaStream.stream).active || i.getTracks().every($dbaf12f73216aff4$var$Et));
        var i;
        if (n && await this._isCurrentStreamSatisfiesConstraints(r)) return this._logger.debug("Current stream is active and satisfies constraints. Returning cached one"), this._logger.info("Media stream is ready", {
            mediaStream: this._currentMediaStream.stream
        }), this._currentMediaStream.stream;
        this._logger.debug(`Current stream ${n ? "does not satisfies constraints" : "is inactive"}. Creating new stream`), await this._stopCurrentStream();
        let s = await this._createNewStream(r);
        return this._logger.info("Media stream is ready", {
            mediaStream: s
        }), s;
    }
    async _stopCurrentStream() {
        var e;
        (this._logger.debug("Stopping current media stream"), this._currentMediaStream) ? (await (e = this._currentMediaStream.stream, void (e && (e.getTracks().forEach((t)=>{
            t.stop(), e.removeTrack(t);
        }), e.stop && e.stop()))), this._currentMediaStream = null) : this._logger.verbose("No current stream known. Skipping");
    }
    async _checkKindPermissions(e) {
        this._logger.debug("Checking kind permissions", {
            constraints: e
        });
        let t = {
            isAvailable: !1,
            error: null
        };
        try {
            this._logger.verbose("Requesting media permissions for constraints", {
                constraints: e
            }), t.isAvailable = await $dbaf12f73216aff4$var$vt(e), this._logger.verbose("Successfully got permissions for constraints", {
                constraints: e
            });
        } catch (r) {
            this._logger.verbose("Could not get permissions for constraints", {
                constraints: e,
                error: r
            }), t.isAvailable = !1, t.error = r;
        }
        return this._logger.debug("Final result of permissions check", {
            constraints: e,
            checkResults: t
        }), t;
    }
    async _getMediaStream(e) {
        this._logger.debug("Getting media stream with constraints", {
            constraints: e
        });
        let t = $dbaf12f73216aff4$var$gt(), r = await t(e);
        return this._currentMediaStream = {
            constraints: e,
            stream: r
        }, this._logger.debug("Resulting media stream", {
            mediaStream: this._currentMediaStream.stream
        }), this._currentMediaStream.stream;
    }
    async _createNewStream(e) {
        this._logger.debug("Creating new media stream with constraints", {
            constraints: e
        });
        try {
            return await this._getMediaStream(e);
        } catch (t) {
            if (this._logger.warn("Got an error while creating new media stream", {
                error: t,
                constraints: e
            }), "OverconstrainedError" === t.name && "deviceId" === t.constraint) {
                this._logger.verbose("Trying to get stream with no audio deviceId specified");
                let t = {
                    ...e,
                    audio: !0
                };
                return await this._getMediaStream(t);
            }
            throw t;
        }
    }
    async _getMediaDevices() {
        return this._logger.verbose("Getting media devices"), this._mediaDevices ? (this._logger.verbose("Has media devices in cache, returning them", {
            devices: this._mediaDevices
        }), this._mediaDevices) : (this._mediaDevices = await (async ()=>{
            let e = await navigator.mediaDevices.enumerateDevices();
            return {
                audioInputs: $dbaf12f73216aff4$var$mt(e, $dbaf12f73216aff4$var$E.AUDIO_INPUT),
                audioOutputs: $dbaf12f73216aff4$var$mt(e, $dbaf12f73216aff4$var$E.AUDIO_OUTPUT),
                videoInputs: $dbaf12f73216aff4$var$mt(e, $dbaf12f73216aff4$var$E.VIDEO_INPUT)
            };
        })(), this._mediaDevices);
    }
    async _isCurrentStreamSatisfiesConstraints(e) {
        if (this._logger.debug("Checking if current media stream satisfies constraints", {
            constraints: e,
            mediaStream: this._currentMediaStream
        }), !this._currentMediaStream) return this._logger.verbose("No current media stream available"), !1;
        try {
            if (e.video) {
                this._logger.verbose("Checking video track constraints");
                let t = this._currentMediaStream.stream.getVideoTracks()[0];
                if (!t && e.video) return this._logger.verbose("No video track in media stream and constraints has video"), !1;
                if (t && !e.video) return this._logger.verbose("There is video track in media stream and constraints has no video"), !1;
                if ("object" == typeof e.video && e.video.deviceId && t.getCapabilities().deviceId !== e.video.deviceId) return this._logger.verbose("Constraints has video device ID and it not matches current device id"), !1;
                t && "boolean" != typeof e.video && (this._logger.verbose("Trying to apply new constraints for video"), await t.applyConstraints(e.video));
            }
        } catch (e) {
            return this._logger.debug("Could not apply constraints or get capabilities of video track", {
                error: e
            }), !1;
        }
        try {
            if (e.audio) {
                this._logger.verbose("Checking audio track constraints");
                let t = this._currentMediaStream.stream.getAudioTracks()[0];
                if (!t && e.audio) return this._logger.verbose("No audio track in media stream and constraints has audio"), !1;
                if (t && !e.audio) return this._logger.verbose("There is audio track in media stream and constraints has no audio"), !1;
                if ("object" == typeof e.audio && e.audio.deviceId && t.getCapabilities().deviceId !== e.audio.deviceId) return this._logger.verbose("Constraints has audio device ID and it not matches current device id"), !1;
                t && "boolean" != typeof e.audio && (this._logger.verbose("Trying to apply new constraints for audio"), await t.applyConstraints(e.audio));
            }
        } catch (e) {
            return this._logger.debug("Could not apply constraints or get capabilities of audio track", {
                error: e
            }), !1;
        }
        return !0;
    }
    async _onDevicesChanged() {
        this._logger.debug("Media devices has changed"), this._mediaDevices = null;
        let e = await this._getMediaDevices();
        this._mediaDevices = e, this.emitEvent($dbaf12f73216aff4$var$y.MEDIA_DEVICES_UPDATED, e);
    }
}).prototype, "_onDevicesChanged", null);
let $dbaf12f73216aff4$var$St, $dbaf12f73216aff4$var$Rt = (e)=>{
    if (!e) return {};
    try {
        let t = new URL(e).pathname.split("/"), r = t[2], n = t[t.length - 1];
        return {
            streamId: r,
            resolution: n.match(/\d+_(\w+)/)?.[1] || "source",
            isMaster: "master" === t[3]
        };
    } catch (e) {
        return {};
    }
};
var $dbaf12f73216aff4$var$Tt;
($dbaf12f73216aff4$var$Tt = $dbaf12f73216aff4$var$St || ($dbaf12f73216aff4$var$St = {})).THROUGHPUT_ESTIMATOR = "throughputEstimator", $dbaf12f73216aff4$var$Tt.DROPPED_FRAMES_ESTIMATOR = "droppedFramesEstimator", $dbaf12f73216aff4$var$Tt.SWITCH_HISTORY = "switchHistory", $dbaf12f73216aff4$var$Tt.INSUFFICIENT_BUFFER = "insufficientBuffer", $dbaf12f73216aff4$var$Tt.MINIMAL_BUFFER_TO_INCREASE = "minimalBufferToIncrease", $dbaf12f73216aff4$var$Tt.DELTA_BUFFER = "deltaBuffer", $dbaf12f73216aff4$var$Tt.MAX_RESOLUTION_ESTIMATOR = "maxResolution";
const $dbaf12f73216aff4$var$At = {
    enabledABRRules: [
        $dbaf12f73216aff4$var$St.THROUGHPUT_ESTIMATOR,
        $dbaf12f73216aff4$var$St.SWITCH_HISTORY,
        $dbaf12f73216aff4$var$St.MINIMAL_BUFFER_TO_INCREASE,
        $dbaf12f73216aff4$var$St.INSUFFICIENT_BUFFER,
        $dbaf12f73216aff4$var$St.MAX_RESOLUTION_ESTIMATOR
    ],
    cooldownPeriod: 1e4,
    minimalBufferAmountToSwitchUp: 500
}, $dbaf12f73216aff4$var$Lt = {
    enabledABRRules: {
        isMultiple: !0,
        values: [
            $dbaf12f73216aff4$var$St.DROPPED_FRAMES_ESTIMATOR,
            $dbaf12f73216aff4$var$St.THROUGHPUT_ESTIMATOR,
            $dbaf12f73216aff4$var$St.SWITCH_HISTORY,
            $dbaf12f73216aff4$var$St.MINIMAL_BUFFER_TO_INCREASE,
            $dbaf12f73216aff4$var$St.INSUFFICIENT_BUFFER,
            $dbaf12f73216aff4$var$St.DELTA_BUFFER,
            $dbaf12f73216aff4$var$St.MAX_RESOLUTION_ESTIMATOR
        ]
    }
};
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
let $dbaf12f73216aff4$var$$t;
var $dbaf12f73216aff4$var$Bt;
($dbaf12f73216aff4$var$Bt = $dbaf12f73216aff4$var$$t || ($dbaf12f73216aff4$var$$t = {})).WAIT_FOR_PREFETCH_SEGMENT = "waitForSegment", $dbaf12f73216aff4$var$Bt.WAIT_FOR_PLAYLIST = "waitForPlaylist";
const $dbaf12f73216aff4$export$f84bd70098573c5c = {
    playlistLoader: {
        playlistLoadingTimeout: 2500,
        forceStaticPlaylistLoadingTimeout: !1,
        lowLatencyMode: !0,
        equalPlaylistsAmountToDecline: 10,
        blockingMode: $dbaf12f73216aff4$var$$t.WAIT_FOR_PLAYLIST,
        maxVODPlaylistLoadingRetries: 3,
        maxVODFragmentLoadingRetries: 3,
        baseVODPlaylistRetryTimeout: 500,
        baseVODFragmentRetryTimeout: 5e3,
        VODLoadNextSegmentThreshold: 5e3,
        disableTimeoutsInVOD: !0,
        retryLowLatencyPlaylistTimeout: 1e3,
        targetBufferMultiplier: 1,
        disableRotateTimeoutIncrease: !0,
        shouldLogFragmentsHistory: !1,
        workerMode: !0,
        partHoldBack: void 0,
        additionalStartParts: 2,
        sendCustomRefererHeader: !1
    },
    fragmentLoader: {
        fragmentLoadingTimeout: 2500,
        workerMode: !0
    },
    resolutionsManager: {
        autoloadLowestResolution: !0,
        initialResolutionWidth: 0,
        initialResolutionHeight: 720,
        initialResolutionBitrate: 0,
        initialResolutionBitrateThreshold: 1e5,
        maxPlaylistTimeDifference: 4e4,
        awaitForSegmentEndToSwitch: !0,
        awaitForSegmentEndToSwitchManual: !1,
        recreateSourceBufferOnResolutionChange: !1,
        useFallbackResolutionIfResolutionNotFound: !0
    },
    bufferController: {
        checkMetricsInterval: 150,
        bufferStallThreshold: .2,
        maxBackBufferAmount: 1e4,
        bufferEdgeThreshold: .3,
        endOfRangeThreshold: .4,
        nudgePlaybackAmount: .1,
        numberOfCandidatesToDetectGap: 2,
        numberOfFragmentToKeep: 2,
        recreateSourceBufferOnResolutionChange: !1,
        saveLastSegmentsCount: 3,
        sourceBufferStuckTimeout: 1e3
    },
    throughputHistory: {
        ewmaFastAlpha: .9,
        ewmaSlowAlpha: .2,
        ignorePlaylistsMetrics: !0
    },
    abr: $dbaf12f73216aff4$var$At,
    switchHistory: {
        banResolutionDuration: 7e3
    },
    throughputEstimator: {
        optimalResolutionLowerBound: .65,
        optimalResolutionUpperBound: .88,
        amountOfFragmentToBecomeConfident: 10
    },
    droppedFramesEstimator: {
        resetHistoryTimeout: 3e5,
        optimalDroppedFramesFraction: .1,
        minimalFramesPlayed: 200
    },
    fragmentParser: {
        workerMode: !1
    },
    debugger: {
        enableRemoteDebugging: !1,
        debuggerUrl: "wss://doppio-player-debug.stripcdn.com",
        maxWSConnectionRetries: 3,
        modulesStateGatheringPeriod: 1e3,
        enableLifecycleEvents: !0
    },
    insufficientBufferEstimator: {
        minimalBufferAmount: .1,
        ignoreMetricsBeforeBufferExceedsMinimal: !0,
        switchToMinimalResolution: !1
    },
    minimalBufferToIncreaseEstimator: {
        minimalBufferAmount: 500
    },
    deltaBufferEstimator: {
        bufferDeltaFractionToDetectFall: .1,
        numberOfFallsToDetect: 2
    },
    playbackStateController: {
        autoPlay: !1,
        syncToLiveEdge: !1,
        syncToLiveDelta: 1,
        playingTimeFractionCollectionWindow: 1e5,
        stallDurationToDisableTargetBufferDecrease: 1e4
    },
    targetBufferIncreaser: {
        bufferAmountToIncrease: 200,
        bufferAmountThreshold: 300
    },
    targetBufferDecreaser: {
        periodOfEventsToCancelDecrease: 1e4
    },
    originalTargetBufferDecreaser: {
        periodOfEventsToCancelDecrease: 1e4,
        allowTargetBufferDecrease: !1,
        targetBufferDecreaseTimeout: 1e4,
        maxTargetBufferMultiplier: 4
    },
    playbackSpeedActuator: {
        maxPlaybackRate: 1.05,
        minPlaybackRate: .9
    },
    playbackSpeedWatcher: {
        maxLiveSyncThreshold: .4,
        minLiveSyncThreshold: .3,
        maxTargetBufferMultiplier: 3,
        targetBufferInitialMultiplier: 1,
        targetBufferDecreaseCoefficient: .25
    },
    bufferStallsDetector: {
        bufferAmountToDetectStall: .1
    },
    fragmentsFilter: {
        reportInconsistentTracks: !0,
        filterOutInconsistentTracks: !1
    },
    fragmentBuffer: {
        numberOfFragmentsToKeepInBuffer: 3,
        baseChunksSaverUrl: "chunks.doppiostreams.com",
        saveProbability: .05
    }
}, $dbaf12f73216aff4$export$1d46f2bb2132f676 = {
    playlistLoader: {
        blockingMode: {
            values: [
                $dbaf12f73216aff4$var$$t.WAIT_FOR_PLAYLIST,
                $dbaf12f73216aff4$var$$t.WAIT_FOR_PREFETCH_SEGMENT
            ],
            isMultiple: !1
        }
    },
    fragmentLoader: {},
    resolutionsManager: {},
    bufferController: {},
    throughputHistory: {},
    abr: $dbaf12f73216aff4$var$Lt,
    switchHistory: {},
    throughputEstimator: {},
    droppedFramesEstimator: {},
    fragmentParser: {},
    debugger: {},
    insufficientBufferEstimator: {},
    minimalBufferToIncreaseEstimator: {},
    deltaBufferEstimator: {},
    playbackStateController: {},
    targetBufferIncreaser: {},
    targetBufferDecreaser: {},
    originalTargetBufferDecreaser: {},
    playbackSpeedActuator: {},
    playbackSpeedWatcher: {},
    bufferStallsDetector: {},
    fragmentsFilter: {},
    fragmentBuffer: {}
}, $dbaf12f73216aff4$var$wt = [
    "error",
    "fatal"
], { ConfigConsumer: $dbaf12f73216aff4$var$Ot, setConfig: $dbaf12f73216aff4$var$Dt } = $dbaf12f73216aff4$var$j($dbaf12f73216aff4$export$f84bd70098573c5c);
class $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 extends $dbaf12f73216aff4$var$Ot {
}
let $dbaf12f73216aff4$var$Mt;
var $dbaf12f73216aff4$var$It;
($dbaf12f73216aff4$var$It = $dbaf12f73216aff4$var$Mt || ($dbaf12f73216aff4$var$Mt = {})).OK = "ok", $dbaf12f73216aff4$var$It.ERROR = "error";
const $dbaf12f73216aff4$var$Ft = {
    playlistType: {
        multivariantDetected: "basePlaylistRotator.playlistType.multivariantDetected",
        simpleDetected: "basePlaylistRotator.playlistType.simpleDetected",
        llDetected: "basePlaylistRotator.playlistType.llDetected",
        vodDetected: "basePlaylistRotator.playlistType.vodDetected"
    },
    playlists: {
        playlistRequested: "basePlaylistRotator.playlists.playlistRequested",
        playlistLoaded: "basePlaylistRotator.playlists.playlistLoaded",
        playlistLoadingError: "basePlaylistRotator.playlists.playlistLoadingError",
        playlistParsed: "basePlaylistRotator.playlists.playlistLoadingError",
        playlistInfo: "basePlaylistRotator.playlists.playlistInfo",
        vodFragmentsInfo: "basePlaylistRotator.playlists.VODFragmentsInfo",
        independenceTypeUpdate: "basePlaylistRotator.playlists.independenceTypeUpdate",
        renditionReportsUpdated: "basePlaylistRotator.playlists.renditionReportsUpdated",
        lastPlaylistOfSegmentLoaded: "basePlaylistRotator.playlists.lastPlaylistOfSegmentLoaded"
    },
    fragments: {
        fragmentsDetected: "basePlaylistRotator.fragments.fragmentsDetected",
        requestReleaseFromCache: "basePlaylistRotator.fragments.requestReleaseFromCache",
        periodFragmentsFound: "basePlaylistRotator.fragments.periodFragmentsFound"
    }
};
var $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$97df3d41385b7849$export$9f4c67ab29d25f83 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    status = "Idle";
    state = $dbaf12f73216aff4$var$Mt.OK;
    additionalInfo = {};
    groups = [
        "abr"
    ];
    _numberOfFalls = 0;
    _lastKnownBufferAmount = 0;
    _currentBufferAmount = 0;
    constructor(e){
        super("deltaBufferEstimator", e), this._onPlaylistParsedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.playlistInfo, this._onPlaylistParsed);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onPlaylistParsedListener), this.reset();
    }
    reset() {
        this._numberOfFalls = 0;
    }
    getNextEstimatedResolution(e, t, r) {
        return this._currentBufferAmount = r.bufferAmount, !t || this._numberOfFalls < this.config.numberOfFallsToDetect ? null : e[Math.max(0, e.findIndex(({ name: e })=>e === t.name) - 1)];
    }
    _handleConfigUpdated() {
        this._numberOfFalls = 0;
    }
    _onPlaylistParsed() {
        const { _currentBufferAmount: e, _lastKnownBufferAmount: t } = this;
        this._lastKnownBufferAmount = e, e > t && (this._numberOfFalls = 0);
        const r = t / e;
        r > 1 + this.config.bufferDeltaFractionToDetectFall && this._numberOfFalls++, this.additionalInfo = {
            numberOfFalls: this._numberOfFalls,
            bufferDelta: r
        };
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$97df3d41385b7849$export$9f4c67ab29d25f83.prototype, "_onPlaylistParsed", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$kt = {
    requestResetWithOverplay: "buffer.requestResetWithOverplay",
    bufferStalled: "buffer.stalled",
    bufferMetricsAvailable: "buffer.metricsAvaialable",
    playbackStallChanged: "buffer.playbackStallChanged",
    requestSourceBufferOperation: "buffer.requestSourceBufferOperation",
    playbackStateChanged: "buffer.playbackStateChanged",
    endOfStreamReached: "buffer.endOfStreamReached",
    onFragmentAppended: "buffer.onFragmentAppended",
    fragmentAdded: "buffer.fragmentAdded",
    changeCodec: "buffer.changeCodec",
    sourceBufferStuck: "buffer.sourceBufferStuck"
}, $dbaf12f73216aff4$var$Nt = {
    resolutionsAvailable: "resolutionsManager.resolutionsAvailable",
    reportCurrentResolution: "resolutionManager.reportCurrentResolution",
    resolutionChanged: "resolutionManager.resolutionChanged",
    resolutionCodecAvailable: "resolutionManager.resolutionChanged",
    resolutionAutoChanged: "resolutionManager.resolutionAutoChanged",
    requestResolutionChange: "resolutionManager.requestResolutionChange",
    requestRestartFromMain: "resolutionManager.requestRestartFromMain",
    resolutionNotFound: "resolutionManager.resolutionNotFound",
    resolutionsMaximumAvailable: "resolutionManager.resolutionsMaximumAvailable"
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$7000bb4e4ec8b8c3$export$709054a4c4c750e6 {
    _droppedFrames = {};
    _currentResolution = null;
    _isFirstMetricsOfResolution = !0;
    constructor(e){
        this._eventBus = e, this._onBufferMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsReady), this._onResolutionChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChanged);
    }
    destroy() {
        this._eventBus.unsubscribe(this._onBufferMetricsReadyListener), this._eventBus.unsubscribe(this._onResolutionChangedListener), this.reset();
    }
    getCurrentResolutionHistory() {
        return this._currentResolution && this._droppedFrames[this._currentResolution.name] ? this._droppedFrames[this._currentResolution.name] : null;
    }
    getResolutionHistoryByName(e) {
        return this._droppedFrames[e] || null;
    }
    reset() {
        this._droppedFrames = {}, this._currentResolution = null, this._isFirstMetricsOfResolution = !0;
    }
    _onBufferMetricsReady(e) {
        if (!this._currentResolution) return;
        const { name: t } = this._currentResolution;
        this._droppedFrames[t] || (this._droppedFrames[t] = {
            droppedFramesNumber: 0,
            totalFramesNumber: 0
        }), this._isFirstMetricsOfResolution ? this._isFirstMetricsOfResolution = !1 : (this._droppedFrames[t].droppedFramesNumber += e.droppedVideoFramesDelta, this._droppedFrames[t].totalFramesNumber += e.totalVideoFramesDelta);
    }
    _onResolutionChanged(e) {
        this._currentResolution?.name !== e.name && (this._currentResolution = e, this._isFirstMetricsOfResolution = !0);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$7000bb4e4ec8b8c3$export$709054a4c4c750e6.prototype, "_onBufferMetricsReady", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$7000bb4e4ec8b8c3$export$709054a4c4c750e6.prototype, "_onResolutionChanged", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$89bb8e518717ef2e$export$14dfd3dff6a7e4ae extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {
        droppedFramesByResolution: {}
    };
    groups = [
        "abr"
    ];
    _lastClearTs = 0;
    _droppedFramesHistory = new $dbaf12f73216aff4$var$$7000bb4e4ec8b8c3$export$709054a4c4c750e6(this._eventBus);
    constructor(e){
        super("droppedFramesEstimator", e), this._onMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onMetricsReady);
    }
    destroy() {
        super.destroy(), this._droppedFramesHistory.destroy(), this._eventBus.unsubscribe(this._onMetricsReadyListener);
    }
    reset() {
        this._droppedFramesHistory.reset();
    }
    getNextEstimatedResolution(e) {
        const { minimalFramesPlayed: t } = this.config;
        return e.find(({ name: e })=>{
            const r = this._droppedFramesHistory.getResolutionHistoryByName(e);
            return this.additionalInfo.droppedFramesByResolution[e] = r, !r || r.totalFramesNumber < t || r.droppedFramesNumber / r.totalFramesNumber < this.config.optimalDroppedFramesFraction;
        }) || null;
    }
    _handleConfigUpdated() {}
    _onMetricsReady(e) {
        e.currentTimestamp - this._lastClearTs > this.config.resetHistoryTimeout && (this._droppedFramesHistory.reset(), this._lastClearTs = e.currentTimestamp);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$89bb8e518717ef2e$export$14dfd3dff6a7e4ae.prototype, "_onMetricsReady", null);
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
var $dbaf12f73216aff4$var$Vt = $dbaf12f73216aff4$var$a("3mtZ4");
const $dbaf12f73216aff4$var$Ut = {
    resolutionsConstraintsAvailable: "AbrController.resolutionsConstraintsAvailable"
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$dbbcd9c9f5a10b70$export$18f513ea99665198 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "abr"
    ];
    _lastAvailableResolutions = [];
    _currentResolutionsLimit = null;
    _estimatedResolution = null;
    constructor(e){
        this._eventBus = e, this._onResolutionsConstraintsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ut.resolutionsConstraintsAvailable, this._onResolutionsConstraintsAvailable);
    }
    destroy() {
        this._eventBus.unsubscribe(this._onResolutionsConstraintsAvailableListener);
    }
    reset() {}
    getNextEstimatedResolution(e) {
        return this._lastAvailableResolutions !== e && (this._lastAvailableResolutions = e, this._calculationAvailableResolution(this._currentResolutionsLimit)), this._estimatedResolution;
    }
    _onResolutionsConstraintsAvailable(e) {
        $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Vt).isEqual(this._currentResolutionsLimit, e) || this._calculationAvailableResolution(e);
    }
    _meetsLimits(e, t) {
        return !(void 0 !== t?.bitrate && e.bitrate > t?.bitrate) && !(void 0 !== t?.height && e.height > t?.height) && !(void 0 !== t?.width && e.width > t?.width) && (void 0 === t?.fps || !(void 0 === e.fps || +e.fps > +t?.fps));
    }
    _calculationAvailableResolution(e) {
        if (this._currentResolutionsLimit = {
            ...e
        }, 0 === this._lastAvailableResolutions?.length) return;
        if (null === e) return void (this._estimatedResolution = null);
        const t = this._lastAvailableResolutions.filter((t)=>!e || this._meetsLimits(t, e));
        this._estimatedResolution = t[0] || this._lastAvailableResolutions.slice(-1)[0];
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$dbbcd9c9f5a10b70$export$18f513ea99665198.prototype, "_onResolutionsConstraintsAvailable", null);
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$2513900d05bc0cb7$export$7aa9ad8404c0d315 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _lastSelectedResolution = null;
    _bannedResolutions = [];
    constructor(e){
        super("switchHistory", e), this._onResolutionSelectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChanged), this._onMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._checkBanedResolutions);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onResolutionSelectedListener), this._eventBus.unsubscribe(this._onMetricsReadyListener), this.reset();
    }
    reset() {
        this._bannedResolutions = [];
    }
    getBannedResolutions() {
        return this._bannedResolutions.map(({ resolution: e })=>e);
    }
    _handleConfigUpdated(e) {
        e.banResolutionDuration && this._checkBanedResolutions();
    }
    _onResolutionChanged(e) {
        !this._lastSelectedResolution || this._lastSelectedResolution.bitrate < e.bitrate ? this._lastSelectedResolution = e : this._lastSelectedResolution.bitrate > e.bitrate && (this._bannedResolutions.push({
            resolution: e,
            bannedAt: Date.now()
        }), this._lastSelectedResolution = e);
    }
    _checkBanedResolutions() {
        if (!this._bannedResolutions.length) return;
        const e = Date.now();
        this._bannedResolutions = this._bannedResolutions.filter(({ bannedAt: t })=>e - t < this.config.banResolutionDuration);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2513900d05bc0cb7$export$7aa9ad8404c0d315.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2513900d05bc0cb7$export$7aa9ad8404c0d315.prototype, "_onResolutionChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2513900d05bc0cb7$export$7aa9ad8404c0d315.prototype, "_checkBanedResolutions", null);
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$qt = {
    events: {
        browserRedirectDetected: "networkLoader.events.browserRedirectDetected",
        networkRequestSettled: "networkLoader.events.networkRequestSettled"
    },
    stats: {
        statsReady: "networkLoader.stats.statsEvent"
    }
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266 {
    _previousFastValue = null;
    _previousSlowValue = null;
    constructor(e, t, r){
        this._eventBus = r, this._fastAlpha = e, this._slowAlpha = t;
    }
    addValue(e) {
        const { _fastAlpha: t, _slowAlpha: r } = this;
        this._previousFastValue = t * e + (1 - t) * (this._previousFastValue || e), this._previousSlowValue = r * e + (1 - r) * (this._previousSlowValue || e), this._eventBus.publish("EWMAMetrics", {
            fast: this._previousFastValue,
            slow: this._previousSlowValue
        });
    }
    getCurrentValue() {
        return this._previousSlowValue && this._previousFastValue ? Math.min(this._previousFastValue, this._previousSlowValue) : 0;
    }
    getCurrentMaximalValue() {
        return this._previousFastValue && this._previousSlowValue ? Math.max(this._previousSlowValue, this._previousFastValue) : 0;
    }
    reset() {
        this._previousSlowValue = null, this._previousFastValue = null;
    }
}
class $dbaf12f73216aff4$var$$30a866620297da5e$export$2e3eaf77ce37b1e9 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    constructor(e){
        super("throughputHistory", e), this._measuredSpeedEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus), this._realSpeedEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus), this._ttfbEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus), this._onNetMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$qt.stats.statsReady, this._onNetworkMetricsReady);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onNetMetricsReadyListener), this._measuredSpeedEwmaInstance.reset(), this._realSpeedEwmaInstance.reset();
    }
    getCurrentBitrateEstimate() {
        return {
            measuredSpeed: this._measuredSpeedEwmaInstance.getCurrentValue(),
            realSpeedWithoutTTFB: this._realSpeedEwmaInstance.getCurrentValue(),
            ttfb: this._ttfbEwmaInstance.getCurrentMaximalValue()
        };
    }
    reset() {
        this._measuredSpeedEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus), this._realSpeedEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus), this._ttfbEwmaInstance = new $dbaf12f73216aff4$var$$fb520263187a23db$export$acb33a230ebe3266(this.config.ewmaFastAlpha, this.config.ewmaSlowAlpha, this._eventBus);
    }
    _handleConfigUpdated(e) {
        (e.ewmaFastAlpha || e.ewmaSlowAlpha) && this.reset();
    }
    _onNetworkMetricsReady(e) {
        if (this.config.ignorePlaylistsMetrics && "text" === e.type) return;
        const t = 8 * e.sizeInKb / ((e.downloadDuration - e.ttfb) / 1e3);
        this._measuredSpeedEwmaInstance.addValue(e.calculatedSpeed), this._realSpeedEwmaInstance.addValue(t), this._ttfbEwmaInstance.addValue(e.ttfb / 1e3);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$30a866620297da5e$export$2e3eaf77ce37b1e9.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$30a866620297da5e$export$2e3eaf77ce37b1e9.prototype, "_onNetworkMetricsReady", null);
const $dbaf12f73216aff4$var$Gt = (e)=>e / 1024;
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$a858cf7c6f08c5e8$export$e9a2267c4de91991 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "abr"
    ];
    _isResultsConfident = !1;
    _fragmentsLoadedAmount = 0;
    constructor(e){
        super("throughputEstimator", e), this._throughputHistory = new $dbaf12f73216aff4$var$$30a866620297da5e$export$2e3eaf77ce37b1e9(this._eventBus), this._onNetworkMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$qt.stats.statsReady, this._onNetworkStatsReady);
    }
    destroy() {
        super.destroy(), this._throughputHistory.destroy(), this._eventBus.unsubscribe(this._onNetworkMetricsReadyListener);
    }
    reset() {
        this._throughputHistory.reset(), this._isResultsConfident = !1;
    }
    getNextEstimatedResolution(e) {
        const { realSpeedWithoutTTFB: t, measuredSpeed: r, ttfb: n } = this._throughputHistory.getCurrentBitrateEstimate();
        if (this.additionalInfo = {
            realSpeedWithoutTTFB: t,
            measuredSpeed: r,
            ttfb: n
        }, !e.length || !r || !this._isResultsConfident) return null;
        const i = $dbaf12f73216aff4$var$Gt(e[0].bitrate) / (n + $dbaf12f73216aff4$var$Gt(e[0].bitrate) / t);
        if ($dbaf12f73216aff4$var$Gt(e[0].bitrate) < i) return e[0];
        const s = e.find(({ bitrate: e })=>{
            const r = $dbaf12f73216aff4$var$Gt(e), i = r / (n + r / t);
            return i * this.config.optimalResolutionLowerBound <= r && r <= i * this.config.optimalResolutionUpperBound;
        });
        if (s) return s;
        return e.find(({ bitrate: e })=>$dbaf12f73216aff4$var$Gt(e) <= r * this.config.optimalResolutionLowerBound) || e.slice(-1)[0];
    }
    _handleConfigUpdated() {}
    _onNetworkStatsReady(e) {
        "binary" !== e.type || this._isResultsConfident || (this._fragmentsLoadedAmount += 1, this._fragmentsLoadedAmount >= this.config.amountOfFragmentToBecomeConfident && (this._isResultsConfident = !0));
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$a858cf7c6f08c5e8$export$e9a2267c4de91991.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$a858cf7c6f08c5e8$export$e9a2267c4de91991.prototype, "_onNetworkStatsReady", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
const $dbaf12f73216aff4$var$Wt = {
    [$dbaf12f73216aff4$var$St.DROPPED_FRAMES_ESTIMATOR]: $dbaf12f73216aff4$var$$89bb8e518717ef2e$export$14dfd3dff6a7e4ae,
    [$dbaf12f73216aff4$var$St.THROUGHPUT_ESTIMATOR]: $dbaf12f73216aff4$var$$a858cf7c6f08c5e8$export$e9a2267c4de91991,
    [$dbaf12f73216aff4$var$St.SWITCH_HISTORY]: class $057e53ca2c164943$export$6f9cb52e0b33c918 {
        state = $dbaf12f73216aff4$var$Mt.OK;
        status = "Idle";
        additionalInfo = {
            bannedResolution: []
        };
        groups = [
            "abr"
        ];
        constructor(e){
            this._eventBus = e, this._switchHistory = new $dbaf12f73216aff4$var$$2513900d05bc0cb7$export$7aa9ad8404c0d315(this._eventBus);
        }
        reset() {
            this._switchHistory.reset();
        }
        destroy() {
            this._switchHistory.destroy();
        }
        getNextEstimatedResolution(e) {
            const t = this._switchHistory.getBannedResolutions().map(({ name: e })=>e);
            return this.additionalInfo.bannedResolution = t, e.find(({ name: e })=>!t.includes(e)) || null;
        }
    },
    [$dbaf12f73216aff4$var$St.INSUFFICIENT_BUFFER]: class $f494bb6c32affb33$export$b6b549889e1286d7 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
        status = "Idle";
        state = $dbaf12f73216aff4$var$Mt.OK;
        groups = [
            "abr"
        ];
        additionalInfo = {};
        _hasPassedMinimalBuffer = !1;
        constructor(e){
            super("insufficientBufferEstimator", e);
        }
        destroy() {
            super.destroy();
        }
        reset() {
            this._hasPassedMinimalBuffer = !1;
        }
        getNextEstimatedResolution(e, t, r) {
            const n = r.bufferAmount > this.config.minimalBufferAmount;
            !this._hasPassedMinimalBuffer && n && (this._hasPassedMinimalBuffer = !0);
            const i = !this.config.ignoreMetricsBeforeBufferExceedsMinimal || this._hasPassedMinimalBuffer;
            if (this.additionalInfo.isResultsConfident = i, this.additionalInfo.isBufferExceedsMinimal = n, this.additionalInfo.hasPassedMinimalBuffer = this._hasPassedMinimalBuffer, !i || n || !t) return null;
            this._hasPassedMinimalBuffer = !1;
            const s = e.slice(-1)[0], a = t.url === s.url ? t : e[e.findIndex(({ name: e })=>e === t.name) + 1];
            return this.config.switchToMinimalResolution ? s : a;
        }
        _handleConfigUpdated() {
            this._hasPassedMinimalBuffer = !1;
        }
    },
    [$dbaf12f73216aff4$var$St.MINIMAL_BUFFER_TO_INCREASE]: class $d4907d94f67e26b0$export$38b90fffc2eda758 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
        state = $dbaf12f73216aff4$var$Mt.OK;
        status = "Idle";
        additionalInfo = {};
        groups = [
            "abr"
        ];
        constructor(e){
            super("minimalBufferToIncreaseEstimator", e);
        }
        destroy() {
            super.destroy();
        }
        reset() {}
        getNextEstimatedResolution(e, t, r) {
            return 1e3 * r.bufferAmount > this.config.minimalBufferAmount ? null : t;
        }
        _handleConfigUpdated() {}
    },
    [$dbaf12f73216aff4$var$St.DELTA_BUFFER]: $dbaf12f73216aff4$var$$97df3d41385b7849$export$9f4c67ab29d25f83,
    [$dbaf12f73216aff4$var$St.MAX_RESOLUTION_ESTIMATOR]: $dbaf12f73216aff4$var$$dbbcd9c9f5a10b70$export$18f513ea99665198
};
class $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "general",
        "abr"
    ];
    additionalInfo = {
        switchReasonHistory: []
    };
    _currentResolution = null;
    _availableResolutions = [];
    _estimators = {};
    _lastSwitchTime = 0;
    constructor(e){
        super("abr", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - AbrController"), this._onResolutionChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChanged), this._onResolutionsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionsAvailable, this._onResolutionsAvailable), this._onMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._recalculateCurrentLevel), this._recreateEstimators(), this._lastSwitchTime = Date.now();
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onMetricsReadyListener), this._eventBus.unsubscribe(this._onResolutionChangedListener), this._eventBus.unsubscribe(this._onResolutionsAvailableListener), Object.values(this._estimators).forEach((e)=>{
            e.destroy();
        }), this._estimators = {};
    }
    _handleConfigUpdated(e) {
        e.enabledABRRules && this._recreateEstimators();
    }
    _recreateEstimators() {
        Object.values(this._estimators).forEach((e)=>e.destroy()), this._estimators = this.config.enabledABRRules.reduce((e, t)=>(e[t] = new $dbaf12f73216aff4$var$Wt[t](this._eventBus), e), {});
    }
    _recalculateCurrentLevel(e) {
        const t = Object.entries(this._estimators).reduce((t, [r, n])=>(t[r] = n.getNextEstimatedResolution(this._availableResolutions, this._currentResolution, e), t), {});
        if (this.additionalInfo.estimations = Object.entries(t).reduce((e, [t, r])=>(e[t] = r?.name || "null", e), {}), Date.now() - this._lastSwitchTime < this.config.cooldownPeriod) return;
        if (!Object.values(this._estimators).length) return;
        const r = Object.values(t).filter((e)=>e).sort((e, t)=>(e?.bitrate || 0) - (t?.bitrate || 0))[0];
        if (!!r && r.name !== this._currentResolution?.name) {
            const e = Object.entries(t).reduce((e, [t, n])=>(n?.name === r?.name && e.push(t), e), []);
            this.additionalInfo.switchReasonHistory.unshift(`${this._currentResolution?.name} -> ${r?.name}; ${e.join(",")}`), this._lastSwitchTime = Date.now(), this.additionalInfo.lastSwitchTime = this._lastSwitchTime, this.additionalInfo.lastSwitchReason = Object.entries(t).filter(([, e])=>e?.name === r?.name).map(([e])=>e).join("; "), this._logger.info(`ABR wants to change the resolution, ${this._currentResolution?.name} -> ${r?.name}`), this._eventBus.publish($dbaf12f73216aff4$var$Nt.requestResolutionChange, r);
        }
    }
    _onResolutionsAvailable(e) {
        this._availableResolutions = e;
    }
    _onResolutionChanged(e) {
        this._currentResolution = e, Object.values(this._estimators).forEach((e)=>e.reset());
    }
    get additionalModules() {
        return this._estimators;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e.prototype, "_recalculateCurrentLevel", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e.prototype, "_onResolutionsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e.prototype, "_onResolutionChanged", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _isPaused = !1;
    _isInVodMode = !1;
    _fragmentTimeRanges = [];
    _videoElement = null;
    constructor(e){
        super("bufferController", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - BufferCleaner"), this._onBufferMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), this._onPeriodFragmentsFound = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.fragments.periodFragmentsFound, this._onFragmentPeriodFound), this._onVODFragmentsInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.vodFragmentsInfo, this._onVODFragmentsInfoAvailable);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onPeriodFragmentsFound), this._eventBus.unsubscribe(this._onVODFragmentsInfoAvailableListener), this._eventBus.unsubscribe(this._onBufferMetricsReadyListener);
    }
    start() {
        this._isPaused = !1;
    }
    pause() {
        this._isPaused = !0;
    }
    setVODMode(e) {
        this._isInVodMode = e;
    }
    setVideoElement(e) {
        this._videoElement = e;
    }
    removeVideoElement() {
        this._videoElement = null;
    }
    _handleConfigUpdated() {}
    _onVODFragmentsInfoAvailable(e) {
        this._fragmentTimeRanges = e.map(({ fragmentStartTS: e, fragmentEndTS: t })=>({
                startTS: e,
                endTS: t
            }));
    }
    _onBufferMetricsAvailable(e) {
        if (!(this._isPaused || 0 === e.bufferedTimeRanges.length || this._isInVodMode && this._fragmentTimeRanges.length)) {
            const t = e.isPaused ? [
                {
                    startTS: e.currentPlaybackPosition - 1,
                    endTS: e.currentPlaybackPosition + 1
                },
                {
                    startTS: e.bufferedTimeRanges.slice(-1)[0]?.end - this.config.maxBackBufferAmount / 1e3,
                    endTS: e.bufferedTimeRanges.slice(-1)[0]?.end
                }
            ] : [
                {
                    startTS: e.currentPlaybackPosition - this.config.maxBackBufferAmount / 1e3,
                    endTS: e.bufferedTimeRanges.slice(-1)[0].end
                }
            ];
            this._clearBufferWithSafetyTimeRanges(t);
        }
    }
    _onFragmentPeriodFound({ endTsOfPeriod: e }) {
        if (this._isPaused || !this._videoElement || this._videoElement.currentTime < this.config.maxBackBufferAmount / 1e3) return;
        const { currentTime: t } = this._videoElement, r = [
            {
                startTS: t - this.config.maxBackBufferAmount / 1e3,
                endTS: e
            }
        ];
        this._clearBufferWithSafetyTimeRanges(r);
    }
    _clearBufferWithSafetyTimeRanges(e) {
        if (!this._videoElement?.buffered.length) return;
        const t = e.sort((e, t)=>e.startTS - t.startTS).filter(({ startTS: e, endTS: t })=>e < t).map((t, r)=>({
                startTS: r > 0 ? e[r - 1].endTS : 0,
                endTS: t.startTS
            })).filter(({ startTS: e, endTS: t })=>e < t);
        this._isInVodMode && Number.isFinite(this._videoElement.duration) && e.length && e.slice(-1)[0].endTS < this._videoElement.duration && t.push({
            startTS: e.slice(-1)[0].endTS,
            endTS: this._videoElement.duration
        }), t.forEach((e)=>{
            this._eventBus.publish($dbaf12f73216aff4$var$kt.requestSourceBufferOperation, (t)=>{
                this._logger.verbose(`Removing buffered range ${e.startTS} -> ${e.endTS}`), t.remove(e.startTS, e.endTS);
            });
        });
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1.prototype, "_onVODFragmentsInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1.prototype, "_onBufferMetricsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1.prototype, "_onFragmentPeriodFound", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
let $dbaf12f73216aff4$export$2c4fd850a78e2155;
var $dbaf12f73216aff4$var$Ht;
let $dbaf12f73216aff4$export$b21d389d4d866e74;
var $dbaf12f73216aff4$var$Yt;
let $dbaf12f73216aff4$export$99d210b57a8acd4e;
var $dbaf12f73216aff4$var$zt;
let $dbaf12f73216aff4$var$Xt;
var $dbaf12f73216aff4$var$Zt;
($dbaf12f73216aff4$var$Ht = $dbaf12f73216aff4$export$2c4fd850a78e2155 || ($dbaf12f73216aff4$export$2c4fd850a78e2155 = {})).MANIFEST_LOADED = "ManifestLoaded", $dbaf12f73216aff4$var$Ht.FIRST_MEDIA_PLAYLIST_LOADED = "FirstMediaPlaylistLoaded", $dbaf12f73216aff4$var$Ht.FIRST_FRAGMENT_LOADED = "FirstFragmentLoaded", $dbaf12f73216aff4$var$Ht.FIRST_FRAGMENT_BUFFERED = "FirstFragmentBuffered", ($dbaf12f73216aff4$var$Yt = $dbaf12f73216aff4$export$b21d389d4d866e74 || ($dbaf12f73216aff4$export$b21d389d4d866e74 = {})).MANIFEST_LOAD_ERROR = "ManifestLoadError", $dbaf12f73216aff4$var$Yt.PLAYLIST_LOAD_ERROR = "PlaylistLoadError", $dbaf12f73216aff4$var$Yt.FRAGMENT_LOAD_ERROR = "FragmentLoadError", ($dbaf12f73216aff4$var$zt = $dbaf12f73216aff4$export$99d210b57a8acd4e || ($dbaf12f73216aff4$export$99d210b57a8acd4e = {})).VARIANTS_DETECTED = "variantDetected", $dbaf12f73216aff4$var$zt.RESOLUTION_CHANGED = "resolutionChanged", $dbaf12f73216aff4$var$zt.METRICS_AVAILABLE = "metricsAvailable", $dbaf12f73216aff4$var$zt.ERROR = "error", $dbaf12f73216aff4$var$zt.MANIFEST_LOADING = "manifestLoading", $dbaf12f73216aff4$var$zt.MANIFEST_LOADED = "manifestLoaded", $dbaf12f73216aff4$var$zt.MANIFEST_PARSED = "manifestParsed", $dbaf12f73216aff4$var$zt.LEVEL_LOADED = "levelLoaded", $dbaf12f73216aff4$var$zt.LEVEL_SWITCHED = "levelSwitched", $dbaf12f73216aff4$var$zt.LEVEL_SWITCHED_AUTO = "levelSwitchedAuto", $dbaf12f73216aff4$var$zt.LEVEL_SWITCHING = "levelSwitching", $dbaf12f73216aff4$var$zt.MEDIA_ATTACHED = "mediaAttached", $dbaf12f73216aff4$var$zt.MEDIA_DETACHED = "mediaDetached", $dbaf12f73216aff4$var$zt.FRAG_LOADED = "fragmentLoaded", $dbaf12f73216aff4$var$zt.LEVEL_METADATA_LOADED = "levelMetadataLoaded", $dbaf12f73216aff4$var$zt.STREAM_STATE_TRANSITION = "streamStateTransition", $dbaf12f73216aff4$var$zt.PLAYBACK_STATE_CHANGED = "playbackStateChanged", $dbaf12f73216aff4$var$zt.FRAG_BUFFERED = "fragBuffered", $dbaf12f73216aff4$var$zt.DEBUGGER_CONNECTED = "debuggerConnected", $dbaf12f73216aff4$var$zt.STREAM_ENDED = "streamEnded", $dbaf12f73216aff4$var$zt.LIFECYCLE_EVENT = "lifecycleEvent", $dbaf12f73216aff4$var$zt.LIFECYCLE_ERROR = "lifecycleError", $dbaf12f73216aff4$var$zt.FRAGMENT_FILTERED_OUT = "fragmentFilteredOut", $dbaf12f73216aff4$var$zt.RESOLUTION_NOT_FOUND = "resolutionNotFound", ($dbaf12f73216aff4$var$Zt = $dbaf12f73216aff4$var$Xt || ($dbaf12f73216aff4$var$Xt = {})).MEDIA_ERROR = "mediaError", $dbaf12f73216aff4$var$Zt.NETWORK_ERROR = "networkError", $dbaf12f73216aff4$var$Zt.PARSING_ERROR = "parsingError";
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$5e5782f1e89bfd87$export$4f2bbf2cced9990c extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _sourceBuffer = null;
    _opsQueue = [];
    _sourceBufferStuckTimer = null;
    constructor(e){
        super("bufferController", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - BufferOpsQueue"), this._eventBus = e;
    }
    setSourceBuffer(e) {
        this._sourceBuffer && this._sourceBuffer.removeEventListener("updateend", this._onBufferReady), this._sourceBuffer = e, this._sourceBuffer.addEventListener("updateend", this._onBufferReady), this._sourceBufferStuckTimer = setTimeout(()=>{
            this._eventBus.publish($dbaf12f73216aff4$var$kt.sourceBufferStuck, {});
        }, this.config.sourceBufferStuckTimeout);
    }
    destroy() {
        super.destroy();
        try {
            this._disarmSourceBufferStuckTimer(), this._sourceBuffer?.removeEventListener("updateend", this._onBufferReady), this._sourceBuffer?.abort();
        } catch (e) {
            this._logger.info("Source buffer cannot be aborted. Ignore it");
        }
        this._opsQueue = [];
    }
    removeSourceBuffer(e) {
        this._sourceBuffer && (this.immediatelyRecreateSourceBuffer(e), this._sourceBuffer.removeEventListener("updateend", this._onBufferReady), this._sourceBuffer = null);
    }
    addBufferOperation(e, t, r) {
        if (!this._sourceBuffer) return this._logger.warn(`There is no sourceBuffer defined. Operation (${r || "unknown"}) will be executed once sourceBuffer will be appended`), void this._opsQueue.push({
            operation: e,
            errorHandler: t
        });
        if (this._sourceBuffer.updating || this._opsQueue.length > 0) this._opsQueue.push({
            operation: e,
            errorHandler: t
        });
        else try {
            e(this._sourceBuffer);
        } catch (r) {
            t ? t(this._sourceBuffer, r) : (this._eventBus.publish($dbaf12f73216aff4$export$99d210b57a8acd4e.ERROR, {
                type: $dbaf12f73216aff4$var$Xt.MEDIA_ERROR,
                details: r
            }), this._logger.error(`Cannot recreate source buffer: ${r.toString()}, ${e}`));
        }
    }
    immediatelyRecreateSourceBuffer(e) {
        try {
            if (!this._sourceBuffer || !e || ![
                ...e.sourceBuffers
            ].includes(this._sourceBuffer)) return;
            this._disarmSourceBufferStuckTimer(), this._opsQueue = [], this._sourceBuffer.abort(), this._sourceBuffer.remove(0, Number.POSITIVE_INFINITY);
        } catch (e) {
            this._logger.error(`Cannot recreate source buffer: ${e.toString()}`);
        }
    }
    _recheckQueue() {
        if (!this._sourceBuffer || this._sourceBuffer.updating || !this._opsQueue.length) return;
        const e = this._opsQueue.shift();
        if (e) try {
            e.operation(this._sourceBuffer);
        } catch (t) {
            e.errorHandler ? e.errorHandler?.(this._sourceBuffer, t) : (this._logger.error(`Cannot perform source buffer operation: ${t.toString()} ${e}`), this._eventBus.publish($dbaf12f73216aff4$export$99d210b57a8acd4e.ERROR, {
                type: $dbaf12f73216aff4$var$Xt.MEDIA_ERROR,
                details: t
            }));
        }
        !this._sourceBuffer.updating && this._opsQueue.length && this._recheckQueue();
    }
    _onBufferReady() {
        this._recheckQueue(), this._disarmSourceBufferStuckTimer();
    }
    _disarmSourceBufferStuckTimer() {
        this._sourceBufferStuckTimer && clearTimeout(this._sourceBufferStuckTimer);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e5782f1e89bfd87$export$4f2bbf2cced9990c.prototype, "_onBufferReady", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5e5782f1e89bfd87$export$4f2bbf2cced9990c.prototype, "_disarmSourceBufferStuckTimer", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$df2305e98ea3787a$export$99845b89bd212bca extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _isPrevCheckStalled = !1;
    constructor(e){
        super("bufferStallsDetector", e), this._onBufferMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener);
    }
    _handleConfigUpdated() {}
    _onBufferMetricsAvailable({ isStallCandidate: e, bufferedTimeRanges: t, currentPlaybackPosition: r }) {
        const n = t.slice(-1)[0], i = n ? n.end - r : 0, s = e && i < this.config.bufferAmountToDetectStall;
        this._isPrevCheckStalled !== s && (this._isPrevCheckStalled = s, this._eventBus.publish($dbaf12f73216aff4$var$kt.playbackStallChanged, s));
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df2305e98ea3787a$export$99845b89bd212bca.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df2305e98ea3787a$export$99845b89bd212bca.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df2305e98ea3787a$export$99845b89bd212bca.prototype, "_onBufferMetricsAvailable", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
const $dbaf12f73216aff4$var$Jt = {
    lifecycleEvent: "debugger.lifecycleEvent",
    debuggerConnected: "debugger.connected"
}, $dbaf12f73216aff4$var$er = (e, t)=>(r)=>{
        t.publish($dbaf12f73216aff4$var$Jt.lifecycleEvent, {
            module: e,
            eventInfo: r,
            timestamp: Date.now()
        });
    };
let $dbaf12f73216aff4$var$tr;
var $dbaf12f73216aff4$var$rr;
($dbaf12f73216aff4$var$rr = $dbaf12f73216aff4$var$tr || ($dbaf12f73216aff4$var$tr = {})).UNKNOWN = "unknown", $dbaf12f73216aff4$var$rr.GAP = "gap", $dbaf12f73216aff4$var$rr.IN_RANGE = "inRange", $dbaf12f73216aff4$var$rr.END_OF_RANGE = "endOfRange";
class $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "buffer"
    ];
    _lastPlaybackPosition = 0;
    _videoElement = null;
    _numberOfDetectedStallCandidates = 0;
    constructor(e){
        super("bufferController", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - LiveGapController"), this._lifecycleEventReporter = $dbaf12f73216aff4$var$er("LiveGapController", this._eventBus), this._onBufferMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsReady);
    }
    setVideoElement(e) {
        this._videoElement = e;
    }
    removeVideoElement() {
        this._videoElement = null;
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onBufferMetricsReadyListener);
    }
    _handleConfigUpdated() {}
    _checkIfJumpNeeded(e) {
        let t = !1, r = $dbaf12f73216aff4$var$tr.UNKNOWN;
        const n = this._lastPlaybackPosition !== e.currentPlaybackPosition;
        this._lastPlaybackPosition = e.currentPlaybackPosition, n ? this._numberOfDetectedStallCandidates = 0 : this._numberOfDetectedStallCandidates += 1;
        const i = !e.bufferedTimeRanges.some(({ isCurrentTimeRange: e })=>e);
        return !n && this.config.numberOfCandidatesToDetectGap <= this._numberOfDetectedStallCandidates && (this._numberOfDetectedStallCandidates = 0, this._lifecycleEventReporter("Playback stalled"), this._logger.info("Playback position didnt changed since last check"), t = !0, r = e.currentTimeRange && e.currentTimeRange.end - e.currentPlaybackPosition < this.config.endOfRangeThreshold ? $dbaf12f73216aff4$var$tr.END_OF_RANGE : $dbaf12f73216aff4$var$tr.IN_RANGE), i && (this._lifecycleEventReporter("Gap detected"), this._logger.info("Gap detected"), t = !0, r = $dbaf12f73216aff4$var$tr.GAP), this.additionalInfo.isInLastBufferedRange = e.isInLastBufferedRange, this.additionalInfo.isPlaybackPositionChanged = n, this.additionalInfo.isInGap = i, this.additionalInfo.stuckType = r, {
            isJumpNeeded: t,
            stuckType: r
        };
    }
    _onBufferMetricsReady(e) {
        if (!e.bufferedTimeRanges.length || 0 === this._videoElement?.currentTime || this._videoElement?.paused) return;
        const { isJumpNeeded: t, stuckType: r } = this._checkIfJumpNeeded(e);
        return t ? (this._lifecycleEventReporter("Gap detected. Skipping it"), [
            $dbaf12f73216aff4$var$tr.END_OF_RANGE,
            $dbaf12f73216aff4$var$tr.GAP
        ].includes(r) ? this._jumpToNextRangeStart(e) : this._nudgePlayback(e)) : void 0;
    }
    _setNextPlaybackPosition(e) {
        this._videoElement && (this._videoElement.currentTime = e);
    }
    _jumpToNextRangeStart(e) {
        if (e.isInLastBufferedRange || e.currentPlaybackPosition >= e.bufferedTimeRanges.slice(-1)[0].end) return void this._nudgePlayback(e);
        const t = e.bufferedTimeRanges.find(({ start: t })=>t > e.currentPlaybackPosition);
        t ? (this._lifecycleEventReporter(`Jump to next range requested, jumping to ${t.start + .01}`), this._setNextPlaybackPosition(t.start + .01)) : this._nudgePlayback(e);
    }
    _nudgePlayback(e) {
        if (e.isOnBufferEdge) return;
        const t = e.currentPlaybackPosition + this.config.nudgePlaybackAmount;
        this._lifecycleEventReporter("Nudge playback position"), this._setNextPlaybackPosition(t);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09.prototype, "_onBufferMetricsReady", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$fdfa1bb54e0f3d32$export$c72b1932f177fbab extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "buffer"
    ];
    _videoElement = null;
    _fragments = [];
    _lastPlaybackPosition = 0;
    _numberOfDetectedStallCandidates = 0;
    constructor(e){
        super("bufferController", e), this._onBufferMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), this._onVODFragmentInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.vodFragmentsInfo, this._onVODFragmentsInfoAvailable);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onBufferMetricsReadyListener), this._eventBus.unsubscribe(this._onVODFragmentInfoAvailableListener);
    }
    setVideoElement(e) {
        this._videoElement = e;
    }
    removeVideoElement() {
        this._videoElement = null;
    }
    _handleConfigUpdated() {}
    _onVODFragmentsInfoAvailable(e) {
        this._fragments = e.map(({ fragmentEndTS: e, fragmentStartTS: t })=>({
                startTs: t,
                endTs: e
            }));
    }
    _onBufferMetricsAvailable(e) {
        if (!this._fragments.length || !e.bufferedTimeRanges || this._videoElement?.paused) return;
        const t = this._lastPlaybackPosition !== e.currentPlaybackPosition;
        this._lastPlaybackPosition = e.currentPlaybackPosition, t ? this._numberOfDetectedStallCandidates = 0 : this._numberOfDetectedStallCandidates += 1;
        const r = !e.bufferedTimeRanges.some(({ isCurrentTimeRange: e })=>e), n = !t && this.config.numberOfCandidatesToDetectGap <= this._numberOfDetectedStallCandidates;
        if (r || n) {
            const t = this._fragments.find(({ startTs: t })=>t > e.currentPlaybackPosition)?.startTs || -1, r = e.bufferedTimeRanges.find(({ start: t })=>t > e.currentPlaybackPosition)?.start || -1;
            t === r && this._videoElement && (this._videoElement.currentTime = r + .01, this._numberOfDetectedStallCandidates = 0);
        }
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$fdfa1bb54e0f3d32$export$c72b1932f177fbab.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$fdfa1bb54e0f3d32$export$c72b1932f177fbab.prototype, "_onVODFragmentsInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$fdfa1bb54e0f3d32$export$c72b1932f177fbab.prototype, "_onBufferMetricsAvailable", null);
class $dbaf12f73216aff4$var$$183bf5d7cfea5447$export$c02e13b4c15311c6 {
    groups = [
        "buffer"
    ];
    _liveGapController = null;
    _vodGapController = null;
    _videoElement = null;
    _isInVODMode = !1;
    constructor(e){
        this._eventBus = e, this._liveGapController = new $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09(this._eventBus), this._recreateGapController();
    }
    destroy() {
        this._vodGapController?.destroy(), this._liveGapController?.destroy();
    }
    setIsVod(e) {
        this._isInVODMode = e, this._recreateGapController();
    }
    setVideoElement(e) {
        this._videoElement = e, this._liveGapController && this._liveGapController.setVideoElement(e), this._vodGapController && this._vodGapController.setVideoElement(e);
    }
    removeVideoElement() {
        this._videoElement = null, this._liveGapController?.removeVideoElement(), this._vodGapController?.removeVideoElement();
    }
    _recreateGapController() {
        this._vodGapController?.destroy(), this._liveGapController?.destroy(), this._isInVODMode ? this._vodGapController = new $dbaf12f73216aff4$var$$fdfa1bb54e0f3d32$export$c72b1932f177fbab(this._eventBus) : this._liveGapController = new $dbaf12f73216aff4$var$$f99e0744617de48d$export$e33bbeb0d43aef09(this._eventBus), this._videoElement && this.setVideoElement(this._videoElement);
    }
    get status() {
        return this._vodGapController?.status || this._liveGapController?.status || "Idle";
    }
    get state() {
        return this._vodGapController?.state || this._liveGapController?.state || $dbaf12f73216aff4$var$Mt.OK;
    }
    get additionalInfo() {
        return this._vodGapController?.additionalInfo || this._liveGapController?.additionalInfo || {};
    }
}
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$nr = {
    targetBufferIncreaseRequested: "targetBuffer.targetBufferIncreaseRequested",
    targetBufferIncreased: "targetBuffer.targetBufferIncreased",
    targetBufferDecreaseRequested: "targetBuffer.targetBufferDecreaseRequested",
    originalTargetBufferDecreaseRequested: "targetBuffer.originalTargetBufferDecreaseRequested",
    originalTargetBufferDisable: "targetBuffer.originalTargetBufferDisable",
    targetBufferDecreased: "targetBuffer.targetBufferDecreased"
}, $dbaf12f73216aff4$var$ir = {
    setPlaybackSpeed: "playbackSpeed.setPlaybackSpeed"
};
class $dbaf12f73216aff4$var$$a1566a777200e261$export$5ee0f0d53c6212e3 {
    _registeredEvents = [];
    registerEvent() {
        this._registeredEvents.push(Date.now());
    }
    checkEventsInPeriod(e) {
        const t = Date.now() - e;
        return this._registeredEvents = this._registeredEvents.filter((e)=>e >= t), this._registeredEvents.length;
    }
    clear() {
        this._registeredEvents = [];
    }
}
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$65a546e1d84c1a88$export$c51d73b35eb67dab extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    _nextCheckTimestamp = 0;
    _currentMultiplier = 0;
    _increaseEventsCollector = new $dbaf12f73216aff4$var$$a1566a777200e261$export$5ee0f0d53c6212e3;
    constructor(e){
        super("originalTargetBufferDecreaser", e), this.additionalInfo = {
            isDecreasingDisabled: !1,
            currentMultiplier: this._currentMultiplier
        }, this._onTargetBufferIncreasedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.targetBufferIncreased, this._onTargetBufferIncreased), this._onBufferMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onTargetBufferIncreasedListener), this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener);
    }
    _updateIsDisabledAdditionalInfo() {
        this.additionalInfo.isDecreasingDisabled = !0;
    }
    _updateMultiplier() {
        this._currentMultiplier += 1, this.additionalInfo.currentMultiplier = this._currentMultiplier;
    }
    _onTargetBufferIncreased() {
        this._increaseEventsCollector.registerEvent(), this._eventBus.publish($dbaf12f73216aff4$var$nr.originalTargetBufferDisable, {}), this._updateIsDisabledAdditionalInfo();
    }
    _onBufferMetricsAvailable() {
        0 !== this._nextCheckTimestamp && this._nextCheckTimestamp < performance.now() && this.config.allowTargetBufferDecrease && 0 === this._increaseEventsCollector.checkEventsInPeriod(this.config.targetBufferDecreaseTimeout) && this._currentMultiplier < this.config.maxTargetBufferMultiplier && (this._eventBus.publish($dbaf12f73216aff4$var$nr.originalTargetBufferDecreaseRequested, {}), this._updateMultiplier(), this._nextCheckTimestamp = performance.now() + this.config.targetBufferDecreaseTimeout), this._nextCheckTimestamp = 0 === this._nextCheckTimestamp ? performance.now() + this.config.targetBufferDecreaseTimeout : this._nextCheckTimestamp;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$65a546e1d84c1a88$export$c51d73b35eb67dab.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$65a546e1d84c1a88$export$c51d73b35eb67dab.prototype, "_onTargetBufferIncreased", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$65a546e1d84c1a88$export$c51d73b35eb67dab.prototype, "_onBufferMetricsAvailable", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
let $dbaf12f73216aff4$var$sr;
var $dbaf12f73216aff4$var$ar;
($dbaf12f73216aff4$var$ar = $dbaf12f73216aff4$var$sr || ($dbaf12f73216aff4$var$sr = {})).FAST = "fast", $dbaf12f73216aff4$var$ar.NORMAL = "normal", $dbaf12f73216aff4$var$ar.SLOW = "slow";
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$70cef6d7b5d2a813$export$c6735ef8fc483cce extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    _videoElement = null;
    _currentPlaybackSpeed = $dbaf12f73216aff4$var$sr.NORMAL;
    constructor(e){
        super("playbackSpeedActuator", e), this._onPlaybackSpeedChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ir.setPlaybackSpeed, this._onPlaybackSpeedChanged);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onPlaybackSpeedChangedListener);
    }
    setVideoElement(e) {
        this._videoElement = e, this._setPlaybackSpeed();
    }
    _handleConfigUpdated() {
        this._setPlaybackSpeed();
    }
    _onPlaybackSpeedChanged(e) {
        this._currentPlaybackSpeed = e, this._setPlaybackSpeed();
    }
    _setPlaybackSpeed() {
        if (!this._videoElement) return;
        const e = {
            [$dbaf12f73216aff4$var$sr.FAST]: this.config.maxPlaybackRate,
            [$dbaf12f73216aff4$var$sr.NORMAL]: 1,
            [$dbaf12f73216aff4$var$sr.SLOW]: this.config.minPlaybackRate
        };
        this._videoElement.playbackRate = e[this._currentPlaybackSpeed];
    }
    get additionalInfo() {
        return {
            currentPlaybackMode: this._currentPlaybackSpeed
        };
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70cef6d7b5d2a813$export$c6735ef8fc483cce.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70cef6d7b5d2a813$export$c6735ef8fc483cce.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70cef6d7b5d2a813$export$c6735ef8fc483cce.prototype, "_onPlaybackSpeedChanged", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$or = {
    getPlaybackSpeedControllerMetrics: "getSideMetricsAsyncEvents.getPlaybackSpeedControllerMetrics",
    playbackSpeedControllerMetricsAvailable: "getSideMetricsAsyncEvents.playbackSpeedControllerMetricsAvailable",
    getPlayingTimeFraction: "getSideMetricsAsyncEvents.getPlayingTimeFraction",
    getPlayingTimeFractionAvailable: "getSideMetricsAsyncEvents.getPlayingTimeFractionAvailable"
}, $dbaf12f73216aff4$var$lr = {
    fragments: {
        fragmentLoaded: "fragmentLoader.fragments.fragmentLoaded",
        fragmentLoadingStarted: "fragmentLoader.fragments.fragmentLoadingStarted",
        fragmentLoadingAborted: "fragmentLoader.fragments.fragmentLoadingAborted",
        fragmentLoadingError: "fragmentLoader.fragments.fragmentLoadingError",
        fragmentHistoryReadyForPrint: "fragmentLoader.fragments.fragmentHistoryReadyForPrint"
    }
}, $dbaf12f73216aff4$var$ur = {
    fragmentLoader: $dbaf12f73216aff4$var$lr,
    playlistRotator: $dbaf12f73216aff4$var$Ft,
    streamLoader: {
        playlistRotatorTypeChanged: "streamLoader.playlistRotatorTypeChanged"
    }
}, $dbaf12f73216aff4$var$dr = (e, t)=>e.partHoldBack || e.serverControl?.partHoldBack || e.serverControl?.holdBack || t;
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    _originalTargetBuffer = 2;
    _currentTargetBufferMultiplier = 1;
    _currentPlaybackRateMode = $dbaf12f73216aff4$var$sr.NORMAL;
    _isPaused = !1;
    _isDecriseable = !0;
    _currentOriginalTargetBufferMultiplier = 0;
    constructor(e){
        super("playbackSpeedWatcher", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - PlaybackSpeedWatcher"), this._onBufferMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), this._onTargetBufferDecreaseRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.targetBufferDecreaseRequested, this._targetBufferDecreaseRequested), this._onTargetBufferIncreaseRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.targetBufferIncreaseRequested, this._targetBufferIncreaseRequested), this._onPlaylistInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlists.playlistInfo, this._onPlaylistInfoAvailable), this._onPlaybackSpeedControllerMetricsRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$or.getPlaybackSpeedControllerMetrics, this._onPlaybackSpeedControllerMetricsRequested), this._onOriginalTargetBufferDecreaseRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.originalTargetBufferDecreaseRequested, this._originalTargetBufferDecreaseRequested), this._onOriginalTargetBufferDecreaseDisableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.originalTargetBufferDisable, this._onOriginalTargetBufferDecreaseDisable), this.config.targetBufferInitialMultiplier && this.config.targetBufferInitialMultiplier < 1 && this._logger.warn("Target buffer multiplier set to value lower than 1. It is unsafe to load less than target-duration, forcing no multiplier instead");
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onBufferMetricsReadyListener), this._eventBus.unsubscribe(this._onTargetBufferDecreaseRequestedListener), this._eventBus.unsubscribe(this._onTargetBufferIncreaseRequestedListener), this._eventBus.unsubscribe(this._onPlaylistInfoAvailableListener), this._eventBus.unsubscribe(this._onPlaybackSpeedControllerMetricsRequestedListener), this._eventBus.unsubscribe(this._onOriginalTargetBufferDecreaseRequestedListener), this._eventBus.unsubscribe(this._onOriginalTargetBufferDecreaseDisableListener);
    }
    pause() {
        this._isPaused = !0, this._setNewPlaybackRateMode($dbaf12f73216aff4$var$sr.NORMAL);
    }
    resume() {
        this._isPaused = !1;
    }
    _handleConfigUpdated() {}
    _setNewPlaybackRateMode(e) {
        this._currentPlaybackRateMode !== e && (this._currentPlaybackRateMode = e, this._eventBus.publish($dbaf12f73216aff4$var$ir.setPlaybackSpeed, e));
    }
    _onBufferMetricsAvailable(e) {
        if (this._isPaused) return;
        const t = this._getTargetBuffer(), r = e.bufferAmountWithoutGaps - t;
        0 !== e.currentPlaybackPosition && (r > this.config.maxLiveSyncThreshold * t ? this._setNewPlaybackRateMode($dbaf12f73216aff4$var$sr.FAST) : -1 * r > this.config.minLiveSyncThreshold * t ? this._setNewPlaybackRateMode($dbaf12f73216aff4$var$sr.SLOW) : (this._currentPlaybackRateMode === $dbaf12f73216aff4$var$sr.SLOW && r > 0 || this._currentPlaybackRateMode === $dbaf12f73216aff4$var$sr.FAST && r < 0) && this._setNewPlaybackRateMode($dbaf12f73216aff4$var$sr.NORMAL));
    }
    _targetBufferIncreaseRequested() {
        this._currentTargetBufferMultiplier < this.config.maxTargetBufferMultiplier && (this._currentTargetBufferMultiplier += 1, this._eventBus.publish($dbaf12f73216aff4$var$nr.targetBufferIncreased, {}));
    }
    _targetBufferDecreaseRequested() {
        this._currentTargetBufferMultiplier > 1 && (this._currentTargetBufferMultiplier -= 1, this._eventBus.publish($dbaf12f73216aff4$var$nr.targetBufferIncreased, {}));
    }
    _onPlaylistInfoAvailable(e) {
        this._originalTargetBuffer = $dbaf12f73216aff4$var$dr(e, 3 * e.targetDuration);
    }
    _onPlaybackSpeedControllerMetricsRequested() {
        this._eventBus.publish($dbaf12f73216aff4$var$or.playbackSpeedControllerMetricsAvailable, this._getTargetBuffer());
    }
    _getTargetBuffer() {
        return this._isDecriseable ? this._originalTargetBuffer - this._currentOriginalTargetBufferMultiplier * this.config.targetBufferDecreaseCoefficient : this._originalTargetBuffer * this._currentTargetBufferMultiplier * this.config.targetBufferInitialMultiplier;
    }
    get additionalInfo() {
        return {
            currentTargetBufferMultiplier: this._currentTargetBufferMultiplier,
            currentTargetBuffer: this._getTargetBuffer()
        };
    }
    _originalTargetBufferDecreaseRequested() {
        this._currentOriginalTargetBufferMultiplier += 1;
    }
    _onOriginalTargetBufferDecreaseDisable() {
        this._isDecriseable = !1;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_onBufferMetricsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_targetBufferIncreaseRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_targetBufferDecreaseRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_onPlaylistInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_onPlaybackSpeedControllerMetricsRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_originalTargetBufferDecreaseRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc.prototype, "_onOriginalTargetBufferDecreaseDisable", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    additionalInfo = {};
    currentTargetBufferMultiplier = 1;
    _nextCheckTimestamp = 0;
    _currentPlaybackRateMode = $dbaf12f73216aff4$var$sr.NORMAL;
    _slowdownEventsCollector = new $dbaf12f73216aff4$var$$a1566a777200e261$export$5ee0f0d53c6212e3;
    constructor(e){
        super("targetBufferDecreaser", e), this._onPlaybackRateModeChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ir.setPlaybackSpeed, this._onPlaybackRateModeChanged), this._onBufferMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), this._onTargetBufferIncreasedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$nr.targetBufferIncreased, this._onTargetBufferIncreased);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onPlaybackRateModeChangedListener), this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener), this._eventBus.unsubscribe(this._onTargetBufferIncreasedListener);
    }
    _handleConfigUpdated() {}
    _onPlaybackRateModeChanged(e) {
        e === this._currentPlaybackRateMode || e !== $dbaf12f73216aff4$var$sr.SLOW && this._currentPlaybackRateMode !== $dbaf12f73216aff4$var$sr.SLOW || this._slowdownEventsCollector.registerEvent(), this._currentPlaybackRateMode = e;
    }
    _onBufferMetricsAvailable() {
        0 !== this._nextCheckTimestamp && this._nextCheckTimestamp < Date.now() && this.currentTargetBufferMultiplier > 1 && this._currentPlaybackRateMode !== $dbaf12f73216aff4$var$sr.SLOW && 0 === this._slowdownEventsCollector.checkEventsInPeriod(this.config.periodOfEventsToCancelDecrease) && (this._eventBus.publish($dbaf12f73216aff4$var$nr.targetBufferDecreaseRequested, {}), this.currentTargetBufferMultiplier -= 1, this._nextCheckTimestamp = this.currentTargetBufferMultiplier > 1 ? Date.now() + this.config.periodOfEventsToCancelDecrease : 0);
    }
    _onTargetBufferIncreased() {
        this.currentTargetBufferMultiplier += 1, this._nextCheckTimestamp = Date.now() + this.config.periodOfEventsToCancelDecrease;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5.prototype, "_onPlaybackRateModeChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5.prototype, "_onBufferMetricsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5.prototype, "_onTargetBufferIncreased", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$55af34cc4ae7f467$export$9d3173f3a0bdb071 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    _hasFallenBelowLine = !0;
    constructor(e){
        super("targetBufferIncreaser", e), this._onBufferMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener);
    }
    _handleConfigUpdated() {}
    _onBufferMetricsAvailable(e) {
        this._hasFallenBelowLine ? 1e3 * e.bufferAmountWithoutGaps >= this.config.bufferAmountThreshold && (this._hasFallenBelowLine = !1) : 1e3 * e.bufferAmountWithoutGaps < this.config.bufferAmountToIncrease && (this._hasFallenBelowLine = !0, this._eventBus.publish($dbaf12f73216aff4$var$nr.targetBufferIncreaseRequested, {}));
    }
    get additionalInfo() {
        return {
            hasFallenBelowLine: this._hasFallenBelowLine
        };
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$55af34cc4ae7f467$export$9d3173f3a0bdb071.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$55af34cc4ae7f467$export$9d3173f3a0bdb071.prototype, "_onBufferMetricsAvailable", null);
class $dbaf12f73216aff4$var$$c2af732bfbf031c8$export$86796fbb0fba9474 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "PlaybackSpeed"
    ];
    additionalInfo = {};
    constructor(e){
        this._eventBus = e, this._playbackSpeedActuator = new $dbaf12f73216aff4$var$$70cef6d7b5d2a813$export$c6735ef8fc483cce(this._eventBus), this._playbackSpeedWatcher = new $dbaf12f73216aff4$var$$2515bc070ae27704$export$35f7c08672e083fc(this._eventBus), this._targetBufferDecreaser = new $dbaf12f73216aff4$var$$e806ba744bad5d35$export$3c09f7f26ed8a4c5(this._eventBus), this._targetBufferIncreaser = new $dbaf12f73216aff4$var$$55af34cc4ae7f467$export$9d3173f3a0bdb071(this._eventBus), this._originalTargetBufferDecreaser = new $dbaf12f73216aff4$var$$65a546e1d84c1a88$export$c51d73b35eb67dab(this._eventBus);
    }
    setVideoElement(e) {
        this._playbackSpeedActuator.setVideoElement(e);
    }
    removeVideoElement() {
        this._playbackSpeedActuator.setVideoElement(null);
    }
    pause() {
        this._playbackSpeedWatcher.pause();
    }
    resume() {
        this._playbackSpeedWatcher.resume();
    }
    destroy() {
        this._playbackSpeedActuator.destroy(), this._playbackSpeedWatcher.destroy(), this._targetBufferDecreaser.destroy(), this._targetBufferIncreaser.destroy(), this._originalTargetBufferDecreaser.destroy();
    }
    get additionalModules() {
        return {
            playbackSpeedActuator: this._playbackSpeedActuator,
            playbackSpeedWatcher: this._playbackSpeedWatcher,
            targetBufferIncreaser: this._targetBufferIncreaser,
            targetBufferDecreaser: this._targetBufferDecreaser,
            originalTargetBufferDecreaser: this._originalTargetBufferDecreaser
        };
    }
}
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
let $dbaf12f73216aff4$export$af29ccb356acd9fc;
var $dbaf12f73216aff4$var$hr;
($dbaf12f73216aff4$var$hr = $dbaf12f73216aff4$export$af29ccb356acd9fc || ($dbaf12f73216aff4$export$af29ccb356acd9fc = {})).IDLE = "idle", $dbaf12f73216aff4$var$hr.LOADING = "loading", $dbaf12f73216aff4$var$hr.PLAYING = "playing", $dbaf12f73216aff4$var$hr.PAUSED = "paused", $dbaf12f73216aff4$var$hr.ERROR = "error";
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _currentState = $dbaf12f73216aff4$export$af29ccb356acd9fc.IDLE;
    _numberOfStallsOnEdge = 0;
    _videoElement = null;
    _syncOnNextMetrics = !1;
    _isInStall = !1;
    _targetLiveEdge = 6;
    _stallTS = 0;
    _startTS = 0;
    _stalledTimeRanges = [];
    _stallsToChangeState = 3;
    constructor(e){
        super("playbackStateController", e), this._onPlaybackMetricsReadyListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onMetricsAvailable), this._onResolutionChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this.reset), this._onFragmentRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingStarted, this._onFragmentRequested), this._onPlaylistInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlists.playlistInfo, this._onPlaylistInfoAvailable), this._onPlayingTimeFractionRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$or.getPlayingTimeFraction, this._onPlayingTimeFractionRequested);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onPlaybackMetricsReadyListener), this._eventBus.unsubscribe(this._onResolutionChangedListener), this._eventBus.unsubscribe(this._onFragmentRequestedListener), this._eventBus.unsubscribe(this._onPlaylistInfoAvailableListener), this._eventBus.unsubscribe(this._onPlayingTimeFractionRequestedListener), this._videoElement?.removeEventListener("canplaythrough", this._onCanPlayThrough), this._videoElement?.removeEventListener("play", this._onPlay), this._videoElement?.removeEventListener("playing", this._onPlaying);
    }
    setVideoElement(e) {
        this._videoElement && (this._videoElement.removeEventListener("canplaythrough", this._onCanPlayThrough), this._videoElement?.removeEventListener("play", this._onPlay), this._videoElement?.removeEventListener("playing", this._onPlaying)), this._videoElement = e, this._videoElement?.addEventListener("canplaythrough", this._onCanPlayThrough), this._videoElement?.addEventListener("play", this._onPlay), this._videoElement?.addEventListener("playing", this._onPlaying);
    }
    reset() {
        this._currentState = $dbaf12f73216aff4$export$af29ccb356acd9fc.IDLE, this._numberOfStallsOnEdge = 0;
    }
    resetPlayingTimeCollector() {
        this._stallTS = 0, this._startTS = 0, this._stalledTimeRanges = [];
    }
    _handleConfigUpdated() {}
    _setNextState(e) {
        e !== this._currentState && (this._eventBus.publish($dbaf12f73216aff4$var$kt.playbackStateChanged, {
            prevState: this._currentState,
            nextState: e
        }), this._currentState = e);
    }
    _onFragmentRequested() {
        this._currentState === $dbaf12f73216aff4$export$af29ccb356acd9fc.IDLE && this._setNextState($dbaf12f73216aff4$export$af29ccb356acd9fc.LOADING);
    }
    _onMetricsAvailable(e) {
        if (this._syncOnNextMetrics && e.bufferedTimeRanges.length && (this._syncOnNextMetrics = !1, this._syncToLiveEdge(e.bufferedTimeRanges.slice(-1)[0].end)), this._currentState === $dbaf12f73216aff4$export$af29ccb356acd9fc.IDLE) return;
        this._isInStall !== e.isStallCandidate && (this._isInStall = e.isStallCandidate, e.isStallCandidate ? this._onStall() : this._onPlaying());
        const t = 0 === e.playbackPositionDelta && e.isOnBufferEdge;
        if (!t) return this._numberOfStallsOnEdge = 0, void this._setNextState($dbaf12f73216aff4$export$af29ccb356acd9fc.PLAYING);
        t && this._currentState === $dbaf12f73216aff4$export$af29ccb356acd9fc.PLAYING && this._numberOfStallsOnEdge++, this._numberOfStallsOnEdge >= this._stallsToChangeState && this._setNextState($dbaf12f73216aff4$export$af29ccb356acd9fc.PAUSED), this._isInStall && this.config.stallDurationToDisableTargetBufferDecrease <= Date.now() - this._stallTS && this._eventBus.publish($dbaf12f73216aff4$var$nr.originalTargetBufferDisable, {});
    }
    _onCanPlayThrough() {
        this._startTS || (this._startTS = Date.now()), this.config.autoPlay && this._videoElement?.play();
    }
    _onPlaylistInfoAvailable(e) {
        this._targetLiveEdge = $dbaf12f73216aff4$var$dr(e, 3 * e.targetDuration);
    }
    _onPlay() {
        this.config.syncToLiveEdge && this._videoElement && (this._videoElement.buffered.length ? this._syncToLiveEdge(this._videoElement.buffered.end(this._videoElement.buffered.length - 1)) : this._syncOnNextMetrics = !0);
    }
    _getDesiredPosition(e) {
        return e - this.config.syncToLiveDelta * this._targetLiveEdge;
    }
    _syncToLiveEdge(e) {
        if (!this._videoElement || !this._videoElement?.buffered.length) return;
        const t = this._getDesiredPosition(e);
        t > this._videoElement.buffered.start(0) && t > this._videoElement.currentTime && (this._videoElement.currentTime = t);
    }
    _onPlaying() {
        this._stallTS && (this._stalledTimeRanges.push({
            startTS: this._stallTS,
            endTS: Date.now()
        }), this._stallTS = 0);
    }
    _onStall() {
        this._stallTS = Date.now();
    }
    _onPlayingTimeFractionRequested() {
        const e = this._calculatePlayingTimeFraction();
        this._eventBus.publish($dbaf12f73216aff4$var$or.getPlayingTimeFractionAvailable, e);
    }
    _calculatePlayingTimeFraction() {
        if (!this._startTS) return null;
        const e = Date.now() - this.config.playingTimeFractionCollectionWindow;
        this._stalledTimeRanges = this._stalledTimeRanges.filter(({ endTS: t })=>t > e);
        const t = Date.now() - this._startTS, r = t - this._stalledTimeRanges.reduce((e, t)=>e + (t.endTS - t.startTS), 0) - (this._stallTS ? Date.now() - this._stallTS : 0);
        return this._startTS = Date.now(), r / t;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "reset", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onFragmentRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onMetricsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onCanPlayThrough", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onPlaylistInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onPlay", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onPlaying", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af.prototype, "_onPlayingTimeFractionRequested", null);
const $dbaf12f73216aff4$var$fr = {
    fragments: {
        fragmentsParsed: "fragmentParser.fragments.fragmentsParsed",
        videoFragmentParsed: "fragmentParser.fragments.videoFragmentParsed",
        audioFragmentParsed: "fragmentParser.fragments.audioFragmentParsed"
    }
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$63b11d0241e1eeff$export$e6b010bf8f7a0c59 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _cache = [];
    _lastMsn = -1;
    constructor(e){
        super("bufferController", e);
    }
    append(e) {
        for (const t of e)if (this._cache.length) {
            if (t.msn !== this._lastMsn) {
                const e = t.msn - this.config.saveLastSegmentsCount + 1;
                this._cache = [
                    ...this._cache.filter((t)=>t.isInitSection || t.msn >= e),
                    t
                ];
            } else this._cache.push(t);
            this._lastMsn = t.msn;
        } else t.isInitSection && (this._cache = [
            t
        ]);
    }
    getAll() {
        return this._cache;
    }
    reset() {
        this._cache = [], this._lastMsn = -1;
    }
    destroy() {
        super.destroy(), this._cache = [], this._lastMsn = -1;
    }
}
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$_r = (e)=>new Promise((t)=>{
        e.publish($dbaf12f73216aff4$var$or.getPlayingTimeFraction, {}), e.subscribeOnce($dbaf12f73216aff4$var$or.getPlayingTimeFractionAvailable, (e)=>{
            t(e);
        });
    });
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$0a1e6289d75dd2dd$export$3deee27db14f5576 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "buffer",
        "general"
    ];
    additionalInfo = {};
    _videoElement = null;
    _checkIntervalId = null;
    _lastCheckTimestamp = 0;
    _lastFramesTotal = 0;
    _lastFramesDropped = 0;
    _lastFramesPlayed = 0;
    _lastRealFPS = 0;
    _lastPlaybackFPS = 0;
    _lastPlaybackPosition = 0;
    _lastBufferAmount = 0;
    constructor(e){
        super("bufferController", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - BufferMetrics");
    }
    destroy() {
        this._checkIntervalId && globalThis.clearInterval(this._checkIntervalId);
    }
    setVideoElement(e) {
        this._videoElement = e, this._rearmInterval();
    }
    removeVideoElement() {
        this._videoElement = null, this._checkIntervalId && globalThis.clearInterval(this._checkIntervalId);
    }
    _handleConfigUpdated(e) {
        Number.isNaN(e.checkMetricsInterval) || this._rearmInterval();
    }
    _rearmInterval() {
        this._checkIntervalId && globalThis.clearInterval(this._checkIntervalId), this._checkIntervalId = globalThis.setInterval(this._performCheck, this.config.checkMetricsInterval);
    }
    _getCurrentBufferAmount(e) {
        if (!this._videoElement) return this._logger.warn("Cannot compute buffer, there is no video element registered"), 0;
        const { currentTime: t, buffered: r } = this._videoElement;
        return 0 === r.length || t > r.end(r.length - 1) ? 0 : e ? r.end(r.length - 1) - t : 0;
    }
    _getCurrentBufferAmountWithoutGaps(e, t) {
        if (!this._videoElement) return this._logger.warn("Cannot compute buffer, there is no video element registered"), 0;
        if (!e) return 0;
        const { currentTime: r } = this._videoElement;
        return e.end - r + t.filter(({ start: t })=>t >= e.end).reduce((e, t)=>e + (t.end - t.start), 0);
    }
    async _performCheck() {
        if (!this._videoElement) return this._checkIntervalId && globalThis.clearInterval(this._checkIntervalId), void this._logger.warn("Cannot compute metrics, there is no video element registered");
        const { creationTime: e, totalVideoFrames: t, droppedVideoFrames: r } = this._videoElement.getVideoPlaybackQuality(), { buffered: n, currentTime: i, paused: s, duration: a, playbackRate: o } = this._videoElement, l = e / 1e3;
        if (!this._lastCheckTimestamp) return this._lastCheckTimestamp = l, this._lastFramesTotal = t, this._lastFramesDropped = r, this._lastFramesPlayed = t - r, void (this._lastPlaybackPosition = i);
        const u = await (d = this._eventBus, new Promise((e)=>{
            d.publish($dbaf12f73216aff4$var$or.getPlaybackSpeedControllerMetrics, {}), d.subscribeOnce($dbaf12f73216aff4$var$or.playbackSpeedControllerMetricsAvailable, (t)=>{
                e(t);
            });
        }));
        var d;
        const c = await $dbaf12f73216aff4$var$_r(this._eventBus) || 0, h = t - r, f = l - this._lastCheckTimestamp, _ = i - this._lastPlaybackPosition, g = t - this._lastFramesTotal, p = r - this._lastFramesDropped, m = h - this._lastFramesPlayed, b = g / f, v = g / _, y = this._lastRealFPS - b, E = this._lastPlaybackFPS - v, S = Array(n.length).fill(null).map((e, t)=>{
            const r = {
                start: n.start(t),
                end: n.end(t),
                index: t,
                isCurrentTimeRange: !1
            };
            return (r.start <= i && i <= r.end || s && 0 === t) && (r.isCurrentTimeRange = !0), r;
        }), R = S.find(({ isCurrentTimeRange: e })=>e) || null, T = this._getCurrentBufferAmount(R), A = T < this.config.bufferEdgeThreshold, L = i > 0 && !s && (T < this.config.bufferStallThreshold || 0 === _), $ = R?.index === S.length - 1, B = this._getCurrentBufferAmountWithoutGaps(R, S), P = {
            currentTimestamp: e,
            currentPlaybackPosition: i,
            playedVideoFrames: h,
            totalVideoFramesDelta: g,
            droppedVideoFramesDelta: p,
            playedVideoFramesDelta: m,
            playbackSpeed: o,
            isOnBufferEdge: A,
            bufferAmount: T,
            bufferAmountWithoutGaps: B,
            latency: 0,
            totalVideoFrames: t,
            droppedVideoFrames: r,
            realFPS: b,
            playbackFPS: v,
            timeDelta: f,
            playbackPositionDelta: _,
            playingTimeFraction: c,
            realFPSDelta: y,
            playbackFPSDelta: E,
            isStallCandidate: L,
            bufferedTimeRanges: S,
            currentTimeRange: R,
            isInLastBufferedRange: $,
            knownDuration: a,
            isPaused: s,
            targetBuffer: u
        };
        this._lastCheckTimestamp = l, this._lastFramesTotal = t, this._lastFramesDropped = r, this._lastFramesPlayed = t - r, this._lastRealFPS = b, this._lastPlaybackFPS = v, this._lastPlaybackPosition = i, this._lastBufferAmount = T, this._eventBus.publish($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, P), this.additionalInfo = P;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0a1e6289d75dd2dd$export$3deee27db14f5576.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0a1e6289d75dd2dd$export$3deee27db14f5576.prototype, "_performCheck", null);
const $dbaf12f73216aff4$var$gr = (e)=>`video/mp4; codecs="${e}"`;
class $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "buffer",
        "general"
    ];
    _sourceBuffer = null;
    _isSourceBufferReady = !1;
    _awaitingForNextSourceBuffer = !1;
    _isVODMode = !1;
    _closeOnNextSegment = !1;
    _currentVideoDuration = Number.POSITIVE_INFINITY;
    _videoElement = null;
    _mediaSource = null;
    _knownObjectURL = "";
    _mimeType = 'video/mp4; codecs="mp4a.40.2,avc1.64001f"';
    _shouldRecreateSourceBufferOnStall = !1;
    _sourceBufferStuckTimer = null;
    constructor(e){
        super("bufferController", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - BufferController"), this._logger.info("Created"), this._eventBus = e, this._bufferCleaner = new $dbaf12f73216aff4$var$$5e42036442ea87f2$export$28184ad99c81dbd1(this._eventBus), this._bufferMetrics = new $dbaf12f73216aff4$var$$0a1e6289d75dd2dd$export$3deee27db14f5576(this._eventBus), this._bufferStallsDetector = new $dbaf12f73216aff4$var$$df2305e98ea3787a$export$99845b89bd212bca(this._eventBus), this._bufferOpsQueue = new $dbaf12f73216aff4$var$$5e5782f1e89bfd87$export$4f2bbf2cced9990c(this._eventBus), this._playbackSpeedController = new $dbaf12f73216aff4$var$$c2af732bfbf031c8$export$86796fbb0fba9474(this._eventBus), this._playbackStateController = new $dbaf12f73216aff4$var$$66ef3315720ffbb3$export$ee3ff0e893c021af(this._eventBus), this._bufferChunksCache = new $dbaf12f73216aff4$var$$63b11d0241e1eeff$export$e6b010bf8f7a0c59(this._eventBus), this._onFragmentParsedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$fr.fragments.fragmentsParsed, this._onFragmentsParsed), this._onSoftResetRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.requestResetWithOverplay, this._onSoftResetRequested), this._onVODPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.vodDetected, this._onVODPlaylistDetected), this._onSimplePlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.simpleDetected, this._onLivePlaylistDetected), this._onLLPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.llDetected, this._onLivePlaylistDetected), this._onSourceBufferOperationRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.requestSourceBufferOperation, this._onSourceBufferOperationRequested), this._onPlaylistInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlists.playlistInfo, this._onPlaylistInfoAvailable), this._onEndOfStreamReachedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.endOfStreamReached, this._onEndOfStreamReached), this._onResolutionCodecChangeRequestListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.changeCodec, this._onResolutionCodecChangeRequest), this._onResolutionChangeListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChange), this._onPlaybackStallChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.playbackStallChanged, this._onPlaybackStallChanged), this._onSourceBufferStuckListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.sourceBufferStuck, this._onSourceBufferStuck), this._gapController = new $dbaf12f73216aff4$var$$183bf5d7cfea5447$export$c02e13b4c15311c6(this._eventBus);
    }
    attachVideoElement(e) {
        this._logger.info("Attach video element", e), this._bufferMetrics.setVideoElement(e), this._playbackSpeedController.setVideoElement(e), this._gapController.setVideoElement(e), this._bufferCleaner.setVideoElement(e), this._playbackStateController.setVideoElement(e), this._videoElement = e, this._recreateMediaSource();
    }
    scheduleSourceBufferRecreation() {
        this._awaitingForNextSourceBuffer = !0;
    }
    detachVideoElement() {
        if (this._logger.info("Detaching video element"), this._eventBus.publish($dbaf12f73216aff4$var$kt.requestResetWithOverplay, {}), this._bufferMetrics.removeVideoElement(), this._playbackSpeedController.removeVideoElement(), this._gapController.removeVideoElement(), this._bufferCleaner.removeVideoElement(), this._playbackStateController.setVideoElement(null), "open" === this._mediaSource?.readyState && this._videoElement && this._videoElement.readyState >= this._videoElement.HAVE_METADATA) try {
            this._logger.verbose("Calling endOfStream of mediaSource"), this._mediaSource.endOfStream();
        } catch (e) {
            this._logger.warn(`Error occurred while detaching video element. Ignoring it ${e.message}`);
        }
        try {
            this._mediaSource && this._sourceBuffer && ([
                ...this._mediaSource.sourceBuffers
            ].includes(this._sourceBuffer) && (this._logger.debug("Removing sourceBuffer from MediaSource"), this._mediaSource.removeSourceBuffer(this._sourceBuffer)), this._sourceBuffer = null);
        } catch (e) {
            this._logger.error(`Failed to reset source buffer ${e.message}`);
        }
        if (this._mediaSource && (this._mediaSource.removeEventListener("sourceopen", this._onSourceBufferOpened), this._mediaSource.removeEventListener("sourceclose", this._onSourceBufferClosed), this._mediaSource.removeEventListener("error", this._onSourceBufferError)), this._videoElement) {
            if (this._knownObjectURL) {
                const e = this._knownObjectURL;
                setTimeout(()=>{
                    this._logger.debug(`Revoking Object URL ${e}`), globalThis.URL.revokeObjectURL(e);
                }, 100);
            }
            this._videoElement.src === this._knownObjectURL && (this._videoElement.removeAttribute("src"), this._videoElement.load());
        }
        this._mediaSource = null, this._videoElement = null, this._knownObjectURL = "", this._isSourceBufferReady = !1;
    }
    destroy() {
        super.destroy(), this._logger.info("Destroy"), this.detachVideoElement(), this._eventBus.unsubscribe(this._onFragmentParsedListener), this._eventBus.unsubscribe(this._onSoftResetRequestedListener), this._eventBus.unsubscribe(this._onSourceBufferOperationRequestedListener), this._eventBus.unsubscribe(this._onVODPlaylistDetectedListener), this._eventBus.unsubscribe(this._onSimplePlaylistDetectedListener), this._eventBus.unsubscribe(this._onLLPlaylistDetectedListener), this._eventBus.unsubscribe(this._onPlaylistInfoAvailableListener), this._eventBus.unsubscribe(this._onEndOfStreamReachedListener), this._eventBus.unsubscribe(this._onResolutionCodecChangeRequestListener), this._eventBus.unsubscribe(this._onResolutionChangeListener), this._eventBus.unsubscribe(this._onPlaybackStallChangedListener), this._eventBus.unsubscribe(this._onSourceBufferStuckListener), this._gapController.destroy(), this._bufferMetrics.destroy(), this._bufferOpsQueue.destroy(), this._bufferCleaner.destroy(), this._playbackSpeedController.destroy(), this._playbackStateController.destroy(), this._bufferChunksCache.destroy(), this._disarmSourceBufferStuckTimer();
    }
    reset() {
        this._disarmSourceBufferStuckTimer(), this._recreateSourceBuffer(), this._bufferChunksCache.reset();
    }
    _onFragmentsParsed(e) {
        this._awaitingForNextSourceBuffer && (this._awaitingForNextSourceBuffer = !1, this._recreateSourceBuffer()), this._bufferOpsQueue.addBufferOperation(()=>{
            this._mediaSource && "open" === this._mediaSource.readyState && (this._mediaSource.duration = this._currentVideoDuration);
        }, ()=>{
            this._logger.warn("Could not set mediaSource duration");
        }, "setMediaSourceDuration");
        for (const t of e)this._bufferOpsQueue.addBufferOperation((e)=>{
            this._logger.debug(`Adding ${t.getMsnPn()} to buffer`), e.appendBuffer(t.data), t.msn > -1 && (this._logger.debug(`${t.startTs} -> ${t.endTs} loaded (${t.getMsnPn()})`), this._eventBus.publish($dbaf12f73216aff4$var$kt.fragmentAdded, t)), this._mediaSource && t.endTs === this._mediaSource.duration && this._eventBus.publish($dbaf12f73216aff4$var$kt.endOfStreamReached, {});
        }, (e, r)=>{
            this._logger.error(`${t.url} (${t.getMsnPn()}) cannot be added to buffer: ${r}`);
        }, "appendBuffer");
        this._sourceBuffer || this._bufferChunksCache.append(e), this._bufferOpsQueue.addBufferOperation(()=>{
            this._mediaSource && "open" === this._mediaSource.readyState && (this._mediaSource.duration = this._currentVideoDuration, this._videoElement && 0 === this._videoElement.currentTime && this._videoElement.buffered.length > 0 && this._videoElement.buffered.start(0) > 0 && (this._videoElement.currentTime = this._videoElement.buffered.start(0)));
        }, ()=>{
            this._logger.warn("Could not change current time of video");
        }, "setVideoElementStartPosition");
    }
    _onSourceBufferOpened() {
        if (this._logger.debug("Source buffer is open now"), this._disarmSourceBufferStuckTimer(), this._mediaSource) {
            this._logger.debug("Media source known"), "open" === this._mediaSource.readyState && (this._logger.debug("State of mediaSource is open. Setting duration"), this._mediaSource.duration = this._currentVideoDuration), this._isSourceBufferReady = !0, this._sourceBuffer = this._mediaSource.addSourceBuffer(this._mimeType), this._logger.debug(`Source buffer is open with mimeType ${this._mimeType}`), this._bufferOpsQueue.setSourceBuffer(this._sourceBuffer);
            const e = this._bufferChunksCache.getAll();
            this._bufferChunksCache.destroy(), e.length && this._onFragmentsParsed(e);
        }
    }
    _recreateSourceBuffer() {
        this._logger.info("Will recreate source buffer"), this._bufferOpsQueue.immediatelyRecreateSourceBuffer(this._mediaSource), this._videoElement && (this._videoElement.currentTime = 0);
    }
    _onResolutionCodecChangeRequest({ codec: e }) {
        if (e) {
            const t = $dbaf12f73216aff4$var$gr(e);
            t !== this._mimeType && (this._mimeType = t);
        }
    }
    _onSourceBufferClosed() {
        this._logger.debug("Source buffer closed"), this._isSourceBufferReady = !1;
    }
    _onSourceBufferError() {
        this._logger.debug("Source buffer error"), this._isSourceBufferReady = !1;
    }
    _onSoftResetRequested() {
        this._logger.debug("Soft reset requested"), this._shouldRecreateSourceBufferOnStall = !1, this._awaitingForNextSourceBuffer = !0, this._playbackStateController.resetPlayingTimeCollector();
    }
    _endOfStreamReached() {
        this._mediaSource && (this._closeOnNextSegment = !0);
    }
    _onSourceBufferOperationRequested(e) {
        this._bufferOpsQueue.addBufferOperation(e);
    }
    _onLivePlaylistDetected() {
        this._isVODMode = !1, this._bufferCleaner.setVODMode(!1), this._gapController.setIsVod(!1), this._currentVideoDuration = Number.POSITIVE_INFINITY, this._playbackSpeedController.resume(), this._mediaSource && "open" === this._mediaSource.readyState && (this._mediaSource.duration = this._currentVideoDuration);
    }
    _onVODPlaylistDetected() {
        this._isVODMode = !0, this._bufferCleaner.setVODMode(!0), this._playbackSpeedController.pause(), this._gapController.setIsVod(!0);
    }
    _onPlaybackStallChanged(e) {
        e && this._shouldRecreateSourceBufferOnStall && (this._logger.info("Will recreate source buffer, because playback stall was detected"), this._onSoftResetRequested());
    }
    _onPlaylistInfoAvailable(e) {
        e && e.playlists && e.playlists[0].attributes.CODECS && (this._mimeType = $dbaf12f73216aff4$var$gr(e.playlists[0].attributes.CODECS), this._bufferOpsQueue.addBufferOperation((e)=>{
            e.changeType(this._mimeType);
        }, ()=>{
            this._logger.warn("Could not change codecs");
        }, "changeType")), ("VOD" === e.playlistType || e.endList) && (this._currentVideoDuration = e.segments.reduce((e, t)=>e + t.duration, 0), this._mediaSource && "open" === this._mediaSource.readyState && (this._mediaSource.duration = this._currentVideoDuration, this._mediaSource.setLiveSeekableRange(0, this._currentVideoDuration)));
    }
    _onEndOfStreamReached() {
        this._bufferOpsQueue.addBufferOperation(()=>{
            this._logger.info("Setting endOfStream"), this._mediaSource?.endOfStream();
        });
    }
    _onResolutionChange() {
        this.config.recreateSourceBufferOnResolutionChange ? (this._logger.info("Will recreate source buffer, because resolution was changed, and config.recreateSourceBufferOnResolutionChange is true"), this._onSoftResetRequested()) : this._shouldRecreateSourceBufferOnStall = !0;
    }
    _onSourceBufferStuck() {
        this._logger.info("Source buffer stuck. Schedule reset"), this._onSoftResetRequested();
    }
    _recreateMediaSource() {
        this._logger.info("Recreate media source"), this._mediaSource && (this._logger.debug("Media source already known. Removing event listeners"), this._mediaSource.removeEventListener("sourceopen", this._onSourceBufferOpened), this._mediaSource.removeEventListener("sourceclose", this._onSourceBufferClosed), this._mediaSource.removeEventListener("error", this._onSourceBufferError)), this._mediaSource = new $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.MediaSource, this._logger.debug("Media source created. Attaching event listeners"), this._mediaSource.addEventListener("sourceopen", this._onSourceBufferOpened, {
            once: !0
        }), this._mediaSource.addEventListener("sourceclose", this._onSourceBufferClosed), this._mediaSource.addEventListener("error", this._onSourceBufferError), this._videoElement && (this._videoElement.src = globalThis.URL.createObjectURL(this._mediaSource), this._logger.debug(`MSE URL: ${this._videoElement.src}`)), this._sourceBufferStuckTimer = setTimeout(()=>{
            this._logger.debug("Source buffer stuck timeout set"), this._recreateMediaSource();
        }, this.config.sourceBufferStuckTimeout);
    }
    _disarmSourceBufferStuckTimer() {
        this._sourceBufferStuckTimer && (this._logger.debug("Source buffer stuck timer disarm"), clearTimeout(this._sourceBufferStuckTimer));
    }
    get additionalModules() {
        return {
            gapController: this._gapController,
            bufferMetrics: this._bufferMetrics,
            playbackSpeed: this._playbackSpeedController
        };
    }
    static get MediaSource() {
        if (window?.ManagedMediaSource) return window.ManagedMediaSource;
        if (window?.MediaSource) return window.MediaSource;
        throw new Error("No Media Source candidates found");
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onFragmentsParsed", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSourceBufferOpened", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onResolutionCodecChangeRequest", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSourceBufferClosed", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSourceBufferError", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSoftResetRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_endOfStreamReached", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSourceBufferOperationRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onLivePlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onVODPlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onPlaybackStallChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onPlaylistInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onEndOfStreamReached", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onResolutionChange", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_onSourceBufferStuck", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77.prototype, "_recreateMediaSource", null);
class $dbaf12f73216aff4$var$$b13a7c90f8916026$export$5087227eb54526 extends $dbaf12f73216aff4$var$M {
}
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$pr = {
    fragmentsReleased: "fragmentsFilter.fragmentsReleased",
    problemDetected: "fragmentsFilter.problemDetected"
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _localFragmentParser = null;
    _workerFragmentParser = null;
    _fragmentsCache = [];
    _isCacheRequired = !1;
    constructor(e){
        super("fragmentParser", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - FragmentParser"), this._onFragmentReleasedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$pr.fragmentsReleased, this._onFragmentsLoaded), this._onVODPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.vodDetected, this._onVODPlaylistDetected), this._onSimplePlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.simpleDetected, this._onLivePlaylistDetected), this._onLLPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.llDetected, this._onLivePlaylistDetected), this._onReleaseFromCacheRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.fragments.requestReleaseFromCache, this._onReleaseFromCacheRequested);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onFragmentReleasedListener), this._eventBus.unsubscribe(this._onVODPlaylistDetectedListener), this._eventBus.unsubscribe(this._onSimplePlaylistDetectedListener), this._eventBus.unsubscribe(this._onLLPlaylistDetectedListener), this._eventBus.unsubscribe(this._onReleaseFromCacheRequestedListener);
    }
    _handleConfigUpdated() {}
    _onReleaseFromCacheRequested({ msn: e }) {
        const t = this._fragmentsCache.find((t)=>t.msn === e);
        t && this._eventBus.publish($dbaf12f73216aff4$var$fr.fragments.fragmentsParsed, [
            t
        ]);
    }
    _onLivePlaylistDetected() {
        this._isCacheRequired = !1, this._fragmentsCache = [];
    }
    _onVODPlaylistDetected() {
        this._isCacheRequired = !0;
    }
    async _onFragmentsLoaded(e) {
        this._logger.verbose(`Sending fragment ${e.map((e)=>e.getMsnPn())} for parsing`), this._eventBus.publish($dbaf12f73216aff4$var$fr.fragments.fragmentsParsed, e);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "_onReleaseFromCacheRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "_onLivePlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "_onVODPlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0.prototype, "_onFragmentsLoaded", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$mr = (e)=>{
    const t = new DataView(e);
    let r = 0;
    const n = [];
    for(; r < e.byteLength;){
        const i = t.getUint32(r, !1), s = {
            size: i,
            name: (new TextDecoder).decode(e.slice(r + 4, r + 8)),
            payload: e.slice(r + 8, r + i)
        };
        r += i, n.push(s);
    }
    return n;
}, $dbaf12f73216aff4$var$br = (e)=>{
    const t = e.reduce((e, t)=>e + t.byteLength, 0), r = new Uint8Array(t);
    return e.reduce((e, t)=>(r.set(new Uint8Array(t), e), e + t.byteLength), 0), r.buffer;
}, $dbaf12f73216aff4$var$vr = {
    fragmentsReleased: "fragmentsQueue.fragmentReleased"
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
const $dbaf12f73216aff4$var$yr = {
    saveData: "fragmentsBufferEvents.saveData"
};
class $dbaf12f73216aff4$var$$667435329a91e53d$export$7dc2c7c17829d4bb extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _lastKnownInitSectionNumberOfTracks = null;
    constructor(e){
        super("fragmentsFilter", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - FragmentsFilter"), this._onFragmentReleasedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$vr.fragmentsReleased, this._onFragmentReleasedFromQueue);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onFragmentReleasedListenerToken);
    }
    _onFragmentReleasedFromQueue(e) {
        const t = [];
        for (const r of e)if (r.isInitSection) this._parseInitSection(r), t.push(r);
        else {
            const e = this._parseMediaFragment(r);
            this.config.filterOutInconsistentTracks && !e || t.push(r);
        }
        this._eventBus.publish($dbaf12f73216aff4$var$pr.fragmentsReleased, t);
    }
    _parseInitSection(e) {
        this._logger.debug("Parsing init section");
        const t = $dbaf12f73216aff4$var$mr(e.data), r = t.find(({ name: e })=>"moov" === e) || null;
        if (this._logger.verbose(`Found following root boxes: ${t.map(({ name: e })=>e).join(", ")}`), r) {
            const e = $dbaf12f73216aff4$var$mr(r.payload);
            this._logger.verbose(`Found following child of moov boxes: ${e.map(({ name: e })=>e).join(", ")}`);
            const t = e.filter(({ name: e })=>"trak" === e);
            this._logger.info(`Found ${t.length} trak boxes`), this._lastKnownInitSectionNumberOfTracks = t.length;
        }
    }
    _parseMediaFragment(e) {
        if (null === this._lastKnownInitSectionNumberOfTracks) return !0;
        const t = $dbaf12f73216aff4$var$mr(e.data), r = t.filter(({ name: e })=>"sidx" === e);
        this._logger.verbose(`Found following root boxes: ${t.map(({ name: e })=>e).join(", ")}`);
        const n = t.filter(({ name: e })=>"moof" === e), i = [];
        let s = !1;
        r.length > 0 && r.length % this._lastKnownInitSectionNumberOfTracks != 0 && (this._logger.warn(`Inconsistent media chunk: number of SIDX boxes is invalid, ${r.length} found, ${this._lastKnownInitSectionNumberOfTracks} expected`), i.push(`Number of SIDX boxes (${r.length}) is not equal to the known amount of media tracks (${this._lastKnownInitSectionNumberOfTracks})`), s = !0);
        for (const e of n){
            const t = $dbaf12f73216aff4$var$mr(e.payload), r = t.filter(({ name: e })=>"traf" === e);
            this._logger.verbose(`Found following child of moof boxes: ${t.map(({ name: e })=>e).join(", ")}`), r.length !== this._lastKnownInitSectionNumberOfTracks && (this._logger.warn(`Inconsistent media chunk: number of TRAF boxes is invalid, ${r.length} found, ${this._lastKnownInitSectionNumberOfTracks} expected`), i.push(`Number of TRAF boxes (${r.length}) is not equal to the known amount of media tracks (${this._lastKnownInitSectionNumberOfTracks})`), s = !0);
        }
        return s && (this._logger.warn(`Fragment ${e.getMsnPn()} should be reported`), this._eventBus.publish($dbaf12f73216aff4$var$pr.problemDetected, {
            fragment: e.url.split("/").slice(-1)[0],
            reason: i.join("; ")
        }), this._eventBus.publish($dbaf12f73216aff4$var$yr.saveData, {})), s;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$667435329a91e53d$export$7dc2c7c17829d4bb.prototype, "_onFragmentReleasedFromQueue", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
let $dbaf12f73216aff4$var$Er;
var $dbaf12f73216aff4$var$Sr;
($dbaf12f73216aff4$var$Sr = $dbaf12f73216aff4$var$Er || ($dbaf12f73216aff4$var$Er = {})).UNKNOWN = "unknown", $dbaf12f73216aff4$var$Sr.INDEPENDENT = "independent", $dbaf12f73216aff4$var$Sr.PART = "part";
class $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "queue"
    ];
    _queuedFragments = [];
    _additionalInfo = {};
    constructor(e){
        this._eventBus = e, this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - FragmentsQueue"), this._fragmentRequestedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingStarted, this._onFragmentRequested), this._onFragmentsDetectedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.fragments.fragmentsDetected, this._onFragmentsDetected), this._softResetRequestedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.requestResetWithOverplay, this._onSoftResetRequested), this._fragmentLoadedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoaded, this._onFragmentLoaded), this._fragmentAbortedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingAborted, this._onFragmentAborted), this._fragmentErrorListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingError, this._onFragmentAborted), this._onFragmentReleaseFromCacheRequestedToken = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.fragments.requestReleaseFromCache, this._onFragmentReleasedFromCache), this._onResolutionChangedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onSoftResetRequested);
    }
    getCurrentQueue() {
        return this._queuedFragments;
    }
    destroy() {
        this._eventBus.unsubscribe(this._onFragmentsDetectedListenerToken), this._eventBus.unsubscribe(this._fragmentLoadedListenerToken), this._eventBus.unsubscribe(this._fragmentRequestedListenerToken), this._eventBus.unsubscribe(this._softResetRequestedListenerToken), this._eventBus.unsubscribe(this._onResolutionChangedListenerToken), this._eventBus.unsubscribe(this._fragmentErrorListenerToken), this._eventBus.unsubscribe(this._fragmentAbortedListenerToken), this._eventBus.unsubscribe(this._onFragmentReleaseFromCacheRequestedToken), this.reset();
    }
    reset() {
        this._queuedFragments = [], this.status = "Idle";
    }
    _onSoftResetRequested() {
        this.reset();
    }
    _onFragmentRequested(e) {
        this._queuedFragments.find(({ url: t })=>e.url === t) ? this._logger.warn(`Same fragment (${e.getMsnPn()}) was already in queue! Ignoring it`) : (this._logger.verbose(`Add fragment ${e.getMsnPn()} to queue`), e.goToLifecycleStage("addedToQueue"), this._queuedFragments.push(e), this.status = "Awaiting fragments");
    }
    _onFragmentLoaded(e) {
        const t = this._queuedFragments.find(({ msn: t, pn: r })=>t === e.msn && r === e.pn);
        t ? (this._logger.debug(`Fragment ${e.getMsnPn()} was resolved finally`), t.data = e.data, this._checkQueue()) : this._logger.warn(`Received fragment ${e.getMsnPn()} was not in queue. Pls check it`);
    }
    _onFragmentReleasedFromCache({ msn: e }) {
        this._queuedFragments = this._queuedFragments.filter((t)=>t.msn === e), this._checkQueue();
    }
    _onFragmentsDetected(e) {
        e.forEach((e)=>{
            const t = this._queuedFragments.find(({ msn: t, pn: r })=>t === e.msn && r === e.pn);
            t && (t.independent = e.independent);
        }), this._checkQueue();
    }
    _onFragmentAborted(e) {
        const t = this._queuedFragments.filter(({ msn: t })=>t <= e.msn);
        this._queuedFragments = this._queuedFragments.filter((e)=>!t.includes(e)), this._checkQueue();
    }
    _checkQueue() {
        if (this._logger.verbose("Checking queue"), !this._queuedFragments.length) return void this._logger.verbose("Queue is empty. Skipping");
        if (!this._queuedFragments[0].data || this._queuedFragments[0].independent === $dbaf12f73216aff4$var$Er.UNKNOWN) return void this._logger.verbose("First queued fragment is empty. Skipping");
        const e = this._queuedFragments.findIndex((e)=>!e.data || e.independent === $dbaf12f73216aff4$var$Er.UNKNOWN);
        if (-1 === e) return this._logger.verbose("Looks like whole queue was resolved"), void this._releaseFragmentsFromQueue(this._queuedFragments);
        this._logger.verbose(`${e} fragments ready. Releasing them`);
        const t = this._queuedFragments.slice(0, e);
        this._releaseFragmentsFromQueue(t);
    }
    _releaseFragmentsFromQueue(e) {
        this._logger.verbose(`Release fragment  ${e.map((e)=>e.getMsnPn())}from queue`), e.forEach((e)=>e.goToLifecycleStage("releasedFromQueue")), this._queuedFragments = this._queuedFragments.filter((t)=>!e.includes(t)), this._eventBus.publish($dbaf12f73216aff4$var$vr.fragmentsReleased, e), this.status = this._queuedFragments.length > 0 ? this.status : "Idle";
    }
    get additionalInfo() {
        return {
            ...this._additionalInfo,
            awaitingFragments: this.getCurrentQueue().map((e)=>({
                    ...e,
                    data: void 0
                }))
        };
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onSoftResetRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onFragmentRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onFragmentLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onFragmentReleasedFromCache", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onFragmentsDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_onFragmentAborted", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771.prototype, "_releaseFragmentsFromQueue", null);
const $dbaf12f73216aff4$var$Rr = new class $fea8cd9fb2854447$var$OOLogger {
    _ooEndpoint = "/api/front/v2/logs/streaming";
    async reportError(e, t) {
        try {
            await fetch(this._ooEndpoint, {
                headers: {
                    "Content-Type": "application/json"
                },
                method: "POST",
                body: JSON.stringify({
                    doppioLifecycleError: {
                        errorType: e,
                        context: t
                    }
                })
            });
        } catch (e) {}
    }
};
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
let $dbaf12f73216aff4$var$Tr;
var $dbaf12f73216aff4$var$Ar;
($dbaf12f73216aff4$var$Ar = $dbaf12f73216aff4$var$Tr || ($dbaf12f73216aff4$var$Tr = {})).UNKNOWN = "unknown", $dbaf12f73216aff4$var$Ar.LOADING = "loading", $dbaf12f73216aff4$var$Ar.LOADED = "loaded", $dbaf12f73216aff4$var$Ar.ABORTED = "aborted", $dbaf12f73216aff4$var$Ar.ERROR = "error", $dbaf12f73216aff4$var$Ar.DESTROYED = "destroyed", $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
let $dbaf12f73216aff4$var$Lr;
var $dbaf12f73216aff4$var$$r;
($dbaf12f73216aff4$var$$r = $dbaf12f73216aff4$var$Lr || ($dbaf12f73216aff4$var$Lr = {})).FETCH = "fetch", $dbaf12f73216aff4$var$$r.ABORT = "abort", $dbaf12f73216aff4$var$$r.DESTROY = "destroy", $dbaf12f73216aff4$var$$r.DATA_READY = "dataReady", $dbaf12f73216aff4$var$$r.STATS_READY = "statsReady", $dbaf12f73216aff4$var$$r.CHANGE_STATE = "changeState", $dbaf12f73216aff4$var$$r.ERROR = "error", $dbaf12f73216aff4$var$$r.REDIRECT_DETECTED = "redirectDetected";
const $dbaf12f73216aff4$var$Br = (e)=>{
    const t = e.reduce((e, t)=>e + t.length, 0), r = new Uint8Array(t);
    let n = 0;
    return e.forEach((e)=>{
        r.set(e, n), n += e.length;
    }), r;
}, $dbaf12f73216aff4$var$Pr = (e, t, r, n)=>{
    const i = ((e, t, r)=>{
        if (!globalThis.performance || !globalThis.performance.getEntriesByName) return null;
        const n = globalThis.performance.getEntriesByName(e)[0];
        if (!n) return null;
        const { connectStart: i, connectEnd: s, domainLookupEnd: a, duration: o, domainLookupStart: l, encodedBodySize: u, responseStart: d, requestStart: c } = n, h = (u || t) / 1024, f = o;
        return globalThis.performance.clearResourceTimings(), {
            connectDuration: s - i,
            domainLookupDuration: a - l,
            sizeInKb: h,
            ttfb: d - c,
            downloadDuration: f,
            calculatedSpeed: h / (f / 1e3) * 8,
            type: r,
            url: e
        };
    })(e, r, n);
    return i || {
        connectDuration: 0,
        domainLookupDuration: 0,
        sizeInKb: r / 1024,
        ttfb: 0,
        url: e,
        downloadDuration: t,
        calculatedSpeed: r / 1024 / (t / 1e3) * 8,
        type: n
    };
};
class $dbaf12f73216aff4$var$$23b27e332a61b135$export$df6d58d46cb3f0ea {
    requestUrl = "";
    realUrl = "";
    mode = "";
    _dataChunks = [];
    _receivedLength = 0;
    _abortController = new AbortController;
    _startLoadTimestamp = 0;
    _isAborted = !1;
    constructor(e){
        this._config = e;
    }
    abort() {
        this._isAborted = !0, this._abortController.abort();
    }
    async fetch(e, t) {
        try {
            globalThis.performance && globalThis.performance.clearResourceTimings && globalThis.performance.clearResourceTimings(), this._config.onChangeState($dbaf12f73216aff4$var$Tr.LOADING), this._startLoadTimestamp = Date.now(), this.requestUrl = e, this.mode = t, this._receivedLength = 0;
            const r = new Request(this.requestUrl), n = {
                signal: this._abortController.signal
            };
            this._config.requestCustomReferer && (n.headers = {
                "X-Referer": this._config.requestCustomReferer
            });
            const i = await fetch(r, n);
            this.realUrl = i.url;
            const s = i.body?.getReader();
            if (!s) throw new Error;
            for(;;){
                const { done: e, value: t } = await s.read();
                if (e) break;
                this._dataChunks.push(t), this._receivedLength += t.length;
            }
            if (!i.ok && (!i.status || i.status > 399)) throw this.error = {
                status: i.status,
                statusText: i.statusText || this._receivedLength ? String.fromCharCode(...$dbaf12f73216aff4$var$Br(this._dataChunks)) : ""
            }, new Error;
            const a = $dbaf12f73216aff4$var$Br(this._dataChunks).buffer;
            this._config.onDataReady("text" !== this.mode ? a : new TextDecoder("utf-8").decode(a)), this._config.onStatsReady(this._getNetworkStats()), this.realUrl !== this.requestUrl && this._config.onRedirectDetected(this.requestUrl, this.realUrl), this._config.onChangeState($dbaf12f73216aff4$var$Tr.LOADED, {
                realUrl: i.url,
                status: i.status
            });
        } catch (e) {
            if (this._isAborted) return this._config.onStatsReady(this._getNetworkStats()), void this._config.onChangeState($dbaf12f73216aff4$var$Tr.ABORTED);
            this.error || (this.error = {
                status: -1,
                statusText: e.toString()
            }), this._config.onError(this.error), this._config.onChangeState($dbaf12f73216aff4$var$Tr.ERROR, {
                status: this.error.status
            });
        }
    }
    _getNetworkStats() {
        const e = Date.now() - this._startLoadTimestamp, t = "text" === this.mode ? "text" : "binary";
        return $dbaf12f73216aff4$var$Pr(this.requestUrl, e, this._receivedLength, t);
    }
}
const $dbaf12f73216aff4$var$Cr = [
    $dbaf12f73216aff4$var$Tr.ERROR,
    $dbaf12f73216aff4$var$Tr.LOADED,
    $dbaf12f73216aff4$var$Tr.ABORTED
], $dbaf12f73216aff4$var$wr = new Map, $dbaf12f73216aff4$var$Or = async (e = "", t)=>{
    let r = $dbaf12f73216aff4$var$wr.get(e);
    if (!r && t) {
        const t = URL.createObjectURL(new Blob([
            `${$dbaf12f73216aff4$var$n('let e;var t;(t=e||(e={})).FETCH="fetch",t.ABORT="abort",t.DESTROY="destroy",t.DATA_READY="dataReady",t.STATS_READY="statsReady",t.CHANGE_STATE="changeState",t.ERROR="error",t.REDIRECT_DETECTED="redirectDetected";const r=e=>{const t=e.reduce(((e,t)=>e+t.length),0),r=new Uint8Array(t);let a=0;return e.forEach((e=>{r.set(e,a),a+=e.length})),r};let a;var o;(o=a||(a={})).UNKNOWN="unknown",o.LOADING="loading",o.LOADED="loaded",o.ABORTED="aborted",o.ERROR="error",o.DESTROYED="destroyed";const s=(e,t,r,a)=>{const o=((e,t,r)=>{if(!globalThis.performance||!globalThis.performance.getEntriesByName)return null;const a=globalThis.performance.getEntriesByName(e)[0];if(!a)return null;const{connectStart:o,connectEnd:s,domainLookupEnd:n,duration:i,domainLookupStart:l,encodedBodySize:d,responseStart:c,requestStart:u}=a,h=(d||t)/1024,g=i;return globalThis.performance.clearResourceTimings(),{connectDuration:s-o,domainLookupDuration:n-l,sizeInKb:h,ttfb:c-u,downloadDuration:g,calculatedSpeed:h/(g/1e3)*8,type:r,url:e}})(e,r,a);return o||{connectDuration:0,domainLookupDuration:0,sizeInKb:r/1024,ttfb:0,url:e,downloadDuration:t,calculatedSpeed:r/1024/(t/1e3)*8,type:a}};class $23b27e332a61b135$export$df6d58d46cb3f0ea{requestUrl="";realUrl="";mode="";_dataChunks=[];_receivedLength=0;_abortController=new AbortController;_startLoadTimestamp=0;_isAborted=!1;constructor(e){this._config=e}abort(){this._isAborted=!0,this._abortController.abort()}async fetch(e,t){try{globalThis.performance&&globalThis.performance.clearResourceTimings&&globalThis.performance.clearResourceTimings(),this._config.onChangeState(a.LOADING),this._startLoadTimestamp=Date.now(),this.requestUrl=e,this.mode=t,this._receivedLength=0;const o=new Request(this.requestUrl),s={signal:this._abortController.signal};this._config.requestCustomReferer&&(s.headers={"X-Referer":this._config.requestCustomReferer});const n=await fetch(o,s);this.realUrl=n.url;const i=n.body?.getReader();if(!i)throw new Error;for(;;){const{done:e,value:t}=await i.read();if(e)break;this._dataChunks.push(t),this._receivedLength+=t.length}if(!n.ok&&(!n.status||n.status>399))throw this.error={status:n.status,statusText:n.statusText||this._receivedLength?String.fromCharCode(...r(this._dataChunks)):""},new Error;const l=r(this._dataChunks).buffer;this._config.onDataReady("text"!==this.mode?l:new TextDecoder("utf-8").decode(l)),this._config.onStatsReady(this._getNetworkStats()),this.realUrl!==this.requestUrl&&this._config.onRedirectDetected(this.requestUrl,this.realUrl),this._config.onChangeState(a.LOADED,{realUrl:n.url,status:n.status})}catch(e){if(this._isAborted)return this._config.onStatsReady(this._getNetworkStats()),void this._config.onChangeState(a.ABORTED);this.error||(this.error={status:-1,statusText:e.toString()}),this._config.onError(this.error),this._config.onChangeState(a.ERROR,{status:this.error.status})}}_getNetworkStats(){const e=Date.now()-this._startLoadTimestamp,t="text"===this.mode?"text":"binary";return s(this.requestUrl,e,this._receivedLength,t)}}const n=new Map;self.addEventListener("message",(({data:t})=>{if(t.type)switch(t.type){case e.ABORT:{const e=n.get(t.payload.url);e&&e.abort();break}case e.DESTROY:{const e=n.get(t.payload.url);e&&e.abort(),n.delete(t.payload.url);break}case e.FETCH:{const r=new $23b27e332a61b135$export$df6d58d46cb3f0ea({requestCustomReferer:t.payload.requestCustomReferer,onDataReady:r=>{self.postMessage({type:e.DATA_READY,payload:{binaryData:r,url:t.payload.url}})},onChangeState:(r,a)=>{self.postMessage({type:e.CHANGE_STATE,payload:{newState:r,url:t.payload.url,metadata:a}})},onStatsReady:r=>{self.postMessage({type:e.STATS_READY,payload:{stats:r,url:t.payload.url}})},onError:r=>{self.postMessage({type:e.ERROR,payload:{error:r,url:t.payload.url}})},onRedirectDetected:(t,r)=>{self.postMessage({type:e.REDIRECT_DETECTED,payload:{url:t,responseUrl:r}})}});r.fetch(t.payload.url,t.payload.mode),n.set(t.payload.url,r);break}}}));')}`
        ], {
            type: "application/javascript"
        }));
        if (r = new Worker(t), !r) throw new Error;
        $dbaf12f73216aff4$var$wr.set(e, r);
    }
    return r || null;
}, $dbaf12f73216aff4$var$Dr = async (e)=>{
    const t = await $dbaf12f73216aff4$var$Or(e);
    t && t.terminate(), $dbaf12f73216aff4$var$wr.delete(e);
};
class $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96 {
    data = null;
    error = null;
    stats = null;
    realUrl = "";
    _state = $dbaf12f73216aff4$var$Tr.UNKNOWN;
    _retriesAmount = 0;
    _timeoutAbortHandler = null;
    _retryTimeoutHandler = null;
    _fetcherWorker = null;
    _fetcherSimple = null;
    _workerMode = !1;
    constructor(e, t){
        if (this._eventBus = t, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "Doppio - NetworkLoader"), !e.url || !e.onStateChanged) throw new Error("Invalid config");
        this._workerMode = !!e.workerMode, this._config = e, this._logger.debug("Created with config", e), this._recreateFetcherAndAutoload();
    }
    startLoad() {
        return this._state === $dbaf12f73216aff4$var$Tr.UNKNOWN && (this._armTimeoutAbort(), this._logger.debug(`Starting load ${this._config.url}`), this._startAsyncLoad(), !0);
    }
    cancel(e) {
        this._disarmTimeoutAbort(), this._disarmRetryTimeout(), this.error = {
            status: -1,
            statusText: `Cancelled because of ${e ?? "unknown reason"}`
        }, $dbaf12f73216aff4$var$Cr.includes(this._state) || (this._logger.warn(`${this._config.url} loading was cancelled with reason ${e}, current status is ${this._state}`), this._workerMode ? this._fetcherWorker?.postMessage({
            type: $dbaf12f73216aff4$var$Lr.ABORT,
            payload: {
                url: this._config.url
            }
        }) : this._fetcherSimple?.abort());
    }
    destroy() {
        $dbaf12f73216aff4$var$Cr.includes(this._state) || (this.cancel("Destroyed"), this._state = $dbaf12f73216aff4$var$Tr.DESTROYED), this._disarmTimeoutAbort(), this._disarmRetryTimeout(), this.data = null, this.error = null, this._removeFetcherFromWorker();
    }
    _onAbortTimeoutFired() {
        this._logger.info(`${this._config.url} loading timeout`), this.cancel("Loading timeout");
    }
    _armRetryTimeout() {
        this._logger.info(`Retry loading ${this._retriesAmount} time`), this._disarmRetryTimeout(), this._setNewState($dbaf12f73216aff4$var$Tr.UNKNOWN), this._retriesAmount++, this._retryTimeoutHandler = globalThis.setTimeout(()=>{
            this.startLoad();
        }, 2 ** this._retriesAmount);
    }
    _disarmRetryTimeout() {
        this._retryTimeoutHandler && globalThis.clearTimeout(this._retryTimeoutHandler);
    }
    _armTimeoutAbort() {
        !this._config.loadingTimeout || this._config.loadingTimeout <= 0 ? this._logger.debug("LoadingTimeout is not defined or below zero! Skipping abort timeout arming") : (this._logger.debug("Arming loading abort timeout"), this._timeoutAbortHandler && (this._logger.debug("Another timeout already armed. Cancel it"), this._disarmTimeoutAbort()), this._timeoutAbortHandler = setTimeout(()=>{
            this._onAbortTimeoutFired();
        }, this._config.loadingTimeout));
    }
    _disarmTimeoutAbort() {
        this._timeoutAbortHandler && (this._logger.debug("Disarming abort timeout"), clearTimeout(this._timeoutAbortHandler));
    }
    _setNewState(e, t) {
        this._state !== e && (e === $dbaf12f73216aff4$var$Tr.LOADED && this._logger.verbose(`${this._config.url} loading finished`), $dbaf12f73216aff4$var$Cr.includes(e) && (this._eventBus.publish($dbaf12f73216aff4$var$qt.events.networkRequestSettled, {
            response: {
                url: this.url,
                body: this.data,
                timestamp: performance.now(),
                ...t || {}
            }
        }), this._removeFetcherFromWorker(), this._disarmTimeoutAbort()), this._logger.verbose(`Loading ${this._config.url}, state transition: ${this._state} -> ${e}`), [
            $dbaf12f73216aff4$var$Tr.ABORTED,
            $dbaf12f73216aff4$var$Tr.ERROR
        ].includes(e) && this._state !== $dbaf12f73216aff4$var$Tr.DESTROYED && this._config.maxRetries && this._config.baseRetryTimeout && this._retriesAmount < this._config.maxRetries ? this._armRetryTimeout() : (this._config.onStateChanged(this._state, e, this), this._state = e));
    }
    _removeFetcherFromWorker() {
        this._fetcherWorker?.removeEventListener("message", this._handleWorkerMessage), this._fetcherWorker?.postMessage({
            type: $dbaf12f73216aff4$var$Lr.DESTROY,
            payload: {
                url: this._config.url
            }
        });
    }
    async _startAsyncLoad() {
        if (this._workerMode) {
            const e = {
                type: $dbaf12f73216aff4$var$Lr.FETCH,
                payload: {
                    url: this._config.url,
                    mode: this._config.mode,
                    requestCustomReferer: this._config.requestCustomReferer
                }
            };
            this._fetcherWorker?.postMessage(e);
        } else this._fetcherSimple?.fetch(this._config.url, this._config.mode);
    }
    async _recreateFetcherAndAutoload() {
        if (this._fetcherSimple?.abort(), this._fetcherWorker?.postMessage({
            type: $dbaf12f73216aff4$var$Lr.DESTROY,
            payload: {
                url: this._config.url
            }
        }), this._workerMode) try {
            this._fetcherWorker = await $dbaf12f73216aff4$var$Or(this._eventBus.getAppId(), !0), this._fetcherWorker?.addEventListener("message", this._handleWorkerMessage);
        } catch (e) {
            return this._logger.warn("Could not use worker for network request. Fallback to simple mode", {
                error: e
            }), this._workerMode = !1, void this._recreateFetcherAndAutoload();
        }
        else this._fetcherSimple = new $dbaf12f73216aff4$var$$23b27e332a61b135$export$df6d58d46cb3f0ea({
            requestCustomReferer: this._config.requestCustomReferer,
            onDataReady: this._handleDataReady,
            onChangeState: this._setNewState,
            onStatsReady: this._handleLoadStatsReady,
            onError: this._handleError,
            onRedirectDetected: this._handleRedirectDetected
        });
        this._config.autoLoad && (this._logger.debug("AutoLoad config field set to true. Starting load"), globalThis.queueMicrotask(()=>{
            this.startLoad();
        }));
    }
    _handleDataReady(e) {
        this.data = e;
    }
    _handleLoadStatsReady(e) {
        this.stats = e, this._eventBus.publish($dbaf12f73216aff4$var$qt.stats.statsReady, e);
    }
    _handleError(e) {
        this.error = e, this._logger.warn(`Cannot load ${this._config.url}`, e);
    }
    _handleRedirectDetected(e, t) {
        this._eventBus.publish($dbaf12f73216aff4$var$qt.events.browserRedirectDetected, {
            requestUrl: e,
            responseUrl: t
        });
    }
    _handleWorkerMessage({ data: e }) {
        if (e.payload.url === this._config.url && e.type) switch(e.type){
            case $dbaf12f73216aff4$var$Lr.DATA_READY:
                this._handleDataReady(e.payload.binaryData);
                break;
            case $dbaf12f73216aff4$var$Lr.CHANGE_STATE:
                this._setNewState(e.payload.newState, e.payload.metadata);
                break;
            case $dbaf12f73216aff4$var$Lr.STATS_READY:
                this._handleLoadStatsReady(e.payload.stats);
                break;
            case $dbaf12f73216aff4$var$Lr.ERROR:
                this._handleError(e.payload.error);
                break;
            case $dbaf12f73216aff4$var$Lr.REDIRECT_DETECTED:
                this._handleRedirectDetected(e.payload.url, e.payload.responseUrl);
        }
    }
    get url() {
        return this._config.url;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_setNewState", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_handleDataReady", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_handleLoadStatsReady", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_handleError", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_handleRedirectDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96.prototype, "_handleWorkerMessage", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "loader"
    ];
    additionalInfo = {
        loadingFragments: {}
    };
    _lastRequestedFragments = [];
    _pendingFragments = [];
    _loaders = [];
    constructor(e){
        super("fragmentLoader", e), this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "Doppio - FragmentLoader"), this._fragmentsDetectedSubscription = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.fragments.fragmentsDetected, this._onFragmentsDetected), this._fragmentAddedToBufferSubscription = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.fragmentAdded, this._onFragmentAddedToBuffer), this._fragmentHistoryReadyToPrintSubscription = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentHistoryReadyForPrint, this._onFragmentHistoryReadyToPrint), this._logger.info("Instance created");
    }
    destroy() {
        super.destroy(), this._loaders.forEach((e)=>{
            e.destroy();
        }), this._eventBus.unsubscribe(this._fragmentsDetectedSubscription), this._eventBus.unsubscribe(this._fragmentAddedToBufferSubscription), this._eventBus.unsubscribe(this._fragmentHistoryReadyToPrintSubscription), this._logger.info("Destroyed");
    }
    _handleConfigUpdated() {}
    _onFragmentsDetected(e) {
        this.status = "Handling new fragments", this._logger.debug("Fragments was requested to load", e.map((e)=>e.getMsnPn()));
        const t = e.filter((e)=>!this._lastRequestedFragments.find((t)=>t.url === e.url));
        this._logger.verbose("Actual fragments is", t.map((e)=>e.getMsnPn())), this._pendingFragments = this._pendingFragments.concat(t), t.forEach((e)=>{
            this._eventBus.publish($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingStarted, e), this.additionalInfo.loadingFragments.url = $dbaf12f73216aff4$var$Tr.UNKNOWN, this._addFragmentToQueue(e.url, e.requestedLoadingTimeout, e);
        }), this._lastRequestedFragments = e;
    }
    _onFragmentAddedToBuffer(e) {
        e.goToLifecycleStage("addedToBuffer");
    }
    _onFragmentLoadAborted(e) {
        e.goToLifecycleStage("loadDataAborted");
    }
    _onFragmentHistoryReadyToPrint(e) {
        this._logger.info(e.historyString);
    }
    _addFragmentToQueue(e, t = this.config?.fragmentLoadingTimeout, r) {
        this._logger.verbose(`Requesting ${e} to load; Fragment ${r.getMsnPn()}`), r.goToLifecycleStage("loadDataStart");
        const n = new $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96({
            url: e,
            autoLoad: !0,
            mode: "arrayBuffer",
            onStateChanged: this._onLoaderStateChanged,
            loadingTimeout: t,
            workerMode: this.config.workerMode
        }, this._eventBus);
        this._loaders.push(n);
    }
    _onLoaderStateChanged(e, t, r) {
        if (this.additionalInfo.loadingFragments[r.url] = t, ![
            $dbaf12f73216aff4$var$Tr.LOADED,
            $dbaf12f73216aff4$var$Tr.ERROR,
            $dbaf12f73216aff4$var$Tr.ABORTED
        ].includes(t)) return;
        this._logger.verbose(`Loader state changed: ${e} -> ${t}`);
        const n = this._pendingFragments.find((e)=>e.url === r.url);
        n && (n.stats = r.stats, n.data = r.data), n ? (r.error && (n.error = r.error), t === $dbaf12f73216aff4$var$Tr.LOADED && (this._logger.debug(`${r.url} fragment downloaded (${n.getMsnPn()})`), n.goToLifecycleStage("loadDataEnd"), delete this.additionalInfo.loadingFragments[r.url], this._eventBus.publish($dbaf12f73216aff4$var$lr.fragments.fragmentLoaded, n)), t === $dbaf12f73216aff4$var$Tr.ERROR && (this._lastRequestedFragments = this._lastRequestedFragments.filter((e)=>e.url !== r.url), this._logger.debug(`${r.url} fragment loading error (${n.getMsnPn()})`), this._onFragmentLoadAborted(n), this._eventBus.publish($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingError, n)), t === $dbaf12f73216aff4$var$Tr.ABORTED && (this._lastRequestedFragments = this._lastRequestedFragments.filter((e)=>e.url !== r.url), this._logger.debug(`${r.url} fragment loading aborted (${n.getMsnPn()})`), this._onFragmentLoadAborted(n), this._eventBus.publish($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingError, n)), this._pendingFragments = this._pendingFragments.filter((e)=>e !== n), this._loaders = this._loaders.filter((e)=>e !== r), this.status = this._loaders.length ? "Loading fragments" : "Idle") : this._logger.warn("Downloaded fragment was not even planned. Ignoring it", {
            url: r.url
        });
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_onFragmentsDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_onFragmentAddedToBuffer", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_onFragmentLoadAborted", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_onFragmentHistoryReadyToPrint", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881.prototype, "_onLoaderStateChanged", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
const $dbaf12f73216aff4$var$Mr = (e)=>{
    try {
        const t = new URL(e);
        return Boolean(t.origin);
    } catch (e) {
        return !1;
    }
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa {
    _logger = null;
    _shouldLogHistory = !1;
    _history = [];
    _hasLifecycleEnded = !1;
    _isStuckTimer = null;
    _lastTs = Date.now();
    constructor(e, t, r){
        Object.assign(this, e), this._eventBus = t, this._shouldLogHistory = r || !1, t && (this._logger = $dbaf12f73216aff4$var$J(t, "Doppio - Fragment")), this.duration = e.duration, this.msn = e.msn, this.pn = e.pn, e.playlistUrl || e.fragmentUrl ? this.url = $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa._buildUrl(e.playlistUrl, e.fragmentUrl) : this.url = e.url, this._logger?.verbose(`Fragment ${this.getMsnPn()} created`), this.goToLifecycleStage("created");
    }
    getMsnPn() {
        return `${this.msn}/${this.pn || 0}`;
    }
    goToLifecycleStage(e) {
        if (this._clearStuckTimer(), !this._shouldLogHistory || this._hasLifecycleEnded) return;
        const t = Date.now();
        this._history.push({
            event: e,
            timeSincePreviousEvent: t - this._lastTs
        }), this._lastTs = t, "loadDataAborted" === e ? (this._hasLifecycleEnded = !0, this._publishHistoryReadyForPrint("Fragments lifecycle: ABORTED")) : "addedToBuffer" === e ? (this._hasLifecycleEnded = !0, this._publishHistoryReadyForPrint("Fragments lifecycle: SUCCESS")) : this._isStuckTimer = setTimeout(this._handleFragmentStuck, 3e3);
    }
    static _buildUrl(e, t) {
        if ($dbaf12f73216aff4$var$Mr(t)) return t;
        const r = new URL(e);
        if (t.startsWith("/")) return `${r.origin}${t}`;
        const n = r.pathname.split("/");
        return n.pop() || n.pop(), `${r.origin}/${n.concat(t).join("/")}`;
    }
    _handleFragmentStuck() {
        this._publishHistoryReadyForPrint("Fragments lifecycle: STUCK");
    }
    _publishHistoryReadyForPrint(e) {
        this._eventBus?.publish($dbaf12f73216aff4$var$lr.fragments.fragmentHistoryReadyForPrint, {
            historyString: `${e} ${this.getMsnPn()}:\n${this._history.map((e)=>`Event: ${e.event}, ${e.timeSincePreviousEvent}ms since previous event`).join("\n")}`
        });
    }
    _clearStuckTimer() {
        this._isStuckTimer && clearTimeout(this._isStuckTimer);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa.prototype, "_handleFragmentStuck", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4");
var $dbaf12f73216aff4$var$Ir = {}, $dbaf12f73216aff4$var$Fr = {};
function $dbaf12f73216aff4$var$xr(e, t) {
    return ($dbaf12f73216aff4$var$Fr = $dbaf12f73216aff4$var$xr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e;
    }).__esModule = !0, $dbaf12f73216aff4$var$Fr.default = $dbaf12f73216aff4$var$Fr, $dbaf12f73216aff4$var$xr(e, t);
}
($dbaf12f73216aff4$var$Fr = $dbaf12f73216aff4$var$xr).__esModule = !0, $dbaf12f73216aff4$var$Fr.default = $dbaf12f73216aff4$var$Fr, ($dbaf12f73216aff4$var$Ir = function(e, t) {
    e.prototype = Object.create(t.prototype), e.prototype.constructor = e, $dbaf12f73216aff4$var$Fr(e, t);
}).__esModule = !0, $dbaf12f73216aff4$var$Ir.default = $dbaf12f73216aff4$var$Ir;
var $dbaf12f73216aff4$var$kr = function() {
    function e() {
        this.listeners = {};
    }
    var t = e.prototype;
    return t.on = function(e, t) {
        this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
    }, t.off = function(e, t) {
        if (!this.listeners[e]) return !1;
        var r = this.listeners[e].indexOf(t);
        return this.listeners[e] = this.listeners[e].slice(0), this.listeners[e].splice(r, 1), r > -1;
    }, t.trigger = function(e) {
        var t = this.listeners[e];
        if (t) {
            if (2 === arguments.length) for(var r = t.length, n = 0; n < r; ++n)t[n].call(this, arguments[1]);
            else for(var i = Array.prototype.slice.call(arguments, 1), s = t.length, a = 0; a < s; ++a)t[a].apply(this, i);
        }
    }, t.dispose = function() {
        this.listeners = {};
    }, t.pipe = function(e) {
        this.on("data", function(t) {
            e.push(t);
        });
    }, e;
}(), $dbaf12f73216aff4$var$Nr = {};
function $dbaf12f73216aff4$var$Vr() {
    return $dbaf12f73216aff4$var$Nr = $dbaf12f73216aff4$var$Vr = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var n in r)({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
    }, $dbaf12f73216aff4$var$Nr.__esModule = !0, $dbaf12f73216aff4$var$Nr.default = $dbaf12f73216aff4$var$Nr, $dbaf12f73216aff4$var$Vr.apply(null, arguments);
}
($dbaf12f73216aff4$var$Nr = $dbaf12f73216aff4$var$Vr).__esModule = !0, $dbaf12f73216aff4$var$Nr.default = $dbaf12f73216aff4$var$Nr;
var $dbaf12f73216aff4$var$Ur = {};
($dbaf12f73216aff4$var$Ur = function(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}).__esModule = !0, $dbaf12f73216aff4$var$Ur.default = $dbaf12f73216aff4$var$Ur;
var $dbaf12f73216aff4$var$qr, $dbaf12f73216aff4$var$Gr;
$dbaf12f73216aff4$var$Gr = "undefined" != typeof window ? window : void 0 !== $dbaf12f73216aff4$var$r ? $dbaf12f73216aff4$var$r : "undefined" != typeof self ? self : {}, $dbaf12f73216aff4$var$qr = $dbaf12f73216aff4$var$Gr;
var $dbaf12f73216aff4$var$Wr = (0, $fkrEL$Buffer);
function $dbaf12f73216aff4$var$jr(e) {
    for(var t, r = (t = e, $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$qr).atob ? $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$qr).atob(t) : $dbaf12f73216aff4$var$Wr.from(t, "base64").toString("binary")), i = new Uint8Array(r.length), s = 0; s < r.length; s++)i[s] = r.charCodeAt(s);
    return i;
}
var $dbaf12f73216aff4$var$Hr = function(e) {
    function t() {
        var t;
        return (t = e.call(this) || this).buffer = "", t;
    }
    return $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Ir)(t, e), t.prototype.push = function(e) {
        var t;
        for(this.buffer += e, t = this.buffer.indexOf("\n"); t > -1; t = this.buffer.indexOf("\n"))this.trigger("data", this.buffer.substring(0, t)), this.buffer = this.buffer.substring(t + 1);
    }, t;
}($dbaf12f73216aff4$var$kr), $dbaf12f73216aff4$var$Kr = String.fromCharCode(9), $dbaf12f73216aff4$var$Yr = function(e) {
    var t = /([0-9.]*)?@?([0-9.]*)?/.exec(e || ""), r = {};
    return t[1] && (r.length = parseInt(t[1], 10)), t[2] && (r.offset = parseInt(t[2], 10)), r;
}, $dbaf12f73216aff4$var$Qr = function(e) {
    for(var t, r = e.split(new RegExp('(?:^|,)((?:[^=]*)=(?:"[^"]*"|[^,]*))')), n = {}, i = r.length; i--;)"" !== r[i] && ((t = /([^=]*)=(.*)/.exec(r[i]).slice(1))[0] = t[0].replace(/^\s+|\s+$/g, ""), t[1] = t[1].replace(/^\s+|\s+$/g, ""), t[1] = t[1].replace(/^['"](.*)['"]$/g, "$1"), n[t[0]] = t[1]);
    return n;
}, $dbaf12f73216aff4$var$zr = function(e) {
    function t() {
        var t;
        return (t = e.call(this) || this).customParsers = [], t.tagMappers = [], t;
    }
    $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Ir)(t, e);
    var r = t.prototype;
    return r.push = function(e) {
        var t, r, i = this;
        0 !== (e = e.trim()).length && ("#" === e[0] ? this.tagMappers.reduce(function(t, r) {
            var n = r(e);
            return n === e ? t : t.concat([
                n
            ]);
        }, [
            e
        ]).forEach(function(e) {
            for(var s = 0; s < i.customParsers.length; s++)if (i.customParsers[s].call(i, e)) return;
            if (0 === e.indexOf("#EXT")) {
                if (e = e.replace("\r", ""), t = /^#EXTM3U/.exec(e)) i.trigger("data", {
                    type: "tag",
                    tagType: "m3u"
                });
                else {
                    if (t = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(e)) return r = {
                        type: "tag",
                        tagType: "inf"
                    }, t[1] && (r.duration = parseFloat(t[1])), t[2] && (r.title = t[2]), void i.trigger("data", r);
                    if (t = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(e)) return r = {
                        type: "tag",
                        tagType: "targetduration"
                    }, t[1] && (r.duration = parseInt(t[1], 10)), void i.trigger("data", r);
                    if (t = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(e)) return r = {
                        type: "tag",
                        tagType: "version"
                    }, t[1] && (r.version = parseInt(t[1], 10)), void i.trigger("data", r);
                    if (t = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(e)) return r = {
                        type: "tag",
                        tagType: "media-sequence"
                    }, t[1] && (r.number = parseInt(t[1], 10)), void i.trigger("data", r);
                    if (t = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(e)) return r = {
                        type: "tag",
                        tagType: "discontinuity-sequence"
                    }, t[1] && (r.number = parseInt(t[1], 10)), void i.trigger("data", r);
                    if (t = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(e)) return r = {
                        type: "tag",
                        tagType: "playlist-type"
                    }, t[1] && (r.playlistType = t[1]), void i.trigger("data", r);
                    if (t = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(e)) return r = $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Nr)($dbaf12f73216aff4$var$Yr(t[1]), {
                        type: "tag",
                        tagType: "byterange"
                    }), void i.trigger("data", r);
                    if (t = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(e)) return r = {
                        type: "tag",
                        tagType: "allow-cache"
                    }, t[1] && (r.allowed = !/NO/.test(t[1])), void i.trigger("data", r);
                    if (t = /^#EXT-X-MAP:?(.*)$/.exec(e)) {
                        if (r = {
                            type: "tag",
                            tagType: "map"
                        }, t[1]) {
                            var a = $dbaf12f73216aff4$var$Qr(t[1]);
                            a.URI && (r.uri = a.URI), a.BYTERANGE && (r.byterange = $dbaf12f73216aff4$var$Yr(a.BYTERANGE));
                        }
                        i.trigger("data", r);
                    } else if (t = /^#EXT-X-STREAM-INF:?(.*)$/.exec(e)) {
                        if (r = {
                            type: "tag",
                            tagType: "stream-inf"
                        }, t[1]) {
                            if (r.attributes = $dbaf12f73216aff4$var$Qr(t[1]), r.attributes.RESOLUTION) {
                                var o = r.attributes.RESOLUTION.split("x"), l = {};
                                o[0] && (l.width = parseInt(o[0], 10)), o[1] && (l.height = parseInt(o[1], 10)), r.attributes.RESOLUTION = l;
                            }
                            r.attributes.BANDWIDTH && (r.attributes.BANDWIDTH = parseInt(r.attributes.BANDWIDTH, 10)), r.attributes["PROGRAM-ID"] && (r.attributes["PROGRAM-ID"] = parseInt(r.attributes["PROGRAM-ID"], 10));
                        }
                        i.trigger("data", r);
                    } else {
                        if (t = /^#EXT-X-MEDIA:?(.*)$/.exec(e)) return r = {
                            type: "tag",
                            tagType: "media"
                        }, t[1] && (r.attributes = $dbaf12f73216aff4$var$Qr(t[1])), void i.trigger("data", r);
                        if (t = /^#EXT-X-ENDLIST/.exec(e)) i.trigger("data", {
                            type: "tag",
                            tagType: "endlist"
                        });
                        else if (t = /^#EXT-X-DISCONTINUITY/.exec(e)) i.trigger("data", {
                            type: "tag",
                            tagType: "discontinuity"
                        });
                        else {
                            if (t = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "program-date-time"
                            }, t[1] && (r.dateTimeString = t[1], r.dateTimeObject = new Date(t[1])), void i.trigger("data", r);
                            if (t = /^#EXT-X-KEY:?(.*)$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "key"
                            }, t[1] && (r.attributes = $dbaf12f73216aff4$var$Qr(t[1]), r.attributes.IV && ("0x" === r.attributes.IV.substring(0, 2).toLowerCase() && (r.attributes.IV = r.attributes.IV.substring(2)), r.attributes.IV = r.attributes.IV.match(/.{8}/g), r.attributes.IV[0] = parseInt(r.attributes.IV[0], 16), r.attributes.IV[1] = parseInt(r.attributes.IV[1], 16), r.attributes.IV[2] = parseInt(r.attributes.IV[2], 16), r.attributes.IV[3] = parseInt(r.attributes.IV[3], 16), r.attributes.IV = new Uint32Array(r.attributes.IV))), void i.trigger("data", r);
                            if (t = /^#EXT-X-START:?(.*)$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "start"
                            }, t[1] && (r.attributes = $dbaf12f73216aff4$var$Qr(t[1]), r.attributes["TIME-OFFSET"] = parseFloat(r.attributes["TIME-OFFSET"]), r.attributes.PRECISE = /YES/.test(r.attributes.PRECISE)), void i.trigger("data", r);
                            if (t = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "cue-out-cont"
                            }, t[1] ? r.data = t[1] : r.data = "", void i.trigger("data", r);
                            if (t = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "cue-out"
                            }, t[1] ? r.data = t[1] : r.data = "", void i.trigger("data", r);
                            if (t = /^#EXT-X-CUE-IN:?(.*)?$/.exec(e)) return r = {
                                type: "tag",
                                tagType: "cue-in"
                            }, t[1] ? r.data = t[1] : r.data = "", void i.trigger("data", r);
                            if ((t = /^#EXT-X-SKIP:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "skip"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), r.attributes.hasOwnProperty("SKIPPED-SEGMENTS") && (r.attributes["SKIPPED-SEGMENTS"] = parseInt(r.attributes["SKIPPED-SEGMENTS"], 10)), r.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES") && (r.attributes["RECENTLY-REMOVED-DATERANGES"] = r.attributes["RECENTLY-REMOVED-DATERANGES"].split($dbaf12f73216aff4$var$Kr)), void i.trigger("data", r);
                            if ((t = /^#EXT-X-PART:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "part"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), [
                                "DURATION"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = parseFloat(r.attributes[e]));
                            }), [
                                "INDEPENDENT",
                                "GAP"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = /YES/.test(r.attributes[e]));
                            }), r.attributes.hasOwnProperty("BYTERANGE") && (r.attributes.byterange = $dbaf12f73216aff4$var$Yr(r.attributes.BYTERANGE)), void i.trigger("data", r);
                            if ((t = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "server-control"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), [
                                "CAN-SKIP-UNTIL",
                                "PART-HOLD-BACK",
                                "HOLD-BACK"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = parseFloat(r.attributes[e]));
                            }), [
                                "CAN-SKIP-DATERANGES",
                                "CAN-BLOCK-RELOAD"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = /YES/.test(r.attributes[e]));
                            }), void i.trigger("data", r);
                            if ((t = /^#EXT-X-PART-INF:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "part-inf"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), [
                                "PART-TARGET"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = parseFloat(r.attributes[e]));
                            }), void i.trigger("data", r);
                            if ((t = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "preload-hint"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), [
                                "BYTERANGE-START",
                                "BYTERANGE-LENGTH"
                            ].forEach(function(e) {
                                if (r.attributes.hasOwnProperty(e)) {
                                    r.attributes[e] = parseInt(r.attributes[e], 10);
                                    var t = "BYTERANGE-LENGTH" === e ? "length" : "offset";
                                    r.attributes.byterange = r.attributes.byterange || {}, r.attributes.byterange[t] = r.attributes[e], delete r.attributes[e];
                                }
                            }), void i.trigger("data", r);
                            if ((t = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(e)) && t[1]) return (r = {
                                type: "tag",
                                tagType: "rendition-report"
                            }).attributes = $dbaf12f73216aff4$var$Qr(t[1]), [
                                "LAST-MSN",
                                "LAST-PART"
                            ].forEach(function(e) {
                                r.attributes.hasOwnProperty(e) && (r.attributes[e] = parseInt(r.attributes[e], 10));
                            }), void i.trigger("data", r);
                            i.trigger("data", {
                                type: "tag",
                                data: e.slice(4)
                            });
                        }
                    }
                }
            } else i.trigger("data", {
                type: "comment",
                text: e.slice(1)
            });
        }) : this.trigger("data", {
            type: "uri",
            uri: e
        }));
    }, r.addParser = function(e) {
        var t = this, r = e.expression, n = e.customType, i = e.dataParser, s = e.segment;
        "function" != typeof i && (i = function(e) {
            return e;
        }), this.customParsers.push(function(e) {
            if (r.exec(e)) return t.trigger("data", {
                type: "custom",
                data: i(e),
                customType: n,
                segment: s
            }), !0;
        });
    }, r.addTagMapper = function(e) {
        var t = e.expression, r = e.map;
        this.tagMappers.push(function(e) {
            return t.test(e) ? r(e) : e;
        });
    }, t;
}($dbaf12f73216aff4$var$kr), $dbaf12f73216aff4$var$Xr = function(e) {
    var t = {};
    return Object.keys(e).forEach(function(r) {
        var n;
        t[n = r, n.toLowerCase().replace(/-(\w)/g, function(e) {
            return e[1].toUpperCase();
        })] = e[r];
    }), t;
}, $dbaf12f73216aff4$var$Zr = function(e) {
    var t = e.serverControl, r = e.targetDuration, n = e.partTargetDuration;
    if (t) {
        var i = "#EXT-X-SERVER-CONTROL", s = "holdBack", a = "partHoldBack", o = r && 3 * r, l = n && 2 * n;
        r && !t.hasOwnProperty(s) && (t[s] = o, this.trigger("info", {
            message: i + " defaulting HOLD-BACK to targetDuration * 3 (" + o + ")."
        })), o && t[s] < o && (this.trigger("warn", {
            message: i + " clamping HOLD-BACK (" + t[s] + ") to targetDuration * 3 (" + o + ")"
        }), t[s] = o), n && !t.hasOwnProperty(a) && (t[a] = 3 * n, this.trigger("info", {
            message: i + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + t[a] + ")."
        })), n && t[a] < l && (this.trigger("warn", {
            message: i + " clamping PART-HOLD-BACK (" + t[a] + ") to partTargetDuration * 2 (" + l + ")."
        }), t[a] = l);
    }
}, $dbaf12f73216aff4$var$Jr = function(e) {
    function t() {
        var t;
        (t = e.call(this) || this).lineStream = new $dbaf12f73216aff4$var$Hr, t.parseStream = new $dbaf12f73216aff4$var$zr, t.lineStream.pipe(t.parseStream);
        var r, i, s = $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Ur)(t), a = [], o = {}, l = !1, u = function() {}, d = {
            AUDIO: {},
            VIDEO: {},
            "CLOSED-CAPTIONS": {},
            SUBTITLES: {}
        }, c = 0;
        t.manifest = {
            allowCache: !0,
            discontinuityStarts: [],
            segments: []
        };
        var h = 0, f = 0;
        return t.on("end", function() {
            o.uri || !o.parts && !o.preloadHints || (!o.map && r && (o.map = r), !o.key && i && (o.key = i), o.timeline || "number" != typeof c || (o.timeline = c), t.manifest.preloadSegment = o);
        }), t.parseStream.on("data", function(e) {
            var t, _;
            ({
                tag: function() {
                    (({
                        version: function() {
                            e.version && (this.manifest.version = e.version);
                        },
                        "allow-cache": function() {
                            this.manifest.allowCache = e.allowed, "allowed" in e || (this.trigger("info", {
                                message: "defaulting allowCache to YES"
                            }), this.manifest.allowCache = !0);
                        },
                        byterange: function() {
                            var t = {};
                            "length" in e && (o.byterange = t, t.length = e.length, "offset" in e || (e.offset = h)), "offset" in e && (o.byterange = t, t.offset = e.offset), h = t.offset + t.length;
                        },
                        endlist: function() {
                            this.manifest.endList = !0;
                        },
                        inf: function() {
                            "mediaSequence" in this.manifest || (this.manifest.mediaSequence = 0, this.trigger("info", {
                                message: "defaulting media sequence to zero"
                            })), "discontinuitySequence" in this.manifest || (this.manifest.discontinuitySequence = 0, this.trigger("info", {
                                message: "defaulting discontinuity sequence to zero"
                            })), e.duration > 0 && (o.duration = e.duration), 0 === e.duration && (o.duration = .01, this.trigger("info", {
                                message: "updating zero segment duration to a small value"
                            })), this.manifest.segments = a;
                        },
                        key: function() {
                            if (e.attributes) {
                                if ("NONE" !== e.attributes.METHOD) {
                                    if (e.attributes.URI) {
                                        if ("com.apple.streamingkeydelivery" === e.attributes.KEYFORMAT) return this.manifest.contentProtection = this.manifest.contentProtection || {}, void (this.manifest.contentProtection["com.apple.fps.1_0"] = {
                                            attributes: e.attributes
                                        });
                                        if ("com.microsoft.playready" === e.attributes.KEYFORMAT) return this.manifest.contentProtection = this.manifest.contentProtection || {}, void (this.manifest.contentProtection["com.microsoft.playready"] = {
                                            uri: e.attributes.URI
                                        });
                                        if ("urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed" === e.attributes.KEYFORMAT) return -1 === [
                                            "SAMPLE-AES",
                                            "SAMPLE-AES-CTR",
                                            "SAMPLE-AES-CENC"
                                        ].indexOf(e.attributes.METHOD) ? void this.trigger("warn", {
                                            message: "invalid key method provided for Widevine"
                                        }) : ("SAMPLE-AES-CENC" === e.attributes.METHOD && this.trigger("warn", {
                                            message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                                        }), "data:text/plain;base64," !== e.attributes.URI.substring(0, 23) ? void this.trigger("warn", {
                                            message: "invalid key URI provided for Widevine"
                                        }) : e.attributes.KEYID && "0x" === e.attributes.KEYID.substring(0, 2) ? (this.manifest.contentProtection = this.manifest.contentProtection || {}, void (this.manifest.contentProtection["com.widevine.alpha"] = {
                                            attributes: {
                                                schemeIdUri: e.attributes.KEYFORMAT,
                                                keyId: e.attributes.KEYID.substring(2)
                                            },
                                            pssh: $dbaf12f73216aff4$var$jr(e.attributes.URI.split(",")[1])
                                        })) : void this.trigger("warn", {
                                            message: "invalid key ID provided for Widevine"
                                        }));
                                        e.attributes.METHOD || this.trigger("warn", {
                                            message: "defaulting key method to AES-128"
                                        }), i = {
                                            method: e.attributes.METHOD || "AES-128",
                                            uri: e.attributes.URI
                                        }, void 0 !== e.attributes.IV && (i.iv = e.attributes.IV);
                                    } else this.trigger("warn", {
                                        message: "ignoring key declaration without URI"
                                    });
                                } else i = null;
                            } else this.trigger("warn", {
                                message: "ignoring key declaration without attribute list"
                            });
                        },
                        "media-sequence": function() {
                            isFinite(e.number) ? this.manifest.mediaSequence = e.number : this.trigger("warn", {
                                message: "ignoring invalid media sequence: " + e.number
                            });
                        },
                        "discontinuity-sequence": function() {
                            isFinite(e.number) ? (this.manifest.discontinuitySequence = e.number, c = e.number) : this.trigger("warn", {
                                message: "ignoring invalid discontinuity sequence: " + e.number
                            });
                        },
                        "playlist-type": function() {
                            /VOD|EVENT/.test(e.playlistType) ? this.manifest.playlistType = e.playlistType : this.trigger("warn", {
                                message: "ignoring unknown playlist type: " + e.playlist
                            });
                        },
                        map: function() {
                            r = {}, e.uri && (r.uri = e.uri), e.byterange && (r.byterange = e.byterange), i && (r.key = i);
                        },
                        "stream-inf": function() {
                            this.manifest.playlists = a, this.manifest.mediaGroups = this.manifest.mediaGroups || d, e.attributes ? (o.attributes || (o.attributes = {}), $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Nr)(o.attributes, e.attributes)) : this.trigger("warn", {
                                message: "ignoring empty stream-inf attributes"
                            });
                        },
                        media: function() {
                            if (this.manifest.mediaGroups = this.manifest.mediaGroups || d, e.attributes && e.attributes.TYPE && e.attributes["GROUP-ID"] && e.attributes.NAME) {
                                var r = this.manifest.mediaGroups[e.attributes.TYPE];
                                r[e.attributes["GROUP-ID"]] = r[e.attributes["GROUP-ID"]] || {}, t = r[e.attributes["GROUP-ID"]], (_ = {
                                    default: /yes/i.test(e.attributes.DEFAULT)
                                }).default ? _.autoselect = !0 : _.autoselect = /yes/i.test(e.attributes.AUTOSELECT), e.attributes.LANGUAGE && (_.language = e.attributes.LANGUAGE), e.attributes.URI && (_.uri = e.attributes.URI), e.attributes["INSTREAM-ID"] && (_.instreamId = e.attributes["INSTREAM-ID"]), e.attributes.CHARACTERISTICS && (_.characteristics = e.attributes.CHARACTERISTICS), e.attributes.FORCED && (_.forced = /yes/i.test(e.attributes.FORCED)), t[e.attributes.NAME] = _;
                            } else this.trigger("warn", {
                                message: "ignoring incomplete or missing media group"
                            });
                        },
                        discontinuity: function() {
                            c += 1, o.discontinuity = !0, this.manifest.discontinuityStarts.push(a.length);
                        },
                        "program-date-time": function() {
                            void 0 === this.manifest.dateTimeString && (this.manifest.dateTimeString = e.dateTimeString, this.manifest.dateTimeObject = e.dateTimeObject), o.dateTimeString = e.dateTimeString, o.dateTimeObject = e.dateTimeObject;
                        },
                        targetduration: function() {
                            !isFinite(e.duration) || e.duration < 0 ? this.trigger("warn", {
                                message: "ignoring invalid target duration: " + e.duration
                            }) : (this.manifest.targetDuration = e.duration, $dbaf12f73216aff4$var$Zr.call(this, this.manifest));
                        },
                        start: function() {
                            e.attributes && !isNaN(e.attributes["TIME-OFFSET"]) ? this.manifest.start = {
                                timeOffset: e.attributes["TIME-OFFSET"],
                                precise: e.attributes.PRECISE
                            } : this.trigger("warn", {
                                message: "ignoring start declaration without appropriate attribute list"
                            });
                        },
                        "cue-out": function() {
                            o.cueOut = e.data;
                        },
                        "cue-out-cont": function() {
                            o.cueOutCont = e.data;
                        },
                        "cue-in": function() {
                            o.cueIn = e.data;
                        },
                        skip: function() {
                            this.manifest.skip = $dbaf12f73216aff4$var$Xr(e.attributes), this.warnOnMissingAttributes_("#EXT-X-SKIP", e.attributes, [
                                "SKIPPED-SEGMENTS"
                            ]);
                        },
                        part: function() {
                            var t = this;
                            l = !0;
                            var r = this.manifest.segments.length, n = $dbaf12f73216aff4$var$Xr(e.attributes);
                            o.parts = o.parts || [], o.parts.push(n), n.byterange && (n.byterange.hasOwnProperty("offset") || (n.byterange.offset = f), f = n.byterange.offset + n.byterange.length);
                            var i = o.parts.length - 1;
                            this.warnOnMissingAttributes_("#EXT-X-PART #" + i + " for segment #" + r, e.attributes, [
                                "URI",
                                "DURATION"
                            ]), this.manifest.renditionReports && this.manifest.renditionReports.forEach(function(e, r) {
                                e.hasOwnProperty("lastPart") || t.trigger("warn", {
                                    message: "#EXT-X-RENDITION-REPORT #" + r + " lacks required attribute(s): LAST-PART"
                                });
                            });
                        },
                        "server-control": function() {
                            var t = this.manifest.serverControl = $dbaf12f73216aff4$var$Xr(e.attributes);
                            t.hasOwnProperty("canBlockReload") || (t.canBlockReload = !1, this.trigger("info", {
                                message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
                            })), $dbaf12f73216aff4$var$Zr.call(this, this.manifest), t.canSkipDateranges && !t.hasOwnProperty("canSkipUntil") && this.trigger("warn", {
                                message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
                            });
                        },
                        "preload-hint": function() {
                            var t = this.manifest.segments.length, r = $dbaf12f73216aff4$var$Xr(e.attributes), n = r.type && "PART" === r.type;
                            o.preloadHints = o.preloadHints || [], o.preloadHints.push(r), r.byterange && (r.byterange.hasOwnProperty("offset") || (r.byterange.offset = n ? f : 0, n && (f = r.byterange.offset + r.byterange.length)));
                            var i = o.preloadHints.length - 1;
                            if (this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + i + " for segment #" + t, e.attributes, [
                                "TYPE",
                                "URI"
                            ]), r.type) for(var s = 0; s < o.preloadHints.length - 1; s++){
                                var a = o.preloadHints[s];
                                a.type && a.type === r.type && this.trigger("warn", {
                                    message: "#EXT-X-PRELOAD-HINT #" + i + " for segment #" + t + " has the same TYPE " + r.type + " as preload hint #" + s
                                });
                            }
                        },
                        "rendition-report": function() {
                            var t = $dbaf12f73216aff4$var$Xr(e.attributes);
                            this.manifest.renditionReports = this.manifest.renditionReports || [], this.manifest.renditionReports.push(t);
                            var r = this.manifest.renditionReports.length - 1, n = [
                                "LAST-MSN",
                                "URI"
                            ];
                            l && n.push("LAST-PART"), this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + r, e.attributes, n);
                        },
                        "part-inf": function() {
                            this.manifest.partInf = $dbaf12f73216aff4$var$Xr(e.attributes), this.warnOnMissingAttributes_("#EXT-X-PART-INF", e.attributes, [
                                "PART-TARGET"
                            ]), this.manifest.partInf.partTarget && (this.manifest.partTargetDuration = this.manifest.partInf.partTarget), $dbaf12f73216aff4$var$Zr.call(this, this.manifest);
                        }
                    })[e.tagType] || u).call(s);
                },
                uri: function() {
                    o.uri = e.uri, a.push(o), this.manifest.targetDuration && !("duration" in o) && (this.trigger("warn", {
                        message: "defaulting segment duration to the target duration"
                    }), o.duration = this.manifest.targetDuration), i && (o.key = i), o.timeline = c, r && (o.map = r), f = 0, o = {};
                },
                comment: function() {},
                custom: function() {
                    e.segment ? (o.custom = o.custom || {}, o.custom[e.customType] = e.data) : (this.manifest.custom = this.manifest.custom || {}, this.manifest.custom[e.customType] = e.data);
                }
            })[e.type].call(s);
        }), t;
    }
    $dbaf12f73216aff4$var$n($dbaf12f73216aff4$var$Ir)(t, e);
    var r = t.prototype;
    return r.warnOnMissingAttributes_ = function(e, t, r) {
        var n = [];
        r.forEach(function(e) {
            t.hasOwnProperty(e) || n.push(e);
        }), n.length && this.trigger("warn", {
            message: e + " lacks required attribute(s): " + n.join(", ")
        });
    }, r.push = function(e) {
        this.lineStream.push(e);
    }, r.end = function() {
        this.lineStream.push("\n"), this.trigger("end");
    }, r.addParser = function(e) {
        this.parseStream.addParser(e);
    }, r.addTagMapper = function(e) {
        this.parseStream.addTagMapper(e);
    }, t;
}($dbaf12f73216aff4$var$kr);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
const $dbaf12f73216aff4$var$en = (e, t)=>e.reduce((e, t)=>(t.startTs = e.prevStart, t.endTs = t.startTs + t.duration, e.prevStart = t.endTs, e.parts.push(t), e), {
        parts: [],
        prevStart: t
    }).parts, $dbaf12f73216aff4$var$tn = (e, t = {})=>{
    const r = e.mediaSequence, n = e.segments.map((e, t)=>({
            ...e,
            uri: e.uri,
            msnNumber: r + t,
            partNumber: 0,
            parts: (e?.parts || []).map((e, n)=>({
                    ...e,
                    msnNumber: r + t,
                    partNumber: n
                }))
        })).map((e)=>(e.parts = e.dateTimeObject ? $dbaf12f73216aff4$var$en(e.parts, e.dateTimeObject.getTime() / 1e3) : e.parts, e)), i = r + n.length, s = (e.preloadSegment?.parts || []).map((e, t)=>({
            ...e,
            msnNumber: i,
            partNumber: t
        })), a = (e.preloadSegment?.preloadHints || []).map((e, t)=>({
            ...e,
            msnNumber: i,
            partNumber: t + s.length
        })), o = n.slice(-1)[0], l = {
        ...e.preloadSegment,
        parts: e.preloadSegment && o.dateTimeObject ? $dbaf12f73216aff4$var$en(s, o.dateTimeObject.getTime() / 1e3 + o.duration) : s,
        preloadHints: a,
        msnNumber: i,
        partNumber: 0
    }, u = {
        ...e,
        segments: n,
        preloadSegment: l
    };
    return t.partHoldBack && (u.partHoldBack = t.partHoldBack), u;
};
class $dbaf12f73216aff4$var$$361586a50c32ab56$export$d6c195e44d5413 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _lastPlaylistContent = "";
    _samePlaylistsCount = 0;
    _isActive = !0;
    _currentPlaylistLoader = null;
    _url = null;
    constructor(e, t, r){
        super(t, r), this._logger = $dbaf12f73216aff4$var$J(r, `Doppio - ${e}`), this._lifecycleEventReporter = $dbaf12f73216aff4$var$er("playlistRotator", this._eventBus), this._logger.info("Instance created");
    }
    destroy() {
        super.destroy(), this._isActive = !1, this._logger.info("Destroyed");
    }
    _onPlaylistLoadingStateChanged(e, t) {
        if (!this._isActive) return void this._logger.warn("Loader was destroyed, but we are trying to load handle playlist load state change!");
        if (!this._currentPlaylistLoader || [
            $dbaf12f73216aff4$var$Tr.ABORTED,
            $dbaf12f73216aff4$var$Tr.ERROR
        ].includes(t)) return this._lifecycleEventReporter(`Loading error reported, ${this._currentPlaylistLoader?.error}`), this._logger.warn(`Playlist loader reported ${t === $dbaf12f73216aff4$var$Tr.ERROR ? "error" : "as aborted"} (${this._currentPlaylistLoader?.error?.statusText || "no error"} with status ${this._currentPlaylistLoader?.error?.statusText || "no status"}). Planning next load`), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistLoadingError, {
            error: this._currentPlaylistLoader?.error
        }), t === $dbaf12f73216aff4$var$Tr.ERROR && "4" === this._currentPlaylistLoader?.error?.status.toString()[0] && (this._logger.warn("Playlist loading reported 4xx status. Requesting start over"), this._eventBus.publish($dbaf12f73216aff4$var$Nt.requestRestartFromMain, {})), this._currentPlaylistLoader = null, void this._planNextLoad();
        if (t !== $dbaf12f73216aff4$var$Tr.LOADED) return;
        if (!this._isPlaylistValid(this._currentPlaylistLoader.data)) return this._logger.warn("Playlist seems to be invalid. Plan next load"), this._currentPlaylistLoader = null, void this._planNextLoad();
        this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistLoaded, {
            originalUrl: this._url,
            realUrl: this._currentPlaylistLoader.realUrl,
            stats: this._currentPlaylistLoader.stats
        });
        const r = this._currentPlaylistLoader.data, n = this._isPlaylistChanged(r);
        if (this._currentPlaylistLoader = null, !n) return this._logger.warn("Loaded playlist is identical to previous one. Skipping it"), void this._planNextLoad();
        const i = this._parsePlaylist(r);
        if (!i) return this._logger.warn("Empty playlist parse result! Should restart"), void this._eventBus.publish($dbaf12f73216aff4$var$Nt.requestRestartFromMain, {});
        this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistInfo, i), this._lifecycleEventReporter("Playlist loaded"), this._handleParsedPlaylist(i);
    }
    _isPlaylistValid(e) {
        return Boolean(e?.trim().length) && e?.includes("#EXT-X-VERSION");
    }
    _isPlaylistChanged(e) {
        return this._lastPlaylistContent !== e;
    }
    _isPlaylistUpToDate(e) {
        if (void 0 !== this.config.equalPlaylistsAmountToDecline && this.config.equalPlaylistsAmountToDecline < 1) return !0;
        if (e === this._lastPlaylistContent) {
            this._samePlaylistsCount++;
            const { equalPlaylistsAmountToDecline: e = 2 } = this.config;
            if (this._samePlaylistsCount >= e) return !1;
        } else this._samePlaylistsCount = 0;
        return this._lastPlaylistContent = e, !0;
    }
    _parsePlaylist(e) {
        this._logger.verbose("Parsing manifest");
        try {
            const t = new $dbaf12f73216aff4$var$Jr;
            t.push(e), t.end();
            const { manifest: r } = t;
            this._logger.verbose("Manifest parsed");
            const n = Array.isArray(r?.playlists) && r.playlists.length > 0, i = Array.isArray(r?.segments) && r.segments.length > 0;
            return n || i || $dbaf12f73216aff4$var$Rr.reportError("Playlist seems to be parsed invalid", {
                playlistContent: e,
                playlistUrl: this._url,
                parsedPlaylistResult: r
            }), $dbaf12f73216aff4$var$tn(r, {
                partHoldBack: this.config.partHoldBack ? this.config.partHoldBack / 1e3 : void 0
            });
        } catch (t) {
            return $dbaf12f73216aff4$var$Rr.reportError("Could not parse playlist", {
                playlistContent: e,
                playlistUrl: this._url
            }), null;
        }
    }
    _isMultiVariantPlaylist(e) {
        return e.playlists && (!e.segments || Array.isArray(e.segments) && 0 === e.segments.length);
    }
    _isVODPlaylist(e) {
        return "VOD" === e.playlistType || e.endList;
    }
    _isSimplePlaylist(e) {
        return !this._isLowLatencyPlaylist(e) && !this._isVODPlaylist(e);
    }
    _isLowLatencyPlaylist(e) {
        return Boolean(e.partInf);
    }
    _handleFragmentsDetected(e) {
        this._logger.verbose("Detected fragments", e.map((e)=>e.getMsnPn())), this._logger.debug("Fragments was detected and extracted. Emitting it"), this._lifecycleEventReporter(`Found fragments ${e.map(({ url: e })=>e).join(",")}`), this._eventBus.publish($dbaf12f73216aff4$var$Ft.fragments.fragmentsDetected, e);
    }
    _handleLLManifestDetected(e) {
        this._logger.debug("Low-latency playlist detected. Emitting it"), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlistType.llDetected, e);
    }
    _handleVODPlaylist(e) {
        this._logger.debug("VOD playlist detected. Emitting it"), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlistType.vodDetected, e);
    }
    _handleMultivariantManifestDetected(e) {
        const t = e.playlists.reduce((e, t)=>(e[t.attributes.NAME] = {
                name: t.attributes.NAME,
                bitrate: t.attributes.BANDWIDTH,
                url: t.uri,
                width: t.attributes.RESOLUTION.width,
                height: t.attributes.RESOLUTION.height,
                fps: t.attributes["FRAME-RATE"]
            }, e), {});
        this._logger.verbose("Variants detected", t), this._logger.debug("Multivariant playlist detected. Emitting it"), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlistType.multivariantDetected, t);
    }
    _handleSimplePlaylistDetected(e) {
        this._logger.debug("Simple playlist detected. Emitting it"), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlistType.simpleDetected, e);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$361586a50c32ab56$export$d6c195e44d5413.prototype, "_onPlaylistLoadingStateChanged", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f extends $dbaf12f73216aff4$var$$361586a50c32ab56$export$d6c195e44d5413 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "loader"
    ];
    _playlistLoaderTimeout = null;
    _nextMSN = -1;
    _nextPN = -1;
    _partHoldBack = -1;
    _lastLoadedFragment = null;
    _awaitingFragmentURL = null;
    _hasLoadedInitialAmount = !1;
    constructor(e, t){
        const { url: r, startManifest: n, initialMSN: i, initialPN: s, lastLoadedFragment: a } = t;
        super("LLPlaylistRotationController", "playlistLoader", e), this._lifecycleEventReporter("Created"), this._url = r, this._lastLoadedFragment = a, n ? this._handleParsedPlaylist(n) : (this._nextMSN = Number.isFinite(i) ? i : -1, this._nextPN = Number.isFinite(s) ? s : -1, this._loadNextPlaylist()), this._onSegmentLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoaded, this._onFragmentFinished), this._onSegmentFailedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingError, this._onFragmentFinished), this._onSegmentAbortedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingAborted, this._onFragmentFinished), this._onFragmentAddedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.fragmentAdded, this._onFragmentAdded), this.config.targetBufferMultiplier && this.config.targetBufferMultiplier < 1 && this._logger.warn("Target buffer multiplier set to value lower than 1. It is unsafe to load less than target-duration, forcing no multiplier instead");
    }
    destroy() {
        this._isActive = !1, super.destroy(), this._currentPlaylistLoader?.destroy(), this._currentPlaylistLoader = null, this._logger.info("Destroy controller"), this._eventBus.unsubscribe(this._onSegmentLoadedListener), this._eventBus.unsubscribe(this._onSegmentAbortedListener), this._eventBus.unsubscribe(this._onSegmentFailedListener), this._eventBus.unsubscribe(this._onFragmentAddedListener), this._lifecycleEventReporter("Destroyed");
    }
    abortCurrentPlaylistLoading() {
        this._logger.info("Aborting current loading playlist");
    }
    setURL(e, t) {
        t ? this._url = e : (this._logger.info(`Setting new url ${e}`), this._currentPlaylistLoader?.destroy(), this._url = e, this._nextPN = -1, this._nextMSN = -1, this._loadNextPlaylist());
    }
    _handleConfigUpdated(e) {
        if (e.equalPlaylistsAmountToDecline && (this._samePlaylistsCount = 0), !1 === e.lowLatencyMode) {
            const e = this._parsePlaylist(this._lastPlaylistContent);
            e ? this._handleSimplePlaylistDetected(e) : this._eventBus.publish($dbaf12f73216aff4$var$Nt.requestRestartFromMain, {});
        }
    }
    _loadNextPlaylist() {
        if (!this._isActive) return void this._logger.warn("Loader was destroying, but we trying to load next playlist!");
        const { playlistLoadingTimeout: e } = this.config;
        this._logger.debug("Loading next playlist"), this._lifecycleEventReporter(`Loading next playlist with url ${this._url}`), this.status = "Loading playlist", this._currentPlaylistLoader && this._currentPlaylistLoader.cancel(`Another playlist with url ${this._url} scheduled to load`);
        const t = this._buildUrl();
        this._currentPlaylistLoader = new $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96({
            url: t,
            loadingTimeout: e,
            autoLoad: !0,
            mode: "text",
            onStateChanged: this._onPlaylistLoadingStateChanged,
            workerMode: this.config.workerMode,
            requestCustomReferer: this.config.sendCustomRefererHeader ? $dbaf12f73216aff4$var$l().location?.href : void 0
        }, this._eventBus), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistRequested, {});
    }
    _handleParsedPlaylist(e) {
        this._lifecycleEventReporter("Playlist parsed");
        const t = Math.max(this.config.targetBufferMultiplier, 1);
        if (this._partHoldBack = $dbaf12f73216aff4$var$dr(e, e.targetDuration || 2) * t, this._isMultiVariantPlaylist(e)) return void this._handleMultivariantManifestDetected(e);
        if (this._isSimplePlaylist(e)) return void this._handleSimplePlaylistDetected(e);
        if (this._isVODPlaylist(e)) return void this._handleVODPlaylist(e);
        const r = 0 === (e.preloadSegment.parts || []).length, n = e.segments.flatMap((t)=>t.parts.map(({ uri: t, independent: r, partNumber: n, startTs: i, endTs: s, msnNumber: a, duration: o })=>new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
                    url: t,
                    independent: r ? $dbaf12f73216aff4$var$Er.INDEPENDENT : $dbaf12f73216aff4$var$Er.PART,
                    msn: a,
                    pn: n,
                    duration: o,
                    isTransmuxingBypassRequested: !!e.segments[0].map?.uri,
                    startTs: i,
                    endTs: s
                }, this._eventBus, this.config.shouldLogFragmentsHistory))).concat((e.preloadSegment.parts || []).map(({ uri: t, independent: r = !1, msnNumber: n, partNumber: i, startTs: s, endTs: a, duration: o })=>new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
                url: t,
                independent: r ? $dbaf12f73216aff4$var$Er.INDEPENDENT : $dbaf12f73216aff4$var$Er.PART,
                msn: n,
                pn: i,
                duration: o,
                isTransmuxingBypassRequested: !!e.segments[0].map?.uri,
                startTs: s,
                endTs: a
            }, this._eventBus, this.config.shouldLogFragmentsHistory))).filter(({ msn: e, pn: t })=>!this._hasLoadedInitialAmount || e > this._nextMSN || e === this._nextMSN && t >= this._nextPN), i = n.reverse(), s = i.reduce((e, t)=>(e.currentDuration < this._partHoldBack && (e.currentIndex += 1, e.currentDuration += t.duration), e), {
            currentDuration: 0,
            currentIndex: -1
        }).currentIndex, a = this._lastLoadedFragment ? i.findIndex((e)=>(e.startTs || 0) < (this._lastLoadedFragment?.endTs || 0)) : -1, o = Math.min(i.length, Math.max(s, a) + this.config.additionalStartParts);
        this._logger.debug(`Minimal part ${i[o]?.msn}:${i[o]?.pn}(${new Date(i[o]?.startTs || 0)})`);
        let l = i.findIndex(({ independent: e }, t)=>t >= o && e === $dbaf12f73216aff4$var$Er.INDEPENDENT);
        -1 === l && (l = i.length - 1), this._logger.debug(`Part to start load from: ${i[l]?.msn}:${i[l]?.pn}`);
        const u = l > -1 ? i.slice(0, l + 1).reverse() : n;
        this.config.blockingMode === $dbaf12f73216aff4$var$$t.WAIT_FOR_PREFETCH_SEGMENT && Array.isArray(e.preloadSegment.preloadHints) && e.preloadSegment.preloadHints.length && (this._awaitingFragmentURL = e.preloadSegment.preloadHints[0]?.uri || null, u.push(...e.preloadSegment.preloadHints.map(({ uri: t, msnNumber: r, partNumber: n })=>new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
                url: t,
                independent: $dbaf12f73216aff4$var$Er.UNKNOWN,
                msn: r,
                pn: n,
                duration: 0,
                isTransmuxingBypassRequested: !!e.segments[0].map?.uri
            }, this._eventBus, this.config.shouldLogFragmentsHistory)))), e.segments[0].map?.uri && u.unshift(new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
            playlistUrl: this._url || "",
            fragmentUrl: e.segments[0].map?.uri,
            duration: 0,
            independent: $dbaf12f73216aff4$var$Er.INDEPENDENT,
            msn: -1,
            pn: -1,
            isTransmuxingBypassRequested: !0,
            isInitSection: !0
        }, this._eventBus, this.config.shouldLogFragmentsHistory)), this._handleFragmentsDetected(u), this._hasLoadedInitialAmount = !0, this._nextMSN = e.mediaSequence + e.segments.length, this._nextPN = (e.preloadSegment.parts || []).length, this.additionalInfo.msn = this._nextMSN, this.additionalInfo.pn = this._nextPN, this.status = "Awaiting fragment to load next playlist", r && this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.lastPlaylistOfSegmentLoaded, {}), this.config.blockingMode !== $dbaf12f73216aff4$var$$t.WAIT_FOR_PLAYLIST || this._loadNextPlaylist();
    }
    _planNextLoad() {
        this._playlistLoaderTimeout = $dbaf12f73216aff4$var$l().setTimeout(()=>{
            this._loadNextPlaylist();
        }, this.config.retryLowLatencyPlaylistTimeout);
    }
    _buildUrl() {
        if (-1 === this._nextPN || -1 === this._nextMSN) return this._url || "";
        if (!this._url) return "";
        const e = new URL(this._url);
        return e.searchParams.set("_HLS_msn", `${this._nextMSN}`), e.searchParams.set("_HLS_part", `${this._nextPN}`), e.toString();
    }
    _onFragmentFinished(e) {
        this._logger.debug(`${e.startTs} -> ${e.endTs} loaded (${e.getMsnPn()})`), this.config.blockingMode === $dbaf12f73216aff4$var$$t.WAIT_FOR_PREFETCH_SEGMENT && this._awaitingFragmentURL === e.url && (this._logger.debug("Prefetch segment is ready now, loading next playlist"), this._loadNextPlaylist());
    }
    _onFragmentAdded(e) {
        this._lastLoadedFragment = e;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f.prototype, "_onFragmentFinished", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f.prototype, "_onFragmentAdded", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$02239b8900a03868$export$aeb440a09d15d517 extends $dbaf12f73216aff4$var$$361586a50c32ab56$export$d6c195e44d5413 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "loader"
    ];
    additionalInfo = {};
    _playlistLoaderTimeout = null;
    _lastTargetDuration = 2;
    constructor(e, t, r){
        super("SimplePlaylistRotationController", "playlistLoader", e), this._lifecycleEventReporter("Created"), this._url = t, r ? this._handleParsedPlaylist(r) : this._loadNextPlaylist();
    }
    destroy() {
        this._isActive = !1, super.destroy(), this._currentPlaylistLoader?.destroy(), this._currentPlaylistLoader = null, this._logger.info("Destroy controller"), this._playlistLoaderTimeout && clearTimeout(this._playlistLoaderTimeout), this._lifecycleEventReporter("Destroyed");
    }
    abortCurrentPlaylistLoading() {
        this._logger.info("Aborting current loading playlist"), this._currentPlaylistLoader?.destroy();
    }
    setURL(e, t) {
        t ? this._url = e : (this._logger.info(`Setting new url ${e}`), this._currentPlaylistLoader?.destroy(), this._url = e, this._loadNextPlaylist());
    }
    _handleConfigUpdated(e) {
        e.equalPlaylistsAmountToDecline && (this._samePlaylistsCount = 0);
    }
    _loadNextPlaylist() {
        if (!this._isActive) return void this._logger.warn("Loader was destroying, but we trying to load next playlist!");
        const { playlistLoadingTimeout: e } = this.config;
        this._logger.debug("Loading next playlist"), this._lifecycleEventReporter(`Loading next playlist with url ${this._url}`), this.status = "Loading playlist", this._currentPlaylistLoader && this._currentPlaylistLoader.cancel(`Another playlist with url ${this._url} scheduled to load`), this._url && (this._currentPlaylistLoader = new $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96({
            url: this._url,
            loadingTimeout: e,
            autoLoad: !0,
            mode: "text",
            onStateChanged: this._onPlaylistLoadingStateChanged,
            workerMode: this.config.workerMode,
            requestCustomReferer: this.config.sendCustomRefererHeader ? $dbaf12f73216aff4$var$l().location?.href : void 0
        }, this._eventBus), this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistRequested, {}));
    }
    _handleParsedPlaylist(e) {
        if (this._lifecycleEventReporter("Playlist parsed"), this._isMultiVariantPlaylist(e)) return void this._handleMultivariantManifestDetected(e);
        if (this._isLowLatencyPlaylist(e) && this.config.lowLatencyMode) return void this._handleLLManifestDetected(e);
        if (this._isVODPlaylist(e)) return void this._handleVODPlaylist(e);
        if (this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.lastPlaylistOfSegmentLoaded, {}), !this._url) return;
        const t = this._url;
        this._lastTargetDuration = e.targetDuration || 2;
        const r = e.segments.map((r)=>new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
                fragmentUrl: r.uri,
                playlistUrl: t,
                duration: r.duration,
                independent: $dbaf12f73216aff4$var$Er.INDEPENDENT,
                msn: r.msnNumber,
                pn: r.partNumber,
                isTransmuxingBypassRequested: !!e.segments[0].map?.uri
            }, this._eventBus, this.config.shouldLogFragmentsHistory));
        e.segments[0]?.map?.uri && r.unshift(new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
            fragmentUrl: e.segments[0].map.uri,
            playlistUrl: t,
            independent: $dbaf12f73216aff4$var$Er.INDEPENDENT,
            msn: -1,
            pn: -1,
            isTransmuxingBypassRequested: !0,
            duration: 0,
            isInitSection: !0
        }, this._eventBus, this.config.shouldLogFragmentsHistory)), this._handleFragmentsDetected(r), this._planNextLoad();
    }
    _planNextLoad() {
        const e = this._getNextPlaylistLoadTimeout();
        this._currentPlaylistLoader && (this._currentPlaylistLoader.destroy(), this._currentPlaylistLoader = null), this._logger.info(`Expecting next load in ${e} ms`), this._lifecycleEventReporter("Awaiting next loading"), this.status = "Awaiting next loading", this._playlistLoaderTimeout = globalThis.setTimeout(()=>{
            this._loadNextPlaylist();
        }, e);
    }
    _getNextPlaylistLoadTimeout() {
        const { forceStaticPlaylistLoadingTimeout: e, staticPlaylistLoadingTimeoutInDurations: t } = this.config;
        if (e && t) return this._logger.verbose(`forceStaticPlaylistLoadingTimeout is set to true and staticPlaylistLoadingTimeoutInDurations is set to ${t}. Using static timeout`), t * this._lastTargetDuration * 1e3;
        const r = !this.config.disableRotateTimeoutIncrease && this._samePlaylistsCount > 1 ? 1.5 : 1;
        return this._logger.verbose(`There was ${this._samePlaylistsCount} same playlists. Multiplier is ${r}. Target duration is ${this._lastTargetDuration}`), r * this._lastTargetDuration * 1e3;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$02239b8900a03868$export$aeb440a09d15d517.prototype, "_handleConfigUpdated", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
let $dbaf12f73216aff4$var$rn;
var $dbaf12f73216aff4$var$nn;
($dbaf12f73216aff4$var$nn = $dbaf12f73216aff4$var$rn || ($dbaf12f73216aff4$var$rn = {}))[$dbaf12f73216aff4$var$nn.NONE = 0] = "NONE", $dbaf12f73216aff4$var$nn[$dbaf12f73216aff4$var$nn.LOADING = 1] = "LOADING", $dbaf12f73216aff4$var$nn[$dbaf12f73216aff4$var$nn.LOADED = 2] = "LOADED", $dbaf12f73216aff4$var$nn[$dbaf12f73216aff4$var$nn.ERROR = 3] = "ERROR";
class $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4 extends $dbaf12f73216aff4$var$$361586a50c32ab56$export$d6c195e44d5413 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    _fragments = [];
    _lastHandledFragments = [];
    _chunksRetryTimeout = null;
    _isDurationPositive = !1;
    constructor(e, t, r){
        super("VODPlaylistRotationController", "playlistLoader", e), this._url = t, this._onFragmentLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoaded, this._onFragmentLoaded), this._onFragmentAbortedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingAborted, this._onFragmentLoadingError), this._onFragmentErrorListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.fragmentLoader.fragments.fragmentLoadingError, this._onFragmentLoadingError), this._onBufferMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), r ? this._handleParsedPlaylist(r) : this._loadNextPlaylist();
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onFragmentLoadedListener), this._eventBus.unsubscribe(this._onBufferMetricsAvailableListener), this._eventBus.unsubscribe(this._onFragmentErrorListener), this._eventBus.unsubscribe(this._onFragmentAbortedListener);
    }
    setURL(e, t) {
        t ? this._url = e : (this._logger.info(`Setting new url ${e}`), this._currentPlaylistLoader?.destroy(), this._url = e, this._loadNextPlaylist());
    }
    abortCurrentPlaylistLoading() {
        this._logger.info("Aborting current loading playlist"), this._currentPlaylistLoader?.destroy();
    }
    _handleConfigUpdated() {}
    _loadNextPlaylist() {
        const { playlistLoadingTimeout: e, baseVODPlaylistRetryTimeout: t, maxVODPlaylistLoadingRetries: r } = this.config;
        this._logger.debug("Loading VOD playlist"), this._currentPlaylistLoader && this._currentPlaylistLoader.cancel(`Another playlist with url ${this._url} scheduled to load`), this._currentPlaylistLoader = new $dbaf12f73216aff4$var$$ad702b5f13a721f9$export$ec63827108d91a96({
            url: this._url || "",
            loadingTimeout: e,
            autoLoad: !0,
            mode: "text",
            onStateChanged: this._onPlaylistLoadingStateChanged,
            baseRetryTimeout: t,
            maxRetries: r,
            workerMode: this.config.workerMode
        }, this._eventBus);
    }
    _onPlaylistLoadingStateChanged(e, t) {
        if (!this._currentPlaylistLoader || [
            $dbaf12f73216aff4$var$Tr.ABORTED,
            $dbaf12f73216aff4$var$Tr.ERROR
        ].includes(t)) return this.state = $dbaf12f73216aff4$var$Mt.ERROR, this.additionalInfo = {
            playlistLoadError: this._currentPlaylistLoader?.error
        }, this._logger.warn(`Playlist loader reported ${t === $dbaf12f73216aff4$var$Tr.ERROR ? "error" : "as aborted"} (${this._currentPlaylistLoader?.error?.statusText || "no error"} with status ${this._currentPlaylistLoader?.error?.statusText || "no status"}). Planning next load`), void (this._currentPlaylistLoader = null);
        if (t !== $dbaf12f73216aff4$var$Tr.LOADED) return;
        const r = this._currentPlaylistLoader.data;
        this._currentPlaylistLoader = null;
        const n = this._parsePlaylist(r);
        n ? (this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.playlistInfo, n), this._handleParsedPlaylist(n)) : this._eventBus.publish($dbaf12f73216aff4$var$Nt.requestRestartFromMain, {});
    }
    _handleParsedPlaylist(e) {
        this._isMultiVariantPlaylist(e) ? this._handleMultivariantManifestDetected(e) : this._isLowLatencyPlaylist(e) && this.config.lowLatencyMode ? this._handleLLManifestDetected(e) : this._isSimplePlaylist(e) ? this._handleSimplePlaylistDetected(e) : (this.status = "Playlist loaded", this._populateVODFragments(e.segments));
    }
    _planNextLoad() {}
    _populateVODFragments(e) {
        let t = 0;
        for(let r = 0; r < e.length; r++){
            const n = e[r], i = {
                url: n.uri,
                fragmentIndex: r,
                fragmentStartTS: t,
                fragmentEndTS: t + n.duration,
                readinessState: $dbaf12f73216aff4$var$rn.NONE,
                isLast: r === e.length - 1
            };
            this._fragments.push(i), t = i.fragmentEndTS;
        }
        this._isDurationPositive = t > 0, this._eventBus.publish($dbaf12f73216aff4$var$Ft.playlists.vodFragmentsInfo, this._fragments);
    }
    _loadFragment(e) {
        const t = e.map(({ url: e })=>e);
        e.filter(({ readinessState: e, url: r })=>e === $dbaf12f73216aff4$var$rn.LOADED && t.includes(r)).forEach((e)=>{
            this._logger.info(`Some fragments already loaded, reemitting it: ${e.fragmentIndex}`), this._eventBus.publish($dbaf12f73216aff4$var$Ft.fragments.requestReleaseFromCache, {
                msn: e.fragmentIndex
            });
        });
        const r = e.filter(({ readinessState: e })=>[
                $dbaf12f73216aff4$var$rn.NONE
            ].includes(e));
        r.forEach((e)=>e.readinessState = $dbaf12f73216aff4$var$rn.LOADING), this._handleFragmentsDetected(r.map((e)=>new $dbaf12f73216aff4$var$$fad2924ecc119fe5$export$ffb0004e005737fa({
                msn: e.fragmentIndex,
                playlistUrl: this._url || "",
                fragmentUrl: e.url,
                pn: 0,
                independent: $dbaf12f73216aff4$var$Er.INDEPENDENT,
                duration: e.fragmentEndTS - e.fragmentStartTS,
                requestedLoadingTimeout: this.config.disableTimeoutsInVOD ? -1 : this.config.baseVODFragmentRetryTimeout,
                startTs: e.fragmentStartTS,
                endTs: e.fragmentEndTS,
                isTransmuxingBypassRequested: e.url.endsWith(".mp4")
            }, this._eventBus, this.config.shouldLogFragmentsHistory))), this._lastHandledFragments = t;
    }
    _onFragmentLoaded(e) {
        this._logger.info(`Fragment ${e.msn} loaded`);
        const t = this._fragments.find(({ fragmentIndex: t })=>t === e.msn);
        t && (t.readinessState = $dbaf12f73216aff4$var$rn.LOADED, t.data = e.data, this.additionalInfo.fragments = this._fragments.map((e)=>({
                ...e,
                data: void 0
            })));
    }
    _onFragmentLoadingError(e) {
        const t = this._fragments.find(({ fragmentIndex: t })=>t === e.msn);
        t && (t.readinessState = $dbaf12f73216aff4$var$rn.ERROR, this._chunksRetryTimeout || (this._chunksRetryTimeout = globalThis.setTimeout(this._retryFragments, this.config.baseVODFragmentRetryTimeout)));
    }
    _retryFragments() {
        this._chunksRetryTimeout = null;
        this._fragments.filter(({ readinessState: e })=>e === $dbaf12f73216aff4$var$rn.ERROR).forEach((e)=>e.readinessState = $dbaf12f73216aff4$var$rn.NONE);
    }
    _onBufferMetricsAvailable(e) {
        if (this._fragments.some(({ readinessState: e })=>e === $dbaf12f73216aff4$var$rn.LOADING) || !this._isDurationPositive) return;
        let t = [];
        const { currentTimeRange: r, currentPlaybackPosition: n, isInLastBufferedRange: i, bufferedTimeRanges: s } = e, a = i || !!r && !s.some(({ start: e, end: t })=>e <= r.end + 1 && r.end + 1 <= t), o = n + this.config.VODLoadNextSegmentThreshold / 1e3;
        if (r && r.end - n < this.config.VODLoadNextSegmentThreshold / 1e3 && a && o < e.knownDuration - .1 && (t = this._findNextFragmentsByTime(n, o).filter(({ fragmentStartTS: e, fragmentEndTS: t })=>!(e <= n && n <= t))), r || (t = this._findNextFragmentsByTime(n, n)), t.length) {
            this._logger.info(`Loading following fragments ${t.map(({ fragmentIndex: e })=>e).join(",")}`);
            const e = Math.min(...t.map(({ fragmentStartTS: e })=>e)), r = Math.max(...t.map(({ fragmentEndTS: e })=>e));
            this._eventBus.publish($dbaf12f73216aff4$var$Ft.fragments.periodFragmentsFound, {
                startTsOfPeriod: e,
                endTsOfPeriod: r
            }), this._loadFragment(t);
        }
    }
    _findNextFragmentsByTime(e, t) {
        return this._fragments.filter(({ fragmentEndTS: r, fragmentStartTS: n })=>n <= e && e <= r || n >= e && t >= r || n <= t && t <= r);
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "destroy", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_onPlaylistLoadingStateChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_planNextLoad", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_onFragmentLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_onFragmentLoadingError", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_retryFragments", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4.prototype, "_onBufferMetricsAvailable", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
let $dbaf12f73216aff4$var$sn;
var $dbaf12f73216aff4$var$an;
($dbaf12f73216aff4$var$an = $dbaf12f73216aff4$var$sn || ($dbaf12f73216aff4$var$sn = {})).VOD = "VOD", $dbaf12f73216aff4$var$an.LOW_LATENCY = "lowLatency", $dbaf12f73216aff4$var$an.SIMPLE = "simple";
class $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {};
    groups = [
        "loader"
    ];
    _streamUrl = null;
    _aclToken = null;
    _playlistsRotator = null;
    _actualRenditionReport = null;
    _lastAddedFragment = null;
    constructor(e = $dbaf12f73216aff4$var$sn.SIMPLE, t, r){
        this._eventBus = r, this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "Doppio - StreamLoader"), this._logger.info("Created"), this._fragmentsLoader = new $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881(this._eventBus), this._initialType = e, this._simplePlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.simpleDetected, this._onSimplePlaylistDetected), this._llPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.llDetected, this._onLLPlaylistDetected), this._vodPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.vodDetected, this._onVODPlaylistDetected), this._onSoftResetRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.requestResetWithOverplay, this._resetPlaylistLoaders), this._onBrowserRedirectDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$qt.events.browserRedirectDetected, this._onBrowserRedirectDetected), this._onFragmentAddedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.fragmentAdded, this._onFragmentAdded), this._lastAddedFragment = t;
    }
    startLoad(e) {
        this._streamUrl = e, this._recreateLoaders();
    }
    destroy() {
        this._logger.info(`Destroying instance, ${this._streamUrl}`), this._fragmentsLoader.destroy(), this._playlistsRotator?.destroy(), this._eventBus.unsubscribe(this._simplePlaylistDetectedListener), this._eventBus.unsubscribe(this._llPlaylistDetectedListener), this._eventBus.unsubscribe(this._vodPlaylistDetectedListener), this._eventBus.unsubscribe(this._onSoftResetRequestedListener), this._eventBus.unsubscribe(this._onFragmentAddedListener), this._eventBus.unsubscribe(this._onBrowserRedirectDetectedListener);
    }
    setActualRenditionReport(e) {
        e && (this._actualRenditionReport = e);
    }
    _recreateLoaders() {
        this.status = "Restarting";
        const e = this._buildUrl();
        this._logger.debug("Recreate loaders"), e && (this._fragmentsLoader.destroy(), this._fragmentsLoader = new $dbaf12f73216aff4$var$$5250354d29c6d1d6$export$f6fc15ab7a2fe881(this._eventBus), this._playlistsRotator ? this._playlistsRotator?.setURL(e) : this._recreateInitialLoader(), this.status = "Working");
    }
    _recreateInitialLoader() {
        switch(this._initialType){
            case $dbaf12f73216aff4$var$sn.SIMPLE:
                this._onSimplePlaylistDetected();
                break;
            case $dbaf12f73216aff4$var$sn.VOD:
                this._onVODPlaylistDetected();
                break;
            case $dbaf12f73216aff4$var$sn.LOW_LATENCY:
                this._onLLPlaylistDetected();
                break;
            default:
                this._onSimplePlaylistDetected();
        }
    }
    _buildUrl() {
        return this._streamUrl ? `${this._streamUrl}${this._aclToken ? "?aclToken=" + this._aclToken : ""}` : null;
    }
    _onFragmentAdded(e) {
        this._lastAddedFragment = e;
    }
    _onSimplePlaylistDetected(e) {
        if (this._playlistsRotator instanceof $dbaf12f73216aff4$var$$02239b8900a03868$export$aeb440a09d15d517) return;
        this._eventBus.publish($dbaf12f73216aff4$var$ur.streamLoader.playlistRotatorTypeChanged, $dbaf12f73216aff4$var$sn.SIMPLE), this._logger.info("Simple playlist detected, switching to simple loader");
        const t = this._buildUrl();
        t && (this._playlistsRotator?.destroy(), this._playlistsRotator = new $dbaf12f73216aff4$var$$02239b8900a03868$export$aeb440a09d15d517(this._eventBus, t, e), this.additionalInfo.playlistRotatorType = "SimplePlaylistRotator");
    }
    _onVODPlaylistDetected(e) {
        if (this._playlistsRotator instanceof $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4) return;
        this._eventBus.publish($dbaf12f73216aff4$var$ur.streamLoader.playlistRotatorTypeChanged, $dbaf12f73216aff4$var$sn.VOD), this._logger.info("VOD playlist detected, switching to VOD loader");
        const t = this._buildUrl();
        t && (this._playlistsRotator?.destroy(), this._playlistsRotator = new $dbaf12f73216aff4$var$$355864c3b7775884$export$350d4622b86387d4(this._eventBus, t, e), this.additionalInfo.playlistRotatorType = "VODPlaylistRotator");
    }
    _onLLPlaylistDetected(e) {
        if (this._playlistsRotator instanceof $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f) return;
        this._eventBus.publish($dbaf12f73216aff4$var$ur.streamLoader.playlistRotatorTypeChanged, $dbaf12f73216aff4$var$sn.LOW_LATENCY), this._logger.info("LL Playlist detected, switching to ll loader");
        const t = this._buildUrl();
        t && (this._playlistsRotator?.destroy(), this._playlistsRotator = new $dbaf12f73216aff4$var$$1caae9a591b98735$export$6991d30b0536d79f(this._eventBus, {
            url: t,
            startManifest: e,
            initialMSN: this._actualRenditionReport?.lastMsn,
            initialPN: this._actualRenditionReport?.lastPart,
            lastLoadedFragment: this._lastAddedFragment
        }), this.additionalInfo.playlistRotatorType = "LowLatencyPlaylistRotator");
    }
    _resetPlaylistLoaders() {
        this._playlistsRotator?.abortCurrentPlaylistLoading(), this.status = "Idle";
    }
    _onBrowserRedirectDetected({ responseUrl: e }) {
        this._streamUrl = e;
        const t = this._buildUrl();
        t && this._playlistsRotator?.setURL(t, !0);
    }
    get additionalModules() {
        const e = {};
        return this._playlistsRotator && (e.playlistRotator = this._playlistsRotator), this._fragmentsLoader && (e.fragmentLoader = this._fragmentsLoader), e;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_onFragmentAdded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_onSimplePlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_onVODPlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_onLLPlaylistDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_resetPlaylistLoaders", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941.prototype, "_onBrowserRedirectDetected", null);
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    additionalInfo = {
        currentResolution: ""
    };
    groups = [
        "resolutionsManager"
    ];
    _currentResolutionsDecreasing = [];
    _currentResolution = null;
    _awaitingResolution = null;
    _lastMSN = -1;
    _lastDSN = -1;
    _lastPDT = -1;
    _url = "";
    _isAutoEnabled = !0;
    _lastPlaylistRotatorType = $dbaf12f73216aff4$var$sn.SIMPLE;
    _streamLoader = null;
    _restartTimeout = null;
    _renditionReports = [];
    _lastLoadedFragment = null;
    _codecsByResolutions = {};
    constructor(e){
        super("resolutionsManager", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - ResolutionManager"), this._multiVariantsPlaylistDetectionListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlistType.multivariantDetected, this._onMultiVariantsPlaylists), this._onResolutionChangeRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.requestResolutionChange, this._onResolutionChangeRequested), this._onPlaylistInfoAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.playlistRotator.playlists.playlistInfo, this._onPlaylistInfoAvailable), this._onRestartFromMainRequestedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.requestRestartFromMain, this._restartFormMain), this._onPlaylistRotatorTypeChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$ur.streamLoader.playlistRotatorTypeChanged, this._onPlaylistRotatorTypeChanged), this._onEndOfSegmentPlaylistLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.lastPlaylistOfSegmentLoaded, this._onEndOfSegmentPlaylistLoaded), this._onFragmentAddedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.fragmentAdded, this._onFragmentAdded);
    }
    destroy() {
        super.destroy(), this._restartTimeout && (clearTimeout(this._restartTimeout), this._restartTimeout = null), this._eventBus.unsubscribe(this._multiVariantsPlaylistDetectionListener), this._eventBus.unsubscribe(this._onResolutionChangeRequestedListener), this._eventBus.unsubscribe(this._onPlaylistInfoAvailableListener), this._eventBus.unsubscribe(this._onRestartFromMainRequestedListener), this._eventBus.unsubscribe(this._onPlaylistRotatorTypeChangedListener), this._eventBus.unsubscribe(this._onEndOfSegmentPlaylistLoadedListener), this._eventBus.unsubscribe(this._onFragmentAddedListener), this._streamLoader?.destroy(), this._codecsByResolutions = {};
    }
    setUrl(e) {
        this._url !== e && (this._lastPDT = -1, this._lastDSN = -1, this._lastMSN = -1, this._logger.info("Setting new url"), this._url = e, this._currentResolution = null, this._currentResolutionsDecreasing = [], this._restart());
    }
    setResolution(e, t = !1) {
        if (this._awaitingResolution = null, e.name === this._currentResolution?.name) return;
        if (this._url && $dbaf12f73216aff4$var$Rt(this._url).streamId && $dbaf12f73216aff4$var$Rt(e.url).streamId && $dbaf12f73216aff4$var$Rt(this._url).streamId !== $dbaf12f73216aff4$var$Rt(e.url).streamId) return void this._logger.warn(`Tried to set resolution with ${e.url}, but the current url is ${this._url}. Skipping since they don't match`);
        const r = this._currentResolution;
        this._logger.info(`Resolution changed: ${this._currentResolution?.name} -> ${e.name}`), this._currentResolution = e, this.additionalInfo.currentResolution = e.name, this._eventBus.publish($dbaf12f73216aff4$var$Nt.resolutionChanged, e), this._codecsByResolutions[e.url] && this._eventBus.publish($dbaf12f73216aff4$var$kt.changeCodec, {
            codec: this._codecsByResolutions[e.url]
        }), !t && r || this._eventBus.publish($dbaf12f73216aff4$var$Nt.resolutionAutoChanged, {
            prevResolution: r?.name,
            nextResolution: e.name
        }), this._restart();
    }
    setNearestResolutionByWidth(e) {
        return this._setResolutionByCriteria(({ width: t })=>t <= e);
    }
    setNearestResolutionByHeight(e) {
        return this._setResolutionByCriteria(({ height: t })=>t <= e);
    }
    setNearestResolutionByBitrate(e) {
        return this._setResolutionByCriteria(({ bitrate: t })=>t <= e + this.config.initialResolutionBitrateThreshold);
    }
    setResolutionByName(e) {
        return this._setResolutionByCriteria(({ name: t })=>t === e);
    }
    toggleAutoResolution(e) {
        this._isAutoEnabled = e;
    }
    restart() {
        this._restart();
    }
    _handleConfigUpdated() {}
    _setResolutionByCriteria(e) {
        const t = this._findResolutionByCriteria(e);
        return t ? this.config.awaitForSegmentEndToSwitchManual && this._currentResolution && this._lastMSN > -1 ? (this._logger.info("Await for segment end for switch resolution"), void (this._awaitingResolution = t)) : void this.setResolution(t) : (this._logger.warn("There are no any resolution in current stream"), this.state = $dbaf12f73216aff4$var$Mt.ERROR, void (this._awaitingResolution = null));
    }
    _findResolutionByCriteria(e) {
        if (!this._currentResolutionsDecreasing.length) return null;
        if (1 === this._currentResolutionsDecreasing.length) return this._currentResolutionsDecreasing[0];
        const t = this._currentResolutionsDecreasing.find(e);
        return t || (this._eventBus.publish($dbaf12f73216aff4$var$Nt.resolutionNotFound, {}), !1 !== this.config.useFallbackResolutionIfResolutionNotFound) ? t || this._currentResolutionsDecreasing.slice(-1)[0] : null;
    }
    _restartFormMain() {
        this._currentResolution = null, this._logger.info("Restart from main"), this._renditionReports = [], this._eventBus.publish($dbaf12f73216aff4$var$kt.requestResetWithOverplay, {}), this._restart(2e3);
    }
    _restart(e = 0) {
        this._restartTimeout && (clearTimeout(this._restartTimeout), this._restartTimeout = null), this._logger.info("Restart resolution manager"), this._destroyStreamLoader(), this._restartTimeout = setTimeout(()=>{
            this._recreateStreamLoader();
        }, e);
    }
    _destroyStreamLoader() {
        this._streamLoader?.destroy(), this._streamLoader = null, this.status = "Awaiting resolutions";
    }
    _recreateStreamLoader() {
        this._destroyStreamLoader(), this._streamLoader = new $dbaf12f73216aff4$var$$70b138d9d2111269$export$9ed3fd9cfbc53941(this._lastPlaylistRotatorType, this._lastLoadedFragment, this._eventBus), this._streamLoader.setActualRenditionReport(this._getActualRenditionReport()), this._streamLoader.startLoad(this._currentResolution ? this._currentResolution.url : this._url);
    }
    _onMultiVariantsPlaylists(e) {
        this._currentResolutionsDecreasing = Object.values(e).sort((e, t)=>t.bitrate - e.bitrate), this.additionalInfo.resolutionsAvailable = this._currentResolutionsDecreasing.map(({ name: e })=>e), this._eventBus.publish($dbaf12f73216aff4$var$Nt.resolutionsAvailable, this._currentResolutionsDecreasing), this.config.initialResolutionBitrate ? this.setNearestResolutionByBitrate(this.config.initialResolutionBitrate) : this.config.initialResolutionHeight ? this.setNearestResolutionByHeight(this.config.initialResolutionHeight) : this.config.initialResolutionWidth ? this.setNearestResolutionByWidth(this.config.initialResolutionWidth) : this.config.autoloadLowestResolution && this.setResolution(this._currentResolutionsDecreasing.slice(-1)[0]);
    }
    _onEndOfSegmentPlaylistLoaded() {
        this._awaitingResolution && (this._logger.info("Last playlist of segment loaded. Ready to switch"), this.setResolution(this._awaitingResolution, !0));
    }
    _onFragmentAdded(e) {
        this._lastLoadedFragment = e;
    }
    _onPlaylistInfoAvailable(e) {
        const { mediaSequence: t, discontinuitySequence: r, segments: n } = e;
        if (e.playlists && (this._codecsByResolutions = e.playlists.reduce((e, t)=>t.attributes?.CODECS ? {
                ...e,
                [t.uri]: t.attributes.CODECS
            } : e, {})), void 0 === t || void 0 === r || void 0 === n) return;
        const i = n[0]?.dateTimeObject?.getTime() || 0;
        -1 === this._lastPDT || -1 === this._lastDSN || -1 === this._lastMSN || (r !== this._lastDSN && (this._logger.info("DSN changed. Requesting overplay"), this._eventBus.publish($dbaf12f73216aff4$var$kt.requestResetWithOverplay, {})), Math.abs(i - this._lastPDT) > this.config.maxPlaylistTimeDifference && (this._logger.warn("PDT delta reached max delta. Restarting from main"), this._restartFormMain())), this._lastMSN = t, this._lastDSN = r, this._lastPDT = i, this._renditionReports = e.renditionReports || [], this._streamLoader?.setActualRenditionReport(this._getActualRenditionReport());
    }
    _onResolutionChangeRequested(e) {
        if (this._isAutoEnabled) return this.config.awaitForSegmentEndToSwitch ? (this._logger.info("Await for segment end for switch resolution"), void (this._awaitingResolution = e)) : void this.setResolution(e, !0);
    }
    _getActualRenditionReport() {
        if (!this._renditionReports.length) return null;
        try {
            return this._renditionReports.find(({ uri: e })=>new URL(e).pathname === new URL(this._currentResolution?.url || "").pathname) || null;
        } catch (e) {
            return null;
        }
    }
    _onPlaylistRotatorTypeChanged(e) {
        this._lastPlaylistRotatorType = e;
    }
    get additionalModules() {
        return this.additionalInfo.isAutoEnabled = this._isAutoEnabled, this._streamLoader ? {
            streamLoader: this._streamLoader
        } : {};
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_handleConfigUpdated", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_restartFormMain", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onMultiVariantsPlaylists", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onEndOfSegmentPlaylistLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onFragmentAdded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onPlaylistInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onResolutionChangeRequested", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3.prototype, "_onPlaylistRotatorTypeChanged", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9 {
    _isResolutionSelected = !1;
    constructor(e, t){
        this._eventBus = t, this._sendEvent = e, this._isDebugEnabled = document?.cookie?.includes("__mmpDebug__=1"), this._onPlaylistLoadingStartedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.playlistRequested, this._onPlaylistLoadingStarted), this._onResolutionChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChanged), this._onResolutionChangedAutoListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionAutoChanged, this._onResolutionAutoChanged), this._onPlaylistLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.playlistLoaded, this._onPlaylistLoaded), this._onPlaylistParsedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.playlistInfo, this._onPlaylistInfoAvailable), this._onFragmentLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoaded, this._onFragmentLoaded), this._onDebuggerConnectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Jt.debuggerConnected, this._onDebuggerConnected), this._onNetworkRequestSettledListener = this._eventBus.subscribe($dbaf12f73216aff4$var$qt.events.networkRequestSettled, this._onNetworkRequestSettled);
    }
    destroy() {
        this._eventBus.unsubscribe(this._onPlaylistLoadingStartedListener), this._eventBus.unsubscribe(this._onPlaylistLoadedListener), this._eventBus.unsubscribe(this._onPlaylistParsedListener), this._eventBus.unsubscribe(this._onFragmentLoadedListener), this._eventBus.unsubscribe(this._onDebuggerConnectedListener), this._eventBus.unsubscribe(this._onResolutionChangedListener), this._eventBus.unsubscribe(this._onResolutionChangedAutoListener), this._eventBus.unsubscribe(this._onNetworkRequestSettledListener);
    }
    _onPlaylistLoadingStarted() {
        this._isResolutionSelected || this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.MANIFEST_LOADING));
    }
    _onResolutionChanged() {
        this._isResolutionSelected = !0;
    }
    _onPlaylistLoaded(e) {
        const { originalUrl: t, realUrl: r, stats: n } = e;
        this._isResolutionSelected ? this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.LEVEL_LOADED, {
            detail: {
                netStats: n
            }
        })) : this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.MANIFEST_LOADED, {
            detail: {
                originalUrl: t,
                realUrl: r
            }
        }));
    }
    _onPlaylistInfoAvailable(e) {
        this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.MANIFEST_PARSED, {
            detail: e
        }));
    }
    _onFragmentLoaded(e) {
        this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.FRAG_LOADED, {
            detail: {
                netStats: e.stats,
                duration: e.duration
            }
        }));
    }
    _onDebuggerConnected(e) {
        this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.DEBUGGER_CONNECTED, {
            detail: {
                panelUrl: e
            }
        }));
    }
    _onResolutionAutoChanged({ prevResolution: e, nextResolution: t }) {
        this._sendEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.LEVEL_SWITCHED_AUTO, {
            detail: {
                prevResolution: e,
                nextResolution: t
            }
        }));
    }
    _onNetworkRequestSettled({ response: e }) {
        this._isDebugEnabled && globalThis.dispatchEvent(new CustomEvent("mmpFetchSettled", {
            detail: {
                response: e
            }
        }));
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onPlaylistLoadingStarted", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onResolutionChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onPlaylistLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onPlaylistInfoAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onFragmentLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onDebuggerConnected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onResolutionAutoChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9.prototype, "_onNetworkRequestSettled", null);
const $dbaf12f73216aff4$var$on = (e)=>{
    if ($dbaf12f73216aff4$var$Mr(e)) return e;
    const t = new URL(document.location.href);
    if (e.startsWith("/")) return `${t.origin}${e}`;
    const r = t.pathname.split("/").filter((e)=>e.trim().length > 0);
    return r.pop() || r.pop(), `${t.origin}/${r.concat(e).join("/")}`;
};
$dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$e32e21341d1ee217$export$66a71be678fc5202 {
    state = $dbaf12f73216aff4$var$Mt.OK;
    status = "Idle";
    groups = [
        "general"
    ];
    _lastMetrics = null;
    get additionalInfo() {
        return {
            totalHeapSize: performance.memory?.totalJSHeapSize,
            usedHeapSize: performance.memory?.usedJSHeapSize,
            sizeLimit: performance.memory?.jsHeapSizeLimit,
            ...this._lastMetrics || {}
        };
    }
}
$dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
var $dbaf12f73216aff4$var$ln = $dbaf12f73216aff4$var$a("3264a");
class $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _debuggableModules = {};
    _modulesInfoGatheringInterval = null;
    _debuggerWorker = null;
    constructor(e){
        super("debugger", e), this._onLifecycleEventReportedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Jt.lifecycleEvent, this._onLifecycleEventReported), this.config.enableRemoteDebugging && this.config.debuggerUrl && this.config.maxWSConnectionRetries && this._startDebugger();
    }
    registerDebuggableModules(e) {
        this._debuggableModules = {
            ...this._debuggableModules,
            ...e
        };
    }
    unregisterDebuggableModules(e) {
        e.forEach((e)=>{
            delete this._debuggableModules[e];
        });
    }
    destroy() {
        super.destroy(), this._debuggerWorker?.disconnect(), this._eventBus.unsubscribe(this._onLifecycleEventReportedListener);
    }
    _handleConfigUpdated(e) {
        this._debuggerWorker && (e.debuggerUrl || e.maxWSConnectionRetries) && (this._destroyWorker(), this._getDebuggerModule()), !1 === e.enableRemoteDebugging && this._stopDebugger(), e.enableRemoteDebugging && (this._destroyWorker(), this._getDebuggerModule()), e.modulesStateGatheringPeriod && (this._disarmSendModulesInfoTimeout(), this._armSendModulesInfoTimeout());
    }
    _destroyWorker() {
        this._debuggerWorker?.disconnect(), this._debuggerWorker = null;
    }
    _startDebugger() {
        this._getDebuggerModule(), this._armSendModulesInfoTimeout();
    }
    _stopDebugger() {
        this._debuggerWorker && (this._debuggerWorker.disconnect(), this._disarmSendModulesInfoTimeout());
    }
    async _sendMessage(e) {
        (await this._getDebuggerModule()).sendMessage(e);
    }
    _onConnected(e) {
        this._eventBus.publish($dbaf12f73216aff4$var$Jt.debuggerConnected, e), this._armSendModulesInfoTimeout();
    }
    _onDisconnected() {
        this._disarmSendModulesInfoTimeout();
    }
    _onLifecycleEventReported(e) {
        this._debuggerWorker && this.config.enableLifecycleEvents && this._sendMessage({
            command: $dbaf12f73216aff4$var$ln.ECommand.MODULE_LIFECYCLE_EVENT_AVAILABLE,
            event: e
        });
    }
    _armSendModulesInfoTimeout() {
        this._modulesInfoGatheringInterval = globalThis.setInterval(this._sendModulesInfo, this.config.modulesStateGatheringPeriod);
    }
    _disarmSendModulesInfoTimeout() {
        this._modulesInfoGatheringInterval && globalThis.clearInterval(this._modulesInfoGatheringInterval);
    }
    _unzipDebuggableModules(e) {
        let t = {
            ...e
        };
        return Object.values(e).forEach((e)=>{
            e.additionalModules && (t = {
                ...t,
                ...this._unzipDebuggableModules(e.additionalModules)
            });
        }), t;
    }
    _sendModulesInfo() {
        const e = this._unzipDebuggableModules(this._debuggableModules), t = Object.entries(e).reduce((e, [t, r])=>(e[t] = {
                additionalInfo: r.additionalInfo,
                state: r.state,
                groups: r.groups,
                status: r.status
            }, e), {});
        this._sendMessage({
            command: $dbaf12f73216aff4$var$ln.ECommand.MODULES_INFO_AVAILABLE,
            payload: t
        });
    }
    async _getDebuggerModule() {
        if (!this._debuggerWorker) {
            const { DebuggerWorker: e } = await $dbaf12f73216aff4$var$a("iVqGx");
            this._debuggerWorker = new e, this._debuggerWorker.setConfig(this.config.debuggerUrl, this.config.maxWSConnectionRetries, this._onConnected, this._onDisconnected), this._debuggerWorker.connect();
        }
        return this._debuggerWorker;
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1.prototype, "_onConnected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1.prototype, "_onDisconnected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1.prototype, "_onLifecycleEventReported", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1.prototype, "_sendModulesInfo", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
class $dbaf12f73216aff4$var$$b51ba8c6e213007b$export$888ef725096339b7 extends $dbaf12f73216aff4$var$$fdb44a1177d4494a$export$cd5442f2b8da7663 {
    _initSectionCache = null;
    _expectedUnitedChunkName = "";
    _fragmentsCache = [];
    constructor(e){
        super("fragmentBuffer", e), this._logger = $dbaf12f73216aff4$var$J(e, "Doppio - FragmentsBuffer"), this._onFragmentReleasedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$vr.fragmentsReleased, this._onFragmentReleasedFromQueue), this._onSaveDataRequestedListenerToken = this._eventBus.subscribe($dbaf12f73216aff4$var$yr.saveData, this.sendUnitedChunk);
    }
    destroy() {
        super.destroy(), this._eventBus.unsubscribe(this._onFragmentReleasedListenerToken), this._eventBus.unsubscribe(this._onSaveDataRequestedListenerToken), this._initSectionCache = null, this._fragmentsCache = [];
    }
    sendUnitedChunk() {
        if (this._initSectionCache && !(Math.random() > this.config.saveProbability)) try {
            const e = $dbaf12f73216aff4$var$br([
                this._initSectionCache.data
            ].concat(...this._fragmentsCache.map(({ data: e })=>e))), t = new Headers;
            t.append("Content-Type", "video/mp4"), fetch(`https://${this.config.baseChunksSaverUrl}/${this._expectedUnitedChunkName}`, {
                method: "PUT",
                headers: t,
                body: e,
                redirect: "follow"
            }).catch((e)=>{
                this._logger.warn(`Could not save problem chunks: ${e}`);
            });
        } catch (e) {
            this._logger.warn(`Could not save problem chunks: ${e}`);
        }
    }
    _onFragmentReleasedFromQueue(e) {
        try {
            for (const t of e){
                if (t.isInitSection) return this._initSectionCache = t, this._expectedUnitedChunkName = t.url.split("/").slice(-1)[0], void (this._fragmentsCache = []);
                this._fragmentsCache.push(t);
                const r = Math.max(...e.map(({ msn: e })=>e)), n = Math.max(0, r - this.config.numberOfFragmentsToKeepInBuffer + 1);
                this._fragmentsCache = this._fragmentsCache.filter(({ msn: e })=>e >= n);
            }
        } catch (e) {
            this._logger.warn("Could not handle fragment"), this._fragmentsCache = [], this._initSectionCache = null;
        }
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$b51ba8c6e213007b$export$888ef725096339b7.prototype, "sendUnitedChunk", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$b51ba8c6e213007b$export$888ef725096339b7.prototype, "_onFragmentReleasedFromQueue", null), $dbaf12f73216aff4$var$a("8NFq9");
$dbaf12f73216aff4$var$o = $dbaf12f73216aff4$var$a("a8VW4"), $dbaf12f73216aff4$var$xt = $dbaf12f73216aff4$var$a("eQOGK");
let $dbaf12f73216aff4$var$un;
($dbaf12f73216aff4$var$un || ($dbaf12f73216aff4$var$un = {})).SAME_PLAYLIST_LOADED_MORE_TIMES = "Same playlist was loaded more than expected times. Looks lise server is malfunctioning";
class $dbaf12f73216aff4$var$$a2161b1dae4e4fa5$export$bae979e68e4dc802 extends Error {
    constructor(e, t, r){
        super(e), this.name = "DoppioNetworkError", this.statusCode = t, this.statusText = r;
    }
}
const $dbaf12f73216aff4$var$dn = {
    lifecycleEvent: "LifecycleEventsManager.LIFECYCLE_EVENT",
    lifecycleError: "LifecycleEventsManager.LIFECYCLE_ERROR"
};
class $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc {
    _manifestLoaded = !1;
    _firstMediaPlaylistLoaded = !1;
    _firstFragmentLoaded = !1;
    _firstFragmentBuffered = !1;
    constructor(e){
        this._eventBus = e, this._onManifestLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlistType.multivariantDetected, this._onManifestLoaded), this._onSimplePlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlistType.simpleDetected, this._onPlaylistLoaded), this._onLLPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlistType.llDetected, this._onPlaylistLoaded), this._onVODPlaylistDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlistType.vodDetected, this._onPlaylistLoaded), this._onFragmentLoadedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoaded, this._onFragmentLoaded), this._onFragmentBufferedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.fragmentAdded, this._onFragmentBuffered), this._onFragmentLoadErrorListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingError, this._onFragmentLoadError), this._onFragmentLoadAbortListener = this._eventBus.subscribe($dbaf12f73216aff4$var$lr.fragments.fragmentLoadingAborted, this._onFragmentLoadError), this._onPlaylistLoadErrorListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Ft.playlists.playlistLoadingError, this._onPlaylistLoadError);
    }
    destroy() {
        this._eventBus.unsubscribe(this._onManifestLoadedListener), this._eventBus.unsubscribe(this._onSimplePlaylistDetectedListener), this._eventBus.unsubscribe(this._onLLPlaylistDetectedListener), this._eventBus.unsubscribe(this._onVODPlaylistDetectedListener), this._eventBus.unsubscribe(this._onFragmentLoadedListener), this._eventBus.unsubscribe(this._onFragmentBufferedListener), this._eventBus.unsubscribe(this._onFragmentLoadErrorListener), this._eventBus.unsubscribe(this._onFragmentLoadAbortListener), this._eventBus.unsubscribe(this._onPlaylistLoadErrorListener);
    }
    reset() {
        this._manifestLoaded = !1, this._firstMediaPlaylistLoaded = !1, this._firstFragmentLoaded = !1, this._firstFragmentBuffered = !1;
    }
    _onManifestLoaded() {
        this._manifestLoaded || (this._manifestLoaded = !0, this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleEvent, {
            eventType: $dbaf12f73216aff4$export$2c4fd850a78e2155.MANIFEST_LOADED
        }));
    }
    _onPlaylistLoaded() {
        this._firstMediaPlaylistLoaded || (this._firstMediaPlaylistLoaded = !0, this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleEvent, {
            eventType: $dbaf12f73216aff4$export$2c4fd850a78e2155.FIRST_MEDIA_PLAYLIST_LOADED
        }));
    }
    _onFragmentLoaded() {
        this._firstFragmentLoaded || (this._firstFragmentLoaded = !0, this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleEvent, {
            eventType: $dbaf12f73216aff4$export$2c4fd850a78e2155.FIRST_FRAGMENT_LOADED
        }));
    }
    _onFragmentBuffered() {
        this._firstFragmentBuffered || (this._firstFragmentBuffered = !0, this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleEvent, {
            eventType: $dbaf12f73216aff4$export$2c4fd850a78e2155.FIRST_FRAGMENT_BUFFERED
        }));
    }
    _onFragmentLoadError(e) {
        this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleError, {
            errorType: $dbaf12f73216aff4$export$b21d389d4d866e74.FRAGMENT_LOAD_ERROR,
            nativeError: new $dbaf12f73216aff4$var$$a2161b1dae4e4fa5$export$bae979e68e4dc802(` ${e.error?.statusText} (${e.error?.status})`, e.error?.status || -1, e.error?.statusText || "No status text known")
        });
    }
    _onPlaylistLoadError({ error: e }) {
        this._eventBus.publish($dbaf12f73216aff4$var$dn.lifecycleError, {
            errorType: this._manifestLoaded ? $dbaf12f73216aff4$export$b21d389d4d866e74.PLAYLIST_LOAD_ERROR : $dbaf12f73216aff4$export$b21d389d4d866e74.MANIFEST_LOAD_ERROR,
            nativeError: new $dbaf12f73216aff4$var$$a2161b1dae4e4fa5$export$bae979e68e4dc802(`Could not load ${this._manifestLoaded ? "playlist" : "manifest"}: ${e?.statusText}(${e?.status})`, e?.status || -1, e?.statusText || "No status text known")
        });
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onManifestLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onPlaylistLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onFragmentLoaded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onFragmentBuffered", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onFragmentLoadError", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc.prototype, "_onPlaylistLoadError", null);
const $dbaf12f73216aff4$export$bd37fab864bb0e40 = "v1.13.3";
class $dbaf12f73216aff4$export$af89f16da513df38 extends EventTarget {
    _eventBus = new $dbaf12f73216aff4$var$$b13a7c90f8916026$export$5087227eb54526;
    _loggerTransport = null;
    _fragmentParser = new $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0(this._eventBus);
    _fragmentQueue = new $dbaf12f73216aff4$var$$e70c8bc7b73ce5f6$export$2a929e999d78f771(this._eventBus);
    _buffer = new $dbaf12f73216aff4$var$$8a93ff1a26029909$export$2057e53fd83d2d77(this._eventBus);
    _resolutionManager = new $dbaf12f73216aff4$var$$d4c75a7acca125f1$export$de6844fe7ae202a3(this._eventBus);
    _abrController = new $dbaf12f73216aff4$var$$cfc73a2200ca48a5$export$264ac4b6e832e14e(this._eventBus);
    _debugger = new $dbaf12f73216aff4$var$$9aaec539b91c3586$export$e5f315ae988d64e1(this._eventBus);
    _fragmentsFilter = new $dbaf12f73216aff4$var$$667435329a91e53d$export$7dc2c7c17829d4bb(this._eventBus);
    _fragmentsBuffer = new $dbaf12f73216aff4$var$$b51ba8c6e213007b$export$888ef725096339b7(this._eventBus);
    _url = null;
    _key = null;
    _videoElement = null;
    _isStarted = !1;
    _commonMetricsCollector = new $dbaf12f73216aff4$var$$e32e21341d1ee217$export$66a71be678fc5202;
    _lifecycleEventsManager = new $dbaf12f73216aff4$var$$df45aea026ec1edb$export$8584300935d5c1dc(this._eventBus);
    constructor(){
        super();
        const e = (Math.random() + 1).toString(36).substring(7);
        this._eventBus.setAppId(e), this._loggerTransport = new $dbaf12f73216aff4$var$ne(this._eventBus, $dbaf12f73216aff4$var$wt, [], []), this._logger = $dbaf12f73216aff4$var$J(this._eventBus, "Doppio - core"), this._logger.info("Created"), this._onResolutionsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionsAvailable, this._onResolutionsAvailable), this._onMetricsAvailableListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.bufferMetricsAvailable, this._onBufferMetricsAvailable), this._onResolutionChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionChanged, this._onResolutionChanged), this._onStreamEndedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.endOfStreamReached, this._onStreamEnded), this._onPlaybackStateChangedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$kt.playbackStateChanged, this._onPlaybackStateChanged), this._legacyEventsController = new $dbaf12f73216aff4$var$$052ebe970d844835$export$183808fb4a9082e9(this.dispatchEvent.bind(this), this._eventBus), this._debugger.registerDebuggableModules({
            fragmentQueue: this._fragmentQueue,
            commonInfo: this._commonMetricsCollector,
            resolutionManager: this._resolutionManager,
            abr: this._abrController
        }), this._onLifecycleEventReportedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$dn.lifecycleEvent, this._onLifecycleEventReported), this._onLifecycleErrorReportedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$dn.lifecycleError, this._onLifecycleErrorReported), this._onResolutionNotFoundListener = this._eventBus.subscribe($dbaf12f73216aff4$var$Nt.resolutionNotFound, this._onResolutionNotFound), this._onFragmentsFilterProblemDetectedListener = this._eventBus.subscribe($dbaf12f73216aff4$var$pr.problemDetected, this._onFragmentFilterProblemDetected);
    }
    destroy() {
        this._eventBus.unsubscribe(this._onResolutionsAvailableListener), this._eventBus.unsubscribe(this._onResolutionChangedListener), this._eventBus.unsubscribe(this._onMetricsAvailableListener), this._eventBus.unsubscribe(this._onStreamEndedListener), this._eventBus.unsubscribe(this._onPlaybackStateChangedListener), this._eventBus.unsubscribe(this._onLifecycleEventReportedListener), this._eventBus.unsubscribe(this._onLifecycleErrorReportedListener), this._eventBus.unsubscribe(this._onResolutionNotFoundListener), this._eventBus.unsubscribe(this._onFragmentsFilterProblemDetectedListener), this._fragmentParser.destroy(), this._buffer.destroy(), this._resolutionManager.destroy(), this._abrController.destroy(), this._fragmentQueue.destroy(), this._debugger.destroy(), this._legacyEventsController.destroy(), this._videoElement?.removeEventListener("error", this._onMediaElementError), this._logger.info("Destroyed"), this._lifecycleEventsManager.destroy(), this._fragmentsFilter.destroy(), this._fragmentsBuffer.destroy(), setTimeout(()=>{
            this._loggerTransport?.destroy();
        }, 1e3), $dbaf12f73216aff4$var$Dr(this._eventBus.getAppId());
    }
    get version() {
        return $dbaf12f73216aff4$export$bd37fab864bb0e40;
    }
    get isStarted() {
        return this._isStarted;
    }
    recoverMediaError() {
        this._buffer.detachVideoElement(), this._videoElement && this._buffer.attachVideoElement(this._videoElement), this._resolutionManager.restart(), this._videoElement?.play();
    }
    start() {
        this._url ? (this._videoElement || this._logger.warn("Video element is not defined."), this._isStarted ? this._restart() : (this._debugger.registerDebuggableModules({
            bufferController: this._buffer
        }), this._resolutionManager.setUrl(this._url), this._isStarted = !0)) : this._logger.fatal("Stream URL is not defined. Cannot start player");
    }
    setUrl(e) {
        if (!e.trim()) return this._stop(), this;
        const t = $dbaf12f73216aff4$var$on(e), r = this._url !== t && this._isStarted;
        return this._url = t, this._key = null, r && (this._lifecycleEventsManager.reset(), this._restart()), this;
    }
    setKey(e) {
        return this._key = e, this;
    }
    setVideoElement(e) {
        return e === this._videoElement || (this._videoElement && (this._buffer.detachVideoElement(), this._videoElement.removeEventListener("error", this._onMediaElementError)), this._videoElement = e, this._videoElement && (this._buffer.attachVideoElement(this._videoElement), this._buffer.scheduleSourceBufferRecreation(), this._videoElement.addEventListener("error", this._onMediaElementError))), this;
    }
    getFragmentQueue() {
        return this._fragmentQueue.getCurrentQueue();
    }
    setLoggerLevel(e, t = [], r = []) {
        return this._loggerTransport && (this._loggerTransport.destroy(), this._loggerTransport = null), this._loggerTransport = new $dbaf12f73216aff4$var$ne(this._eventBus, e, t, r), this;
    }
    setResolutionByName(e) {
        return this._resolutionManager.setResolutionByName(e), this;
    }
    setResolutionByBitrate(e) {
        return this._resolutionManager.setNearestResolutionByBitrate(e);
    }
    disableABR() {
        return this._resolutionManager.toggleAutoResolution(!1), this;
    }
    enableABR() {
        return this._resolutionManager.toggleAutoResolution(!0), this;
    }
    setConfig(e) {
        $dbaf12f73216aff4$var$Dt(e, this._eventBus);
    }
    setMaxABRResolution(e) {
        this._eventBus.publish($dbaf12f73216aff4$var$Ut.resolutionsConstraintsAvailable, e);
    }
    async _restart() {
        this._logger.info("restarting"), this._buffer?.reset(), await this.recoverMediaError(), this._fragmentParser.destroy(), this._fragmentParser = new $dbaf12f73216aff4$var$$0c3e140d9fd60ac7$export$1c5cdf0f111068e0(this._eventBus), this._fragmentQueue.reset(), this._url && this._resolutionManager.setUrl(this._url);
    }
    _stop() {
        this._url = null, this._restart(), this._resolutionManager.setUrl("");
    }
    _onResolutionsAvailable(e) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.VARIANTS_DETECTED, {
            detail: e
        }));
    }
    _onStreamEnded() {
        this.dispatchEvent(new Event($dbaf12f73216aff4$export$99d210b57a8acd4e.STREAM_ENDED));
    }
    _onResolutionChanged(e) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.RESOLUTION_CHANGED, {
            detail: e
        }));
    }
    _onBufferMetricsAvailable(e) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.METRICS_AVAILABLE, {
            detail: e
        }));
    }
    _onPlaybackStateChanged({ prevState: e, nextState: t }) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.PLAYBACK_STATE_CHANGED, {
            detail: {
                prevState: e,
                nextState: t
            }
        }));
    }
    _onFragmentFilterProblemDetected({ reason: e, fragment: t }) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.FRAGMENT_FILTERED_OUT, {
            detail: {
                reason: e,
                fragment: t
            }
        }));
    }
    _onMediaElementError() {
        $dbaf12f73216aff4$var$Rr.reportError("VideoElementError", {
            msg: this._videoElement?.error?.message,
            code: this._videoElement?.error?.code
        }), this._eventBus.publish($dbaf12f73216aff4$var$yr.saveData, {}), this._logger.error(`Media error occurred ${this._videoElement?.error?.message} ${this._videoElement?.error?.code}`), this._videoElement?.error && this.recoverMediaError();
    }
    _onLifecycleEventReported({ eventType: e }) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.LIFECYCLE_EVENT, {
            detail: {
                eventType: e
            }
        }));
    }
    _onLifecycleErrorReported({ errorType: e, nativeError: t }) {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.LIFECYCLE_ERROR, {
            detail: {
                errorType: e,
                nativeError: t
            }
        }));
    }
    _onResolutionNotFound() {
        this.dispatchEvent(new CustomEvent($dbaf12f73216aff4$export$99d210b57a8acd4e.RESOLUTION_NOT_FOUND));
    }
    _addAirPlaySourceIfNeeded() {
        if (this._url && this._videoElement && window.ManagedMediaSource) {
            const e = document.createElement("source");
            e.type = "application/x-mpegURL", e.src = this._url.replace(/playlistType=lowLatency/gi, ""), this._videoElement.appendChild(e);
        }
    }
}
(0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onResolutionsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onStreamEnded", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onResolutionChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onBufferMetricsAvailable", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onPlaybackStateChanged", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onFragmentFilterProblemDetected", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onMediaElementError", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onLifecycleEventReported", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onLifecycleErrorReported", null), (0, $dbaf12f73216aff4$var$o.__decorate)([
    $dbaf12f73216aff4$var$xt.default
], $dbaf12f73216aff4$export$af89f16da513df38.prototype, "_onResolutionNotFound", null);

});
parcelRegister("jecYn", function(module, exports) {
module.exports = import("./Debugger.worker.77753fbf.bed794fd.js").then(()=>parcelRequire('hbCbi'));

});


parcelRegister("4gxuw", function(module, exports) {

$parcel$export(module.exports, "AbstractWrapper", function () { return $7f52331869660786$export$58bff5bd2c5ee4fc; });

var $giOKx = parcelRequire("giOKx");
class $7f52331869660786$export$58bff5bd2c5ee4fc {
    constructor(eventBusInstance, options = {}){
        this._videoElement = null;
        this._lastKnownConfig = {};
        this._lastKnownStreamConfig = null;
        this._playerInstance = null;
        this._metricsCollector = null;
        this._eventBusInstance = eventBusInstance;
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).MODULE_LOADED, {});
        this._persistent = !!options.persistent;
    }
    setMetricsCollector(metricsCollector) {
        this._metricsCollector = metricsCollector;
    }
    destroy() {
        this._destroyPlayerInstance();
        this._isStarted = false;
        return this;
    }
    setAppKey(appKey) {
        this._appKey = appKey;
        return this;
    }
    setVideoElement(videoElement) {
        this._videoElement = videoElement;
        if (videoElement) this._playerInstance?.setVideoElement(videoElement);
        return this;
    }
    recreatePlayerInstance() {
        if (this._playerInstance) {
            this.destroy();
            this._playerInstance = null;
        }
        this._createPlayerInstance();
    }
    start() {
        if (!this._playerInstance) this.recreatePlayerInstance();
        this._playerInstance?.start();
        this._isStarted = true;
        return this;
    }
    stop() {
        this._isStarted = false;
        if (this._persistent && this._playerInstance && 'stop' in this._playerInstance) this._playerInstance.stop();
        else this._destroyPlayerInstance();
        return this;
    }
    setPlayerConfig(config) {
        this._lastKnownConfig = config;
        this._playerInstance?.setConfig(config, true);
        return this;
    }
    _destroyPlayerInstance() {
        if (!this._playerInstance) return;
        this._detachEventListeners();
        this._playerInstance.destroy();
        this._playerInstance = null;
    }
}

});



//# sourceMappingURL=Doppio.ff5d6714.js.map
